import type { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import type { ApolloResolverContext } from '../components/ApolloClient/helpers/context';
import gql from 'graphql-tag';
import type * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Upload: any;
};

export enum Aggr_Search_Sort_Types {
  Conversion = 'CONVERSION',
  RanCount = 'RAN_COUNT',
  SaleAmtAvg = 'SALE_AMT_AVG',
  SaleAmtSum = 'SALE_AMT_SUM',
  SoldCount = 'SOLD_COUNT'
}

export type AmsUpdateResponseMessages = {
  __typename?: 'AMSUpdateResponseMessages';
  error?: Maybe<Array<Maybe<Scalars['String']>>>;
  statusCode?: Maybe<Scalars['Int']>;
  statusText?: Maybe<Scalars['String']>;
  success?: Maybe<Array<Maybe<Scalars['String']>>>;
  warning?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum AccessoryDrawerDisplay {
  WidgetConfig = 'WIDGET_CONFIG'
}

export type Account = {
  __typename?: 'Account';
  accountId: Scalars['Int'];
  accountKey: Scalars['String'];
  accountNotes?: Maybe<Array<Maybe<AccountNote>>>;
  accountOrgDisplayName?: Maybe<Scalars['String']>;
  accountOrgId: Scalars['Int'];
  accountSalesRep?: Maybe<Scalars['String']>;
  accountTypeCode?: Maybe<Scalars['String']>;
  agents?: Maybe<Agents>;
  auctionAccessNumber?: Maybe<Scalars['Int']>;
  canBuy?: Maybe<Scalars['Boolean']>;
  canSell?: Maybe<Scalars['Boolean']>;
  dbaName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  establishedAt?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isFavorite?: Maybe<Scalars['Boolean']>;
  lastAttended?: Maybe<Scalars['String']>;
  lastPurchaseActivity?: Maybe<Scalars['String']>;
  lastSoldActivity?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  locations?: Maybe<Array<Maybe<Location>>>;
  orgCode?: Maybe<Scalars['String']>;
  phoneMain?: Maybe<Scalars['String']>;
  phoneMobile?: Maybe<Scalars['String']>;
  phoneSecondary?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type AccountGroupAccounts = {
  __typename?: 'AccountGroupAccounts';
  accountGroupId?: Maybe<Scalars['Int']>;
  accountId?: Maybe<Scalars['Int']>;
};

export type AccountGroupUsers = {
  __typename?: 'AccountGroupUsers';
  accountGroupId?: Maybe<Scalars['Int']>;
  isOwner?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
};

export type AccountGroups = {
  __typename?: 'AccountGroups';
  accounts?: Maybe<Array<Maybe<AccountGroupAccounts>>>;
  description?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isShared?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  orgId?: Maybe<Scalars['Int']>;
  users?: Maybe<Array<Maybe<AccountGroupUsers>>>;
};

export type AccountGroupsFilter = {
  accountGroupId?: InputMaybe<Scalars['Int']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
};

export type AccountNote = {
  __typename?: 'AccountNote';
  position?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

export type AccountSortBy = {
  ascending: Scalars['Boolean'];
  key: AccountSortingKey;
};

export enum AccountSortingKey {
  AccountNumber = 'AccountNumber',
  EstablishedAt = 'EstablishedAt',
  LegalName = 'LegalName',
  MailingLocationCity = 'MailingLocationCity',
  PrimaryLocationCity = 'PrimaryLocationCity'
}

export type Accounts = {
  __typename?: 'Accounts';
  byId?: Maybe<Account>;
  count?: Maybe<Scalars['Int']>;
  docsByDocTypeShortCode?: Maybe<Array<Maybe<Document>>>;
  list?: Maybe<Array<Maybe<Account>>>;
};


export type AccountsDocsByDocTypeShortCodeArgs = {
  docTypeShortCode?: InputMaybe<Scalars['String']>;
};


export type AccountsListArgs = {
  pageInfo?: InputMaybe<PageInfo>;
  sortBy?: InputMaybe<AccountSortBy>;
};

export type AccountsFilter = {
  auctionAccessNumber?: InputMaybe<Scalars['Int']>;
  docTypeShortCode?: InputMaybe<Scalars['String']>;
  establishedAt?: InputMaybe<DateRange>;
  id?: InputMaybe<Scalars['Int']>;
};

export enum AdjustPricingDataFieldEnum {
  All = 'All',
  BidIncrement = 'BidIncrement',
  BuyNowPrice = 'BuyNowPrice',
  StartingBidPrice = 'StartingBidPrice'
}

export enum AdjustPricingMethodEnum {
  FixedAmount = 'FixedAmount',
  Percent = 'Percent'
}

export type AdminInput = {
  auctionId: Scalars['String'];
  subjectUserId?: InputMaybe<Scalars['String']>;
};

export type AdminInputSub = {
  auctionId: Scalars['String'];
  subjectUserId: Scalars['String'];
};

export type Administrator = {
  __typename?: 'Administrator';
  allGroups?: Maybe<Array<Maybe<RoleAttributes>>>;
  user?: Maybe<User>;
  users?: Maybe<Array<Maybe<UserAttributes>>>;
};


export type AdministratorUserArgs = {
  input: GetSingleUserInput;
};


export type AdministratorUsersArgs = {
  input: GetUserListInput;
};

export type Agent = {
  __typename?: 'Agent';
  accountAuctionAccessNumber?: Maybe<Scalars['String']>;
  accountDisplayName?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['Int']>;
  accountIssuerOrgCode?: Maybe<Scalars['String']>;
  accountKey?: Maybe<Scalars['String']>;
  accountNotes?: Maybe<Array<Maybe<AccountNote>>>;
  agentAuthCode?: Maybe<Scalars['String']>;
  agentId: Scalars['Int'];
  agentNotes?: Maybe<Scalars['String']>;
  agentNumber?: Maybe<Scalars['String']>;
  attendanceHistory?: Maybe<AttendanceList>;
  auctionAccessNumber?: Maybe<Scalars['String']>;
  auctionAccessPicture?: Maybe<Scalars['String']>;
  bidderNumber?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
  buyerName?: Maybe<Scalars['String']>;
  canBuy?: Maybe<Scalars['String']>;
  canSell?: Maybe<Scalars['String']>;
  cellPhone?: Maybe<Scalars['String']>;
  contacts?: Maybe<ContactList>;
  dateAddedOn?: Maybe<Scalars['String']>;
  dealerName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  firstAttendedDate?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  homePhone?: Maybe<Scalars['String']>;
  lastAttendBadgeNum?: Maybe<Scalars['String']>;
  lastAttendBadgeType?: Maybe<Scalars['String']>;
  lastAttendedDate?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lastPurchaseActivity?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<AgentNote>>>;
  online?: Maybe<Scalars['Boolean']>;
  otherCompanies?: Maybe<CompaniesList>;
  roles?: Maybe<Array<Maybe<AgentRole>>>;
  workPhone?: Maybe<Scalars['String']>;
};

export type AgentCompany = {
  __typename?: 'AgentCompany';
  accountDisplayName?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['Int']>;
  agentId?: Maybe<Scalars['Int']>;
};

export type AgentDealerResponse = {
  __typename?: 'AgentDealerResponse';
  agent?: Maybe<Agent>;
  dealer?: Maybe<Dealer>;
};

export type AgentNote = {
  __typename?: 'AgentNote';
  agentId?: Maybe<Scalars['Int']>;
  agentName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  noteText?: Maybe<Scalars['String']>;
  noteType?: Maybe<Scalars['String']>;
  sparkUser?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type AgentNoteType = {
  __typename?: 'AgentNoteType';
  code: Scalars['String'];
  id: Scalars['Int'];
  longDescription?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type AgentNoteUpdate = {
  agentId: Scalars['Int'];
  code?: InputMaybe<Scalars['String']>;
  orgCode: Scalars['String'];
  sparkUserId: Scalars['Int'];
  text?: InputMaybe<Scalars['String']>;
};

export type AgentNoteUpdateResult = {
  __typename?: 'AgentNoteUpdateResult';
  success?: Maybe<Scalars['Boolean']>;
};

export type AgentRole = {
  __typename?: 'AgentRole';
  agentId?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  longDescription?: Maybe<Scalars['String']>;
  ordinal?: Maybe<Scalars['Int']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type AgentRoleAction = {
  roleAction: Scalars['String'];
  roleCode: Scalars['String'];
};

export type AgentRoleUpdate = {
  agentId: Scalars['Int'];
  orgCode?: InputMaybe<Scalars['String']>;
  roleUpdates?: InputMaybe<Array<InputMaybe<AgentRoleAction>>>;
  sparkUserId?: InputMaybe<Scalars['Int']>;
};

export type AgentRoleUpdateResult = {
  __typename?: 'AgentRoleUpdateResult';
  roleCode?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AgentRoleUpdateResults = {
  __typename?: 'AgentRoleUpdateResults';
  results?: Maybe<Array<Maybe<AgentRoleUpdateResult>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Agents = {
  __typename?: 'Agents';
  byId?: Maybe<Agent>;
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Agent>>>;
};


export type AgentsListArgs = {
  pageInfo?: InputMaybe<PageInfo>;
};

export type AgentsFilter = {
  accountId?: InputMaybe<Scalars['Int']>;
  auctionAccessNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  orgCode?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
};

export type AmsCallResult = {
  __typename?: 'AmsCallResult';
  message?: Maybe<Scalars['String']>;
  operation?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AmsResponse = {
  __typename?: 'AmsResponse';
  ifNotes?: Maybe<Array<Maybe<IfOfferNotes>>>;
  stockNumber?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

export type Announcement = {
  __typename?: 'Announcement';
  announcement?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  ordinal?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  typeCode?: Maybe<Scalars['String']>;
  typeLongDescription?: Maybe<Scalars['String']>;
  typeShortDescription?: Maybe<Scalars['String']>;
};

export type Asset = {
  __typename?: 'Asset';
  announcements?: Maybe<Array<Maybe<Announcement>>>;
  assetFees?: Maybe<Array<Maybe<AssetFees>>>;
  assetId: Scalars['ID'];
  blackBookValue?: Maybe<Scalars['Int']>;
  bodyStyle?: Maybe<Scalars['String']>;
  buyer?: Maybe<Agent>;
  buyerAccountId?: Maybe<Scalars['Int']>;
  buyerAccountKey?: Maybe<Scalars['String']>;
  buyerAgentEmail?: Maybe<Scalars['String']>;
  buyerAgentId?: Maybe<Scalars['Int']>;
  buyerAgentName?: Maybe<Scalars['String']>;
  buyerAgentNotes?: Maybe<Scalars['String']>;
  buyerAgentPhoneMobile?: Maybe<Scalars['String']>;
  buyerAgentPicture?: Maybe<Scalars['String']>;
  buyerDisplayName?: Maybe<Scalars['String']>;
  checkinDate?: Maybe<Scalars['String']>;
  checkinTime?: Maybe<Scalars['String']>;
  checkinUser?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  conditionReport?: Maybe<ConditionReport>;
  consignor?: Maybe<Account>;
  consignorAccountId?: Maybe<Scalars['Int']>;
  consignorAccountKey?: Maybe<Scalars['String']>;
  consignorDbaName?: Maybe<Scalars['String']>;
  consignorDisplayName?: Maybe<Scalars['String']>;
  consignorId?: Maybe<Scalars['Int']>;
  consignorLegalName?: Maybe<Scalars['String']>;
  consignorPipelineId?: Maybe<Scalars['String']>;
  countAll?: Maybe<Scalars['Int']>;
  crStatus?: Maybe<Scalars['String']>;
  customerReferenceNumber?: Maybe<Scalars['String']>;
  cylinderConfiguration?: Maybe<Scalars['String']>;
  cylinders?: Maybe<Scalars['String']>;
  drivetrain?: Maybe<Scalars['String']>;
  drivetrainDesc?: Maybe<Scalars['String']>;
  engineSize?: Maybe<Scalars['String']>;
  exteriorColor?: Maybe<Scalars['String']>;
  floorAmount?: Maybe<Scalars['Int']>;
  fuelType?: Maybe<Scalars['String']>;
  grade?: Maybe<Scalars['String']>;
  hasRun?: Maybe<Scalars['Boolean']>;
  hasTitle?: Maybe<Scalars['String']>;
  ifOfferManagement?: Maybe<IfOfferManagement>;
  interiorColor?: Maybe<Scalars['String']>;
  listingCondition?: Maybe<Scalars['String']>;
  listingConditionCode?: Maybe<Scalars['String']>;
  listingConditionId?: Maybe<Scalars['Int']>;
  make?: Maybe<Scalars['String']>;
  mmrValue?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  odometer?: Maybe<Scalars['String']>;
  onlineListing?: Maybe<OnlineListing>;
  ownerStockNumber?: Maybe<Scalars['String']>;
  photoBeauty?: Maybe<Scalars['String']>;
  photoCount?: Maybe<Scalars['Int']>;
  photos?: Maybe<Array<Maybe<Photo>>>;
  pipelineUri?: Maybe<Scalars['String']>;
  pmrValue?: Maybe<Scalars['Int']>;
  proxyBidCount?: Maybe<Scalars['Int']>;
  saleAmount?: Maybe<Scalars['Int']>;
  saleEvents?: Maybe<Array<Maybe<SaleEvent>>>;
  saleListing?: Maybe<SaleListing>;
  saleListingDealSoldAt?: Maybe<Scalars['String']>;
  saleListingLane?: Maybe<Scalars['String']>;
  saleListingLot?: Maybe<Scalars['String']>;
  saleListingOfferCreatedAt?: Maybe<Scalars['String']>;
  saleListingSaleDate?: Maybe<Scalars['String']>;
  saleListingSaleStatus?: Maybe<Scalars['String']>;
  saleListingSoldDateLastRanTime?: Maybe<Scalars['String']>;
  saleListingVenueCode?: Maybe<Scalars['String']>;
  saleListingVenueName?: Maybe<Scalars['String']>;
  saleListingVenueUrl?: Maybe<Scalars['String']>;
  saleMethod?: Maybe<Scalars['String']>;
  sellerAgentEmail?: Maybe<Scalars['String']>;
  sellerAgentId?: Maybe<Scalars['Int']>;
  sellerAgentName?: Maybe<Scalars['String']>;
  sellerAgentPhoneMobile?: Maybe<Scalars['String']>;
  services?: Maybe<Array<Maybe<Service>>>;
  source?: Maybe<Scalars['String']>;
  stockNumber?: Maybe<Scalars['String']>;
  titleNumber?: Maybe<Scalars['String']>;
  titleReceivedDate?: Maybe<Scalars['String']>;
  titleState?: Maybe<Scalars['String']>;
  transmissionType?: Maybe<Scalars['String']>;
  trim?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type AssetFees = {
  __typename?: 'AssetFees';
  amount?: Maybe<Scalars['String']>;
  chargeCode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  run?: Maybe<Scalars['String']>;
  stockNumber?: Maybe<Scalars['String']>;
};

export type AssetFilter = {
  auctionId?: InputMaybe<Scalars['String']>;
  buyerId?: InputMaybe<Scalars['Int']>;
  buyerOrSellerAccountId?: InputMaybe<Scalars['Int']>;
  checkInDate?: InputMaybe<DateRange>;
  consigned?: InputMaybe<Scalars['Boolean']>;
  eventTypeCode?: InputMaybe<Scalars['String']>;
  hasConditionReport?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  photoCount?: InputMaybe<NumberRange>;
  purchased?: InputMaybe<Scalars['Boolean']>;
  saleDate?: InputMaybe<DateRange>;
  sellerId?: InputMaybe<Scalars['Int']>;
  sold?: InputMaybe<Scalars['Boolean']>;
  soldDate?: InputMaybe<DateRange>;
  soldOnline?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['String']>;
  stockNumber?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};

export type Assets = {
  __typename?: 'Assets';
  assetsByStockNumber?: Maybe<Asset>;
  byId?: Maybe<Asset>;
  byStockNumber?: Maybe<Asset>;
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Asset>>>;
};


export type AssetsListArgs = {
  pageInfo?: InputMaybe<PageInfo>;
};

export type Attendance = {
  __typename?: 'Attendance';
  attendanceType?: Maybe<Scalars['String']>;
  bidderBadgeNumber?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['String']>;
  eventName?: Maybe<Scalars['String']>;
};

export type AttendanceList = {
  __typename?: 'AttendanceList';
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Attendance>>>;
};


export type AttendanceListListArgs = {
  days?: InputMaybe<Scalars['Int']>;
  pageInfo?: InputMaybe<PageInfo>;
};

export type Auction = {
  __typename?: 'Auction';
  accounts?: Maybe<Accounts>;
  agentNoteTypes?: Maybe<Array<Maybe<AgentNoteType>>>;
  agentRoles?: Maybe<Array<Maybe<AgentRole>>>;
  agents?: Maybe<Agents>;
  amsInfo?: Maybe<AuctionAmsInfo>;
  assets?: Maybe<Assets>;
  auctionSettings?: Maybe<AuctionSettingsResponse>;
  card?: Maybe<GenericCard>;
  contactManagement?: Maybe<ContactManagement>;
  document?: Maybe<Document>;
  getDownloadLink?: Maybe<ShareReportResponse>;
  getReportConfig?: Maybe<ReportConfig>;
  getReportConfigs?: Maybe<Array<Maybe<ReportConfig>>>;
  groups?: Maybe<Array<Maybe<AccountGroups>>>;
  keys?: Maybe<VdpByStockNumberResults>;
  lightOptions?: Maybe<Array<Maybe<LightOption>>>;
  marketplace?: Maybe<Marketplace>;
  psi?: Maybe<Psi>;
  reportDetailPages: Array<ReportDetailPage>;
  reports?: Maybe<Array<Maybe<Report>>>;
  roles?: Maybe<Array<Maybe<RoleAttributes>>>;
  search?: Maybe<SearchResults>;
  setVehicleInfo?: Maybe<SetVehicleInfoResults>;
  statistics?: Maybe<AuctionStatistics>;
  users?: Maybe<Array<Maybe<UserAttributes>>>;
};


export type AuctionAccountsArgs = {
  filter: AccountsFilter;
};


export type AuctionAgentsArgs = {
  filter: AgentsFilter;
};


export type AuctionAssetsArgs = {
  filter: AssetFilter;
};


export type AuctionAuctionSettingsArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
};


export type AuctionCardArgs = {
  filter?: InputMaybe<CardFilter>;
};


export type AuctionGetDownloadLinkArgs = {
  auctionName?: InputMaybe<Scalars['String']>;
  creationDate?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<GenerateOptions>;
  reportConfigId?: InputMaybe<Scalars['String']>;
  searchFilter?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userSearchString?: InputMaybe<Scalars['String']>;
};


export type AuctionGetReportConfigArgs = {
  reportConfigId?: InputMaybe<Scalars['String']>;
};


export type AuctionGetReportConfigsArgs = {
  reportKey?: InputMaybe<Scalars['String']>;
};


export type AuctionGroupsArgs = {
  filter?: InputMaybe<AccountGroupsFilter>;
};


export type AuctionKeysArgs = {
  amsId?: InputMaybe<Scalars['String']>;
  stockNumber?: InputMaybe<Scalars['String']>;
};


export type AuctionPsiArgs = {
  filter?: InputMaybe<PsiFilter>;
};


export type AuctionReportsArgs = {
  filter: ReportFilter;
};


export type AuctionSearchArgs = {
  filter?: InputMaybe<SearchFilter>;
  pageInfo?: InputMaybe<SearchPageInfo>;
  sort?: InputMaybe<SearchSort>;
};


export type AuctionSetVehicleInfoArgs = {
  amsType?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<Array<InputMaybe<SetAnnouncements>>>;
  assetId: Scalars['ID'];
  cancelProxyBids?: InputMaybe<Scalars['Boolean']>;
  expectedAnnouncements?: InputMaybe<Array<InputMaybe<ExpectedAnnouncement>>>;
  floorPrice?: InputMaybe<SetFloorPrice>;
  lights?: InputMaybe<SetLights>;
  numberOfProxyBids?: InputMaybe<Scalars['Int']>;
  stockNumber: Scalars['String'];
};


export type AuctionStatisticsArgs = {
  filter?: InputMaybe<StatisticsFilter>;
};

export type AuctionAmsInfo = {
  __typename?: 'AuctionAmsInfo';
  lightValues?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AuctionCollection = {
  __typename?: 'AuctionCollection';
  accounts?: Maybe<Accounts>;
};


export type AuctionCollectionAccountsArgs = {
  filter: AccountsFilter;
};

export type AuctionKey = {
  __typename?: 'AuctionKey';
  accountingId?: Maybe<Scalars['String']>;
  amsId?: Maybe<Scalars['String']>;
  pipelineId?: Maybe<Scalars['String']>;
  uaId?: Maybe<Scalars['String']>;
};

export type AuctionSettings = {
  __typename?: 'AuctionSettings';
  bidIncrement: Scalars['Int'];
  buyNowTiers?: Maybe<Array<Maybe<BuyNowTier>>>;
  enforceConditionReport?: Maybe<Scalars['Boolean']>;
  enforceFloorPrice?: Maybe<Scalars['Boolean']>;
  enforceGrade?: Maybe<Scalars['Boolean']>;
  enforceLight?: Maybe<Scalars['Boolean']>;
  nonAdminEditBidIncrement?: Maybe<Scalars['Boolean']>;
  nonAdminEditFloorPrice?: Maybe<Scalars['Boolean']>;
  offerThreshold: Scalars['Int'];
  startBidTiers?: Maybe<Array<Maybe<StartBidTier>>>;
};

export type AuctionSettingsInput = {
  bidIncrement: Scalars['Int'];
  buyNowTiers?: InputMaybe<Array<InputMaybe<BuyNowTierInput>>>;
  enforceConditionReport?: InputMaybe<Scalars['Boolean']>;
  enforceFloorPrice?: InputMaybe<Scalars['Boolean']>;
  enforceGrade?: InputMaybe<Scalars['Boolean']>;
  enforceLight?: InputMaybe<Scalars['Boolean']>;
  nonAdminEditBidIncrement?: InputMaybe<Scalars['Boolean']>;
  nonAdminEditFloorPrice?: InputMaybe<Scalars['Boolean']>;
  offerThreshold: Scalars['Int'];
  startBidTiers?: InputMaybe<Array<InputMaybe<StartBidTierInput>>>;
};

export type AuctionSettingsResponse = {
  __typename?: 'AuctionSettingsResponse';
  data?: Maybe<AuctionSettings>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type AuctionStatistics = {
  __typename?: 'AuctionStatistics';
  bidders?: Maybe<BidderList>;
  biddingStatistics?: Maybe<BiddingStatistics>;
  lanes?: Maybe<LaneList>;
  saleStatistics?: Maybe<SalesDayStatistics>;
  trends?: Maybe<Trends>;
  users?: Maybe<Array<Maybe<User>>>;
};


export type AuctionStatisticsBiddersArgs = {
  filter: BiddersFilter;
};


export type AuctionStatisticsTrendsArgs = {
  filter: TrendsFilter;
};

export type Audit = {
  __typename?: 'Audit';
  getVehicleAuditList?: Maybe<AuditResponse>;
};


export type AuditGetVehicleAuditListArgs = {
  input?: InputMaybe<AuditInput>;
};

export type AuditInput = {
  auctionId?: InputMaybe<Scalars['String']>;
  stockNumber?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};

export type AuditResponse = {
  __typename?: 'AuditResponse';
  data?: Maybe<Array<Maybe<TestVehicleAuditLog>>>;
  error?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export enum BallControlCode {
  Buyer = 'buyer',
  Missing = 'missing',
  Seller = 'seller'
}

export type Bidder = {
  __typename?: 'Bidder';
  accountId?: Maybe<Scalars['Int']>;
  accountKey: Scalars['String'];
  accountOrgId?: Maybe<Scalars['Int']>;
  badge: Scalars['String'];
  dbaName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  eventDate: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type BidderList = {
  __typename?: 'BidderList';
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Bidder>>>;
};


export type BidderListListArgs = {
  pageInfo?: InputMaybe<PageInfo>;
};

export type BiddersFilter = {
  attendedDate?: InputMaybe<DateRange>;
};

export type BiddingStatistics = {
  __typename?: 'BiddingStatistics';
  inlaneBidders?: Maybe<Scalars['Int']>;
  onlineBidders?: Maybe<Scalars['Int']>;
  totalBidders?: Maybe<Scalars['Int']>;
};

export type BuyNowTier = {
  __typename?: 'BuyNowTier';
  amountAbovePriceFloor?: Maybe<Scalars['Int']>;
  priceFloorLBound?: Maybe<Scalars['Int']>;
  priceFloorUBound?: Maybe<Scalars['Int']>;
};

export type BuyNowTierInput = {
  amountAbovePriceFloor?: InputMaybe<Scalars['Int']>;
  priceFloorLBound?: InputMaybe<Scalars['Int']>;
  priceFloorUBound?: InputMaybe<Scalars['Int']>;
};

export type CacheShape = {
  __typename?: 'CacheShape';
  mutation?: Maybe<Mutation>;
  query?: Maybe<Query>;
};

export type CalculatedIfOfferData = {
  __typename?: 'CalculatedIfOfferData';
  buyerMovementThisOffer?: Maybe<Scalars['Int']>;
  buyerNotesThisOffer?: Maybe<Array<Maybe<Scalars['String']>>>;
  sellerMovementThisOffer?: Maybe<Scalars['Int']>;
  sellerNotesThisOffer?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CancelProxyBidsResult = {
  __typename?: 'CancelProxyBidsResult';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success: Scalars['Boolean'];
};

export type Card = {
  __typename?: 'Card';
  config?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type CardFilter = {
  auctionId?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export enum ColOptions {
  AllCols = 'all_cols',
  ViewCols = 'view_cols'
}

export type CompaniesList = {
  __typename?: 'CompaniesList';
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<AgentCompany>>>;
};


export type CompaniesListListArgs = {
  pageInfo?: InputMaybe<PageInfo>;
};

export type ConditionReport = {
  __typename?: 'ConditionReport';
  conditionReportStatus?: Maybe<Scalars['String']>;
  conditionReportTime?: Maybe<Scalars['String']>;
  conditionReportWriter?: Maybe<Scalars['String']>;
};

export type ConfigSearchResults = {
  __typename?: 'ConfigSearchResults';
  searchStringDisplay?: Maybe<Scalars['String']>;
  vehicleData?: Maybe<Array<Maybe<VehicleDataTypes>>>;
};

export type Contact = {
  __typename?: 'Contact';
  account?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['Int']>;
  agentId?: Maybe<Scalars['Int']>;
  agentName?: Maybe<Scalars['String']>;
  buyerSellerAccountId?: Maybe<Scalars['Int']>;
  completedAt?: Maybe<Scalars['String']>;
  completedBy?: Maybe<Scalars['Int']>;
  contactedAt?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  creatorFullName?: Maybe<Scalars['String']>;
  followUpDate?: Maybe<Scalars['String']>;
  followUpUserId?: Maybe<Scalars['Int']>;
  followupUserName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['String']>;
  typeCode?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
  /** @deprecated Use followupUserName instead */
  userName?: Maybe<Scalars['String']>;
};

export type ContactFilter = {
  accountId?: InputMaybe<Scalars['Int']>;
  agentId?: InputMaybe<Scalars['Int']>;
  forFollowUp?: InputMaybe<Scalars['Boolean']>;
  statusCode?: InputMaybe<Scalars['String']>;
};

export type ContactList = {
  __typename?: 'ContactList';
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Contact>>>;
};


export type ContactListListArgs = {
  pageInfo?: InputMaybe<PageInfo>;
  sortBy?: InputMaybe<ContactSortBy>;
};

export type ContactLogStats = {
  __typename?: 'ContactLogStats';
  total?: Maybe<Scalars['Int']>;
};

export type ContactManagement = {
  __typename?: 'ContactManagement';
  contacts?: Maybe<ContactList>;
  statuses?: Maybe<Array<Maybe<ContactStatus>>>;
  types?: Maybe<Array<Maybe<ContactType>>>;
};


export type ContactManagementContactsArgs = {
  filter?: InputMaybe<ContactFilter>;
};

export type ContactSortBy = {
  ascending?: InputMaybe<Scalars['Boolean']>;
  key: ContactSortKey;
};

export enum ContactSortKey {
  AgentName = 'AgentName',
  ContactedDate = 'ContactedDate',
  Status = 'Status'
}

export type ContactStatus = {
  __typename?: 'ContactStatus';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type ContactType = {
  __typename?: 'ContactType';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type CreateAgentContact = {
  agentId: Scalars['Int'];
  buyerSellerAccountId?: InputMaybe<Scalars['Int']>;
  completedAt?: InputMaybe<Scalars['String']>;
  completedBy?: InputMaybe<Scalars['Int']>;
  contactedAt: Scalars['String'];
  followUpDate?: InputMaybe<Scalars['String']>;
  followUpUserId?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  statusCode: Scalars['String'];
  typeCode: Scalars['String'];
};

export type CreateDocumentInput = {
  attachment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  docId?: InputMaybe<Scalars['String']>;
  docName?: InputMaybe<Scalars['String']>;
  docTypeId?: InputMaybe<Scalars['String']>;
  docTypeName?: InputMaybe<Scalars['String']>;
  docTypeShortCode?: InputMaybe<Scalars['String']>;
  stockNumber?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  transactionId: Scalars['String'];
};

export type CreateDocumentOutputAsset = {
  __typename?: 'CreateDocumentOutputAsset';
  assetId?: Maybe<Scalars['ID']>;
  attachment?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Int']>;
  docTypeId?: Maybe<Scalars['Int']>;
  docTypeName?: Maybe<Scalars['String']>;
  docTypeShortCode?: Maybe<Scalars['String']>;
  stockNumber?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

export type CreateDocumentUploadDoc = {
  __typename?: 'CreateDocumentUploadDoc';
  assetId?: Maybe<Scalars['ID']>;
  docId?: Maybe<Scalars['String']>;
  s3PresignedUrl?: Maybe<Scalars['String']>;
  stockNumber?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

export type CreateDocumentsInputAsset = {
  assetId?: InputMaybe<Scalars['ID']>;
  attachment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  docTypeId?: InputMaybe<Scalars['String']>;
  docTypeName?: InputMaybe<Scalars['String']>;
  docTypeShortCode?: InputMaybe<Scalars['String']>;
  stockNumber?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};

export type CreateDocumentsUploadItem = {
  __typename?: 'CreateDocumentsUploadItem';
  asset?: Maybe<CreateDocumentOutputAsset>;
  doc?: Maybe<CreateDocumentUploadDoc>;
  error?: Maybe<Scalars['String']>;
};

export type CreateReportConfigInput = {
  PK?: InputMaybe<Scalars['String']>;
  SK?: InputMaybe<Scalars['String']>;
  auctionId?: InputMaybe<Scalars['String']>;
  displayType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  listViewConfig?: InputMaybe<ListViewConfigInput>;
  searchConfig?: InputMaybe<SearchConfigInput>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type CreateReportConfigResponse = {
  __typename?: 'CreateReportConfigResponse';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type CreateUserInput = {
  admin: AdminInput;
  auctionAccessNumber?: InputMaybe<Scalars['String']>;
  authenticationUsername: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  isGlobalAdmin: Scalars['Boolean'];
  isSiteAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  mobilePhone?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Scalars['String']>;
  workPhone?: InputMaybe<Scalars['String']>;
};

export type CreateVenueEvent = {
  cancelReason?: InputMaybe<Scalars['String']>;
  eventDate: Scalars['String'];
  eventEndTime?: InputMaybe<Scalars['String']>;
  eventSettings?: InputMaybe<AuctionSettingsInput>;
  eventStartTime: Scalars['String'];
  eventTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eventTitle: Scalars['String'];
  eventType: Scalars['String'];
  eventTypeDisplayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  longDescription?: InputMaybe<Scalars['String']>;
  orgCode?: InputMaybe<Scalars['String']>;
  originatingOrgCode?: InputMaybe<Scalars['String']>;
  participatingAuctions: Array<InputMaybe<Scalars['String']>>;
  shortDescription?: InputMaybe<Scalars['String']>;
  venueCode?: InputMaybe<Scalars['String']>;
};

export type CreatedEventResponse = SparkResponse & {
  __typename?: 'CreatedEventResponse';
  data?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type CurrentSale = {
  __typename?: 'CurrentSale';
  asset_id?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  venue_event_id?: Maybe<Scalars['String']>;
  venue_event_key?: Maybe<Scalars['String']>;
};

export type CurrentSaleInput = {
  asset_id?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  venue_event_id?: InputMaybe<Scalars['String']>;
  venue_event_key?: InputMaybe<Scalars['String']>;
};

export type Dashboard = {
  __typename?: 'Dashboard';
  cards?: Maybe<Array<Maybe<Card>>>;
  configJson?: Maybe<Scalars['String']>;
  databaseId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type DashboardCardInput = {
  config?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
};

export type DashboardFilter = {
  id?: InputMaybe<Scalars['String']>;
};

export type DashboardInput = {
  config?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Dashboards = {
  __typename?: 'Dashboards';
  byId?: Maybe<Dashboard>;
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Dashboard>>>;
};


export type DashboardsListArgs = {
  pageInfo?: InputMaybe<PageInfo>;
};

export type DataConfig = {
  __typename?: 'DataConfig';
  dataFilter?: Maybe<ReportSearchFilter>;
  dataSource?: Maybe<DataSourceTypes>;
  pageInfo?: Maybe<PageInfoConfig>;
};

export enum DataSourceTypes {
  Ods = 'ODS',
  Search = 'SEARCH'
}

export type DateRange = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type Deal = {
  __typename?: 'Deal';
  buyer?: Maybe<Agent>;
  currentOfferAmount?: Maybe<Scalars['Int']>;
  dealStatus?: Maybe<Scalars['String']>;
  saleListing?: Maybe<SaleListing>;
};

export type DealFilter = {
  dealId?: InputMaybe<Scalars['Int']>;
};

export type Dealer = {
  __typename?: 'Dealer';
  dealerName?: Maybe<Scalars['String']>;
};

export type DeleteAgentContact = {
  agentId: Scalars['Int'];
};

export type DeleteUserInput = {
  admin: AdminInputSub;
};

export type DocType = {
  __typename?: 'DocType';
  displayOrder: Scalars['Int'];
  docTypeId: Scalars['String'];
  docTypeName: Scalars['String'];
  docTypeNameUnderscored?: Maybe<Scalars['String']>;
  shortCode: Scalars['String'];
  verticalTypeId: Scalars['String'];
};

export type Document = {
  __typename?: 'Document';
  accountId?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  attachment?: Maybe<Scalars['String']>;
  buyerAccount?: Maybe<Account>;
  buyerAccountKey?: Maybe<Scalars['String']>;
  buyerId?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  createdAtFormatted: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdByUserId?: Maybe<Scalars['String']>;
  currentSaleListingDate?: Maybe<Scalars['String']>;
  customerAccountKey?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Int']>;
  displayOrder: Scalars['Int'];
  docId: Scalars['ID'];
  docName?: Maybe<Scalars['String']>;
  docTypeId: Scalars['String'];
  docTypeName: Scalars['String'];
  docTypeNameUnderscored?: Maybe<Scalars['String']>;
  docTypeShortCode?: Maybe<Scalars['String']>;
  documentActivity?: Maybe<DocumentActivity>;
  documentByDocId?: Maybe<Document>;
  documentByDocTypeShortCode?: Maybe<Array<Maybe<Document>>>;
  documentFilterLists?: Maybe<Array<Maybe<Document>>>;
  documentLists?: Maybe<Array<Maybe<Document>>>;
  documentTypes?: Maybe<Array<Maybe<DocType>>>;
  /** @deprecated Will be inside other call */
  documentUploadURLs?: Maybe<Array<Maybe<DocumentUploadUrl>>>;
  documentsByAuctionFilter?: Maybe<PaginatedDocumentResponse>;
  numNotes?: Maybe<Scalars['Int']>;
  s3Url?: Maybe<Scalars['String']>;
  s3UrlDownload?: Maybe<Scalars['String']>;
  s3UrlExpires?: Maybe<Scalars['String']>;
  s3UrlExpiresFormatted?: Maybe<Scalars['String']>;
  sellerAccount?: Maybe<Account>;
  stockNumber?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedAtFormatted?: Maybe<Scalars['String']>;
  vehicleMake?: Maybe<Scalars['String']>;
  vehicleModel?: Maybe<Scalars['String']>;
  vehicleVIN?: Maybe<Scalars['String']>;
  vehicleYear?: Maybe<Scalars['String']>;
  vehiclesWithDocs?: Maybe<VehiclesWithDocsResponse>;
};


export type DocumentDocumentActivityArgs = {
  docId: Scalars['String'];
};


export type DocumentDocumentByDocIdArgs = {
  filter: DocumentsFilter;
};


export type DocumentDocumentByDocTypeShortCodeArgs = {
  filter: DocumentsFilter;
};


export type DocumentDocumentFilterListsArgs = {
  filter: DocumentsFilter;
};


export type DocumentDocumentListsArgs = {
  filter: DocumentsFilter;
};


export type DocumentDocumentTypesArgs = {
  verticalTypeId: Scalars['String'];
};


export type DocumentDocumentUploadUrLsArgs = {
  filter: DocumentUploadUrLsFilter;
};


export type DocumentDocumentsByAuctionFilterArgs = {
  filter: DocumentsFilter;
};


export type DocumentVehiclesWithDocsArgs = {
  tenantId?: InputMaybe<Scalars['String']>;
};

export type DocumentActivity = {
  __typename?: 'DocumentActivity';
  documentViews?: Maybe<Array<Maybe<DocumentView>>>;
};

export type DocumentUploadUrl = {
  __typename?: 'DocumentUploadURL';
  customerId: Scalars['String'];
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  s3Key: Scalars['String'];
  s3uploadUrl: Scalars['String'];
  tenantId: Scalars['String'];
  urlExpires: Scalars['String'];
};

export type DocumentUploadUrLsFilter = {
  accountId?: InputMaybe<Scalars['Int']>;
  consignorAccountKey?: InputMaybe<Scalars['String']>;
  fileType: Scalars['String'];
  numFiles: Scalars['Int'];
};

export type DocumentView = {
  __typename?: 'DocumentView';
  docId: Scalars['String'];
  userDisplay?: Maybe<Scalars['String']>;
  userEmail?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  userType?: Maybe<User_Types>;
  viewedAt: Scalars['Int'];
};

export type DocumentsFilter = {
  accountId?: InputMaybe<Scalars['Int']>;
  amsId?: InputMaybe<Scalars['String']>;
  assetId?: InputMaybe<Scalars['ID']>;
  buyerId?: InputMaybe<Scalars['String']>;
  currentSaleListingDate?: InputMaybe<Scalars['String']>;
  currentSaleListingEndDate?: InputMaybe<Scalars['String']>;
  currentSaleListingStartDate?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  dateStamp?: InputMaybe<Scalars['String']>;
  docId?: InputMaybe<Scalars['String']>;
  docTypeName?: InputMaybe<Scalars['String']>;
  docTypeShortCode?: InputMaybe<Scalars['String']>;
  pageInfo?: InputMaybe<PageInfo>;
  stockNumber?: InputMaybe<Scalars['String']>;
};

export enum EventStatusesEnum {
  Active = 'Active',
  All = 'All',
  Canceled = 'Canceled',
  Ended = 'Ended',
  Future = 'Future',
  Paused = 'Paused'
}

export enum EventTriggerCode {
  Accepted = 'accepted',
  AcceptedBuyer = 'accepted_buyer',
  AcceptedSeller = 'accepted_seller',
  CounterBuyer = 'counter_buyer',
  CounterSeller = 'counter_seller',
  Note = 'note',
  NoteBuyer = 'note_buyer',
  NoteSeller = 'note_seller',
  RejectedBuyer = 'rejected_buyer',
  RejectedSeller = 'rejected_seller',
  System = 'system'
}

export enum EventTypeCode {
  Aborted = 'aborted',
  Completed = 'completed',
  EmailReceiptReceipt = 'email_receipt_receipt',
  EmailSent = 'email_sent',
  NoteAdded = 'note_added',
  OfferChange = 'offer_change',
  Pending = 'pending',
  SmsSent = 'sms_sent',
  Start = 'start'
}

export type EventTypeTrigger = {
  __typename?: 'EventTypeTrigger';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  longDescription?: Maybe<Scalars['String']>;
  ordinal?: Maybe<Scalars['Int']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export enum EventTypesEnum {
  Live = 'live',
  Timed = 'timed'
}

export type EventsListFilter = {
  endDate?: InputMaybe<Scalars['String']>;
  eventStatuses?: InputMaybe<Array<InputMaybe<EventStatusesEnum>>>;
  eventType?: InputMaybe<EventTypesEnum>;
  startDate?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type ExitVehicleRequest = {
  exitStatus: Scalars['String'];
  orgCode?: InputMaybe<Scalars['String']>;
  stockNumber: Scalars['Int'];
  vin: Scalars['String'];
};

export type ExpectedAnnouncement = {
  announcement: Scalars['String'];
  ordinal: Scalars['Int'];
};

export type FullSearch = {
  displayName: Scalars['String'];
  filterName: Scalars['String'];
  searchName: Scalars['String'];
};

export enum GenerateFormats {
  Csv = 'csv',
  Json = 'json',
  Pdf = 'pdf'
}

export type GenerateOptions = {
  colOptions?: InputMaybe<ColOptions>;
};

export type GeneratePdfInput = {
  auctionId?: InputMaybe<Scalars['String']>;
  auctionName?: InputMaybe<Scalars['String']>;
  creationDate?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<GenerateFormats>;
  message?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<GenerateOptions>;
  putMessage?: InputMaybe<MessageInput>;
  reportConfigId?: InputMaybe<Scalars['String']>;
  searchFilter?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userSearchString?: InputMaybe<Scalars['String']>;
};

export type GenericCard = {
  __typename?: 'GenericCard';
  vdpViewsCount?: Maybe<Scalars['Int']>;
  vdpViewsStats?: Maybe<Array<Maybe<OnlineStatistic>>>;
  watchedVehiclesCount?: Maybe<Scalars['Int']>;
  watchedVehiclesList?: Maybe<Array<Maybe<OnlineListing>>>;
};

export type GetSingleUserInput = {
  admin: AdminInputSub;
};

export type GetUserListInput = {
  admin: AdminInput;
};

export type HttpResponse = {
  __typename?: 'HttpResponse';
  statusCode: Scalars['Int'];
  statusMessage?: Maybe<Scalars['String']>;
};

export type IfOfferDetails = {
  assetId?: InputMaybe<Scalars['ID']>;
  buyerAgentId?: InputMaybe<Scalars['Int']>;
  eventTriggerCode?: InputMaybe<EventTriggerCode>;
  eventTypeCode?: InputMaybe<EventTypeCode>;
  isVisible?: InputMaybe<Scalars['Int']>;
  offerAmount?: InputMaybe<Scalars['Int']>;
  offerNote?: InputMaybe<Scalars['String']>;
  orgCode?: InputMaybe<Scalars['String']>;
  sellerAgentId?: InputMaybe<Scalars['Int']>;
  sparkUserId?: InputMaybe<Scalars['Int']>;
};

export type IfOfferFilter = {
  assetId?: InputMaybe<Scalars['ID']>;
  pastHistory?: InputMaybe<Scalars['Boolean']>;
};

export type IfOfferHistory = {
  __typename?: 'IfOfferHistory';
  announcementLight?: Maybe<Scalars['String']>;
  announcementLights?: Maybe<Scalars['String']>;
  assetAnnouncementFour?: Maybe<Scalars['String']>;
  assetAnnouncementOne?: Maybe<Scalars['String']>;
  assetAnnouncementThree?: Maybe<Scalars['String']>;
  assetAnnouncementTwo?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['ID']>;
  ballControlCode?: Maybe<BallControlCode>;
  ballControlDescription?: Maybe<Scalars['String']>;
  buyNowPrice?: Maybe<Scalars['Int']>;
  buyerAgentId?: Maybe<Scalars['Int']>;
  buyerAgentName?: Maybe<Scalars['String']>;
  buyerDisplayName?: Maybe<Scalars['String']>;
  buyerOrSellerAccountId?: Maybe<Scalars['Int']>;
  correlationId?: Maybe<Scalars['String']>;
  currentOfferAmount?: Maybe<Scalars['Int']>;
  currentOfferAmountPrevious?: Maybe<Scalars['Int']>;
  dealId?: Maybe<Scalars['Int']>;
  dealStatusCode?: Maybe<Scalars['String']>;
  eventCreatedAt?: Maybe<Scalars['String']>;
  eventCreatedBy?: Maybe<Scalars['String']>;
  eventCreatedById?: Maybe<Scalars['Int']>;
  eventDate?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['Int']>;
  eventNote?: Maybe<Scalars['String']>;
  eventTriggerCode?: Maybe<EventTriggerCode>;
  eventTriggerDesc?: Maybe<Scalars['String']>;
  eventTypeCode?: Maybe<EventTypeCode>;
  eventTypeDesc?: Maybe<Scalars['String']>;
  fees?: Maybe<Scalars['Int']>;
  floorPrice?: Maybe<Scalars['Int']>;
  isVirtualAuction?: Maybe<Scalars['Boolean']>;
  laneName?: Maybe<Scalars['String']>;
  lotNumber?: Maybe<Scalars['String']>;
  saleListingId?: Maybe<Scalars['Int']>;
  sellerAgentId?: Maybe<Scalars['Int']>;
  sellerAgentName?: Maybe<Scalars['String']>;
  valuationBlackbookAmount?: Maybe<Scalars['Int']>;
  valuationMMRAmount?: Maybe<Scalars['Int']>;
};

export type IfOfferManagement = {
  __typename?: 'IfOfferManagement';
  buyerAgent?: Maybe<Agent>;
  buyerAgents?: Maybe<Array<Maybe<Agent>>>;
  calculatedIfOfferData?: Maybe<CalculatedIfOfferData>;
  eventTriggers?: Maybe<Array<Maybe<EventTypeTrigger>>>;
  eventTypes?: Maybe<Array<Maybe<EventTypeTrigger>>>;
  ifOfferHistory?: Maybe<Array<Maybe<IfOfferHistory>>>;
  noSaleHistory?: Maybe<Array<Maybe<NoSaleHistory>>>;
  pastSalesHistory?: Maybe<Array<Maybe<PastSale>>>;
  sellerAgent?: Maybe<Agent>;
  sellerAgents?: Maybe<Array<Maybe<Agent>>>;
};

export enum IfOfferNoteType {
  Buyer = 'buyer',
  General = 'general',
  Seller = 'seller'
}

export type IfOfferNotes = {
  __typename?: 'IfOfferNotes';
  date: Scalars['String'];
  note: Scalars['String'];
  type: IfOfferNoteType;
  user: Scalars['String'];
};

export type IfOfferUpdateAmsResponse = {
  __typename?: 'IfOfferUpdateAMSResponse';
  data?: Maybe<AmsResponse>;
  messages?: Maybe<AmsUpdateResponseMessages>;
  responseCode?: Maybe<Scalars['Int']>;
};

export type IfOfferUpdateResult = {
  __typename?: 'IfOfferUpdateResult';
  amsStatusCode?: Maybe<Scalars['Int']>;
  amsStatusText?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['ID']>;
  ifNotes?: Maybe<Array<Maybe<IfOfferNotes>>>;
  lastOfferHistoryItem?: Maybe<IfOfferHistory>;
  stockNumber?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  vin?: Maybe<Scalars['String']>;
};

export type IfOfferUpdateResults = {
  __typename?: 'IfOfferUpdateResults';
  results?: Maybe<Array<Maybe<IfOfferUpdateResult>>>;
  searchUpdateSuccess?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type InspectionInput = {
  assetId: Scalars['ID'];
  canPrint?: InputMaybe<Scalars['Boolean']>;
  feeAmount: Scalars['Int'];
  isOverridden?: InputMaybe<Scalars['Boolean']>;
  printer?: InputMaybe<Scalars['String']>;
  serviceClass: Scalars['String'];
  serviceCode: Scalars['String'];
  serviceCodeDescription: Scalars['String'];
  serviceNote?: InputMaybe<Scalars['String']>;
  stockNumber: Scalars['String'];
  vin: Scalars['String'];
};

export type InspectionType = {
  __typename?: 'InspectionType';
  chargeAmount: Scalars['Float'];
  chargeAmountFail?: Maybe<Scalars['Float']>;
  chargeCode?: Maybe<Scalars['String']>;
  defaultPrinterName?: Maybe<Scalars['String']>;
  longDesc: Scalars['String'];
  ordinal: Scalars['Int'];
  orgId: Scalars['Int'];
  printOnCreate?: Maybe<Scalars['Int']>;
  quickPickLabel?: Maybe<Scalars['String']>;
  quickPickOrdinal: Scalars['Int'];
  serviceClass: Scalars['String'];
  serviceCode: Scalars['String'];
  shortDesc: Scalars['String'];
};

export type InspectionTypeFilter = {
  __typename?: 'InspectionTypeFilter';
  amsServiceCode?: Maybe<Scalars['String']>;
  chargeAmount?: Maybe<Scalars['Int']>;
  orgCode: Scalars['String'];
  serviceProductId?: Maybe<Scalars['Int']>;
};

export type Lane = {
  __typename?: 'Lane';
  arbitration?: Maybe<Scalars['Int']>;
  eventDate?: Maybe<Scalars['String']>;
  hasCr?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  offer?: Maybe<Scalars['Int']>;
  offerOnline?: Maybe<Scalars['Int']>;
  registered?: Maybe<Scalars['Int']>;
  run?: Maybe<Scalars['Int']>;
  sold?: Maybe<Scalars['Int']>;
  soldOnline?: Maybe<Scalars['Int']>;
  units?: Maybe<Scalars['Int']>;
};

export type LaneList = {
  __typename?: 'LaneList';
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Lane>>>;
};


export type LaneListListArgs = {
  pageInfo?: InputMaybe<PageInfo>;
};

export type LightOption = {
  __typename?: 'LightOption';
  amsValue?: Maybe<Scalars['String']>;
  lightCode?: Maybe<Scalars['String']>;
  lightDescription?: Maybe<Scalars['String']>;
  lightId?: Maybe<Scalars['Int']>;
};

export type ListView = {
  __typename?: 'ListView';
  columns?: Maybe<Array<Maybe<ReportColumn>>>;
  mobileColumns?: Maybe<Array<Maybe<ReportColumn>>>;
  paths?: Maybe<PathConfig>;
  shareSubject?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  templateVars?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
};

export type ListViewConfigInput = {
  columns?: InputMaybe<Array<InputMaybe<ReportColumnInput>>>;
  mobileColumns?: InputMaybe<Array<InputMaybe<ReportColumnInput>>>;
  paths?: InputMaybe<PathConfigInput>;
  shareSubject?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type LocalCreateDocumentInput = {
  assetId: Scalars['String'];
  customerId: Scalars['String'];
  docTypeShortCode?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  s3Key: Scalars['String'];
  stockNumber?: InputMaybe<Scalars['String']>;
};

export type LocalCreateDocumentOutput = {
  __typename?: 'LocalCreateDocumentOutput';
  docId: Scalars['String'];
};

export type LocalUploadDocumentInput = {
  assetId?: InputMaybe<Scalars['ID']>;
  docTypeShortCode?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  stockNumber?: InputMaybe<Scalars['Int']>;
};

export type Location = {
  __typename?: 'Location';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type LoginCredentials = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  message?: Maybe<Scalars['String']>;
  result: LoginResponseTypes;
};

export enum LoginResponseTypes {
  Failure = 'FAILURE',
  NewPasswordRequired = 'NEW_PASSWORD_REQUIRED',
  Success = 'SUCCESS'
}

export type MaintenanceDetails = {
  endsAt?: InputMaybe<Scalars['String']>;
  isMaintenanceModeActive: Scalars['Boolean'];
  isPartialMaintenance?: InputMaybe<Scalars['Boolean']>;
  isScheduled?: InputMaybe<Scalars['Boolean']>;
  startsAt?: InputMaybe<Scalars['String']>;
  statusMessage?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MaintenanceUpdateResult = {
  __typename?: 'MaintenanceUpdateResult';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Marketplace = {
  __typename?: 'Marketplace';
  listings?: Maybe<OnlineListings>;
  statistics?: Maybe<MarketplaceStatistics>;
};


export type MarketplaceListingsArgs = {
  filter?: InputMaybe<OnlineListingFilter>;
};

export type MarketplaceStatistics = {
  __typename?: 'MarketplaceStatistics';
  activeListings?: Maybe<Scalars['Int']>;
  soldOnline?: Maybe<Scalars['Int']>;
  viewed?: Maybe<Scalars['Int']>;
  viewedByDate?: Maybe<Array<Maybe<OnlineStatistic>>>;
  watched?: Maybe<Scalars['Int']>;
};


export type MarketplaceStatisticsViewedArgs = {
  dates?: InputMaybe<DateRange>;
};


export type MarketplaceStatisticsViewedByDateArgs = {
  dates?: InputMaybe<DateRange>;
};

export type MessageInput = {
  context?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayName: Scalars['String'];
  displayUrl?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  messageBody?: InputMaybe<Scalars['String']>;
  senderEmail: Scalars['String'];
  senderName: Scalars['String'];
  smsNumber?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stockNumber?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  textHeader?: InputMaybe<Scalars['String']>;
};

export type MutateAccountGroupFilter = {
  accountGroupId?: InputMaybe<Scalars['Int']>;
  accountKey?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addAssetsToVenueEvent?: Maybe<Array<Maybe<MutationResponse>>>;
  addDashboardCard?: Maybe<Scalars['Boolean']>;
  addPastSearch?: Maybe<Scalars['Boolean']>;
  /** @deprecated Moving to `createDocuments`. */
  batchCreateDocument?: Maybe<Array<Maybe<Document>>>;
  beginEditingLayouts: Scalars['Boolean'];
  changeAuction?: Maybe<Scalars['Boolean']>;
  changeDashboardName?: Maybe<Scalars['Boolean']>;
  closeAccessoryDrawer?: Maybe<Scalars['Boolean']>;
  copyDashboard?: Maybe<Scalars['Boolean']>;
  copyDashboardCard?: Maybe<Scalars['Boolean']>;
  createAgentContact?: Maybe<Contact>;
  createDashboard?: Maybe<Scalars['Boolean']>;
  createDocuments?: Maybe<Array<Maybe<CreateDocumentsUploadItem>>>;
  createDocumentsClient?: Maybe<Array<Maybe<LocalCreateDocumentOutput>>>;
  createPSI?: Maybe<OpenPsiResponse>;
  createReportConfig?: Maybe<CreateReportConfigResponse>;
  createUser?: Maybe<UserMutationResponse>;
  createVenueEvent?: Maybe<CreatedEventResponse>;
  deleteAgentContact?: Maybe<Scalars['Boolean']>;
  deleteDashboard?: Maybe<Scalars['Boolean']>;
  deleteDashboardCard?: Maybe<Scalars['Boolean']>;
  deleteUser?: Maybe<UserMutationResponse>;
  deleteVenueEvent?: Maybe<MutationResponse>;
  doCompleteNewPassword?: Maybe<LoginResponse>;
  doLogin?: Maybe<LoginResponse>;
  doLogout?: Maybe<Scalars['Boolean']>;
  doResetPasswordByEmail?: Maybe<ResetPasswordByEmailResponse>;
  endEditingLayouts: Scalars['Boolean'];
  exitVehicle?: Maybe<VehicleAmsResponse>;
  generatePDF?: Maybe<ShareReportResponse>;
  generateUploadUrl: DocumentUploadUrl;
  noSale?: Maybe<VehicleAmsResponse>;
  pullVehicle?: Maybe<VehicleAmsResponse>;
  pushToAMS?: Maybe<PushToAmsResponse>;
  pushVehicleToAms?: Maybe<PushVehicleToAmsResults>;
  pushVehiclesToAms?: Maybe<PushVehiclesToAmsResults>;
  putMessage?: Maybe<SendMessageStatus>;
  registerBidder?: Maybe<RegisterBidderResponse>;
  removeAssetFromVenueEvent?: Maybe<MutationResponse>;
  removeAssetsFromVenueEvent?: Maybe<Array<Maybe<MutationResponse>>>;
  removeDocument?: Maybe<Document>;
  reorderUserDashboards?: Maybe<Scalars['Boolean']>;
  resendUnconfirmedPassword?: Maybe<HttpResponse>;
  resetPasswordByEmail?: Maybe<ResetPasswordByEmailResponse>;
  reverseSale?: Maybe<VehicleAmsResponse>;
  saveLayouts?: Maybe<Scalars['Boolean']>;
  setVehicleInfo?: Maybe<SetVehicleInfoResults>;
  sharePdfCsv: Scalars['Boolean'];
  showAccessoryDrawer?: Maybe<Scalars['Boolean']>;
  tempSaveLayouts?: Maybe<Scalars['Boolean']>;
  updateAgentContact?: Maybe<Contact>;
  updateAgentNote?: Maybe<AgentNoteUpdateResult>;
  updateAgentRoles?: Maybe<AgentRoleUpdateResults>;
  updateAllAssetsOnVenueEvent?: Maybe<UpateAllListingsMutationResponse>;
  updateAssetOnVenueEvent?: Maybe<MutationResponse>;
  updateAssetsOnVenueEvent?: Maybe<Array<Maybe<MutationResponse>>>;
  updateAuctionSettings?: Maybe<AuctionSettingsResponse>;
  updateBIRoles?: Maybe<HttpResponse>;
  updateDashboardCard?: Maybe<Scalars['Boolean']>;
  updateDocTypeShortCode?: Maybe<UpdateDocumentsResponse>;
  updateDocument?: Maybe<Document>;
  updateDocuments?: Maybe<UpdateDocumentsResponse>;
  updateFavoriteAccount?: Maybe<HttpResponse>;
  updateIfOffer?: Maybe<IfOfferUpdateResults>;
  updateMaintenanceStatus?: Maybe<MaintenanceUpdateResult>;
  updateMultipleIfOffers?: Maybe<IfOfferUpdateResults>;
  updateRoles?: Maybe<HttpResponse>;
  updateTenantIdAndCreatedAt?: Maybe<UpdateDocumentsResponse>;
  updateUser?: Maybe<UserMutationResponse>;
  updateVenueEvent?: Maybe<CreatedEventResponse>;
  uploadDocument?: Maybe<Scalars['Boolean']>;
  uploadDocuments?: Maybe<Scalars['Boolean']>;
};


export type MutationAddAssetsToVenueEventArgs = {
  assets?: InputMaybe<Array<InputMaybe<VenueSaleListingAssetInput>>>;
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
};


export type MutationAddDashboardCardArgs = {
  card: Scalars['String'];
  dashId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationAddPastSearchArgs = {
  input: FullSearch;
};


export type MutationBatchCreateDocumentArgs = {
  createDocumentInput: Array<InputMaybe<CreateDocumentInput>>;
};


export type MutationChangeAuctionArgs = {
  newAuction: Scalars['String'];
};


export type MutationChangeDashboardNameArgs = {
  dashId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationCopyDashboardArgs = {
  name: Scalars['String'];
  priorDashId?: InputMaybe<Scalars['String']>;
  priorUserId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationCopyDashboardCardArgs = {
  dashId?: InputMaybe<Scalars['String']>;
  heading?: InputMaybe<Scalars['String']>;
  priorDashId?: InputMaybe<Scalars['String']>;
  priorUserId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  widgetId: Scalars['String'];
};


export type MutationCreateAgentContactArgs = {
  input: CreateAgentContact;
};


export type MutationCreateDashboardArgs = {
  name: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateDocumentsArgs = {
  assets?: InputMaybe<Array<InputMaybe<CreateDocumentsInputAsset>>>;
  auctionId: Scalars['String'];
};


export type MutationCreateDocumentsClientArgs = {
  docs: Array<LocalCreateDocumentInput>;
};


export type MutationCreatePsiArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<Array<InputMaybe<InspectionInput>>>;
};


export type MutationCreateReportConfigArgs = {
  input?: InputMaybe<CreateReportConfigInput>;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateVenueEventArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  newVenueEvent?: InputMaybe<CreateVenueEvent>;
};


export type MutationDeleteAgentContactArgs = {
  id: Scalars['Int'];
  input: DeleteAgentContact;
};


export type MutationDeleteDashboardArgs = {
  dashId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteDashboardCardArgs = {
  cardId: Scalars['String'];
  dashId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationDeleteVenueEventArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationDoCompleteNewPasswordArgs = {
  newPassword: Scalars['String'];
};


export type MutationDoLoginArgs = {
  credentials: LoginCredentials;
};


export type MutationDoResetPasswordByEmailArgs = {
  email: Scalars['String'];
};


export type MutationExitVehicleArgs = {
  exitVehicleDetails: ExitVehicleRequest;
};


export type MutationGeneratePdfArgs = {
  input?: InputMaybe<GeneratePdfInput>;
};


export type MutationGenerateUploadUrlArgs = {
  assetId: Scalars['ID'];
};


export type MutationNoSaleArgs = {
  noSaleDetails: NoSaleRequest;
};


export type MutationPullVehicleArgs = {
  pullVehicleDetails: PullVehicleRequest;
};


export type MutationPushToAmsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationPushVehicleToAmsArgs = {
  id: Scalars['ID'];
};


export type MutationPushVehiclesToAmsArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationPutMessageArgs = {
  input?: InputMaybe<MessageInput>;
};


export type MutationRegisterBidderArgs = {
  bidderDetails: RegisterBidderDetails;
};


export type MutationRemoveAssetFromVenueEventArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  venueAssetId?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveAssetsFromVenueEventArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  venueAssetIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationRemoveDocumentArgs = {
  docId: Scalars['String'];
};


export type MutationReorderUserDashboardsArgs = {
  id: Scalars['String'];
  index: Scalars['Int'];
};


export type MutationResendUnconfirmedPasswordArgs = {
  input: ResendUnconfirmedPasswordInput;
};


export type MutationResetPasswordByEmailArgs = {
  input: ResetPasswordByEmailInput;
};


export type MutationReverseSaleArgs = {
  reverseSaleDetails: ReverseSaleRequest;
};


export type MutationSaveLayoutsArgs = {
  dashId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationSetVehicleInfoArgs = {
  amsType: Scalars['String'];
  announcements?: InputMaybe<Array<InputMaybe<SetAnnouncements>>>;
  assetId: Scalars['ID'];
  cancelProxyBids?: InputMaybe<Scalars['Boolean']>;
  expectedAnnouncements?: InputMaybe<Array<InputMaybe<ExpectedAnnouncement>>>;
  floor: Scalars['Int'];
  numberOfProxyBids?: InputMaybe<Scalars['Int']>;
  selectedLightId: Scalars['Int'];
  stockNumber: Scalars['String'];
};


export type MutationSharePdfCsvArgs = {
  displayName?: InputMaybe<Scalars['String']>;
  displayUrl?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  messageBody: Scalars['String'];
  senderEmail: Scalars['String'];
  senderName: Scalars['String'];
  smsNumber?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subject?: InputMaybe<Scalars['String']>;
  textHeader?: InputMaybe<Scalars['String']>;
};


export type MutationShowAccessoryDrawerArgs = {
  input: AccessoryDrawerDisplay;
};


export type MutationTempSaveLayoutsArgs = {
  layouts: Scalars['String'];
};


export type MutationUpdateAgentContactArgs = {
  id: Scalars['Int'];
  input: UpdateAgentContact;
};


export type MutationUpdateAgentNoteArgs = {
  agentNoteUpdate?: InputMaybe<AgentNoteUpdate>;
};


export type MutationUpdateAgentRolesArgs = {
  agentRoleUpdate?: InputMaybe<AgentRoleUpdate>;
};


export type MutationUpdateAllAssetsOnVenueEventArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  updateMethods?: InputMaybe<Array<InputMaybe<UpdateAllVenueAssets>>>;
};


export type MutationUpdateAssetOnVenueEventArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  venueSaleListing?: InputMaybe<VenueSaleListingAssetInput>;
};


export type MutationUpdateAssetsOnVenueEventArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  venueSaleListings?: InputMaybe<Array<InputMaybe<VenueSaleListingAssetInput>>>;
};


export type MutationUpdateAuctionSettingsArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  auctionSettingsInput?: InputMaybe<AuctionSettingsInput>;
};


export type MutationUpdateBiRolesArgs = {
  orgCode?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Scalars['String']>;
  subjectUserId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateDashboardCardArgs = {
  card: Scalars['String'];
  cardId: Scalars['String'];
  dashId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateDocTypeShortCodeArgs = {
  tenantId: Scalars['String'];
};


export type MutationUpdateDocumentArgs = {
  updateDocumentInput: UpdateDocumentInput;
};


export type MutationUpdateDocumentsArgs = {
  tenantId: Scalars['String'];
};


export type MutationUpdateFavoriteAccountArgs = {
  input?: InputMaybe<UpdateFavoritesInput>;
};


export type MutationUpdateIfOfferArgs = {
  ifOfferDetails?: InputMaybe<IfOfferDetails>;
};


export type MutationUpdateMaintenanceStatusArgs = {
  maintenanceDetails?: InputMaybe<MaintenanceDetails>;
};


export type MutationUpdateMultipleIfOffersArgs = {
  ifOfferDetails?: InputMaybe<Array<InputMaybe<IfOfferDetails>>>;
};


export type MutationUpdateRolesArgs = {
  input: UpdateRoles;
};


export type MutationUpdateTenantIdAndCreatedAtArgs = {
  tenantId: Scalars['String'];
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateVenueEventArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  newVenueEvent?: InputMaybe<CreateVenueEvent>;
};


export type MutationUploadDocumentArgs = {
  input: LocalUploadDocumentInput;
};


export type MutationUploadDocumentsArgs = {
  docs: Array<LocalUploadDocumentInput>;
};

export type MutationDataResponse = VenueEvent | VenueSaleListingAsset;

export type MutationResponse = SparkResponse & {
  __typename?: 'MutationResponse';
  data?: Maybe<MutationDataResponse>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type NoSaleHistory = {
  __typename?: 'NoSaleHistory';
  eventDate?: Maybe<Scalars['String']>;
  hasRun?: Maybe<Scalars['Boolean']>;
  highBid?: Maybe<Scalars['Int']>;
  lane?: Maybe<Scalars['String']>;
  lot?: Maybe<Scalars['String']>;
};

export type NoSaleRequest = {
  floorPrice?: InputMaybe<Scalars['Float']>;
  noSaleFlag: Scalars['Boolean'];
  orgCode?: InputMaybe<Scalars['String']>;
  saleDate?: InputMaybe<Scalars['String']>;
  salePrice?: InputMaybe<Scalars['Float']>;
  stockNumber: Scalars['Int'];
  vin: Scalars['String'];
};

export type NumberRange = {
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
};

export type OnlineListing = {
  __typename?: 'OnlineListing';
  assetId?: Maybe<Scalars['ID']>;
  make?: Maybe<Scalars['String']>;
  mmrValuation?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  stockNumber?: Maybe<Scalars['String']>;
  vdpUri?: Maybe<Scalars['String']>;
  watchCount?: Maybe<Scalars['Int']>;
  watchers?: Maybe<Array<Maybe<Watcher>>>;
  webViews?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['String']>;
};

export type OnlineListingFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  saleDate?: InputMaybe<DateRange>;
  sold?: InputMaybe<Scalars['Boolean']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
  watched?: InputMaybe<Scalars['Boolean']>;
};

export type OnlineListings = {
  __typename?: 'OnlineListings';
  byAssetId?: Maybe<OnlineListing>;
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<OnlineListing>>>;
};


export type OnlineListingsListArgs = {
  pageInfo?: InputMaybe<PageInfo>;
};

export type OnlineStatistic = {
  __typename?: 'OnlineStatistic';
  count: Scalars['Int'];
  date: Scalars['String'];
};

export type OpenPsiResponse = {
  __typename?: 'OpenPsiResponse';
  message?: Maybe<Scalars['String']>;
  responseCode?: Maybe<Scalars['Int']>;
  serviceResponses?: Maybe<Array<Maybe<ServiceResponse>>>;
};

export type Organization = {
  __typename?: 'Organization';
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  groupOrgId?: Maybe<Scalars['Int']>;
  isAEAdmin?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isAuctionUser?: Maybe<Scalars['Boolean']>;
  isCorporateGroupUser?: Maybe<Scalars['Boolean']>;
  lastUpdated?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['String']>;
  orgNumber?: Maybe<Scalars['Int']>;
  orgTypeCode?: Maybe<Scalars['String']>;
  sites?: Maybe<Array<Maybe<Site>>>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type OrganizationInput = {
  isAdmin: Scalars['Boolean'];
  isEnabled: Scalars['Boolean'];
  orgId: Scalars['String'];
};

export type PageInfo = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PageInfoConfig = {
  __typename?: 'PageInfoConfig';
  csvMaxRows?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  overRidePageLimit?: Maybe<Scalars['Boolean']>;
  sortColumns?: Maybe<Array<Maybe<SortColumn>>>;
};

export type PageInfoConfigInput = {
  csvMaxRows?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  overRidePageLimit?: InputMaybe<Scalars['Boolean']>;
  sortColumns?: InputMaybe<Array<InputMaybe<SortColumnInput>>>;
};

export type PaginatedDocumentResponse = {
  __typename?: 'PaginatedDocumentResponse';
  itemCount?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<Document>>>;
  nextToken?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaginationControls = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
};

export type PastSale = {
  __typename?: 'PastSale';
  assetId?: Maybe<Scalars['ID']>;
  buyerAccountId?: Maybe<Scalars['Int']>;
  buyerDisplayName?: Maybe<Scalars['String']>;
  closedDate?: Maybe<Scalars['String']>;
  dealHistory?: Maybe<Array<Maybe<IfOfferHistory>>>;
  dealId?: Maybe<Scalars['Int']>;
  dealOutcome?: Maybe<Scalars['String']>;
  dealStatus?: Maybe<Scalars['String']>;
  eventClassCode?: Maybe<Scalars['String']>;
  eventClassName?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['String']>;
  hasRun?: Maybe<Scalars['Boolean']>;
  highBid?: Maybe<Scalars['Int']>;
  lane?: Maybe<Scalars['String']>;
  lastCounter?: Maybe<Scalars['Int']>;
  lastCounterBy?: Maybe<Scalars['String']>;
  lot?: Maybe<Scalars['String']>;
  noSold?: Maybe<Scalars['Boolean']>;
  rejectedBy?: Maybe<Scalars['String']>;
  saleListingId?: Maybe<Scalars['Int']>;
  soldAmount?: Maybe<Scalars['Int']>;
  venueCode?: Maybe<Scalars['String']>;
  venueEventTitle?: Maybe<Scalars['String']>;
  venueName?: Maybe<Scalars['String']>;
};

export type PastSearch = {
  __typename?: 'PastSearch';
  displayName?: Maybe<Scalars['String']>;
  filterName?: Maybe<Scalars['String']>;
  searchName?: Maybe<Scalars['String']>;
};

export type PathConfig = {
  __typename?: 'PathConfig';
  countPath?: Maybe<Scalars['String']>;
  listPath?: Maybe<Scalars['String']>;
};

export type PathConfigInput = {
  countPath?: InputMaybe<Scalars['String']>;
  listPath?: InputMaybe<Scalars['String']>;
};

export type PdfColumn = {
  Header?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type PdfRow = {
  account?: InputMaybe<Scalars['String']>;
  odometer?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  vehicle?: InputMaybe<Scalars['String']>;
};

export enum PendingSuccess {
  False = 'FALSE',
  Pending = 'PENDING',
  True = 'TRUE'
}

export type PermissionItem = {
  __typename?: 'PermissionItem';
  description?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
};

export type Photo = {
  __typename?: 'Photo';
  fileName?: Maybe<Scalars['String']>;
  hiresUrl?: Maybe<Scalars['String']>;
  imageUri_60x50?: Maybe<Scalars['String']>;
  imageUri_70x53?: Maybe<Scalars['String']>;
  imageUri_100x75?: Maybe<Scalars['String']>;
  imageUri_200x150?: Maybe<Scalars['String']>;
  imageUri_220x165?: Maybe<Scalars['String']>;
  imageUri_300x231?: Maybe<Scalars['String']>;
  imageUri_320x240?: Maybe<Scalars['String']>;
  imageUri_400x300?: Maybe<Scalars['String']>;
  imageUri_480x360?: Maybe<Scalars['String']>;
  imageUri_480x480?: Maybe<Scalars['String']>;
  imageUri_640x480?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  pipelineUri?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  standardUrl?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
};

export type Profile = {
  __typename?: 'Profile';
  authenticationId: Scalars['String'];
  dashboards?: Maybe<Array<Scalars['String']>>;
  databaseId: Scalars['Int'];
  email: Scalars['String'];
  familyName: Scalars['String'];
  isAdmin: Scalars['Boolean'];
  mobilePhone?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  roles?: Maybe<Array<RoleAttributes>>;
  userId: Scalars['String'];
  username: Scalars['String'];
};

export type Psi = {
  __typename?: 'Psi';
  inspectionTypes?: Maybe<Array<Maybe<InspectionType>>>;
};


export type PsiInspectionTypesArgs = {
  pageInfo?: InputMaybe<PageInfo>;
};

export type PsiFilter = {
  accountId?: InputMaybe<Scalars['String']>;
  agentId?: InputMaybe<Scalars['String']>;
  orgCode: Scalars['String'];
};

export type PsiNote = {
  __typename?: 'PsiNote';
  agentId?: Maybe<Scalars['Int']>;
  agentName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  noteText?: Maybe<Scalars['String']>;
  noteType?: Maybe<Scalars['String']>;
  sparkUser?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type PullVehicleRequest = {
  orgCode?: InputMaybe<Scalars['String']>;
  stockNumber: Scalars['Int'];
  vin: Scalars['String'];
};

export type PushVehicleToAmsResults = {
  __typename?: 'PushVehicleToAmsResults';
  message?: Maybe<Scalars['String']>;
  stockNumber?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type PushVehiclesToAmsResults = {
  __typename?: 'PushVehiclesToAmsResults';
  results?: Maybe<Array<Maybe<SinglePushVehicleToAmsResult>>>;
};

export type Query = {
  __typename?: 'Query';
  accessoryDrawerState?: Maybe<AccessoryDrawerDisplay>;
  activeOrganization: Organization;
  adminUserAttributes: UserAttributes;
  administrator?: Maybe<Administrator>;
  auction?: Maybe<Auction>;
  auctionCollection?: Maybe<Auction>;
  dashboardReflowTrigger?: Maybe<Scalars['Float']>;
  dashboards: Array<Scalars['String']>;
  documentTypes: Array<DocType>;
  getAgentByAuctionAccess?: Maybe<QueryAgentResponse>;
  getVenueEvent?: Maybe<QueryResponse>;
  getVenueEventRunList?: Maybe<QueryRunListResponse>;
  getVenueEvents?: Maybe<QueryEventsListResponse>;
  isEditingLayouts: Scalars['Boolean'];
  layouts: Scalars['String'];
  passwordRecoveryEmail: Scalars['String'];
  pastSearches?: Maybe<Array<Maybe<PastSearch>>>;
  profile?: Maybe<Profile>;
  roles: Array<RoleAttributes>;
  tempLayouts: Scalars['String'];
  user?: Maybe<User>;
};


export type QueryAdminUserAttributesArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryAuctionArgs = {
  amsId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stockNumber?: InputMaybe<Scalars['String']>;
};


export type QueryAuctionCollectionArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryDashboardsArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryGetAgentByAuctionAccessArgs = {
  auctionAccessId?: InputMaybe<Scalars['String']>;
  auctionId?: InputMaybe<Scalars['String']>;
  dealerId?: InputMaybe<Scalars['String']>;
};


export type QueryGetVenueEventArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
};


export type QueryGetVenueEventRunListArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<RunListFilter>;
  pagination?: InputMaybe<PaginationControls>;
};


export type QueryGetVenueEventsArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<EventsListFilter>;
  pagination?: InputMaybe<PaginationControls>;
};

export type QueryAgentResponse = SparkResponse & {
  __typename?: 'QueryAgentResponse';
  data?: Maybe<AgentDealerResponse>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type QueryEventsListResponse = SparkResponse & {
  __typename?: 'QueryEventsListResponse';
  data?: Maybe<Array<Maybe<VenueEvent>>>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
  totalCount?: Maybe<Scalars['Int']>;
};

export type QueryResponse = SparkResponse & {
  __typename?: 'QueryResponse';
  data?: Maybe<VenueEvent>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type QueryRunListResponse = SparkPaginatedResponse & {
  __typename?: 'QueryRunListResponse';
  data?: Maybe<Array<Maybe<VenueSaleListingAsset>>>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
  totalCount?: Maybe<Scalars['Int']>;
};

export type RegisterBidderDetails = {
  bidderAA?: InputMaybe<Scalars['String']>;
  dealerAA?: InputMaybe<Scalars['String']>;
  orgCode?: InputMaybe<Scalars['String']>;
  saleListingKey?: InputMaybe<Scalars['String']>;
};

export type RegisterBidderResponse = {
  __typename?: 'RegisterBidderResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export type Report = {
  __typename?: 'Report';
  auctionType?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Int']>;
  longDescription?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['Int']>;
  reportId?: Maybe<Scalars['Int']>;
  reportLongName?: Maybe<Scalars['String']>;
  reportShortName?: Maybe<Scalars['String']>;
  reportUrl?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type ReportColumn = {
  __typename?: 'ReportColumn';
  header?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type ReportColumnInput = {
  header?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type ReportConfig = {
  __typename?: 'ReportConfig';
  PK?: Maybe<Scalars['String']>;
  SK?: Maybe<Scalars['String']>;
  auctionId?: Maybe<Scalars['String']>;
  cardViewConfig?: Maybe<ListView>;
  dataConfig?: Maybe<DataConfig>;
  defaultSource?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  listViewConfig?: Maybe<ListView>;
  pdfViewConfig?: Maybe<ListView>;
  reportKey?: Maybe<Scalars['String']>;
  scope?: Maybe<Array<Maybe<Scalars['String']>>>;
  searchResults?: Maybe<ConfigSearchResults>;
  userId?: Maybe<Scalars['String']>;
};

export type ReportDateOffset = {
  __typename?: 'ReportDateOffset';
  end?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
};

export type ReportDetailPage = {
  __typename?: 'ReportDetailPage';
  displayName: Scalars['String'];
  name: Scalars['String'];
  requiredRoles?: Maybe<Array<Scalars['String']>>;
  url: Scalars['String'];
};

export type ReportFilter = {
  auctionType?: InputMaybe<Scalars['String']>;
};

export type ReportSearchFilter = {
  __typename?: 'ReportSearchFilter';
  dataQuery?: Maybe<Scalars['String']>;
  dateOffset?: Maybe<ReportDateOffset>;
  forFollowup?: Maybe<Scalars['String']>;
  searchString?: Maybe<Scalars['String']>;
  searchType?: Maybe<Search_Types>;
  statusCode?: Maybe<Scalars['String']>;
  watched?: Maybe<Scalars['Boolean']>;
};

export type ResendUnconfirmedPasswordInput = {
  admin?: InputMaybe<AdminInputSub>;
  auctionId?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type ResetPasswordByEmailInput = {
  email: Scalars['String'];
};

export type ResetPasswordByEmailResponse = {
  __typename?: 'ResetPasswordByEmailResponse';
  statusCode: Scalars['Int'];
  statusMessage: Scalars['String'];
  userEmail: Scalars['String'];
};

export type ReverseSaleRequest = {
  orgCode?: InputMaybe<Scalars['String']>;
  saleDate?: InputMaybe<Scalars['String']>;
  stockNumber: Scalars['Int'];
  vin: Scalars['String'];
};

export type Role = {
  __typename?: 'Role';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type RoleAttributes = {
  __typename?: 'RoleAttributes';
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type RunListFilter = {
  text?: InputMaybe<Scalars['String']>;
};

export enum Search_Sort_Types {
  AgentPurchasesByDate = 'AGENT_PURCHASES_BY_DATE',
  BuyerAccount = 'BUYER_ACCOUNT',
  BuyerAgent = 'BUYER_AGENT',
  CheckIn = 'CHECK_IN',
  DaysOnLot = 'DAYS_ON_LOT',
  IfOfferCreatedDate = 'IF_OFFER_CREATED_DATE',
  MakeModelYear = 'MAKE_MODEL_YEAR',
  Odometer = 'ODOMETER',
  RanAt = 'RAN_AT',
  RunNumber = 'RUN_NUMBER',
  SaleDateLaneLot = 'SALE_DATE_LANE_LOT',
  SaleDateLastRanTime = 'SALE_DATE_LAST_RAN_TIME',
  SellerAccount = 'SELLER_ACCOUNT',
  SellerMakeModelYear = 'SELLER_MAKE_MODEL_YEAR',
  SoldDateLastRanTime = 'SOLD_DATE_LAST_RAN_TIME',
  StockLotDays = 'STOCK_LOT_DAYS',
  Year = 'YEAR',
  YearMakeModel = 'YEAR_MAKE_MODEL'
}

export enum Search_Types {
  Bidders = 'BIDDERS',
  Broad = 'BROAD',
  Company = 'COMPANY',
  ContactLogs = 'CONTACT_LOGS',
  OnlineListing = 'ONLINE_LISTING',
  Vehicles = 'VEHICLES',
  VehiclesByBuyers = 'VEHICLES_BY_BUYERS',
  VehiclesByCompany = 'VEHICLES_BY_COMPANY',
  VehiclesStats = 'VEHICLES_STATS'
}

export enum Sort_Direction {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SaleEvent = {
  __typename?: 'SaleEvent';
  buyerAgentAaNum?: Maybe<Scalars['String']>;
  buyerAgentStatusCode?: Maybe<Scalars['String']>;
  buyerName?: Maybe<Scalars['String']>;
  buyerOrgAaNum?: Maybe<Scalars['String']>;
  buyerOrgStatusCode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  dealSaleAmt?: Maybe<Scalars['Int']>;
  dealStatus?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['String']>;
  eventEndTs?: Maybe<Scalars['String']>;
  eventEndedAtTs?: Maybe<Scalars['String']>;
  eventStartTs?: Maybe<Scalars['String']>;
  eventTitle?: Maybe<Scalars['String']>;
  floorPrice?: Maybe<Scalars['Int']>;
  lane?: Maybe<Scalars['String']>;
  lotNumber?: Maybe<Scalars['String']>;
  saleListingKey?: Maybe<Scalars['String']>;
  saleListingStatus?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  venueEventKey?: Maybe<Scalars['String']>;
  venueEventTypeCode?: Maybe<Scalars['String']>;
};

export type SaleListing = {
  __typename?: 'SaleListing';
  buyerAgentEmail?: Maybe<Scalars['String']>;
  buyerAgentId?: Maybe<Scalars['Int']>;
  buyerAgentName?: Maybe<Scalars['String']>;
  buyerAgentNotes?: Maybe<Scalars['String']>;
  buyerAgentPhoneMobile?: Maybe<Scalars['String']>;
  buyerAgentPicture?: Maybe<Scalars['String']>;
  hasRun?: Maybe<Scalars['Boolean']>;
  lane?: Maybe<Scalars['String']>;
  listingCondition?: Maybe<Scalars['String']>;
  lot?: Maybe<Scalars['String']>;
  saleDate?: Maybe<Scalars['String']>;
  saleListingDealSoldAt?: Maybe<Scalars['String']>;
  saleListingOfferCreatedAt?: Maybe<Scalars['String']>;
  saleMethod?: Maybe<Scalars['String']>;
  saleStatus?: Maybe<Scalars['String']>;
  sellerAgentEmail?: Maybe<Scalars['String']>;
  sellerAgentId?: Maybe<Scalars['Int']>;
  sellerAgentName?: Maybe<Scalars['String']>;
  sellerAgentPhoneMobile?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  soldDateLastRanTime?: Maybe<Scalars['String']>;
  venueCode?: Maybe<Scalars['String']>;
  venueName?: Maybe<Scalars['String']>;
  venueUrl?: Maybe<Scalars['String']>;
};

export type SalesDayStatistics = {
  __typename?: 'SalesDayStatistics';
  checkedIn?: Maybe<Scalars['Int']>;
  checkedInToday?: Maybe<Scalars['Int']>;
  missingCRs?: Maybe<Scalars['Int']>;
  needsPhotos?: Maybe<Scalars['Int']>;
  run?: Maybe<Scalars['Int']>;
  sold?: Maybe<Scalars['Int']>;
  units?: Maybe<Scalars['Int']>;
};

export type SearchAccount = {
  __typename?: 'SearchAccount';
  accountId?: Maybe<Scalars['String']>;
  accountKey?: Maybe<Scalars['String']>;
  accountLegacyType?: Maybe<Scalars['String']>;
  accountSalesRep?: Maybe<Scalars['String']>;
  auctionAccess?: Maybe<Scalars['String']>;
  canBuy?: Maybe<Scalars['Boolean']>;
  canSell?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  dbaName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  establishedAt?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isFavorite?: Maybe<Scalars['Boolean']>;
  lastAttendedAt?: Maybe<Scalars['String']>;
  lastBoughtAt?: Maybe<Scalars['String']>;
  lastSoldAt?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  searchScore?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type SearchAgent = {
  __typename?: 'SearchAgent';
  accountKey?: Maybe<Scalars['String']>;
  accountSalesRep?: Maybe<Scalars['String']>;
  agentId?: Maybe<Scalars['String']>;
  auctionAccess?: Maybe<Scalars['String']>;
  cellPhone?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  dbaName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastAttendBadgeIssuedAt?: Maybe<Scalars['String']>;
  lastAttendBadgeNum?: Maybe<Scalars['String']>;
  lastAttendBidderType?: Maybe<Scalars['String']>;
  lastAttendDate?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  searchScore?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  workPhone?: Maybe<Scalars['String']>;
};

export type SearchBidder = {
  __typename?: 'SearchBidder';
  BadgeIssuedAt?: Maybe<Scalars['String']>;
  BadgeNum?: Maybe<Scalars['String']>;
  BidderType?: Maybe<Scalars['String']>;
  agentId?: Maybe<Scalars['String']>;
  auctionAccess?: Maybe<Scalars['String']>;
  cellPhone?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  consignor?: Maybe<Scalars['String']>;
  consignorId?: Maybe<Scalars['String']>;
  consignorLegacyId?: Maybe<Scalars['String']>;
  consignorLegacyType?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  searchScore?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  vehiclesPurchasedCount?: Maybe<Scalars['Int']>;
  workPhone?: Maybe<Scalars['String']>;
};

export type SearchConfigInput = {
  pageInfo?: InputMaybe<PageInfoConfigInput>;
  searchString?: InputMaybe<Scalars['String']>;
  searchType?: InputMaybe<Search_Types>;
  subtitle?: InputMaybe<Scalars['String']>;
};

export type SearchContactLog = {
  __typename?: 'SearchContactLog';
  accountAuctionAccess?: Maybe<Scalars['String']>;
  accountDisplayName?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  accountKey?: Maybe<Scalars['String']>;
  agentId?: Maybe<Scalars['String']>;
  agentName?: Maybe<Scalars['String']>;
  auctionCode?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['String']>;
  completedBy?: Maybe<Scalars['String']>;
  completedEmail?: Maybe<Scalars['String']>;
  completedFullName?: Maybe<Scalars['String']>;
  completedUserid?: Maybe<Scalars['String']>;
  completedUsername?: Maybe<Scalars['String']>;
  contactedAt?: Maybe<Scalars['String']>;
  creatorEmail?: Maybe<Scalars['String']>;
  creatorFullName?: Maybe<Scalars['String']>;
  creatorUserid?: Maybe<Scalars['String']>;
  creatorUsername?: Maybe<Scalars['String']>;
  followUpDate?: Maybe<Scalars['String']>;
  followUpUserId?: Maybe<Scalars['String']>;
  followupAt?: Maybe<Scalars['String']>;
  followupEmail?: Maybe<Scalars['String']>;
  followupFullName?: Maybe<Scalars['String']>;
  followupUserid?: Maybe<Scalars['String']>;
  followupUsername?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['String']>;
  typeCode?: Maybe<Scalars['String']>;
  update?: Maybe<Scalars['String']>;
};

export type SearchFilter = {
  createCSV?: InputMaybe<Scalars['Boolean']>;
  searchString: Scalars['String'];
  type?: InputMaybe<Search_Types>;
  useSQL?: InputMaybe<Scalars['Boolean']>;
};

export type SearchPageInfo = {
  aggrSortOrder?: InputMaybe<Sort_Direction>;
  aggrSortType?: InputMaybe<Aggr_Search_Sort_Types>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortColumns?: InputMaybe<Array<InputMaybe<SortColumnInput>>>;
  sortOrder?: InputMaybe<Sort_Direction>;
  sortType?: InputMaybe<Search_Sort_Types>;
  top?: InputMaybe<Scalars['Int']>;
};

export type SearchResults = {
  __typename?: 'SearchResults';
  accountCount?: Maybe<Scalars['Int']>;
  accountResult?: Maybe<Array<Maybe<SearchAccount>>>;
  agentCount?: Maybe<Scalars['Int']>;
  agentResult?: Maybe<Array<Maybe<SearchAgent>>>;
  bidderCount?: Maybe<Scalars['Int']>;
  bidderResult?: Maybe<Array<Maybe<SearchBidder>>>;
  contactLogCount?: Maybe<Scalars['Int']>;
  contactLogResult?: Maybe<Array<Maybe<SearchContactLog>>>;
  contactLogStats?: Maybe<ContactLogStats>;
  searchStringDisplay?: Maybe<Scalars['String']>;
  searchStringJson?: Maybe<Scalars['String']>;
  searchType?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
  vehicleCount?: Maybe<Scalars['Int']>;
  vehicleInSaleCount?: Maybe<Scalars['Int']>;
  vehicleInSaleResult?: Maybe<Array<Maybe<SearchVehicle>>>;
  vehicleRecentlySoldCount?: Maybe<Scalars['Int']>;
  vehicleRecentlySoldResult?: Maybe<Array<Maybe<SearchVehicle>>>;
  vehicleResult?: Maybe<Array<Maybe<SearchVehicle>>>;
  vehicleResultCsvUrl?: Maybe<Scalars['String']>;
  vehicleStats?: Maybe<VehicleStats>;
  vehicleStatsByCompany?: Maybe<Array<Maybe<VehicleStatsByCompany>>>;
};

export type SearchSort = {
  favorites?: InputMaybe<Scalars['Boolean']>;
};

export type SearchVehicle = {
  __typename?: 'SearchVehicle';
  accountSalesRep?: Maybe<Scalars['String']>;
  allCurrentSales?: Maybe<Array<Maybe<CurrentSale>>>;
  announcementFour?: Maybe<Scalars['String']>;
  announcementLight?: Maybe<Scalars['String']>;
  announcementOne?: Maybe<Scalars['String']>;
  announcementThree?: Maybe<Scalars['String']>;
  announcementTwo?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['ID']>;
  ballControlCode?: Maybe<Scalars['String']>;
  buyer?: Maybe<Scalars['String']>;
  buyerAccountKey?: Maybe<Scalars['String']>;
  buyerAgentAaNum?: Maybe<Scalars['String']>;
  buyerAgentBadge?: Maybe<Scalars['String']>;
  buyerAgentEmail?: Maybe<Scalars['String']>;
  buyerAgentId?: Maybe<Scalars['String']>;
  buyerAgentName?: Maybe<Scalars['String']>;
  buyerAgentPhoneMobile?: Maybe<Scalars['String']>;
  buyerAgentStatusCode?: Maybe<Scalars['String']>;
  buyerAuctionAccess?: Maybe<Scalars['String']>;
  buyerAuctionRep?: Maybe<Scalars['String']>;
  buyerCity?: Maybe<Scalars['String']>;
  buyerDisplayName?: Maybe<Scalars['String']>;
  buyerId?: Maybe<Scalars['String']>;
  buyerLegacyId?: Maybe<Scalars['String']>;
  buyerLegacyType?: Maybe<Scalars['String']>;
  buyerOrgAaNum?: Maybe<Scalars['String']>;
  buyerOrgStatusCode?: Maybe<Scalars['String']>;
  buyerState?: Maybe<Scalars['String']>;
  checkedInAt?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  consignor?: Maybe<Scalars['String']>;
  consignorAuctionAccess?: Maybe<Scalars['String']>;
  consignorId?: Maybe<Scalars['String']>;
  consignorLegacyId?: Maybe<Scalars['String']>;
  consignorLegacyType?: Maybe<Scalars['String']>;
  consignorStockNumber?: Maybe<Scalars['String']>;
  daysOnLot?: Maybe<Scalars['String']>;
  dealCurrentOfferAmount?: Maybe<Scalars['String']>;
  dealNote?: Maybe<Scalars['String']>;
  floorAmount?: Maybe<Scalars['String']>;
  hasCr?: Maybe<Scalars['String']>;
  hasTitle?: Maybe<Scalars['String']>;
  isNew?: Maybe<Scalars['String']>;
  lane?: Maybe<Scalars['String']>;
  latestNegotiationBuyerSellerAccountId?: Maybe<Scalars['String']>;
  latestNegotiationDealBuyerAccountDisplayName?: Maybe<Scalars['String']>;
  latestNegotiationDealBuyerAgentName?: Maybe<Scalars['String']>;
  latestNegotiationDealSoldAt?: Maybe<Scalars['String']>;
  latestNegotiationEventDealCurrentOfferAmount?: Maybe<Scalars['String']>;
  latestNegotiationIsOpen?: Maybe<Scalars['String']>;
  latestNegotiationLastEventCreatedAt?: Maybe<Scalars['String']>;
  latestNegotiationStatus?: Maybe<Scalars['String']>;
  latestNegotiationStatusCode?: Maybe<Scalars['String']>;
  lot?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  odometer?: Maybe<Scalars['String']>;
  orgCode?: Maybe<Scalars['String']>;
  photoCount?: Maybe<Scalars['String']>;
  pipelineUri?: Maybe<Scalars['String']>;
  proxyWon?: Maybe<Scalars['String']>;
  psiAmsPrinterName?: Maybe<Scalars['String']>;
  psiAmsServiceResultCode?: Maybe<Scalars['String']>;
  psiChargeAmount?: Maybe<Scalars['Int']>;
  psiCreatedAt?: Maybe<Scalars['String']>;
  psiLongDesc?: Maybe<Scalars['String']>;
  psiNotes?: Maybe<Scalars['String']>;
  psiOrderedAt?: Maybe<Scalars['String']>;
  psiOrderedByAmsUser?: Maybe<Scalars['String']>;
  psiOrderedBySparkAuthenticationUsername?: Maybe<Scalars['String']>;
  psiOrderedBySparkUserId?: Maybe<Scalars['Int']>;
  psiRackPrice?: Maybe<Scalars['String']>;
  psiRequested?: Maybe<Scalars['String']>;
  psiResultBySparkAuthenticationUsername?: Maybe<Scalars['String']>;
  psiServiceCode?: Maybe<Scalars['String']>;
  psiShortDesc?: Maybe<Scalars['String']>;
  psiStatusCode?: Maybe<Scalars['String']>;
  ranAt?: Maybe<Scalars['String']>;
  ranCount?: Maybe<Scalars['String']>;
  run?: Maybe<Scalars['String']>;
  runPadded?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['String']>;
  saleDate?: Maybe<Scalars['String']>;
  saleDateLastRanTime?: Maybe<Scalars['String']>;
  saleListingKey?: Maybe<Scalars['String']>;
  saleMethod?: Maybe<Scalars['String']>;
  saleType?: Maybe<Scalars['String']>;
  searchScore?: Maybe<Scalars['String']>;
  sellerAccountKey?: Maybe<Scalars['String']>;
  sellerAgentEmail?: Maybe<Scalars['String']>;
  sellerAgentId?: Maybe<Scalars['String']>;
  sellerAgentName?: Maybe<Scalars['String']>;
  sellerAgentPhoneMobile?: Maybe<Scalars['String']>;
  sellerAuctionRep?: Maybe<Scalars['String']>;
  sellerDisplayName?: Maybe<Scalars['String']>;
  soldDateLastRanTime?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  sourceSystemKey?: Maybe<Scalars['String']>;
  sourceType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  stockNumber?: Maybe<Scalars['String']>;
  thumbUrl?: Maybe<Scalars['String']>;
  typeCode?: Maybe<Scalars['String']>;
  venueCode?: Maybe<Scalars['String']>;
  venueName?: Maybe<Scalars['String']>;
  venueUrl?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type Service = {
  __typename?: 'Service';
  AssetServiceStatusId?: Maybe<Scalars['String']>;
  amsChargeCode?: Maybe<Scalars['String']>;
  amsPrinterName?: Maybe<Scalars['String']>;
  amsServiceProductCode?: Maybe<Scalars['String']>;
  amsServiceResultCode?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['ID']>;
  chargeAmount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  dealId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  organizationServiceProductId?: Maybe<Scalars['String']>;
  serviceClassCode?: Maybe<Scalars['String']>;
  serviceOrderedAt?: Maybe<Scalars['String']>;
  serviceOrderedByAmsUser?: Maybe<Scalars['String']>;
  serviceOrderedByPipelineUser?: Maybe<Scalars['String']>;
  serviceOrderedBySparkUserId?: Maybe<Scalars['String']>;
  serviceProductDescription?: Maybe<Scalars['String']>;
  serviceResultAt?: Maybe<Scalars['String']>;
  serviceResultByAmsUser?: Maybe<Scalars['String']>;
  serviceResultBySparkUser?: Maybe<Scalars['String']>;
  serviceResultedInArbitration?: Maybe<Scalars['String']>;
};

export type ServiceResponse = {
  __typename?: 'ServiceResponse';
  serviceClass?: Maybe<Scalars['String']>;
  serviceCode?: Maybe<Scalars['String']>;
  serviceCodeDescription?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['Int']>;
  statusText?: Maybe<Scalars['String']>;
  stockNumber?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

export type SetAnnouncements = {
  announcement: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  ordinal: Scalars['Int'];
};

export type SetFloorPrice = {
  newValue?: InputMaybe<Scalars['Int']>;
  oldValue?: InputMaybe<Scalars['Int']>;
};

export type SetLights = {
  newValue?: InputMaybe<Scalars['String']>;
  oldValue?: InputMaybe<Scalars['String']>;
};

export type SetVehicleInfoResults = {
  __typename?: 'SetVehicleInfoResults';
  cancelProxyBidsResult?: Maybe<CancelProxyBidsResult>;
  results?: Maybe<Array<Maybe<AmsCallResult>>>;
};

export type ShareReportResponse = SparkResponse & {
  __typename?: 'ShareReportResponse';
  data?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export type SinglePushVehicleToAmsResult = {
  __typename?: 'SinglePushVehicleToAmsResult';
  id: Scalars['ID'];
  isPossible: Scalars['Boolean'];
};

export type Site = {
  __typename?: 'Site';
  auctionName?: Maybe<Scalars['String']>;
  biCode?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  lookoutCodeName?: Maybe<Scalars['String']>;
  pipelineCode?: Maybe<Scalars['String']>;
};

export type SortColumn = {
  __typename?: 'SortColumn';
  name?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Sort_Direction>;
};

export type SortColumnInput = {
  name?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Sort_Direction>;
};

export type SparkPaginatedResponse = {
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
  totalCount?: Maybe<Scalars['Int']>;
};

export type SparkResponse = {
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type StartBidTier = {
  __typename?: 'StartBidTier';
  amountBelowPriceFloor?: Maybe<Scalars['Int']>;
  priceFloorLBound?: Maybe<Scalars['Int']>;
  priceFloorUBound?: Maybe<Scalars['Int']>;
};

export type StartBidTierInput = {
  amountBelowPriceFloor?: InputMaybe<Scalars['Int']>;
  priceFloorLBound?: InputMaybe<Scalars['Int']>;
  priceFloorUBound?: InputMaybe<Scalars['Int']>;
};

export type StatisticsFilter = {
  dataSource?: InputMaybe<Scalars['String']>;
  dates?: InputMaybe<DateRange>;
  photoCount?: InputMaybe<NumberRange>;
};

export type TestVehicleAuditLog = {
  __typename?: 'TestVehicleAuditLog';
  account?: Maybe<Scalars['String']>;
  auction_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  detail?: Maybe<Scalars['String']>;
  detail_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  stock?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

export type TrendInfo = {
  __typename?: 'TrendInfo';
  avgPerWeekLast90?: Maybe<Scalars['Int']>;
  last7?: Maybe<Scalars['Int']>;
  last90?: Maybe<Scalars['Int']>;
};

export type Trends = {
  __typename?: 'Trends';
  consigned?: Maybe<TrendInfo>;
  purchased?: Maybe<TrendInfo>;
  sold?: Maybe<TrendInfo>;
};

export type TrendsFilter = {
  buyerOrSellerAccountId?: InputMaybe<Scalars['Int']>;
};

export enum User_Types {
  External = 'EXTERNAL',
  Spark = 'SPARK'
}

export type UpateAllListingsMutationResponse = SparkResponse & {
  __typename?: 'UpateAllListingsMutationResponse';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type UpdateAgentContact = {
  agentId?: InputMaybe<Scalars['Int']>;
  completedAt?: InputMaybe<Scalars['String']>;
  completedBy?: InputMaybe<Scalars['Int']>;
  contactedAt?: InputMaybe<Scalars['String']>;
  followUpDate?: InputMaybe<Scalars['String']>;
  followUpUserId?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  statusCode?: InputMaybe<Scalars['String']>;
  typeCode?: InputMaybe<Scalars['String']>;
};

export type UpdateAllVenueAssets = {
  amount: Scalars['Int'];
  dataField: AdjustPricingDataFieldEnum;
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
  type: AdjustPricingMethodEnum;
};

export type UpdateDocumentInput = {
  deleted?: InputMaybe<Scalars['Int']>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  docId: Scalars['String'];
  docName?: InputMaybe<Scalars['String']>;
  docTypeId?: InputMaybe<Scalars['String']>;
  docTypeName?: InputMaybe<Scalars['String']>;
  docTypeShortCode?: InputMaybe<Scalars['String']>;
  stockNumber?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type UpdateDocumentsResponse = {
  __typename?: 'UpdateDocumentsResponse';
  totalDocsUpdated?: Maybe<Scalars['Int']>;
  totalVehiclesUpdated?: Maybe<Scalars['Int']>;
};

export type UpdateFavoritesInput = {
  accountGroupId?: InputMaybe<Scalars['Int']>;
  accountKey: Scalars['String'];
  isFavorite: Scalars['Boolean'];
  orgCode: Scalars['String'];
};

export type UpdateRoles = {
  authenticationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  roleId: Scalars['Int'];
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateUserInput = {
  admin?: InputMaybe<AdminInput>;
  updatedAttributes?: InputMaybe<UserAttributesInput>;
  updatedCard?: InputMaybe<DashboardCardInput>;
  updatedDashboard?: InputMaybe<DashboardInput>;
  updatedDashboards?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedOrganizations?: InputMaybe<Array<OrganizationInput>>;
  updatedRoles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type User = {
  __typename?: 'User';
  attributes?: Maybe<UserAttributes>;
  biRoles?: Maybe<Scalars['String']>;
  dashboardList?: Maybe<Dashboards>;
  dashboards?: Maybe<Array<Maybe<Scalars['String']>>>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  permissions?: Maybe<UserPermissions>;
  roles?: Maybe<Array<Maybe<RoleAttributes>>>;
};


export type UserDashboardListArgs = {
  filter?: InputMaybe<DashboardFilter>;
};

export type UserAttributes = {
  __typename?: 'UserAttributes';
  auctionAccessNumber?: Maybe<Scalars['String']>;
  authenticationId?: Maybe<Scalars['String']>;
  authenticationSource?: Maybe<Scalars['String']>;
  authenticationUsername?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  customRoles?: Maybe<Scalars['String']>;
  databaseId?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  isGlobalAdmin?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  lastSeenAt?: Maybe<Scalars['String']>;
  lockedAt?: Maybe<Scalars['String']>;
  lockedBy?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  workPhone?: Maybe<Scalars['String']>;
};

export type UserAttributesInput = {
  auctionAccessNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  isGlobalAdmin?: InputMaybe<Scalars['Boolean']>;
  isLocked?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  workPhone?: InputMaybe<Scalars['String']>;
};

export type UserMutationResponse = {
  __typename?: 'UserMutationResponse';
  auctionAccessNumber?: Maybe<Scalars['String']>;
  authenticationId?: Maybe<Scalars['String']>;
  authenticationUsername?: Maybe<Scalars['String']>;
  databaseId?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  isGlobalAdmin?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['Int']>;
  statusMessage?: Maybe<Scalars['String']>;
  workPhone?: Maybe<Scalars['String']>;
};

export type UserPermissions = {
  __typename?: 'UserPermissions';
  orgPermissions?: Maybe<Array<Maybe<PermissionItem>>>;
  userPermissions?: Maybe<Array<Maybe<PermissionItem>>>;
};


export type UserPermissionsOrgPermissionsArgs = {
  auctionId: Scalars['String'];
};

export type VdpByStockNumberResults = {
  __typename?: 'VdpByStockNumberResults';
  assetId?: Maybe<Scalars['ID']>;
  uaId?: Maybe<Scalars['String']>;
};

export type VehicleAmsResponse = {
  __typename?: 'VehicleAMSResponse';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type VehicleDataTypes = OnlineListing | SearchVehicle | VehicleStatsByCompany;

export type VehicleStats = {
  __typename?: 'VehicleStats';
  avgSaleAmount?: Maybe<Scalars['Int']>;
  completed?: Maybe<Scalars['Int']>;
  conversion?: Maybe<Scalars['Float']>;
  ran?: Maybe<Scalars['Int']>;
  sold?: Maybe<Scalars['Int']>;
  sumSaleAmount?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type VehicleStatsByCompany = {
  __typename?: 'VehicleStatsByCompany';
  accountId?: Maybe<Scalars['Int']>;
  accountName?: Maybe<Scalars['String']>;
  avgSaleAmount?: Maybe<Scalars['Int']>;
  conversion?: Maybe<Scalars['Float']>;
  ran?: Maybe<Scalars['Int']>;
  sold?: Maybe<Scalars['Int']>;
  sumSaleAmount?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type VehiclesWithDocsResponse = {
  __typename?: 'VehiclesWithDocsResponse';
  totalDocCount?: Maybe<Scalars['Int']>;
  vehiclesWithDocsCount?: Maybe<Scalars['Int']>;
};

export type VenueEvent = {
  __typename?: 'VenueEvent';
  endedAt?: Maybe<Scalars['String']>;
  eventDate: Scalars['String'];
  eventEndTime?: Maybe<Scalars['String']>;
  eventSettings?: Maybe<AuctionSettings>;
  eventStartTime: Scalars['String'];
  eventTags?: Maybe<Array<Maybe<Scalars['String']>>>;
  eventTitle: Scalars['String'];
  eventType: Scalars['String'];
  eventTypeDisplayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  longDescription?: Maybe<Scalars['String']>;
  noSale?: Maybe<Scalars['Int']>;
  onOffer?: Maybe<Scalars['Int']>;
  orgCode?: Maybe<Scalars['String']>;
  originatingOrgCode?: Maybe<Scalars['String']>;
  participatingAuctions: Array<Maybe<Scalars['String']>>;
  sales?: Maybe<Scalars['Int']>;
  shortDescription?: Maybe<Scalars['String']>;
  sold?: Maybe<Scalars['Int']>;
  unitCount?: Maybe<Scalars['Int']>;
  venueCode?: Maybe<Scalars['String']>;
};

export type VenueSaleListingAsset = {
  __typename?: 'VenueSaleListingAsset';
  announcementLight?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['ID']>;
  assetOrigin?: Maybe<Scalars['String']>;
  bidIncrement?: Maybe<Scalars['Int']>;
  blackBook?: Maybe<Scalars['Int']>;
  buyNowPrice?: Maybe<Scalars['Int']>;
  consignor?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  floorPrice?: Maybe<Scalars['Int']>;
  grade?: Maybe<Scalars['Float']>;
  hasCr?: Maybe<Scalars['Boolean']>;
  lane?: Maybe<Scalars['String']>;
  listingCondition?: Maybe<Scalars['String']>;
  lot?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  mmr?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  orgCode?: Maybe<Scalars['String']>;
  ranCount?: Maybe<Scalars['Int']>;
  saleListingId?: Maybe<Scalars['String']>;
  startBid?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['String']>;
  stockNumber?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type VenueSaleListingAssetInput = {
  allCurrentSales?: InputMaybe<Array<InputMaybe<CurrentSaleInput>>>;
  announcementLight?: InputMaybe<Scalars['String']>;
  assetId?: InputMaybe<Scalars['ID']>;
  bidIncrement?: InputMaybe<Scalars['Int']>;
  blackBook?: InputMaybe<Scalars['Int']>;
  buyNowPrice?: InputMaybe<Scalars['Int']>;
  consignor?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  floorPrice?: InputMaybe<Scalars['Int']>;
  grade?: InputMaybe<Scalars['Float']>;
  hasCr?: InputMaybe<Scalars['Boolean']>;
  lane?: InputMaybe<Scalars['String']>;
  listingCondition?: InputMaybe<Scalars['String']>;
  lot?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  mmr?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['String']>;
  orgCode?: InputMaybe<Scalars['String']>;
  removalReason?: InputMaybe<Scalars['String']>;
  saleListingId?: InputMaybe<Scalars['String']>;
  startBid?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['String']>;
  stockNumber?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

export enum ViewType {
  CardView = 'card_view',
  ListView = 'list_view',
  PdfView = 'pdf_view'
}

export type Watcher = {
  __typename?: 'Watcher';
  emailAddress?: Maybe<Scalars['String']>;
  memberName?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type PushToAmsResponse = {
  __typename?: 'pushToAMSResponse';
  results?: Maybe<Array<Maybe<PushToAmsResposeResult>>>;
};

export type PushToAmsResposeResult = {
  __typename?: 'pushToAMSResposeResult';
  id: Scalars['ID'];
  success: PendingSuccess;
};

export type SendMessageStatus = {
  __typename?: 'sendMessageStatus';
  emailSentStatus?: Maybe<Scalars['String']>;
  smsSentStatus?: Maybe<Scalars['String']>;
};

export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  AGGR_SEARCH_SORT_TYPES: Aggr_Search_Sort_Types;
  AMSUpdateResponseMessages: ResolverTypeWrapper<AmsUpdateResponseMessages>;
  AccessoryDrawerDisplay: AccessoryDrawerDisplay;
  Account: ResolverTypeWrapper<Account>;
  AccountGroupAccounts: ResolverTypeWrapper<AccountGroupAccounts>;
  AccountGroupUsers: ResolverTypeWrapper<AccountGroupUsers>;
  AccountGroups: ResolverTypeWrapper<AccountGroups>;
  AccountGroupsFilter: AccountGroupsFilter;
  AccountNote: ResolverTypeWrapper<AccountNote>;
  AccountSortBy: AccountSortBy;
  AccountSortingKey: AccountSortingKey;
  Accounts: ResolverTypeWrapper<Accounts>;
  AccountsFilter: AccountsFilter;
  AdjustPricingDataFieldEnum: AdjustPricingDataFieldEnum;
  AdjustPricingMethodEnum: AdjustPricingMethodEnum;
  AdminInput: AdminInput;
  AdminInputSub: AdminInputSub;
  Administrator: ResolverTypeWrapper<Administrator>;
  Agent: ResolverTypeWrapper<Agent>;
  AgentCompany: ResolverTypeWrapper<AgentCompany>;
  AgentDealerResponse: ResolverTypeWrapper<AgentDealerResponse>;
  AgentNote: ResolverTypeWrapper<AgentNote>;
  AgentNoteType: ResolverTypeWrapper<AgentNoteType>;
  AgentNoteUpdate: AgentNoteUpdate;
  AgentNoteUpdateResult: ResolverTypeWrapper<AgentNoteUpdateResult>;
  AgentRole: ResolverTypeWrapper<AgentRole>;
  AgentRoleAction: AgentRoleAction;
  AgentRoleUpdate: AgentRoleUpdate;
  AgentRoleUpdateResult: ResolverTypeWrapper<AgentRoleUpdateResult>;
  AgentRoleUpdateResults: ResolverTypeWrapper<AgentRoleUpdateResults>;
  Agents: ResolverTypeWrapper<Agents>;
  AgentsFilter: AgentsFilter;
  AmsCallResult: ResolverTypeWrapper<AmsCallResult>;
  AmsResponse: ResolverTypeWrapper<AmsResponse>;
  Announcement: ResolverTypeWrapper<Announcement>;
  Asset: ResolverTypeWrapper<Asset>;
  AssetFees: ResolverTypeWrapper<AssetFees>;
  AssetFilter: AssetFilter;
  Assets: ResolverTypeWrapper<Assets>;
  Attendance: ResolverTypeWrapper<Attendance>;
  AttendanceList: ResolverTypeWrapper<AttendanceList>;
  Auction: ResolverTypeWrapper<Auction>;
  AuctionAmsInfo: ResolverTypeWrapper<AuctionAmsInfo>;
  AuctionCollection: ResolverTypeWrapper<AuctionCollection>;
  AuctionKey: ResolverTypeWrapper<AuctionKey>;
  AuctionSettings: ResolverTypeWrapper<AuctionSettings>;
  AuctionSettingsInput: AuctionSettingsInput;
  AuctionSettingsResponse: ResolverTypeWrapper<AuctionSettingsResponse>;
  AuctionStatistics: ResolverTypeWrapper<AuctionStatistics>;
  Audit: ResolverTypeWrapper<Audit>;
  AuditInput: AuditInput;
  AuditResponse: ResolverTypeWrapper<AuditResponse>;
  BallControlCode: BallControlCode;
  Bidder: ResolverTypeWrapper<Bidder>;
  BidderList: ResolverTypeWrapper<BidderList>;
  BiddersFilter: BiddersFilter;
  BiddingStatistics: ResolverTypeWrapper<BiddingStatistics>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  BuyNowTier: ResolverTypeWrapper<BuyNowTier>;
  BuyNowTierInput: BuyNowTierInput;
  CacheShape: ResolverTypeWrapper<CacheShape>;
  CalculatedIfOfferData: ResolverTypeWrapper<CalculatedIfOfferData>;
  CancelProxyBidsResult: ResolverTypeWrapper<CancelProxyBidsResult>;
  Card: ResolverTypeWrapper<Card>;
  CardFilter: CardFilter;
  ColOptions: ColOptions;
  CompaniesList: ResolverTypeWrapper<CompaniesList>;
  ConditionReport: ResolverTypeWrapper<ConditionReport>;
  ConfigSearchResults: ResolverTypeWrapper<Omit<ConfigSearchResults, 'vehicleData'> & { vehicleData?: Maybe<Array<Maybe<ResolversTypes['VehicleDataTypes']>>> }>;
  Contact: ResolverTypeWrapper<Contact>;
  ContactFilter: ContactFilter;
  ContactList: ResolverTypeWrapper<ContactList>;
  ContactLogStats: ResolverTypeWrapper<ContactLogStats>;
  ContactManagement: ResolverTypeWrapper<ContactManagement>;
  ContactSortBy: ContactSortBy;
  ContactSortKey: ContactSortKey;
  ContactStatus: ResolverTypeWrapper<ContactStatus>;
  ContactType: ResolverTypeWrapper<ContactType>;
  CreateAgentContact: CreateAgentContact;
  CreateDocumentInput: CreateDocumentInput;
  CreateDocumentOutputAsset: ResolverTypeWrapper<CreateDocumentOutputAsset>;
  CreateDocumentUploadDoc: ResolverTypeWrapper<CreateDocumentUploadDoc>;
  CreateDocumentsInputAsset: CreateDocumentsInputAsset;
  CreateDocumentsUploadItem: ResolverTypeWrapper<CreateDocumentsUploadItem>;
  CreateReportConfigInput: CreateReportConfigInput;
  CreateReportConfigResponse: ResolverTypeWrapper<CreateReportConfigResponse>;
  CreateUserInput: CreateUserInput;
  CreateVenueEvent: CreateVenueEvent;
  CreatedEventResponse: ResolverTypeWrapper<CreatedEventResponse>;
  CurrentSale: ResolverTypeWrapper<CurrentSale>;
  CurrentSaleInput: CurrentSaleInput;
  Dashboard: ResolverTypeWrapper<Dashboard>;
  DashboardCardInput: DashboardCardInput;
  DashboardFilter: DashboardFilter;
  DashboardInput: DashboardInput;
  Dashboards: ResolverTypeWrapper<Dashboards>;
  DataConfig: ResolverTypeWrapper<DataConfig>;
  DataSourceTypes: DataSourceTypes;
  DateRange: DateRange;
  Deal: ResolverTypeWrapper<Deal>;
  DealFilter: DealFilter;
  Dealer: ResolverTypeWrapper<Dealer>;
  DeleteAgentContact: DeleteAgentContact;
  DeleteUserInput: DeleteUserInput;
  DocType: ResolverTypeWrapper<DocType>;
  Document: ResolverTypeWrapper<Document>;
  DocumentActivity: ResolverTypeWrapper<DocumentActivity>;
  DocumentUploadURL: ResolverTypeWrapper<DocumentUploadUrl>;
  DocumentUploadURLsFilter: DocumentUploadUrLsFilter;
  DocumentView: ResolverTypeWrapper<DocumentView>;
  DocumentsFilter: DocumentsFilter;
  EventStatusesEnum: EventStatusesEnum;
  EventTriggerCode: EventTriggerCode;
  EventTypeCode: EventTypeCode;
  EventTypeTrigger: ResolverTypeWrapper<EventTypeTrigger>;
  EventTypesEnum: EventTypesEnum;
  EventsListFilter: EventsListFilter;
  ExitVehicleRequest: ExitVehicleRequest;
  ExpectedAnnouncement: ExpectedAnnouncement;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  FullSearch: FullSearch;
  GenerateFormats: GenerateFormats;
  GenerateOptions: GenerateOptions;
  GeneratePDFInput: GeneratePdfInput;
  GenericCard: ResolverTypeWrapper<GenericCard>;
  GetSingleUserInput: GetSingleUserInput;
  GetUserListInput: GetUserListInput;
  HttpResponse: ResolverTypeWrapper<HttpResponse>;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  IfOfferDetails: IfOfferDetails;
  IfOfferFilter: IfOfferFilter;
  IfOfferHistory: ResolverTypeWrapper<IfOfferHistory>;
  IfOfferManagement: ResolverTypeWrapper<IfOfferManagement>;
  IfOfferNoteType: IfOfferNoteType;
  IfOfferNotes: ResolverTypeWrapper<IfOfferNotes>;
  IfOfferUpdateAMSResponse: ResolverTypeWrapper<IfOfferUpdateAmsResponse>;
  IfOfferUpdateResult: ResolverTypeWrapper<IfOfferUpdateResult>;
  IfOfferUpdateResults: ResolverTypeWrapper<IfOfferUpdateResults>;
  InspectionInput: InspectionInput;
  InspectionType: ResolverTypeWrapper<InspectionType>;
  InspectionTypeFilter: ResolverTypeWrapper<InspectionTypeFilter>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  Lane: ResolverTypeWrapper<Lane>;
  LaneList: ResolverTypeWrapper<LaneList>;
  LightOption: ResolverTypeWrapper<LightOption>;
  ListView: ResolverTypeWrapper<ListView>;
  ListViewConfigInput: ListViewConfigInput;
  LocalCreateDocumentInput: LocalCreateDocumentInput;
  LocalCreateDocumentOutput: ResolverTypeWrapper<LocalCreateDocumentOutput>;
  LocalUploadDocumentInput: LocalUploadDocumentInput;
  Location: ResolverTypeWrapper<Location>;
  LoginCredentials: LoginCredentials;
  LoginResponse: ResolverTypeWrapper<LoginResponse>;
  LoginResponseTypes: LoginResponseTypes;
  MaintenanceDetails: MaintenanceDetails;
  MaintenanceUpdateResult: ResolverTypeWrapper<MaintenanceUpdateResult>;
  Marketplace: ResolverTypeWrapper<Marketplace>;
  MarketplaceStatistics: ResolverTypeWrapper<MarketplaceStatistics>;
  MessageInput: MessageInput;
  MutateAccountGroupFilter: MutateAccountGroupFilter;
  Mutation: ResolverTypeWrapper<{}>;
  MutationDataResponse: ResolversTypes['VenueEvent'] | ResolversTypes['VenueSaleListingAsset'];
  MutationResponse: ResolverTypeWrapper<Omit<MutationResponse, 'data'> & { data?: Maybe<ResolversTypes['MutationDataResponse']> }>;
  NoSaleHistory: ResolverTypeWrapper<NoSaleHistory>;
  NoSaleRequest: NoSaleRequest;
  NumberRange: NumberRange;
  OnlineListing: ResolverTypeWrapper<OnlineListing>;
  OnlineListingFilter: OnlineListingFilter;
  OnlineListings: ResolverTypeWrapper<OnlineListings>;
  OnlineStatistic: ResolverTypeWrapper<OnlineStatistic>;
  OpenPsiResponse: ResolverTypeWrapper<OpenPsiResponse>;
  Organization: ResolverTypeWrapper<Organization>;
  OrganizationInput: OrganizationInput;
  PageInfo: PageInfo;
  PageInfoConfig: ResolverTypeWrapper<PageInfoConfig>;
  PageInfoConfigInput: PageInfoConfigInput;
  PaginatedDocumentResponse: ResolverTypeWrapper<PaginatedDocumentResponse>;
  PaginationControls: PaginationControls;
  PastSale: ResolverTypeWrapper<PastSale>;
  PastSearch: ResolverTypeWrapper<PastSearch>;
  PathConfig: ResolverTypeWrapper<PathConfig>;
  PathConfigInput: PathConfigInput;
  PdfColumn: PdfColumn;
  PdfRow: PdfRow;
  PendingSuccess: PendingSuccess;
  PermissionItem: ResolverTypeWrapper<PermissionItem>;
  Photo: ResolverTypeWrapper<Photo>;
  Profile: ResolverTypeWrapper<Profile>;
  Psi: ResolverTypeWrapper<Psi>;
  PsiFilter: PsiFilter;
  PsiNote: ResolverTypeWrapper<PsiNote>;
  PullVehicleRequest: PullVehicleRequest;
  PushVehicleToAmsResults: ResolverTypeWrapper<PushVehicleToAmsResults>;
  PushVehiclesToAmsResults: ResolverTypeWrapper<PushVehiclesToAmsResults>;
  Query: ResolverTypeWrapper<{}>;
  QueryAgentResponse: ResolverTypeWrapper<QueryAgentResponse>;
  QueryEventsListResponse: ResolverTypeWrapper<QueryEventsListResponse>;
  QueryResponse: ResolverTypeWrapper<QueryResponse>;
  QueryRunListResponse: ResolverTypeWrapper<QueryRunListResponse>;
  RegisterBidderDetails: RegisterBidderDetails;
  RegisterBidderResponse: ResolverTypeWrapper<RegisterBidderResponse>;
  Report: ResolverTypeWrapper<Report>;
  ReportColumn: ResolverTypeWrapper<ReportColumn>;
  ReportColumnInput: ReportColumnInput;
  ReportConfig: ResolverTypeWrapper<ReportConfig>;
  ReportDateOffset: ResolverTypeWrapper<ReportDateOffset>;
  ReportDetailPage: ResolverTypeWrapper<ReportDetailPage>;
  ReportFilter: ReportFilter;
  ReportSearchFilter: ResolverTypeWrapper<ReportSearchFilter>;
  ResendUnconfirmedPasswordInput: ResendUnconfirmedPasswordInput;
  ResetPasswordByEmailInput: ResetPasswordByEmailInput;
  ResetPasswordByEmailResponse: ResolverTypeWrapper<ResetPasswordByEmailResponse>;
  ReverseSaleRequest: ReverseSaleRequest;
  Role: ResolverTypeWrapper<Role>;
  RoleAttributes: ResolverTypeWrapper<RoleAttributes>;
  RunListFilter: RunListFilter;
  SEARCH_SORT_TYPES: Search_Sort_Types;
  SEARCH_TYPES: Search_Types;
  SORT_DIRECTION: Sort_Direction;
  SaleEvent: ResolverTypeWrapper<SaleEvent>;
  SaleListing: ResolverTypeWrapper<SaleListing>;
  SalesDayStatistics: ResolverTypeWrapper<SalesDayStatistics>;
  SearchAccount: ResolverTypeWrapper<SearchAccount>;
  SearchAgent: ResolverTypeWrapper<SearchAgent>;
  SearchBidder: ResolverTypeWrapper<SearchBidder>;
  SearchConfigInput: SearchConfigInput;
  SearchContactLog: ResolverTypeWrapper<SearchContactLog>;
  SearchFilter: SearchFilter;
  SearchPageInfo: SearchPageInfo;
  SearchResults: ResolverTypeWrapper<SearchResults>;
  SearchSort: SearchSort;
  SearchVehicle: ResolverTypeWrapper<SearchVehicle>;
  Service: ResolverTypeWrapper<Service>;
  ServiceResponse: ResolverTypeWrapper<ServiceResponse>;
  SetAnnouncements: SetAnnouncements;
  SetFloorPrice: SetFloorPrice;
  SetLights: SetLights;
  SetVehicleInfoResults: ResolverTypeWrapper<SetVehicleInfoResults>;
  ShareReportResponse: ResolverTypeWrapper<ShareReportResponse>;
  SinglePushVehicleToAmsResult: ResolverTypeWrapper<SinglePushVehicleToAmsResult>;
  Site: ResolverTypeWrapper<Site>;
  SortColumn: ResolverTypeWrapper<SortColumn>;
  SortColumnInput: SortColumnInput;
  SparkPaginatedResponse: ResolversTypes['QueryRunListResponse'];
  SparkResponse: ResolversTypes['CreatedEventResponse'] | ResolversTypes['MutationResponse'] | ResolversTypes['QueryAgentResponse'] | ResolversTypes['QueryEventsListResponse'] | ResolversTypes['QueryResponse'] | ResolversTypes['ShareReportResponse'] | ResolversTypes['UpateAllListingsMutationResponse'];
  StartBidTier: ResolverTypeWrapper<StartBidTier>;
  StartBidTierInput: StartBidTierInput;
  StatisticsFilter: StatisticsFilter;
  String: ResolverTypeWrapper<Scalars['String']>;
  TestVehicleAuditLog: ResolverTypeWrapper<TestVehicleAuditLog>;
  TrendInfo: ResolverTypeWrapper<TrendInfo>;
  Trends: ResolverTypeWrapper<Trends>;
  TrendsFilter: TrendsFilter;
  USER_TYPES: User_Types;
  UpateAllListingsMutationResponse: ResolverTypeWrapper<UpateAllListingsMutationResponse>;
  UpdateAgentContact: UpdateAgentContact;
  UpdateAllVenueAssets: UpdateAllVenueAssets;
  UpdateDocumentInput: UpdateDocumentInput;
  UpdateDocumentsResponse: ResolverTypeWrapper<UpdateDocumentsResponse>;
  UpdateFavoritesInput: UpdateFavoritesInput;
  UpdateRoles: UpdateRoles;
  UpdateUserInput: UpdateUserInput;
  Upload: ResolverTypeWrapper<Scalars['Upload']>;
  User: ResolverTypeWrapper<User>;
  UserAttributes: ResolverTypeWrapper<UserAttributes>;
  UserAttributesInput: UserAttributesInput;
  UserMutationResponse: ResolverTypeWrapper<UserMutationResponse>;
  UserPermissions: ResolverTypeWrapper<UserPermissions>;
  VdpByStockNumberResults: ResolverTypeWrapper<VdpByStockNumberResults>;
  VehicleAMSResponse: ResolverTypeWrapper<VehicleAmsResponse>;
  VehicleDataTypes: ResolversTypes['OnlineListing'] | ResolversTypes['SearchVehicle'] | ResolversTypes['VehicleStatsByCompany'];
  VehicleStats: ResolverTypeWrapper<VehicleStats>;
  VehicleStatsByCompany: ResolverTypeWrapper<VehicleStatsByCompany>;
  VehiclesWithDocsResponse: ResolverTypeWrapper<VehiclesWithDocsResponse>;
  VenueEvent: ResolverTypeWrapper<VenueEvent>;
  VenueSaleListingAsset: ResolverTypeWrapper<VenueSaleListingAsset>;
  VenueSaleListingAssetInput: VenueSaleListingAssetInput;
  ViewType: ViewType;
  Watcher: ResolverTypeWrapper<Watcher>;
  pushToAMSResponse: ResolverTypeWrapper<PushToAmsResponse>;
  pushToAMSResposeResult: ResolverTypeWrapper<PushToAmsResposeResult>;
  sendMessageStatus: ResolverTypeWrapper<SendMessageStatus>;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  AMSUpdateResponseMessages: AmsUpdateResponseMessages;
  Account: Account;
  AccountGroupAccounts: AccountGroupAccounts;
  AccountGroupUsers: AccountGroupUsers;
  AccountGroups: AccountGroups;
  AccountGroupsFilter: AccountGroupsFilter;
  AccountNote: AccountNote;
  AccountSortBy: AccountSortBy;
  Accounts: Accounts;
  AccountsFilter: AccountsFilter;
  AdminInput: AdminInput;
  AdminInputSub: AdminInputSub;
  Administrator: Administrator;
  Agent: Agent;
  AgentCompany: AgentCompany;
  AgentDealerResponse: AgentDealerResponse;
  AgentNote: AgentNote;
  AgentNoteType: AgentNoteType;
  AgentNoteUpdate: AgentNoteUpdate;
  AgentNoteUpdateResult: AgentNoteUpdateResult;
  AgentRole: AgentRole;
  AgentRoleAction: AgentRoleAction;
  AgentRoleUpdate: AgentRoleUpdate;
  AgentRoleUpdateResult: AgentRoleUpdateResult;
  AgentRoleUpdateResults: AgentRoleUpdateResults;
  Agents: Agents;
  AgentsFilter: AgentsFilter;
  AmsCallResult: AmsCallResult;
  AmsResponse: AmsResponse;
  Announcement: Announcement;
  Asset: Asset;
  AssetFees: AssetFees;
  AssetFilter: AssetFilter;
  Assets: Assets;
  Attendance: Attendance;
  AttendanceList: AttendanceList;
  Auction: Auction;
  AuctionAmsInfo: AuctionAmsInfo;
  AuctionCollection: AuctionCollection;
  AuctionKey: AuctionKey;
  AuctionSettings: AuctionSettings;
  AuctionSettingsInput: AuctionSettingsInput;
  AuctionSettingsResponse: AuctionSettingsResponse;
  AuctionStatistics: AuctionStatistics;
  Audit: Audit;
  AuditInput: AuditInput;
  AuditResponse: AuditResponse;
  Bidder: Bidder;
  BidderList: BidderList;
  BiddersFilter: BiddersFilter;
  BiddingStatistics: BiddingStatistics;
  Boolean: Scalars['Boolean'];
  BuyNowTier: BuyNowTier;
  BuyNowTierInput: BuyNowTierInput;
  CacheShape: CacheShape;
  CalculatedIfOfferData: CalculatedIfOfferData;
  CancelProxyBidsResult: CancelProxyBidsResult;
  Card: Card;
  CardFilter: CardFilter;
  CompaniesList: CompaniesList;
  ConditionReport: ConditionReport;
  ConfigSearchResults: Omit<ConfigSearchResults, 'vehicleData'> & { vehicleData?: Maybe<Array<Maybe<ResolversParentTypes['VehicleDataTypes']>>> };
  Contact: Contact;
  ContactFilter: ContactFilter;
  ContactList: ContactList;
  ContactLogStats: ContactLogStats;
  ContactManagement: ContactManagement;
  ContactSortBy: ContactSortBy;
  ContactStatus: ContactStatus;
  ContactType: ContactType;
  CreateAgentContact: CreateAgentContact;
  CreateDocumentInput: CreateDocumentInput;
  CreateDocumentOutputAsset: CreateDocumentOutputAsset;
  CreateDocumentUploadDoc: CreateDocumentUploadDoc;
  CreateDocumentsInputAsset: CreateDocumentsInputAsset;
  CreateDocumentsUploadItem: CreateDocumentsUploadItem;
  CreateReportConfigInput: CreateReportConfigInput;
  CreateReportConfigResponse: CreateReportConfigResponse;
  CreateUserInput: CreateUserInput;
  CreateVenueEvent: CreateVenueEvent;
  CreatedEventResponse: CreatedEventResponse;
  CurrentSale: CurrentSale;
  CurrentSaleInput: CurrentSaleInput;
  Dashboard: Dashboard;
  DashboardCardInput: DashboardCardInput;
  DashboardFilter: DashboardFilter;
  DashboardInput: DashboardInput;
  Dashboards: Dashboards;
  DataConfig: DataConfig;
  DateRange: DateRange;
  Deal: Deal;
  DealFilter: DealFilter;
  Dealer: Dealer;
  DeleteAgentContact: DeleteAgentContact;
  DeleteUserInput: DeleteUserInput;
  DocType: DocType;
  Document: Document;
  DocumentActivity: DocumentActivity;
  DocumentUploadURL: DocumentUploadUrl;
  DocumentUploadURLsFilter: DocumentUploadUrLsFilter;
  DocumentView: DocumentView;
  DocumentsFilter: DocumentsFilter;
  EventTypeTrigger: EventTypeTrigger;
  EventsListFilter: EventsListFilter;
  ExitVehicleRequest: ExitVehicleRequest;
  ExpectedAnnouncement: ExpectedAnnouncement;
  Float: Scalars['Float'];
  FullSearch: FullSearch;
  GenerateOptions: GenerateOptions;
  GeneratePDFInput: GeneratePdfInput;
  GenericCard: GenericCard;
  GetSingleUserInput: GetSingleUserInput;
  GetUserListInput: GetUserListInput;
  HttpResponse: HttpResponse;
  ID: Scalars['ID'];
  IfOfferDetails: IfOfferDetails;
  IfOfferFilter: IfOfferFilter;
  IfOfferHistory: IfOfferHistory;
  IfOfferManagement: IfOfferManagement;
  IfOfferNotes: IfOfferNotes;
  IfOfferUpdateAMSResponse: IfOfferUpdateAmsResponse;
  IfOfferUpdateResult: IfOfferUpdateResult;
  IfOfferUpdateResults: IfOfferUpdateResults;
  InspectionInput: InspectionInput;
  InspectionType: InspectionType;
  InspectionTypeFilter: InspectionTypeFilter;
  Int: Scalars['Int'];
  Lane: Lane;
  LaneList: LaneList;
  LightOption: LightOption;
  ListView: ListView;
  ListViewConfigInput: ListViewConfigInput;
  LocalCreateDocumentInput: LocalCreateDocumentInput;
  LocalCreateDocumentOutput: LocalCreateDocumentOutput;
  LocalUploadDocumentInput: LocalUploadDocumentInput;
  Location: Location;
  LoginCredentials: LoginCredentials;
  LoginResponse: LoginResponse;
  MaintenanceDetails: MaintenanceDetails;
  MaintenanceUpdateResult: MaintenanceUpdateResult;
  Marketplace: Marketplace;
  MarketplaceStatistics: MarketplaceStatistics;
  MessageInput: MessageInput;
  MutateAccountGroupFilter: MutateAccountGroupFilter;
  Mutation: {};
  MutationDataResponse: ResolversParentTypes['VenueEvent'] | ResolversParentTypes['VenueSaleListingAsset'];
  MutationResponse: Omit<MutationResponse, 'data'> & { data?: Maybe<ResolversParentTypes['MutationDataResponse']> };
  NoSaleHistory: NoSaleHistory;
  NoSaleRequest: NoSaleRequest;
  NumberRange: NumberRange;
  OnlineListing: OnlineListing;
  OnlineListingFilter: OnlineListingFilter;
  OnlineListings: OnlineListings;
  OnlineStatistic: OnlineStatistic;
  OpenPsiResponse: OpenPsiResponse;
  Organization: Organization;
  OrganizationInput: OrganizationInput;
  PageInfo: PageInfo;
  PageInfoConfig: PageInfoConfig;
  PageInfoConfigInput: PageInfoConfigInput;
  PaginatedDocumentResponse: PaginatedDocumentResponse;
  PaginationControls: PaginationControls;
  PastSale: PastSale;
  PastSearch: PastSearch;
  PathConfig: PathConfig;
  PathConfigInput: PathConfigInput;
  PdfColumn: PdfColumn;
  PdfRow: PdfRow;
  PermissionItem: PermissionItem;
  Photo: Photo;
  Profile: Profile;
  Psi: Psi;
  PsiFilter: PsiFilter;
  PsiNote: PsiNote;
  PullVehicleRequest: PullVehicleRequest;
  PushVehicleToAmsResults: PushVehicleToAmsResults;
  PushVehiclesToAmsResults: PushVehiclesToAmsResults;
  Query: {};
  QueryAgentResponse: QueryAgentResponse;
  QueryEventsListResponse: QueryEventsListResponse;
  QueryResponse: QueryResponse;
  QueryRunListResponse: QueryRunListResponse;
  RegisterBidderDetails: RegisterBidderDetails;
  RegisterBidderResponse: RegisterBidderResponse;
  Report: Report;
  ReportColumn: ReportColumn;
  ReportColumnInput: ReportColumnInput;
  ReportConfig: ReportConfig;
  ReportDateOffset: ReportDateOffset;
  ReportDetailPage: ReportDetailPage;
  ReportFilter: ReportFilter;
  ReportSearchFilter: ReportSearchFilter;
  ResendUnconfirmedPasswordInput: ResendUnconfirmedPasswordInput;
  ResetPasswordByEmailInput: ResetPasswordByEmailInput;
  ResetPasswordByEmailResponse: ResetPasswordByEmailResponse;
  ReverseSaleRequest: ReverseSaleRequest;
  Role: Role;
  RoleAttributes: RoleAttributes;
  RunListFilter: RunListFilter;
  SaleEvent: SaleEvent;
  SaleListing: SaleListing;
  SalesDayStatistics: SalesDayStatistics;
  SearchAccount: SearchAccount;
  SearchAgent: SearchAgent;
  SearchBidder: SearchBidder;
  SearchConfigInput: SearchConfigInput;
  SearchContactLog: SearchContactLog;
  SearchFilter: SearchFilter;
  SearchPageInfo: SearchPageInfo;
  SearchResults: SearchResults;
  SearchSort: SearchSort;
  SearchVehicle: SearchVehicle;
  Service: Service;
  ServiceResponse: ServiceResponse;
  SetAnnouncements: SetAnnouncements;
  SetFloorPrice: SetFloorPrice;
  SetLights: SetLights;
  SetVehicleInfoResults: SetVehicleInfoResults;
  ShareReportResponse: ShareReportResponse;
  SinglePushVehicleToAmsResult: SinglePushVehicleToAmsResult;
  Site: Site;
  SortColumn: SortColumn;
  SortColumnInput: SortColumnInput;
  SparkPaginatedResponse: ResolversParentTypes['QueryRunListResponse'];
  SparkResponse: ResolversParentTypes['CreatedEventResponse'] | ResolversParentTypes['MutationResponse'] | ResolversParentTypes['QueryAgentResponse'] | ResolversParentTypes['QueryEventsListResponse'] | ResolversParentTypes['QueryResponse'] | ResolversParentTypes['ShareReportResponse'] | ResolversParentTypes['UpateAllListingsMutationResponse'];
  StartBidTier: StartBidTier;
  StartBidTierInput: StartBidTierInput;
  StatisticsFilter: StatisticsFilter;
  String: Scalars['String'];
  TestVehicleAuditLog: TestVehicleAuditLog;
  TrendInfo: TrendInfo;
  Trends: Trends;
  TrendsFilter: TrendsFilter;
  UpateAllListingsMutationResponse: UpateAllListingsMutationResponse;
  UpdateAgentContact: UpdateAgentContact;
  UpdateAllVenueAssets: UpdateAllVenueAssets;
  UpdateDocumentInput: UpdateDocumentInput;
  UpdateDocumentsResponse: UpdateDocumentsResponse;
  UpdateFavoritesInput: UpdateFavoritesInput;
  UpdateRoles: UpdateRoles;
  UpdateUserInput: UpdateUserInput;
  Upload: Scalars['Upload'];
  User: User;
  UserAttributes: UserAttributes;
  UserAttributesInput: UserAttributesInput;
  UserMutationResponse: UserMutationResponse;
  UserPermissions: UserPermissions;
  VdpByStockNumberResults: VdpByStockNumberResults;
  VehicleAMSResponse: VehicleAmsResponse;
  VehicleDataTypes: ResolversParentTypes['OnlineListing'] | ResolversParentTypes['SearchVehicle'] | ResolversParentTypes['VehicleStatsByCompany'];
  VehicleStats: VehicleStats;
  VehicleStatsByCompany: VehicleStatsByCompany;
  VehiclesWithDocsResponse: VehiclesWithDocsResponse;
  VenueEvent: VenueEvent;
  VenueSaleListingAsset: VenueSaleListingAsset;
  VenueSaleListingAssetInput: VenueSaleListingAssetInput;
  Watcher: Watcher;
  pushToAMSResponse: PushToAmsResponse;
  pushToAMSResposeResult: PushToAmsResposeResult;
  sendMessageStatus: SendMessageStatus;
}>;

export type Aws_Api_KeyDirectiveArgs = { };

export type Aws_Api_KeyDirectiveResolver<Result, Parent, ContextType = ApolloResolverContext, Args = Aws_Api_KeyDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_AuthDirectiveArgs = {
  cognito_groups?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Aws_AuthDirectiveResolver<Result, Parent, ContextType = ApolloResolverContext, Args = Aws_AuthDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_Cognito_User_PoolsDirectiveArgs = {
  cognito_groups?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Aws_Cognito_User_PoolsDirectiveResolver<Result, Parent, ContextType = ApolloResolverContext, Args = Aws_Cognito_User_PoolsDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_IamDirectiveArgs = { };

export type Aws_IamDirectiveResolver<Result, Parent, ContextType = ApolloResolverContext, Args = Aws_IamDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_LambdaDirectiveArgs = { };

export type Aws_LambdaDirectiveResolver<Result, Parent, ContextType = ApolloResolverContext, Args = Aws_LambdaDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_OidcDirectiveArgs = { };

export type Aws_OidcDirectiveResolver<Result, Parent, ContextType = ApolloResolverContext, Args = Aws_OidcDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_PublishDirectiveArgs = {
  subscriptions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Aws_PublishDirectiveResolver<Result, Parent, ContextType = ApolloResolverContext, Args = Aws_PublishDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_SubscribeDirectiveArgs = {
  mutations?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Aws_SubscribeDirectiveResolver<Result, Parent, ContextType = ApolloResolverContext, Args = Aws_SubscribeDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type DeferDirectiveArgs = { };

export type DeferDirectiveResolver<Result, Parent, ContextType = ApolloResolverContext, Args = DeferDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AmsUpdateResponseMessagesResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AMSUpdateResponseMessages'] = ResolversParentTypes['AMSUpdateResponseMessages']> = ResolversObject<{
  error?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  statusText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  warning?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccountResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Account'] = ResolversParentTypes['Account']> = ResolversObject<{
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  accountKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AccountNote']>>>, ParentType, ContextType>;
  accountOrgDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountOrgId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  accountSalesRep?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agents?: Resolver<Maybe<ResolversTypes['Agents']>, ParentType, ContextType>;
  auctionAccessNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  canBuy?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  canSell?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  dbaName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  establishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFavorite?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastAttended?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastPurchaseActivity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastSoldActivity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Location']>>>, ParentType, ContextType>;
  orgCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneMain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneSecondary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccountGroupAccountsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AccountGroupAccounts'] = ResolversParentTypes['AccountGroupAccounts']> = ResolversObject<{
  accountGroupId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccountGroupUsersResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AccountGroupUsers'] = ResolversParentTypes['AccountGroupUsers']> = ResolversObject<{
  accountGroupId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isOwner?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPrimary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccountGroupsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AccountGroups'] = ResolversParentTypes['AccountGroups']> = ResolversObject<{
  accounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['AccountGroupAccounts']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isDeleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isShared?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  orgId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  users?: Resolver<Maybe<Array<Maybe<ResolversTypes['AccountGroupUsers']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccountNoteResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AccountNote'] = ResolversParentTypes['AccountNote']> = ResolversObject<{
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccountsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Accounts'] = ResolversParentTypes['Accounts']> = ResolversObject<{
  byId?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  docsByDocTypeShortCode?: Resolver<Maybe<Array<Maybe<ResolversTypes['Document']>>>, ParentType, ContextType, Partial<AccountsDocsByDocTypeShortCodeArgs>>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Account']>>>, ParentType, ContextType, Partial<AccountsListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AdministratorResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Administrator'] = ResolversParentTypes['Administrator']> = ResolversObject<{
  allGroups?: Resolver<Maybe<Array<Maybe<ResolversTypes['RoleAttributes']>>>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<AdministratorUserArgs, 'input'>>;
  users?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserAttributes']>>>, ParentType, ContextType, RequireFields<AdministratorUsersArgs, 'input'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Agent'] = ResolversParentTypes['Agent']> = ResolversObject<{
  accountAuctionAccessNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accountIssuerOrgCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AccountNote']>>>, ParentType, ContextType>;
  agentAuthCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agentId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  agentNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agentNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attendanceHistory?: Resolver<Maybe<ResolversTypes['AttendanceList']>, ParentType, ContextType>;
  auctionAccessNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auctionAccessPicture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bidderNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birthday?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  canBuy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  canSell?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cellPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contacts?: Resolver<Maybe<ResolversTypes['ContactList']>, ParentType, ContextType>;
  dateAddedOn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstAttendedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  homePhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastAttendBadgeNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastAttendBadgeType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastAttendedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastPurchaseActivity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AgentNote']>>>, ParentType, ContextType>;
  online?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  otherCompanies?: Resolver<Maybe<ResolversTypes['CompaniesList']>, ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<Maybe<ResolversTypes['AgentRole']>>>, ParentType, ContextType>;
  workPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentCompanyResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AgentCompany'] = ResolversParentTypes['AgentCompany']> = ResolversObject<{
  accountDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  agentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentDealerResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AgentDealerResponse'] = ResolversParentTypes['AgentDealerResponse']> = ResolversObject<{
  agent?: Resolver<Maybe<ResolversTypes['Agent']>, ParentType, ContextType>;
  dealer?: Resolver<Maybe<ResolversTypes['Dealer']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentNoteResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AgentNote'] = ResolversParentTypes['AgentNote']> = ResolversObject<{
  agentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  agentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noteText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noteType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sparkUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentNoteTypeResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AgentNoteType'] = ResolversParentTypes['AgentNoteType']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  longDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentNoteUpdateResultResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AgentNoteUpdateResult'] = ResolversParentTypes['AgentNoteUpdateResult']> = ResolversObject<{
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentRoleResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AgentRole'] = ResolversParentTypes['AgentRole']> = ResolversObject<{
  agentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  longDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ordinal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentRoleUpdateResultResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AgentRoleUpdateResult'] = ResolversParentTypes['AgentRoleUpdateResult']> = ResolversObject<{
  roleCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentRoleUpdateResultsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AgentRoleUpdateResults'] = ResolversParentTypes['AgentRoleUpdateResults']> = ResolversObject<{
  results?: Resolver<Maybe<Array<Maybe<ResolversTypes['AgentRoleUpdateResult']>>>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Agents'] = ResolversParentTypes['Agents']> = ResolversObject<{
  byId?: Resolver<Maybe<ResolversTypes['Agent']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Agent']>>>, ParentType, ContextType, Partial<AgentsListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmsCallResultResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AmsCallResult'] = ResolversParentTypes['AmsCallResult']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmsResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AmsResponse'] = ResolversParentTypes['AmsResponse']> = ResolversObject<{
  ifNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['IfOfferNotes']>>>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AnnouncementResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Announcement'] = ResolversParentTypes['Announcement']> = ResolversObject<{
  announcement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ordinal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeLongDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeShortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AssetResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Asset'] = ResolversParentTypes['Asset']> = ResolversObject<{
  announcements?: Resolver<Maybe<Array<Maybe<ResolversTypes['Announcement']>>>, ParentType, ContextType>;
  assetFees?: Resolver<Maybe<Array<Maybe<ResolversTypes['AssetFees']>>>, ParentType, ContextType>;
  assetId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  blackBookValue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bodyStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyer?: Resolver<Maybe<ResolversTypes['Agent']>, ParentType, ContextType>;
  buyerAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerAccountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentPhoneMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentPicture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkinDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkinTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkinUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conditionReport?: Resolver<Maybe<ResolversTypes['ConditionReport']>, ParentType, ContextType>;
  consignor?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  consignorAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  consignorAccountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorDbaName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  consignorLegalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorPipelineId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countAll?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  crStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerReferenceNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cylinderConfiguration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cylinders?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  drivetrain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  drivetrainDesc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  engineSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exteriorColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  floorAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fuelType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grade?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasRun?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ifOfferManagement?: Resolver<Maybe<ResolversTypes['IfOfferManagement']>, ParentType, ContextType>;
  interiorColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listingCondition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listingConditionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listingConditionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  make?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mmrValue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  odometer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  onlineListing?: Resolver<Maybe<ResolversTypes['OnlineListing']>, ParentType, ContextType>;
  ownerStockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  photoBeauty?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  photoCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  photos?: Resolver<Maybe<Array<Maybe<ResolversTypes['Photo']>>>, ParentType, ContextType>;
  pipelineUri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pmrValue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  proxyBidCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  saleAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  saleEvents?: Resolver<Maybe<Array<Maybe<ResolversTypes['SaleEvent']>>>, ParentType, ContextType>;
  saleListing?: Resolver<Maybe<ResolversTypes['SaleListing']>, ParentType, ContextType>;
  saleListingDealSoldAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingLane?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingLot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingOfferCreatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingSaleDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingSaleStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingSoldDateLastRanTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingVenueCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingVenueName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingVenueUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentPhoneMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  services?: Resolver<Maybe<Array<Maybe<ResolversTypes['Service']>>>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleReceivedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transmissionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trim?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AssetFeesResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AssetFees'] = ResolversParentTypes['AssetFees']> = ResolversObject<{
  amount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chargeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  run?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AssetsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Assets'] = ResolversParentTypes['Assets']> = ResolversObject<{
  assetsByStockNumber?: Resolver<Maybe<ResolversTypes['Asset']>, ParentType, ContextType>;
  byId?: Resolver<Maybe<ResolversTypes['Asset']>, ParentType, ContextType>;
  byStockNumber?: Resolver<Maybe<ResolversTypes['Asset']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Asset']>>>, ParentType, ContextType, Partial<AssetsListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AttendanceResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Attendance'] = ResolversParentTypes['Attendance']> = ResolversObject<{
  attendanceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bidderBadgeNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AttendanceListResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AttendanceList'] = ResolversParentTypes['AttendanceList']> = ResolversObject<{
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Attendance']>>>, ParentType, ContextType, Partial<AttendanceListListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Auction'] = ResolversParentTypes['Auction']> = ResolversObject<{
  accounts?: Resolver<Maybe<ResolversTypes['Accounts']>, ParentType, ContextType, RequireFields<AuctionAccountsArgs, 'filter'>>;
  agentNoteTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AgentNoteType']>>>, ParentType, ContextType>;
  agentRoles?: Resolver<Maybe<Array<Maybe<ResolversTypes['AgentRole']>>>, ParentType, ContextType>;
  agents?: Resolver<Maybe<ResolversTypes['Agents']>, ParentType, ContextType, RequireFields<AuctionAgentsArgs, 'filter'>>;
  amsInfo?: Resolver<Maybe<ResolversTypes['AuctionAmsInfo']>, ParentType, ContextType>;
  assets?: Resolver<Maybe<ResolversTypes['Assets']>, ParentType, ContextType, RequireFields<AuctionAssetsArgs, 'filter'>>;
  auctionSettings?: Resolver<Maybe<ResolversTypes['AuctionSettingsResponse']>, ParentType, ContextType, Partial<AuctionAuctionSettingsArgs>>;
  card?: Resolver<Maybe<ResolversTypes['GenericCard']>, ParentType, ContextType, Partial<AuctionCardArgs>>;
  contactManagement?: Resolver<Maybe<ResolversTypes['ContactManagement']>, ParentType, ContextType>;
  document?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType>;
  getDownloadLink?: Resolver<Maybe<ResolversTypes['ShareReportResponse']>, ParentType, ContextType, Partial<AuctionGetDownloadLinkArgs>>;
  getReportConfig?: Resolver<Maybe<ResolversTypes['ReportConfig']>, ParentType, ContextType, Partial<AuctionGetReportConfigArgs>>;
  getReportConfigs?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReportConfig']>>>, ParentType, ContextType, Partial<AuctionGetReportConfigsArgs>>;
  groups?: Resolver<Maybe<Array<Maybe<ResolversTypes['AccountGroups']>>>, ParentType, ContextType, Partial<AuctionGroupsArgs>>;
  keys?: Resolver<Maybe<ResolversTypes['VdpByStockNumberResults']>, ParentType, ContextType, Partial<AuctionKeysArgs>>;
  lightOptions?: Resolver<Maybe<Array<Maybe<ResolversTypes['LightOption']>>>, ParentType, ContextType>;
  marketplace?: Resolver<Maybe<ResolversTypes['Marketplace']>, ParentType, ContextType>;
  psi?: Resolver<Maybe<ResolversTypes['Psi']>, ParentType, ContextType, Partial<AuctionPsiArgs>>;
  reportDetailPages?: Resolver<Array<ResolversTypes['ReportDetailPage']>, ParentType, ContextType>;
  reports?: Resolver<Maybe<Array<Maybe<ResolversTypes['Report']>>>, ParentType, ContextType, RequireFields<AuctionReportsArgs, 'filter'>>;
  roles?: Resolver<Maybe<Array<Maybe<ResolversTypes['RoleAttributes']>>>, ParentType, ContextType>;
  search?: Resolver<Maybe<ResolversTypes['SearchResults']>, ParentType, ContextType, Partial<AuctionSearchArgs>>;
  setVehicleInfo?: Resolver<Maybe<ResolversTypes['SetVehicleInfoResults']>, ParentType, ContextType, RequireFields<AuctionSetVehicleInfoArgs, 'assetId' | 'stockNumber'>>;
  statistics?: Resolver<Maybe<ResolversTypes['AuctionStatistics']>, ParentType, ContextType, Partial<AuctionStatisticsArgs>>;
  users?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserAttributes']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionAmsInfoResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionAmsInfo'] = ResolversParentTypes['AuctionAmsInfo']> = ResolversObject<{
  lightValues?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionCollectionResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionCollection'] = ResolversParentTypes['AuctionCollection']> = ResolversObject<{
  accounts?: Resolver<Maybe<ResolversTypes['Accounts']>, ParentType, ContextType, RequireFields<AuctionCollectionAccountsArgs, 'filter'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionKeyResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionKey'] = ResolversParentTypes['AuctionKey']> = ResolversObject<{
  accountingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amsId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pipelineId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uaId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionSettingsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionSettings'] = ResolversParentTypes['AuctionSettings']> = ResolversObject<{
  bidIncrement?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  buyNowTiers?: Resolver<Maybe<Array<Maybe<ResolversTypes['BuyNowTier']>>>, ParentType, ContextType>;
  enforceConditionReport?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  enforceFloorPrice?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  enforceGrade?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  enforceLight?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nonAdminEditBidIncrement?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nonAdminEditFloorPrice?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  offerThreshold?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startBidTiers?: Resolver<Maybe<Array<Maybe<ResolversTypes['StartBidTier']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionSettingsResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionSettingsResponse'] = ResolversParentTypes['AuctionSettingsResponse']> = ResolversObject<{
  data?: Resolver<Maybe<ResolversTypes['AuctionSettings']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionStatisticsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionStatistics'] = ResolversParentTypes['AuctionStatistics']> = ResolversObject<{
  bidders?: Resolver<Maybe<ResolversTypes['BidderList']>, ParentType, ContextType, RequireFields<AuctionStatisticsBiddersArgs, 'filter'>>;
  biddingStatistics?: Resolver<Maybe<ResolversTypes['BiddingStatistics']>, ParentType, ContextType>;
  lanes?: Resolver<Maybe<ResolversTypes['LaneList']>, ParentType, ContextType>;
  saleStatistics?: Resolver<Maybe<ResolversTypes['SalesDayStatistics']>, ParentType, ContextType>;
  trends?: Resolver<Maybe<ResolversTypes['Trends']>, ParentType, ContextType, RequireFields<AuctionStatisticsTrendsArgs, 'filter'>>;
  users?: Resolver<Maybe<Array<Maybe<ResolversTypes['User']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuditResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Audit'] = ResolversParentTypes['Audit']> = ResolversObject<{
  getVehicleAuditList?: Resolver<Maybe<ResolversTypes['AuditResponse']>, ParentType, ContextType, Partial<AuditGetVehicleAuditListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuditResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuditResponse'] = ResolversParentTypes['AuditResponse']> = ResolversObject<{
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['TestVehicleAuditLog']>>>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BidderResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Bidder'] = ResolversParentTypes['Bidder']> = ResolversObject<{
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accountKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountOrgId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  badge?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dbaName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BidderListResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['BidderList'] = ResolversParentTypes['BidderList']> = ResolversObject<{
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Bidder']>>>, ParentType, ContextType, Partial<BidderListListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BiddingStatisticsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['BiddingStatistics'] = ResolversParentTypes['BiddingStatistics']> = ResolversObject<{
  inlaneBidders?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  onlineBidders?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalBidders?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BuyNowTierResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['BuyNowTier'] = ResolversParentTypes['BuyNowTier']> = ResolversObject<{
  amountAbovePriceFloor?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  priceFloorLBound?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  priceFloorUBound?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CacheShapeResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['CacheShape'] = ResolversParentTypes['CacheShape']> = ResolversObject<{
  mutation?: Resolver<Maybe<ResolversTypes['Mutation']>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CalculatedIfOfferDataResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['CalculatedIfOfferData'] = ResolversParentTypes['CalculatedIfOfferData']> = ResolversObject<{
  buyerMovementThisOffer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerNotesThisOffer?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  sellerMovementThisOffer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerNotesThisOffer?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CancelProxyBidsResultResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['CancelProxyBidsResult'] = ResolversParentTypes['CancelProxyBidsResult']> = ResolversObject<{
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CardResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Card'] = ResolversParentTypes['Card']> = ResolversObject<{
  config?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompaniesListResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['CompaniesList'] = ResolversParentTypes['CompaniesList']> = ResolversObject<{
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['AgentCompany']>>>, ParentType, ContextType, Partial<CompaniesListListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConditionReportResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ConditionReport'] = ResolversParentTypes['ConditionReport']> = ResolversObject<{
  conditionReportStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conditionReportTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conditionReportWriter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConfigSearchResultsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ConfigSearchResults'] = ResolversParentTypes['ConfigSearchResults']> = ResolversObject<{
  searchStringDisplay?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehicleData?: Resolver<Maybe<Array<Maybe<ResolversTypes['VehicleDataTypes']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContactResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Contact'] = ResolversParentTypes['Contact']> = ResolversObject<{
  account?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  agentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  agentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerSellerAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contactedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  followUpDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  followUpUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  followupUserName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContactListResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ContactList'] = ResolversParentTypes['ContactList']> = ResolversObject<{
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Contact']>>>, ParentType, ContextType, Partial<ContactListListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContactLogStatsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ContactLogStats'] = ResolversParentTypes['ContactLogStats']> = ResolversObject<{
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContactManagementResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ContactManagement'] = ResolversParentTypes['ContactManagement']> = ResolversObject<{
  contacts?: Resolver<Maybe<ResolversTypes['ContactList']>, ParentType, ContextType, Partial<ContactManagementContactsArgs>>;
  statuses?: Resolver<Maybe<Array<Maybe<ResolversTypes['ContactStatus']>>>, ParentType, ContextType>;
  types?: Resolver<Maybe<Array<Maybe<ResolversTypes['ContactType']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContactStatusResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ContactStatus'] = ResolversParentTypes['ContactStatus']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContactTypeResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ContactType'] = ResolversParentTypes['ContactType']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateDocumentOutputAssetResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['CreateDocumentOutputAsset'] = ResolversParentTypes['CreateDocumentOutputAsset']> = ResolversObject<{
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  attachment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  docTypeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  docTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  docTypeShortCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateDocumentUploadDocResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['CreateDocumentUploadDoc'] = ResolversParentTypes['CreateDocumentUploadDoc']> = ResolversObject<{
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  docId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  s3PresignedUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateDocumentsUploadItemResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['CreateDocumentsUploadItem'] = ResolversParentTypes['CreateDocumentsUploadItem']> = ResolversObject<{
  asset?: Resolver<Maybe<ResolversTypes['CreateDocumentOutputAsset']>, ParentType, ContextType>;
  doc?: Resolver<Maybe<ResolversTypes['CreateDocumentUploadDoc']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateReportConfigResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['CreateReportConfigResponse'] = ResolversParentTypes['CreateReportConfigResponse']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreatedEventResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['CreatedEventResponse'] = ResolversParentTypes['CreatedEventResponse']> = ResolversObject<{
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CurrentSaleResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['CurrentSale'] = ResolversParentTypes['CurrentSale']> = ResolversObject<{
  asset_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  display_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venue_event_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venue_event_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DashboardResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Dashboard'] = ResolversParentTypes['Dashboard']> = ResolversObject<{
  cards?: Resolver<Maybe<Array<Maybe<ResolversTypes['Card']>>>, ParentType, ContextType>;
  configJson?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  databaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DashboardsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Dashboards'] = ResolversParentTypes['Dashboards']> = ResolversObject<{
  byId?: Resolver<Maybe<ResolversTypes['Dashboard']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Dashboard']>>>, ParentType, ContextType, Partial<DashboardsListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DataConfigResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['DataConfig'] = ResolversParentTypes['DataConfig']> = ResolversObject<{
  dataFilter?: Resolver<Maybe<ResolversTypes['ReportSearchFilter']>, ParentType, ContextType>;
  dataSource?: Resolver<Maybe<ResolversTypes['DataSourceTypes']>, ParentType, ContextType>;
  pageInfo?: Resolver<Maybe<ResolversTypes['PageInfoConfig']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DealResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Deal'] = ResolversParentTypes['Deal']> = ResolversObject<{
  buyer?: Resolver<Maybe<ResolversTypes['Agent']>, ParentType, ContextType>;
  currentOfferAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dealStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListing?: Resolver<Maybe<ResolversTypes['SaleListing']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DealerResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Dealer'] = ResolversParentTypes['Dealer']> = ResolversObject<{
  dealerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DocTypeResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['DocType'] = ResolversParentTypes['DocType']> = ResolversObject<{
  displayOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  docTypeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  docTypeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  docTypeNameUnderscored?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  verticalTypeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DocumentResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Document'] = ResolversParentTypes['Document']> = ResolversObject<{
  accountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attachment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  buyerAccountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAtFormatted?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentSaleListingDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerAccountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  displayOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  docId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  docName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  docTypeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  docTypeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  docTypeNameUnderscored?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  docTypeShortCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentActivity?: Resolver<Maybe<ResolversTypes['DocumentActivity']>, ParentType, ContextType, RequireFields<DocumentDocumentActivityArgs, 'docId'>>;
  documentByDocId?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType, RequireFields<DocumentDocumentByDocIdArgs, 'filter'>>;
  documentByDocTypeShortCode?: Resolver<Maybe<Array<Maybe<ResolversTypes['Document']>>>, ParentType, ContextType, RequireFields<DocumentDocumentByDocTypeShortCodeArgs, 'filter'>>;
  documentFilterLists?: Resolver<Maybe<Array<Maybe<ResolversTypes['Document']>>>, ParentType, ContextType, RequireFields<DocumentDocumentFilterListsArgs, 'filter'>>;
  documentLists?: Resolver<Maybe<Array<Maybe<ResolversTypes['Document']>>>, ParentType, ContextType, RequireFields<DocumentDocumentListsArgs, 'filter'>>;
  documentTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['DocType']>>>, ParentType, ContextType, RequireFields<DocumentDocumentTypesArgs, 'verticalTypeId'>>;
  documentUploadURLs?: Resolver<Maybe<Array<Maybe<ResolversTypes['DocumentUploadURL']>>>, ParentType, ContextType, RequireFields<DocumentDocumentUploadUrLsArgs, 'filter'>>;
  documentsByAuctionFilter?: Resolver<Maybe<ResolversTypes['PaginatedDocumentResponse']>, ParentType, ContextType, RequireFields<DocumentDocumentsByAuctionFilterArgs, 'filter'>>;
  numNotes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  s3Url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  s3UrlDownload?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  s3UrlExpires?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  s3UrlExpiresFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAtFormatted?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehicleMake?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehicleModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehicleVIN?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehicleYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehiclesWithDocs?: Resolver<Maybe<ResolversTypes['VehiclesWithDocsResponse']>, ParentType, ContextType, Partial<DocumentVehiclesWithDocsArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DocumentActivityResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['DocumentActivity'] = ResolversParentTypes['DocumentActivity']> = ResolversObject<{
  documentViews?: Resolver<Maybe<Array<Maybe<ResolversTypes['DocumentView']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DocumentUploadUrlResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['DocumentUploadURL'] = ResolversParentTypes['DocumentUploadURL']> = ResolversObject<{
  customerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fileType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  s3Key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  s3uploadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  urlExpires?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DocumentViewResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['DocumentView'] = ResolversParentTypes['DocumentView']> = ResolversObject<{
  docId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userDisplay?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userType?: Resolver<Maybe<ResolversTypes['USER_TYPES']>, ParentType, ContextType>;
  viewedAt?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EventTypeTriggerResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['EventTypeTrigger'] = ResolversParentTypes['EventTypeTrigger']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  longDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ordinal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenericCardResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['GenericCard'] = ResolversParentTypes['GenericCard']> = ResolversObject<{
  vdpViewsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vdpViewsStats?: Resolver<Maybe<Array<Maybe<ResolversTypes['OnlineStatistic']>>>, ParentType, ContextType>;
  watchedVehiclesCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  watchedVehiclesList?: Resolver<Maybe<Array<Maybe<ResolversTypes['OnlineListing']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HttpResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['HttpResponse'] = ResolversParentTypes['HttpResponse']> = ResolversObject<{
  statusCode?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  statusMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IfOfferHistoryResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['IfOfferHistory'] = ResolversParentTypes['IfOfferHistory']> = ResolversObject<{
  announcementLight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  announcementLights?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetAnnouncementFour?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetAnnouncementOne?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetAnnouncementThree?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetAnnouncementTwo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  ballControlCode?: Resolver<Maybe<ResolversTypes['BallControlCode']>, ParentType, ContextType>;
  ballControlDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyNowPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerAgentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerOrSellerAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  correlationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentOfferAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  currentOfferAmountPrevious?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dealId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dealStatusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventCreatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventCreatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventCreatedById?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  eventDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  eventNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventTriggerCode?: Resolver<Maybe<ResolversTypes['EventTriggerCode']>, ParentType, ContextType>;
  eventTriggerDesc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventTypeCode?: Resolver<Maybe<ResolversTypes['EventTypeCode']>, ParentType, ContextType>;
  eventTypeDesc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fees?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  floorPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isVirtualAuction?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  laneName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lotNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerAgentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valuationBlackbookAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  valuationMMRAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IfOfferManagementResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['IfOfferManagement'] = ResolversParentTypes['IfOfferManagement']> = ResolversObject<{
  buyerAgent?: Resolver<Maybe<ResolversTypes['Agent']>, ParentType, ContextType>;
  buyerAgents?: Resolver<Maybe<Array<Maybe<ResolversTypes['Agent']>>>, ParentType, ContextType>;
  calculatedIfOfferData?: Resolver<Maybe<ResolversTypes['CalculatedIfOfferData']>, ParentType, ContextType>;
  eventTriggers?: Resolver<Maybe<Array<Maybe<ResolversTypes['EventTypeTrigger']>>>, ParentType, ContextType>;
  eventTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['EventTypeTrigger']>>>, ParentType, ContextType>;
  ifOfferHistory?: Resolver<Maybe<Array<Maybe<ResolversTypes['IfOfferHistory']>>>, ParentType, ContextType>;
  noSaleHistory?: Resolver<Maybe<Array<Maybe<ResolversTypes['NoSaleHistory']>>>, ParentType, ContextType>;
  pastSalesHistory?: Resolver<Maybe<Array<Maybe<ResolversTypes['PastSale']>>>, ParentType, ContextType>;
  sellerAgent?: Resolver<Maybe<ResolversTypes['Agent']>, ParentType, ContextType>;
  sellerAgents?: Resolver<Maybe<Array<Maybe<ResolversTypes['Agent']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IfOfferNotesResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['IfOfferNotes'] = ResolversParentTypes['IfOfferNotes']> = ResolversObject<{
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  note?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['IfOfferNoteType'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IfOfferUpdateAmsResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['IfOfferUpdateAMSResponse'] = ResolversParentTypes['IfOfferUpdateAMSResponse']> = ResolversObject<{
  data?: Resolver<Maybe<ResolversTypes['AmsResponse']>, ParentType, ContextType>;
  messages?: Resolver<Maybe<ResolversTypes['AMSUpdateResponseMessages']>, ParentType, ContextType>;
  responseCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IfOfferUpdateResultResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['IfOfferUpdateResult'] = ResolversParentTypes['IfOfferUpdateResult']> = ResolversObject<{
  amsStatusCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amsStatusText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  ifNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['IfOfferNotes']>>>, ParentType, ContextType>;
  lastOfferHistoryItem?: Resolver<Maybe<ResolversTypes['IfOfferHistory']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IfOfferUpdateResultsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['IfOfferUpdateResults'] = ResolversParentTypes['IfOfferUpdateResults']> = ResolversObject<{
  results?: Resolver<Maybe<Array<Maybe<ResolversTypes['IfOfferUpdateResult']>>>, ParentType, ContextType>;
  searchUpdateSuccess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InspectionTypeResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['InspectionType'] = ResolversParentTypes['InspectionType']> = ResolversObject<{
  chargeAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  chargeAmountFail?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  chargeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultPrinterName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  longDesc?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ordinal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  orgId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  printOnCreate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quickPickLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quickPickOrdinal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  serviceClass?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  serviceCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortDesc?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InspectionTypeFilterResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['InspectionTypeFilter'] = ResolversParentTypes['InspectionTypeFilter']> = ResolversObject<{
  amsServiceCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chargeAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  orgCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  serviceProductId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LaneResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Lane'] = ResolversParentTypes['Lane']> = ResolversObject<{
  arbitration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  eventDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasCr?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  offer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  offerOnline?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  registered?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  run?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  soldOnline?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  units?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LaneListResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['LaneList'] = ResolversParentTypes['LaneList']> = ResolversObject<{
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Lane']>>>, ParentType, ContextType, Partial<LaneListListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LightOptionResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['LightOption'] = ResolversParentTypes['LightOption']> = ResolversObject<{
  amsValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lightCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lightDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lightId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ListViewResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ListView'] = ResolversParentTypes['ListView']> = ResolversObject<{
  columns?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReportColumn']>>>, ParentType, ContextType>;
  mobileColumns?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReportColumn']>>>, ParentType, ContextType>;
  paths?: Resolver<Maybe<ResolversTypes['PathConfig']>, ParentType, ContextType>;
  shareSubject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateVars?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LocalCreateDocumentOutputResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['LocalCreateDocumentOutput'] = ResolversParentTypes['LocalCreateDocumentOutput']> = ResolversObject<{
  docId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LocationResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Location'] = ResolversParentTypes['Location']> = ResolversObject<{
  address1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LoginResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['LoginResponse'] = ResolversParentTypes['LoginResponse']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<ResolversTypes['LoginResponseTypes'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MaintenanceUpdateResultResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['MaintenanceUpdateResult'] = ResolversParentTypes['MaintenanceUpdateResult']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarketplaceResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Marketplace'] = ResolversParentTypes['Marketplace']> = ResolversObject<{
  listings?: Resolver<Maybe<ResolversTypes['OnlineListings']>, ParentType, ContextType, Partial<MarketplaceListingsArgs>>;
  statistics?: Resolver<Maybe<ResolversTypes['MarketplaceStatistics']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarketplaceStatisticsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['MarketplaceStatistics'] = ResolversParentTypes['MarketplaceStatistics']> = ResolversObject<{
  activeListings?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  soldOnline?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  viewed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<MarketplaceStatisticsViewedArgs>>;
  viewedByDate?: Resolver<Maybe<Array<Maybe<ResolversTypes['OnlineStatistic']>>>, ParentType, ContextType, Partial<MarketplaceStatisticsViewedByDateArgs>>;
  watched?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MutationResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = ResolversObject<{
  addAssetsToVenueEvent?: Resolver<Maybe<Array<Maybe<ResolversTypes['MutationResponse']>>>, ParentType, ContextType, Partial<MutationAddAssetsToVenueEventArgs>>;
  addDashboardCard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationAddDashboardCardArgs, 'card'>>;
  addPastSearch?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationAddPastSearchArgs, 'input'>>;
  batchCreateDocument?: Resolver<Maybe<Array<Maybe<ResolversTypes['Document']>>>, ParentType, ContextType, RequireFields<MutationBatchCreateDocumentArgs, 'createDocumentInput'>>;
  beginEditingLayouts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  changeAuction?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationChangeAuctionArgs, 'newAuction'>>;
  changeDashboardName?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationChangeDashboardNameArgs, 'name'>>;
  closeAccessoryDrawer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  copyDashboard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationCopyDashboardArgs, 'name'>>;
  copyDashboardCard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationCopyDashboardCardArgs, 'widgetId'>>;
  createAgentContact?: Resolver<Maybe<ResolversTypes['Contact']>, ParentType, ContextType, RequireFields<MutationCreateAgentContactArgs, 'input'>>;
  createDashboard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationCreateDashboardArgs, 'name'>>;
  createDocuments?: Resolver<Maybe<Array<Maybe<ResolversTypes['CreateDocumentsUploadItem']>>>, ParentType, ContextType, RequireFields<MutationCreateDocumentsArgs, 'auctionId'>>;
  createDocumentsClient?: Resolver<Maybe<Array<Maybe<ResolversTypes['LocalCreateDocumentOutput']>>>, ParentType, ContextType, RequireFields<MutationCreateDocumentsClientArgs, 'docs'>>;
  createPSI?: Resolver<Maybe<ResolversTypes['OpenPsiResponse']>, ParentType, ContextType, Partial<MutationCreatePsiArgs>>;
  createReportConfig?: Resolver<Maybe<ResolversTypes['CreateReportConfigResponse']>, ParentType, ContextType, Partial<MutationCreateReportConfigArgs>>;
  createUser?: Resolver<Maybe<ResolversTypes['UserMutationResponse']>, ParentType, ContextType, RequireFields<MutationCreateUserArgs, 'input'>>;
  createVenueEvent?: Resolver<Maybe<ResolversTypes['CreatedEventResponse']>, ParentType, ContextType, Partial<MutationCreateVenueEventArgs>>;
  deleteAgentContact?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteAgentContactArgs, 'id' | 'input'>>;
  deleteDashboard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<MutationDeleteDashboardArgs>>;
  deleteDashboardCard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteDashboardCardArgs, 'cardId'>>;
  deleteUser?: Resolver<Maybe<ResolversTypes['UserMutationResponse']>, ParentType, ContextType, RequireFields<MutationDeleteUserArgs, 'input'>>;
  deleteVenueEvent?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, Partial<MutationDeleteVenueEventArgs>>;
  doCompleteNewPassword?: Resolver<Maybe<ResolversTypes['LoginResponse']>, ParentType, ContextType, RequireFields<MutationDoCompleteNewPasswordArgs, 'newPassword'>>;
  doLogin?: Resolver<Maybe<ResolversTypes['LoginResponse']>, ParentType, ContextType, RequireFields<MutationDoLoginArgs, 'credentials'>>;
  doLogout?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  doResetPasswordByEmail?: Resolver<Maybe<ResolversTypes['ResetPasswordByEmailResponse']>, ParentType, ContextType, RequireFields<MutationDoResetPasswordByEmailArgs, 'email'>>;
  endEditingLayouts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  exitVehicle?: Resolver<Maybe<ResolversTypes['VehicleAMSResponse']>, ParentType, ContextType, RequireFields<MutationExitVehicleArgs, 'exitVehicleDetails'>>;
  generatePDF?: Resolver<Maybe<ResolversTypes['ShareReportResponse']>, ParentType, ContextType, Partial<MutationGeneratePdfArgs>>;
  generateUploadUrl?: Resolver<ResolversTypes['DocumentUploadURL'], ParentType, ContextType, RequireFields<MutationGenerateUploadUrlArgs, 'assetId'>>;
  noSale?: Resolver<Maybe<ResolversTypes['VehicleAMSResponse']>, ParentType, ContextType, RequireFields<MutationNoSaleArgs, 'noSaleDetails'>>;
  pullVehicle?: Resolver<Maybe<ResolversTypes['VehicleAMSResponse']>, ParentType, ContextType, RequireFields<MutationPullVehicleArgs, 'pullVehicleDetails'>>;
  pushToAMS?: Resolver<Maybe<ResolversTypes['pushToAMSResponse']>, ParentType, ContextType, RequireFields<MutationPushToAmsArgs, 'ids'>>;
  pushVehicleToAms?: Resolver<Maybe<ResolversTypes['PushVehicleToAmsResults']>, ParentType, ContextType, RequireFields<MutationPushVehicleToAmsArgs, 'id'>>;
  pushVehiclesToAms?: Resolver<Maybe<ResolversTypes['PushVehiclesToAmsResults']>, ParentType, ContextType, RequireFields<MutationPushVehiclesToAmsArgs, 'ids'>>;
  putMessage?: Resolver<Maybe<ResolversTypes['sendMessageStatus']>, ParentType, ContextType, Partial<MutationPutMessageArgs>>;
  registerBidder?: Resolver<Maybe<ResolversTypes['RegisterBidderResponse']>, ParentType, ContextType, RequireFields<MutationRegisterBidderArgs, 'bidderDetails'>>;
  removeAssetFromVenueEvent?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, Partial<MutationRemoveAssetFromVenueEventArgs>>;
  removeAssetsFromVenueEvent?: Resolver<Maybe<Array<Maybe<ResolversTypes['MutationResponse']>>>, ParentType, ContextType, Partial<MutationRemoveAssetsFromVenueEventArgs>>;
  removeDocument?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType, RequireFields<MutationRemoveDocumentArgs, 'docId'>>;
  reorderUserDashboards?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationReorderUserDashboardsArgs, 'id' | 'index'>>;
  resendUnconfirmedPassword?: Resolver<Maybe<ResolversTypes['HttpResponse']>, ParentType, ContextType, RequireFields<MutationResendUnconfirmedPasswordArgs, 'input'>>;
  resetPasswordByEmail?: Resolver<Maybe<ResolversTypes['ResetPasswordByEmailResponse']>, ParentType, ContextType, RequireFields<MutationResetPasswordByEmailArgs, 'input'>>;
  reverseSale?: Resolver<Maybe<ResolversTypes['VehicleAMSResponse']>, ParentType, ContextType, RequireFields<MutationReverseSaleArgs, 'reverseSaleDetails'>>;
  saveLayouts?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<MutationSaveLayoutsArgs>>;
  setVehicleInfo?: Resolver<Maybe<ResolversTypes['SetVehicleInfoResults']>, ParentType, ContextType, RequireFields<MutationSetVehicleInfoArgs, 'amsType' | 'assetId' | 'floor' | 'selectedLightId' | 'stockNumber'>>;
  sharePdfCsv?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSharePdfCsvArgs, 'messageBody' | 'senderEmail' | 'senderName'>>;
  showAccessoryDrawer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationShowAccessoryDrawerArgs, 'input'>>;
  tempSaveLayouts?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationTempSaveLayoutsArgs, 'layouts'>>;
  updateAgentContact?: Resolver<Maybe<ResolversTypes['Contact']>, ParentType, ContextType, RequireFields<MutationUpdateAgentContactArgs, 'id' | 'input'>>;
  updateAgentNote?: Resolver<Maybe<ResolversTypes['AgentNoteUpdateResult']>, ParentType, ContextType, Partial<MutationUpdateAgentNoteArgs>>;
  updateAgentRoles?: Resolver<Maybe<ResolversTypes['AgentRoleUpdateResults']>, ParentType, ContextType, Partial<MutationUpdateAgentRolesArgs>>;
  updateAllAssetsOnVenueEvent?: Resolver<Maybe<ResolversTypes['UpateAllListingsMutationResponse']>, ParentType, ContextType, Partial<MutationUpdateAllAssetsOnVenueEventArgs>>;
  updateAssetOnVenueEvent?: Resolver<Maybe<ResolversTypes['MutationResponse']>, ParentType, ContextType, Partial<MutationUpdateAssetOnVenueEventArgs>>;
  updateAssetsOnVenueEvent?: Resolver<Maybe<Array<Maybe<ResolversTypes['MutationResponse']>>>, ParentType, ContextType, Partial<MutationUpdateAssetsOnVenueEventArgs>>;
  updateAuctionSettings?: Resolver<Maybe<ResolversTypes['AuctionSettingsResponse']>, ParentType, ContextType, Partial<MutationUpdateAuctionSettingsArgs>>;
  updateBIRoles?: Resolver<Maybe<ResolversTypes['HttpResponse']>, ParentType, ContextType, Partial<MutationUpdateBiRolesArgs>>;
  updateDashboardCard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpdateDashboardCardArgs, 'card' | 'cardId'>>;
  updateDocTypeShortCode?: Resolver<Maybe<ResolversTypes['UpdateDocumentsResponse']>, ParentType, ContextType, RequireFields<MutationUpdateDocTypeShortCodeArgs, 'tenantId'>>;
  updateDocument?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType, RequireFields<MutationUpdateDocumentArgs, 'updateDocumentInput'>>;
  updateDocuments?: Resolver<Maybe<ResolversTypes['UpdateDocumentsResponse']>, ParentType, ContextType, RequireFields<MutationUpdateDocumentsArgs, 'tenantId'>>;
  updateFavoriteAccount?: Resolver<Maybe<ResolversTypes['HttpResponse']>, ParentType, ContextType, Partial<MutationUpdateFavoriteAccountArgs>>;
  updateIfOffer?: Resolver<Maybe<ResolversTypes['IfOfferUpdateResults']>, ParentType, ContextType, Partial<MutationUpdateIfOfferArgs>>;
  updateMaintenanceStatus?: Resolver<Maybe<ResolversTypes['MaintenanceUpdateResult']>, ParentType, ContextType, Partial<MutationUpdateMaintenanceStatusArgs>>;
  updateMultipleIfOffers?: Resolver<Maybe<ResolversTypes['IfOfferUpdateResults']>, ParentType, ContextType, Partial<MutationUpdateMultipleIfOffersArgs>>;
  updateRoles?: Resolver<Maybe<ResolversTypes['HttpResponse']>, ParentType, ContextType, RequireFields<MutationUpdateRolesArgs, 'input'>>;
  updateTenantIdAndCreatedAt?: Resolver<Maybe<ResolversTypes['UpdateDocumentsResponse']>, ParentType, ContextType, RequireFields<MutationUpdateTenantIdAndCreatedAtArgs, 'tenantId'>>;
  updateUser?: Resolver<Maybe<ResolversTypes['UserMutationResponse']>, ParentType, ContextType, RequireFields<MutationUpdateUserArgs, 'input'>>;
  updateVenueEvent?: Resolver<Maybe<ResolversTypes['CreatedEventResponse']>, ParentType, ContextType, Partial<MutationUpdateVenueEventArgs>>;
  uploadDocument?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUploadDocumentArgs, 'input'>>;
  uploadDocuments?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUploadDocumentsArgs, 'docs'>>;
}>;

export type MutationDataResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['MutationDataResponse'] = ResolversParentTypes['MutationDataResponse']> = ResolversObject<{
  __resolveType: TypeResolveFn<'VenueEvent' | 'VenueSaleListingAsset', ParentType, ContextType>;
}>;

export type MutationResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['MutationResponse'] = ResolversParentTypes['MutationResponse']> = ResolversObject<{
  data?: Resolver<Maybe<ResolversTypes['MutationDataResponse']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NoSaleHistoryResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['NoSaleHistory'] = ResolversParentTypes['NoSaleHistory']> = ResolversObject<{
  eventDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasRun?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  highBid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lane?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OnlineListingResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['OnlineListing'] = ResolversParentTypes['OnlineListing']> = ResolversObject<{
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  make?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mmrValuation?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vdpUri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  watchCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  watchers?: Resolver<Maybe<Array<Maybe<ResolversTypes['Watcher']>>>, ParentType, ContextType>;
  webViews?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OnlineListingsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['OnlineListings'] = ResolversParentTypes['OnlineListings']> = ResolversObject<{
  byAssetId?: Resolver<Maybe<ResolversTypes['OnlineListing']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<Maybe<ResolversTypes['OnlineListing']>>>, ParentType, ContextType, Partial<OnlineListingsListArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OnlineStatisticResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['OnlineStatistic'] = ResolversParentTypes['OnlineStatistic']> = ResolversObject<{
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OpenPsiResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['OpenPsiResponse'] = ResolversParentTypes['OpenPsiResponse']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responseCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  serviceResponses?: Resolver<Maybe<Array<Maybe<ResolversTypes['ServiceResponse']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Organization'] = ResolversParentTypes['Organization']> = ResolversObject<{
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupOrgId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isAEAdmin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isAdmin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isAuctionUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isCorporateGroupUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orgId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orgNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  orgTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sites?: Resolver<Maybe<Array<Maybe<ResolversTypes['Site']>>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageInfoConfigResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['PageInfoConfig'] = ResolversParentTypes['PageInfoConfig']> = ResolversObject<{
  csvMaxRows?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  offset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  overRidePageLimit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sortColumns?: Resolver<Maybe<Array<Maybe<ResolversTypes['SortColumn']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaginatedDocumentResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['PaginatedDocumentResponse'] = ResolversParentTypes['PaginatedDocumentResponse']> = ResolversObject<{
  itemCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Document']>>>, ParentType, ContextType>;
  nextToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PastSaleResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['PastSale'] = ResolversParentTypes['PastSale']> = ResolversObject<{
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  buyerAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  closedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealHistory?: Resolver<Maybe<Array<Maybe<ResolversTypes['IfOfferHistory']>>>, ParentType, ContextType>;
  dealId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dealOutcome?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventClassCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventClassName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasRun?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  highBid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lane?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastCounter?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastCounterBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noSold?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  rejectedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  soldAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  venueCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueEventTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PastSearchResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['PastSearch'] = ResolversParentTypes['PastSearch']> = ResolversObject<{
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filterName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PathConfigResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['PathConfig'] = ResolversParentTypes['PathConfig']> = ResolversObject<{
  countPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PermissionItemResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['PermissionItem'] = ResolversParentTypes['PermissionItem']> = ResolversObject<{
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PhotoResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Photo'] = ResolversParentTypes['Photo']> = ResolversObject<{
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hiresUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_60x50?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_70x53?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_100x75?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_200x150?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_220x165?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_300x231?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_320x240?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_400x300?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_480x360?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_480x480?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUri_640x480?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isPrimary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pipelineUri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  standardUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProfileResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Profile'] = ResolversParentTypes['Profile']> = ResolversObject<{
  authenticationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dashboards?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  databaseId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  familyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mobilePhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<ResolversTypes['RoleAttributes']>>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PsiResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Psi'] = ResolversParentTypes['Psi']> = ResolversObject<{
  inspectionTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['InspectionType']>>>, ParentType, ContextType, Partial<PsiInspectionTypesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PsiNoteResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['PsiNote'] = ResolversParentTypes['PsiNote']> = ResolversObject<{
  agentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  agentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noteText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noteType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sparkUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PushVehicleToAmsResultsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['PushVehicleToAmsResults'] = ResolversParentTypes['PushVehicleToAmsResults']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PushVehiclesToAmsResultsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['PushVehiclesToAmsResults'] = ResolversParentTypes['PushVehiclesToAmsResults']> = ResolversObject<{
  results?: Resolver<Maybe<Array<Maybe<ResolversTypes['SinglePushVehicleToAmsResult']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = ResolversObject<{
  accessoryDrawerState?: Resolver<Maybe<ResolversTypes['AccessoryDrawerDisplay']>, ParentType, ContextType>;
  activeOrganization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  adminUserAttributes?: Resolver<ResolversTypes['UserAttributes'], ParentType, ContextType, Partial<QueryAdminUserAttributesArgs>>;
  administrator?: Resolver<Maybe<ResolversTypes['Administrator']>, ParentType, ContextType>;
  auction?: Resolver<Maybe<ResolversTypes['Auction']>, ParentType, ContextType, Partial<QueryAuctionArgs>>;
  auctionCollection?: Resolver<Maybe<ResolversTypes['Auction']>, ParentType, ContextType, Partial<QueryAuctionCollectionArgs>>;
  dashboardReflowTrigger?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dashboards?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType, Partial<QueryDashboardsArgs>>;
  documentTypes?: Resolver<Array<ResolversTypes['DocType']>, ParentType, ContextType>;
  getAgentByAuctionAccess?: Resolver<Maybe<ResolversTypes['QueryAgentResponse']>, ParentType, ContextType, Partial<QueryGetAgentByAuctionAccessArgs>>;
  getVenueEvent?: Resolver<Maybe<ResolversTypes['QueryResponse']>, ParentType, ContextType, Partial<QueryGetVenueEventArgs>>;
  getVenueEventRunList?: Resolver<Maybe<ResolversTypes['QueryRunListResponse']>, ParentType, ContextType, Partial<QueryGetVenueEventRunListArgs>>;
  getVenueEvents?: Resolver<Maybe<ResolversTypes['QueryEventsListResponse']>, ParentType, ContextType, Partial<QueryGetVenueEventsArgs>>;
  isEditingLayouts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  layouts?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  passwordRecoveryEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pastSearches?: Resolver<Maybe<Array<Maybe<ResolversTypes['PastSearch']>>>, ParentType, ContextType>;
  profile?: Resolver<Maybe<ResolversTypes['Profile']>, ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['RoleAttributes']>, ParentType, ContextType>;
  tempLayouts?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
}>;

export type QueryAgentResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['QueryAgentResponse'] = ResolversParentTypes['QueryAgentResponse']> = ResolversObject<{
  data?: Resolver<Maybe<ResolversTypes['AgentDealerResponse']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryEventsListResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['QueryEventsListResponse'] = ResolversParentTypes['QueryEventsListResponse']> = ResolversObject<{
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['VenueEvent']>>>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['QueryResponse'] = ResolversParentTypes['QueryResponse']> = ResolversObject<{
  data?: Resolver<Maybe<ResolversTypes['VenueEvent']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryRunListResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['QueryRunListResponse'] = ResolversParentTypes['QueryRunListResponse']> = ResolversObject<{
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['VenueSaleListingAsset']>>>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RegisterBidderResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['RegisterBidderResponse'] = ResolversParentTypes['RegisterBidderResponse']> = ResolversObject<{
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReportResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Report'] = ResolversParentTypes['Report']> = ResolversObject<{
  auctionType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  longDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orgId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reportId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reportLongName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reportShortName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reportUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReportColumnResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ReportColumn'] = ResolversParentTypes['ReportColumn']> = ResolversObject<{
  header?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReportConfigResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ReportConfig'] = ResolversParentTypes['ReportConfig']> = ResolversObject<{
  PK?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  SK?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auctionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardViewConfig?: Resolver<Maybe<ResolversTypes['ListView']>, ParentType, ContextType>;
  dataConfig?: Resolver<Maybe<ResolversTypes['DataConfig']>, ParentType, ContextType>;
  defaultSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listViewConfig?: Resolver<Maybe<ResolversTypes['ListView']>, ParentType, ContextType>;
  pdfViewConfig?: Resolver<Maybe<ResolversTypes['ListView']>, ParentType, ContextType>;
  reportKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scope?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  searchResults?: Resolver<Maybe<ResolversTypes['ConfigSearchResults']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReportDateOffsetResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ReportDateOffset'] = ResolversParentTypes['ReportDateOffset']> = ResolversObject<{
  end?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReportDetailPageResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ReportDetailPage'] = ResolversParentTypes['ReportDetailPage']> = ResolversObject<{
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requiredRoles?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReportSearchFilterResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ReportSearchFilter'] = ResolversParentTypes['ReportSearchFilter']> = ResolversObject<{
  dataQuery?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateOffset?: Resolver<Maybe<ResolversTypes['ReportDateOffset']>, ParentType, ContextType>;
  forFollowup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchString?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchType?: Resolver<Maybe<ResolversTypes['SEARCH_TYPES']>, ParentType, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  watched?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ResetPasswordByEmailResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ResetPasswordByEmailResponse'] = ResolversParentTypes['ResetPasswordByEmailResponse']> = ResolversObject<{
  statusCode?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  statusMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RoleResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Role'] = ResolversParentTypes['Role']> = ResolversObject<{
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RoleAttributesResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['RoleAttributes'] = ResolversParentTypes['RoleAttributes']> = ResolversObject<{
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SaleEventResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SaleEvent'] = ResolversParentTypes['SaleEvent']> = ResolversObject<{
  buyerAgentAaNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentStatusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerOrgAaNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerOrgStatusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealSaleAmt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dealStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventEndTs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventEndedAtTs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventStartTs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  floorPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lane?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lotNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueEventKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueEventTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SaleListingResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SaleListing'] = ResolversParentTypes['SaleListing']> = ResolversObject<{
  buyerAgentEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentPhoneMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentPicture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasRun?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lane?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listingCondition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingDealSoldAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingOfferCreatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentPhoneMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sequence?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soldDateLastRanTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SalesDayStatisticsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SalesDayStatistics'] = ResolversParentTypes['SalesDayStatistics']> = ResolversObject<{
  checkedIn?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  checkedInToday?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  missingCRs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  needsPhotos?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  run?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  units?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchAccountResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SearchAccount'] = ResolversParentTypes['SearchAccount']> = ResolversObject<{
  accountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountLegacyType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountSalesRep?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auctionAccess?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  canBuy?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  canSell?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dbaName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  establishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFavorite?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastAttendedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastBoughtAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastSoldAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchScore?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchAgentResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SearchAgent'] = ResolversParentTypes['SearchAgent']> = ResolversObject<{
  accountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountSalesRep?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auctionAccess?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cellPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dbaName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastAttendBadgeIssuedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastAttendBadgeNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastAttendBidderType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastAttendDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchScore?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  workPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchBidderResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SearchBidder'] = ResolversParentTypes['SearchBidder']> = ResolversObject<{
  BadgeIssuedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  BadgeNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  BidderType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auctionAccess?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cellPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorLegacyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorLegacyType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchScore?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehiclesPurchasedCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  workPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchContactLogResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SearchContactLog'] = ResolversParentTypes['SearchContactLog']> = ResolversObject<{
  accountAuctionAccess?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auctionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedUserid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contactedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorUserid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  followUpDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  followUpUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  followupAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  followupEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  followupFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  followupUserid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  followupUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  update?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchResultsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SearchResults'] = ResolversParentTypes['SearchResults']> = ResolversObject<{
  accountCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accountResult?: Resolver<Maybe<Array<Maybe<ResolversTypes['SearchAccount']>>>, ParentType, ContextType>;
  agentCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  agentResult?: Resolver<Maybe<Array<Maybe<ResolversTypes['SearchAgent']>>>, ParentType, ContextType>;
  bidderCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bidderResult?: Resolver<Maybe<Array<Maybe<ResolversTypes['SearchBidder']>>>, ParentType, ContextType>;
  contactLogCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contactLogResult?: Resolver<Maybe<Array<Maybe<ResolversTypes['SearchContactLog']>>>, ParentType, ContextType>;
  contactLogStats?: Resolver<Maybe<ResolversTypes['ContactLogStats']>, ParentType, ContextType>;
  searchStringDisplay?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchStringJson?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vehicleCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vehicleInSaleCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vehicleInSaleResult?: Resolver<Maybe<Array<Maybe<ResolversTypes['SearchVehicle']>>>, ParentType, ContextType>;
  vehicleRecentlySoldCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vehicleRecentlySoldResult?: Resolver<Maybe<Array<Maybe<ResolversTypes['SearchVehicle']>>>, ParentType, ContextType>;
  vehicleResult?: Resolver<Maybe<Array<Maybe<ResolversTypes['SearchVehicle']>>>, ParentType, ContextType>;
  vehicleResultCsvUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehicleStats?: Resolver<Maybe<ResolversTypes['VehicleStats']>, ParentType, ContextType>;
  vehicleStatsByCompany?: Resolver<Maybe<Array<Maybe<ResolversTypes['VehicleStatsByCompany']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchVehicleResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SearchVehicle'] = ResolversParentTypes['SearchVehicle']> = ResolversObject<{
  accountSalesRep?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allCurrentSales?: Resolver<Maybe<Array<Maybe<ResolversTypes['CurrentSale']>>>, ParentType, ContextType>;
  announcementFour?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  announcementLight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  announcementOne?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  announcementThree?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  announcementTwo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  ballControlCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAccountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentAaNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentBadge?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentPhoneMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentStatusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAuctionAccess?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAuctionRep?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerLegacyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerLegacyType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerOrgAaNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerOrgStatusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkedInAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorAuctionAccess?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorLegacyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorLegacyType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorStockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  daysOnLot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealCurrentOfferAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  floorAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasCr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isNew?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lane?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestNegotiationBuyerSellerAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestNegotiationDealBuyerAccountDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestNegotiationDealBuyerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestNegotiationDealSoldAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestNegotiationEventDealCurrentOfferAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestNegotiationIsOpen?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestNegotiationLastEventCreatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestNegotiationStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestNegotiationStatusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  make?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  odometer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orgCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  photoCount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pipelineUri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  proxyWon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiAmsPrinterName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiAmsServiceResultCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiChargeAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  psiCreatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiLongDesc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiOrderedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiOrderedByAmsUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiOrderedBySparkAuthenticationUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiOrderedBySparkUserId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  psiRackPrice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiRequested?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiResultBySparkAuthenticationUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiServiceCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiShortDesc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psiStatusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ranAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ranCount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  run?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  runPadded?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleDateLastRanTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchScore?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAccountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentPhoneMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAuctionRep?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soldDateLastRanTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceSystemKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ServiceResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Service'] = ResolversParentTypes['Service']> = ResolversObject<{
  AssetServiceStatusId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amsChargeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amsPrinterName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amsServiceProductCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amsServiceResultCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  chargeAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationServiceProductId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceClassCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceOrderedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceOrderedByAmsUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceOrderedByPipelineUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceOrderedBySparkUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceProductDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceResultAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceResultByAmsUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceResultBySparkUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceResultedInArbitration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ServiceResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ServiceResponse'] = ResolversParentTypes['ServiceResponse']> = ResolversObject<{
  serviceClass?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceCodeDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  statusText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SetVehicleInfoResultsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SetVehicleInfoResults'] = ResolversParentTypes['SetVehicleInfoResults']> = ResolversObject<{
  cancelProxyBidsResult?: Resolver<Maybe<ResolversTypes['CancelProxyBidsResult']>, ParentType, ContextType>;
  results?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmsCallResult']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShareReportResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ShareReportResponse'] = ResolversParentTypes['ShareReportResponse']> = ResolversObject<{
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SinglePushVehicleToAmsResultResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SinglePushVehicleToAmsResult'] = ResolversParentTypes['SinglePushVehicleToAmsResult']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isPossible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SiteResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Site'] = ResolversParentTypes['Site']> = ResolversObject<{
  auctionName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  biCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lookoutCodeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pipelineCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SortColumnResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SortColumn'] = ResolversParentTypes['SortColumn']> = ResolversObject<{
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['SORT_DIRECTION']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SparkPaginatedResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SparkPaginatedResponse'] = ResolversParentTypes['SparkPaginatedResponse']> = ResolversObject<{
  __resolveType: TypeResolveFn<'QueryRunListResponse', ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type SparkResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SparkResponse'] = ResolversParentTypes['SparkResponse']> = ResolversObject<{
  __resolveType: TypeResolveFn<'CreatedEventResponse' | 'MutationResponse' | 'QueryAgentResponse' | 'QueryEventsListResponse' | 'QueryResponse' | 'ShareReportResponse' | 'UpateAllListingsMutationResponse', ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type StartBidTierResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['StartBidTier'] = ResolversParentTypes['StartBidTier']> = ResolversObject<{
  amountBelowPriceFloor?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  priceFloorLBound?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  priceFloorUBound?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TestVehicleAuditLogResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['TestVehicleAuditLog'] = ResolversParentTypes['TestVehicleAuditLog']> = ResolversObject<{
  account?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auction_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  detail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  detail_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TrendInfoResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['TrendInfo'] = ResolversParentTypes['TrendInfo']> = ResolversObject<{
  avgPerWeekLast90?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  last7?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  last90?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TrendsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Trends'] = ResolversParentTypes['Trends']> = ResolversObject<{
  consigned?: Resolver<Maybe<ResolversTypes['TrendInfo']>, ParentType, ContextType>;
  purchased?: Resolver<Maybe<ResolversTypes['TrendInfo']>, ParentType, ContextType>;
  sold?: Resolver<Maybe<ResolversTypes['TrendInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpateAllListingsMutationResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['UpateAllListingsMutationResponse'] = ResolversParentTypes['UpateAllListingsMutationResponse']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateDocumentsResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['UpdateDocumentsResponse'] = ResolversParentTypes['UpdateDocumentsResponse']> = ResolversObject<{
  totalDocsUpdated?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalVehiclesUpdated?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type UserResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = ResolversObject<{
  attributes?: Resolver<Maybe<ResolversTypes['UserAttributes']>, ParentType, ContextType>;
  biRoles?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dashboardList?: Resolver<Maybe<ResolversTypes['Dashboards']>, ParentType, ContextType, Partial<UserDashboardListArgs>>;
  dashboards?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  organizations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Organization']>>>, ParentType, ContextType>;
  permissions?: Resolver<Maybe<ResolversTypes['UserPermissions']>, ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<Maybe<ResolversTypes['RoleAttributes']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserAttributesResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['UserAttributes'] = ResolversParentTypes['UserAttributes']> = ResolversObject<{
  auctionAccessNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authenticationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authenticationSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authenticationUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customRoles?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  databaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isGlobalAdmin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastSeenAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lockedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lockedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobilePhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  workPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserMutationResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['UserMutationResponse'] = ResolversParentTypes['UserMutationResponse']> = ResolversObject<{
  auctionAccessNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authenticationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authenticationUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  databaseId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isGlobalAdmin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobilePhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  statusMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  workPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserPermissionsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['UserPermissions'] = ResolversParentTypes['UserPermissions']> = ResolversObject<{
  orgPermissions?: Resolver<Maybe<Array<Maybe<ResolversTypes['PermissionItem']>>>, ParentType, ContextType, RequireFields<UserPermissionsOrgPermissionsArgs, 'auctionId'>>;
  userPermissions?: Resolver<Maybe<Array<Maybe<ResolversTypes['PermissionItem']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VdpByStockNumberResultsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['VdpByStockNumberResults'] = ResolversParentTypes['VdpByStockNumberResults']> = ResolversObject<{
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  uaId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VehicleAmsResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['VehicleAMSResponse'] = ResolversParentTypes['VehicleAMSResponse']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VehicleDataTypesResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['VehicleDataTypes'] = ResolversParentTypes['VehicleDataTypes']> = ResolversObject<{
  __resolveType: TypeResolveFn<'OnlineListing' | 'SearchVehicle' | 'VehicleStatsByCompany', ParentType, ContextType>;
}>;

export type VehicleStatsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['VehicleStats'] = ResolversParentTypes['VehicleStats']> = ResolversObject<{
  avgSaleAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  conversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  ran?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sumSaleAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VehicleStatsByCompanyResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['VehicleStatsByCompany'] = ResolversParentTypes['VehicleStatsByCompany']> = ResolversObject<{
  accountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avgSaleAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  conversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  ran?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sumSaleAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VehiclesWithDocsResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['VehiclesWithDocsResponse'] = ResolversParentTypes['VehiclesWithDocsResponse']> = ResolversObject<{
  totalDocCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vehiclesWithDocsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VenueEventResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['VenueEvent'] = ResolversParentTypes['VenueEvent']> = ResolversObject<{
  endedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eventEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventSettings?: Resolver<Maybe<ResolversTypes['AuctionSettings']>, ParentType, ContextType>;
  eventStartTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eventTags?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  eventTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eventType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eventTypeDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  longDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noSale?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  onOffer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  orgCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originatingOrgCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  participatingAuctions?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  sales?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  unitCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  venueCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VenueSaleListingAssetResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['VenueSaleListingAsset'] = ResolversParentTypes['VenueSaleListingAsset']> = ResolversObject<{
  announcementLight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  assetOrigin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bidIncrement?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  blackBook?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyNowPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  consignor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  floorPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  grade?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  hasCr?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lane?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listingCondition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  make?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mmr?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orgCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ranCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  saleListingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startBid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WatcherResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Watcher'] = ResolversParentTypes['Watcher']> = ResolversObject<{
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  memberName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobileNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PushToAmsResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['pushToAMSResponse'] = ResolversParentTypes['pushToAMSResponse']> = ResolversObject<{
  results?: Resolver<Maybe<Array<Maybe<ResolversTypes['pushToAMSResposeResult']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PushToAmsResposeResultResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['pushToAMSResposeResult'] = ResolversParentTypes['pushToAMSResposeResult']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['PendingSuccess'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendMessageStatusResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['sendMessageStatus'] = ResolversParentTypes['sendMessageStatus']> = ResolversObject<{
  emailSentStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  smsSentStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = ApolloResolverContext> = ResolversObject<{
  AMSUpdateResponseMessages?: AmsUpdateResponseMessagesResolvers<ContextType>;
  Account?: AccountResolvers<ContextType>;
  AccountGroupAccounts?: AccountGroupAccountsResolvers<ContextType>;
  AccountGroupUsers?: AccountGroupUsersResolvers<ContextType>;
  AccountGroups?: AccountGroupsResolvers<ContextType>;
  AccountNote?: AccountNoteResolvers<ContextType>;
  Accounts?: AccountsResolvers<ContextType>;
  Administrator?: AdministratorResolvers<ContextType>;
  Agent?: AgentResolvers<ContextType>;
  AgentCompany?: AgentCompanyResolvers<ContextType>;
  AgentDealerResponse?: AgentDealerResponseResolvers<ContextType>;
  AgentNote?: AgentNoteResolvers<ContextType>;
  AgentNoteType?: AgentNoteTypeResolvers<ContextType>;
  AgentNoteUpdateResult?: AgentNoteUpdateResultResolvers<ContextType>;
  AgentRole?: AgentRoleResolvers<ContextType>;
  AgentRoleUpdateResult?: AgentRoleUpdateResultResolvers<ContextType>;
  AgentRoleUpdateResults?: AgentRoleUpdateResultsResolvers<ContextType>;
  Agents?: AgentsResolvers<ContextType>;
  AmsCallResult?: AmsCallResultResolvers<ContextType>;
  AmsResponse?: AmsResponseResolvers<ContextType>;
  Announcement?: AnnouncementResolvers<ContextType>;
  Asset?: AssetResolvers<ContextType>;
  AssetFees?: AssetFeesResolvers<ContextType>;
  Assets?: AssetsResolvers<ContextType>;
  Attendance?: AttendanceResolvers<ContextType>;
  AttendanceList?: AttendanceListResolvers<ContextType>;
  Auction?: AuctionResolvers<ContextType>;
  AuctionAmsInfo?: AuctionAmsInfoResolvers<ContextType>;
  AuctionCollection?: AuctionCollectionResolvers<ContextType>;
  AuctionKey?: AuctionKeyResolvers<ContextType>;
  AuctionSettings?: AuctionSettingsResolvers<ContextType>;
  AuctionSettingsResponse?: AuctionSettingsResponseResolvers<ContextType>;
  AuctionStatistics?: AuctionStatisticsResolvers<ContextType>;
  Audit?: AuditResolvers<ContextType>;
  AuditResponse?: AuditResponseResolvers<ContextType>;
  Bidder?: BidderResolvers<ContextType>;
  BidderList?: BidderListResolvers<ContextType>;
  BiddingStatistics?: BiddingStatisticsResolvers<ContextType>;
  BuyNowTier?: BuyNowTierResolvers<ContextType>;
  CacheShape?: CacheShapeResolvers<ContextType>;
  CalculatedIfOfferData?: CalculatedIfOfferDataResolvers<ContextType>;
  CancelProxyBidsResult?: CancelProxyBidsResultResolvers<ContextType>;
  Card?: CardResolvers<ContextType>;
  CompaniesList?: CompaniesListResolvers<ContextType>;
  ConditionReport?: ConditionReportResolvers<ContextType>;
  ConfigSearchResults?: ConfigSearchResultsResolvers<ContextType>;
  Contact?: ContactResolvers<ContextType>;
  ContactList?: ContactListResolvers<ContextType>;
  ContactLogStats?: ContactLogStatsResolvers<ContextType>;
  ContactManagement?: ContactManagementResolvers<ContextType>;
  ContactStatus?: ContactStatusResolvers<ContextType>;
  ContactType?: ContactTypeResolvers<ContextType>;
  CreateDocumentOutputAsset?: CreateDocumentOutputAssetResolvers<ContextType>;
  CreateDocumentUploadDoc?: CreateDocumentUploadDocResolvers<ContextType>;
  CreateDocumentsUploadItem?: CreateDocumentsUploadItemResolvers<ContextType>;
  CreateReportConfigResponse?: CreateReportConfigResponseResolvers<ContextType>;
  CreatedEventResponse?: CreatedEventResponseResolvers<ContextType>;
  CurrentSale?: CurrentSaleResolvers<ContextType>;
  Dashboard?: DashboardResolvers<ContextType>;
  Dashboards?: DashboardsResolvers<ContextType>;
  DataConfig?: DataConfigResolvers<ContextType>;
  Deal?: DealResolvers<ContextType>;
  Dealer?: DealerResolvers<ContextType>;
  DocType?: DocTypeResolvers<ContextType>;
  Document?: DocumentResolvers<ContextType>;
  DocumentActivity?: DocumentActivityResolvers<ContextType>;
  DocumentUploadURL?: DocumentUploadUrlResolvers<ContextType>;
  DocumentView?: DocumentViewResolvers<ContextType>;
  EventTypeTrigger?: EventTypeTriggerResolvers<ContextType>;
  GenericCard?: GenericCardResolvers<ContextType>;
  HttpResponse?: HttpResponseResolvers<ContextType>;
  IfOfferHistory?: IfOfferHistoryResolvers<ContextType>;
  IfOfferManagement?: IfOfferManagementResolvers<ContextType>;
  IfOfferNotes?: IfOfferNotesResolvers<ContextType>;
  IfOfferUpdateAMSResponse?: IfOfferUpdateAmsResponseResolvers<ContextType>;
  IfOfferUpdateResult?: IfOfferUpdateResultResolvers<ContextType>;
  IfOfferUpdateResults?: IfOfferUpdateResultsResolvers<ContextType>;
  InspectionType?: InspectionTypeResolvers<ContextType>;
  InspectionTypeFilter?: InspectionTypeFilterResolvers<ContextType>;
  Lane?: LaneResolvers<ContextType>;
  LaneList?: LaneListResolvers<ContextType>;
  LightOption?: LightOptionResolvers<ContextType>;
  ListView?: ListViewResolvers<ContextType>;
  LocalCreateDocumentOutput?: LocalCreateDocumentOutputResolvers<ContextType>;
  Location?: LocationResolvers<ContextType>;
  LoginResponse?: LoginResponseResolvers<ContextType>;
  MaintenanceUpdateResult?: MaintenanceUpdateResultResolvers<ContextType>;
  Marketplace?: MarketplaceResolvers<ContextType>;
  MarketplaceStatistics?: MarketplaceStatisticsResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  MutationDataResponse?: MutationDataResponseResolvers<ContextType>;
  MutationResponse?: MutationResponseResolvers<ContextType>;
  NoSaleHistory?: NoSaleHistoryResolvers<ContextType>;
  OnlineListing?: OnlineListingResolvers<ContextType>;
  OnlineListings?: OnlineListingsResolvers<ContextType>;
  OnlineStatistic?: OnlineStatisticResolvers<ContextType>;
  OpenPsiResponse?: OpenPsiResponseResolvers<ContextType>;
  Organization?: OrganizationResolvers<ContextType>;
  PageInfoConfig?: PageInfoConfigResolvers<ContextType>;
  PaginatedDocumentResponse?: PaginatedDocumentResponseResolvers<ContextType>;
  PastSale?: PastSaleResolvers<ContextType>;
  PastSearch?: PastSearchResolvers<ContextType>;
  PathConfig?: PathConfigResolvers<ContextType>;
  PermissionItem?: PermissionItemResolvers<ContextType>;
  Photo?: PhotoResolvers<ContextType>;
  Profile?: ProfileResolvers<ContextType>;
  Psi?: PsiResolvers<ContextType>;
  PsiNote?: PsiNoteResolvers<ContextType>;
  PushVehicleToAmsResults?: PushVehicleToAmsResultsResolvers<ContextType>;
  PushVehiclesToAmsResults?: PushVehiclesToAmsResultsResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  QueryAgentResponse?: QueryAgentResponseResolvers<ContextType>;
  QueryEventsListResponse?: QueryEventsListResponseResolvers<ContextType>;
  QueryResponse?: QueryResponseResolvers<ContextType>;
  QueryRunListResponse?: QueryRunListResponseResolvers<ContextType>;
  RegisterBidderResponse?: RegisterBidderResponseResolvers<ContextType>;
  Report?: ReportResolvers<ContextType>;
  ReportColumn?: ReportColumnResolvers<ContextType>;
  ReportConfig?: ReportConfigResolvers<ContextType>;
  ReportDateOffset?: ReportDateOffsetResolvers<ContextType>;
  ReportDetailPage?: ReportDetailPageResolvers<ContextType>;
  ReportSearchFilter?: ReportSearchFilterResolvers<ContextType>;
  ResetPasswordByEmailResponse?: ResetPasswordByEmailResponseResolvers<ContextType>;
  Role?: RoleResolvers<ContextType>;
  RoleAttributes?: RoleAttributesResolvers<ContextType>;
  SaleEvent?: SaleEventResolvers<ContextType>;
  SaleListing?: SaleListingResolvers<ContextType>;
  SalesDayStatistics?: SalesDayStatisticsResolvers<ContextType>;
  SearchAccount?: SearchAccountResolvers<ContextType>;
  SearchAgent?: SearchAgentResolvers<ContextType>;
  SearchBidder?: SearchBidderResolvers<ContextType>;
  SearchContactLog?: SearchContactLogResolvers<ContextType>;
  SearchResults?: SearchResultsResolvers<ContextType>;
  SearchVehicle?: SearchVehicleResolvers<ContextType>;
  Service?: ServiceResolvers<ContextType>;
  ServiceResponse?: ServiceResponseResolvers<ContextType>;
  SetVehicleInfoResults?: SetVehicleInfoResultsResolvers<ContextType>;
  ShareReportResponse?: ShareReportResponseResolvers<ContextType>;
  SinglePushVehicleToAmsResult?: SinglePushVehicleToAmsResultResolvers<ContextType>;
  Site?: SiteResolvers<ContextType>;
  SortColumn?: SortColumnResolvers<ContextType>;
  SparkPaginatedResponse?: SparkPaginatedResponseResolvers<ContextType>;
  SparkResponse?: SparkResponseResolvers<ContextType>;
  StartBidTier?: StartBidTierResolvers<ContextType>;
  TestVehicleAuditLog?: TestVehicleAuditLogResolvers<ContextType>;
  TrendInfo?: TrendInfoResolvers<ContextType>;
  Trends?: TrendsResolvers<ContextType>;
  UpateAllListingsMutationResponse?: UpateAllListingsMutationResponseResolvers<ContextType>;
  UpdateDocumentsResponse?: UpdateDocumentsResponseResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  User?: UserResolvers<ContextType>;
  UserAttributes?: UserAttributesResolvers<ContextType>;
  UserMutationResponse?: UserMutationResponseResolvers<ContextType>;
  UserPermissions?: UserPermissionsResolvers<ContextType>;
  VdpByStockNumberResults?: VdpByStockNumberResultsResolvers<ContextType>;
  VehicleAMSResponse?: VehicleAmsResponseResolvers<ContextType>;
  VehicleDataTypes?: VehicleDataTypesResolvers<ContextType>;
  VehicleStats?: VehicleStatsResolvers<ContextType>;
  VehicleStatsByCompany?: VehicleStatsByCompanyResolvers<ContextType>;
  VehiclesWithDocsResponse?: VehiclesWithDocsResponseResolvers<ContextType>;
  VenueEvent?: VenueEventResolvers<ContextType>;
  VenueSaleListingAsset?: VenueSaleListingAssetResolvers<ContextType>;
  Watcher?: WatcherResolvers<ContextType>;
  pushToAMSResponse?: PushToAmsResponseResolvers<ContextType>;
  pushToAMSResposeResult?: PushToAmsResposeResultResolvers<ContextType>;
  sendMessageStatus?: SendMessageStatusResolvers<ContextType>;
}>;

export type DirectiveResolvers<ContextType = ApolloResolverContext> = ResolversObject<{
  aws_api_key?: Aws_Api_KeyDirectiveResolver<any, any, ContextType>;
  aws_auth?: Aws_AuthDirectiveResolver<any, any, ContextType>;
  aws_cognito_user_pools?: Aws_Cognito_User_PoolsDirectiveResolver<any, any, ContextType>;
  aws_iam?: Aws_IamDirectiveResolver<any, any, ContextType>;
  aws_lambda?: Aws_LambdaDirectiveResolver<any, any, ContextType>;
  aws_oidc?: Aws_OidcDirectiveResolver<any, any, ContextType>;
  aws_publish?: Aws_PublishDirectiveResolver<any, any, ContextType>;
  aws_subscribe?: Aws_SubscribeDirectiveResolver<any, any, ContextType>;
  defer?: DeferDirectiveResolver<any, any, ContextType>;
}>;

export type CompletePasswordMutationVariables = Exact<{
  password: Scalars['String'];
}>;


export type CompletePasswordMutation = { __typename?: 'Mutation', doCompleteNewPassword?: { __typename?: 'LoginResponse', result: LoginResponseTypes, message?: string | null } | null };

export type GetSavedEmailQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSavedEmailQuery = { __typename?: 'Query', passwordRecoveryEmail: string };

export type ResetPasswordByEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResetPasswordByEmailMutation = { __typename?: 'Mutation', resetPasswordByEmail?: { __typename?: 'ResetPasswordByEmailResponse', userEmail: string, statusCode: number, statusMessage: string } | null };

export type DoLoginMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type DoLoginMutation = { __typename?: 'Mutation', doLogin?: { __typename?: 'LoginResponse', result: LoginResponseTypes, message?: string | null } | null };

export type ViewRouterQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewRouterQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', userId: string, roles?: Array<{ __typename?: 'RoleAttributes', id: number, name?: string | null, description?: string | null }> | null } | null };

export type GetAgentPurchaseHistoryQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  searchString: Scalars['String'];
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type GetAgentPurchaseHistoryQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', vehicleCount?: number | null, searchStringDisplay?: string | null, searchType?: string | null, vehicleResult?: Array<{ __typename?: 'SearchVehicle', year?: string | null, stockNumber?: string | null, make?: string | null, model?: string | null, assetId?: string | null, saleAmount?: string | null, saleDate?: string | null, buyerAgentId?: string | null, buyerAgentName?: string | null } | null> | null } | null } | null };

export type GetAgentByIdQueryVariables = Exact<{
  agentId: Scalars['Int'];
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type GetAgentByIdQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', agents?: { __typename?: 'Agents', byId?: { __typename?: 'Agent', agentId: number, accountKey?: string | null, agentNumber?: string | null, bidderNumber?: string | null, buyerName?: string | null, dealerName?: string | null, dateAddedOn?: string | null, online?: boolean | null, firstName?: string | null, lastName?: string | null, lastAttendedDate?: string | null, firstAttendedDate?: string | null, lastAttendBadgeNum?: string | null, lastAttendBadgeType?: string | null, lastPurchaseActivity?: string | null, cellPhone?: string | null, workPhone?: string | null, homePhone?: string | null, fax?: string | null, email?: string | null, birthday?: string | null, auctionAccessNumber?: string | null, auctionAccessPicture?: string | null, accountDisplayName?: string | null, accountId?: number | null, canBuy?: string | null, canSell?: string | null, agentNotes?: string | null, otherCompanies?: { __typename?: 'CompaniesList', list?: Array<{ __typename?: 'AgentCompany', agentId?: number | null, accountId?: number | null, accountDisplayName?: string | null } | null> | null } | null, attendanceHistory?: { __typename?: 'AttendanceList', list?: Array<{ __typename?: 'Attendance', eventDate?: string | null, bidderBadgeNumber?: string | null, attendanceType?: string | null } | null> | null } | null, roles?: Array<{ __typename?: 'AgentRole', agentId?: number | null, longDescription?: string | null, shortDescription?: string | null, code?: string | null, id?: number | null } | null> | null, notes?: Array<{ __typename?: 'AgentNote', agentId?: number | null, noteType?: string | null, noteText?: string | null } | null> | null, contacts?: { __typename?: 'ContactList', count?: number | null, list?: Array<{ __typename?: 'Contact', id: number, agentId?: number | null, agentName?: string | null, userName?: string | null, followupUserName?: string | null, creatorFullName?: string | null, createdAt?: string | null, contactedAt?: string | null, statusCode?: string | null, typeCode?: string | null, note?: string | null, followUpDate?: string | null, followUpUserId?: number | null, completedBy?: number | null, completedAt?: string | null } | null> | null } | null } | null } | null, agentRoles?: Array<{ __typename?: 'AgentRole', id?: number | null, code?: string | null, shortDescription?: string | null, longDescription?: string | null, ordinal?: number | null } | null> | null } | null };

export type UpdateAgentNoteMutationVariables = Exact<{
  agentNoteUpdate?: InputMaybe<AgentNoteUpdate>;
}>;


export type UpdateAgentNoteMutation = { __typename?: 'Mutation', updateAgentNote?: { __typename?: 'AgentNoteUpdateResult', success?: boolean | null } | null };

export type UpdateAgentRolesMutationVariables = Exact<{
  agentRoleUpdate?: InputMaybe<AgentRoleUpdate>;
}>;


export type UpdateAgentRolesMutation = { __typename?: 'Mutation', updateAgentRoles?: { __typename?: 'AgentRoleUpdateResults', success?: boolean | null, results?: Array<{ __typename?: 'AgentRoleUpdateResult', roleCode?: string | null, success?: boolean | null } | null> | null } | null };

export type UpdateBiRolesMutationVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Scalars['String']>;
  subjectUserId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateBiRolesMutation = { __typename?: 'Mutation', updateBIRoles?: { __typename?: 'HttpResponse', statusCode: number, statusMessage?: string | null } | null };

export type BidderStatsDetailQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  searchString: Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type BidderStatsDetailQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', bidderCount?: number | null, bidderResult?: Array<{ __typename?: 'SearchBidder', agentId?: string | null, firstName?: string | null, lastName?: string | null, eventDate?: string | null, BadgeNum?: string | null, BidderType?: string | null, consignorLegacyId?: string | null, consignor?: string | null, consignorId?: string | null, vehiclesPurchasedCount?: number | null, city?: string | null, state?: string | null } | null> | null } | null } | null };

export type GetContactLogByAccountQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  accountId?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetContactLogByAccountQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', contactManagement?: { __typename?: 'ContactManagement', contacts?: { __typename?: 'ContactList', count?: number | null, list?: Array<{ __typename?: 'Contact', id: number, agentId?: number | null, agentName?: string | null, userName?: string | null, followupUserName?: string | null, creatorFullName?: string | null, contactedAt?: string | null, createdAt?: string | null, statusCode?: string | null, typeCode?: string | null, note?: string | null, followUpDate?: string | null, followUpUserId?: number | null, completedBy?: number | null, completedAt?: string | null } | null> | null } | null } | null } | null };

export type GetCompanyByIdQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  accountId: Scalars['Int'];
}>;


export type GetCompanyByIdQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', accounts?: { __typename?: 'Accounts', byId?: { __typename?: 'Account', accountId: number, accountOrgId: number, accountKey: string, accountSalesRep?: string | null, orgCode?: string | null, legalName?: string | null, displayName?: string | null, dbaName?: string | null, establishedAt?: string | null, auctionAccessNumber?: number | null, lastSoldActivity?: string | null, lastPurchaseActivity?: string | null, accountTypeCode?: string | null, canBuy?: boolean | null, canSell?: boolean | null, isActive?: boolean | null, phoneMain?: string | null, phoneSecondary?: string | null, phoneMobile?: string | null, email?: string | null, website?: string | null, lastAttended?: string | null, isFavorite?: boolean | null, locations?: Array<{ __typename?: 'Location', id: number, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zip?: string | null, type?: string | null } | null> | null, agents?: { __typename?: 'Agents', list?: Array<{ __typename?: 'Agent', firstName?: string | null, lastName?: string | null, cellPhone?: string | null, email?: string | null, auctionAccessNumber?: string | null, auctionAccessPicture?: string | null, agentAuthCode?: string | null, agentNotes?: string | null, agentId: number } | null> | null } | null } | null } | null } | null };

export type ConditionReportDetailQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  searchString: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type ConditionReportDetailQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', vehicleCount?: number | null, vehicleResult?: Array<{ __typename?: 'SearchVehicle', saleDate?: string | null, runPadded?: string | null, stockNumber?: string | null, year?: string | null, make?: string | null, model?: string | null, consignorId?: string | null, consignorLegacyId?: string | null, consignor?: string | null, checkedInAt?: string | null, assetId?: string | null, floorAmount?: string | null, photoCount?: string | null, hasCr?: string | null } | null> | null } | null } | null };

export type FavoritesDetailQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  searchString: Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type FavoritesDetailQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', searchStringJson?: string | null, searchStringDisplay?: string | null, accountCount?: number | null, accountResult?: Array<{ __typename?: 'SearchAccount', accountKey?: string | null, accountId?: string | null, displayName?: string | null, city?: string | null, state?: string | null } | null> | null } | null } | null };

export type IfOffersListQueryVariables = Exact<{
  searchString: Scalars['String'];
  limit: Scalars['Int'];
  auctionId?: InputMaybe<Scalars['String']>;
  offset: Scalars['Int'];
  sortType?: InputMaybe<Search_Sort_Types>;
  sortOrder?: InputMaybe<Sort_Direction>;
}>;


export type IfOffersListQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', vehicleCount?: number | null, searchStringDisplay?: string | null, searchType?: string | null, vehicleResult?: Array<{ __typename?: 'SearchVehicle', assetId?: string | null, status?: string | null, saleMethod?: string | null, saleAmount?: string | null, runPadded?: string | null, lane?: string | null, lot?: string | null, latestNegotiationLastEventCreatedAt?: string | null, latestNegotiationEventDealCurrentOfferAmount?: string | null, latestNegotiationDealBuyerAccountDisplayName?: string | null, latestNegotiationDealBuyerAgentName?: string | null, buyerCity?: string | null, buyerState?: string | null, buyerOrgStatusCode?: string | null, buyerOrgAaNum?: string | null, buyerAgentAaNum?: string | null, buyerAgentStatusCode?: string | null, saleListingKey?: string | null, make?: string | null, model?: string | null, year?: string | null, vin?: string | null, stockNumber?: string | null, saleDate?: string | null, saleDateLastRanTime?: string | null, buyerDisplayName?: string | null, sellerDisplayName?: string | null, dealCurrentOfferAmount?: string | null, dealNote?: string | null, floorAmount?: string | null, buyerAgentName?: string | null, buyerAgentEmail?: string | null, buyerAgentPhoneMobile?: string | null, buyerAgentId?: string | null, sellerAgentName?: string | null, sellerAgentEmail?: string | null, sellerAgentPhoneMobile?: string | null, sellerAgentId?: string | null, thumbUrl?: string | null, ballControlCode?: string | null, typeCode?: string | null, pipelineUri?: string | null, announcementOne?: string | null, announcementTwo?: string | null, announcementThree?: string | null, announcementFour?: string | null, announcementLight?: string | null } | null> | null } | null } | null };

export type MyContactLogFollowupsQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  statusCode?: InputMaybe<Scalars['String']>;
  forFollowUp?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type MyContactLogFollowupsQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', contactManagement?: { __typename?: 'ContactManagement', contacts?: { __typename?: 'ContactList', count?: number | null, list?: Array<{ __typename?: 'Contact', id: number, account?: string | null, accountId?: number | null, agentName?: string | null, agentId?: number | null, userName?: string | null, followupUserName?: string | null, creatorFullName?: string | null, followUpDate?: string | null, followUpUserId?: number | null, contactedAt?: string | null, note?: string | null, typeCode?: string | null, statusCode?: string | null } | null> | null } | null } | null } | null };

export type OdsIfOfferFilterListQueryVariables = Exact<{
  searchString: Scalars['String'];
  limit: Scalars['Int'];
  auctionId?: InputMaybe<Scalars['String']>;
  offset: Scalars['Int'];
  sortType?: InputMaybe<Search_Sort_Types>;
  sortOrder?: InputMaybe<Sort_Direction>;
}>;


export type OdsIfOfferFilterListQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', vehicleCount?: number | null, vehicleResult?: Array<{ __typename?: 'SearchVehicle', assetId?: string | null, status?: string | null, saleMethod?: string | null, saleAmount?: string | null, runPadded?: string | null, lane?: string | null, lot?: string | null, latestNegotiationLastEventCreatedAt?: string | null, latestNegotiationEventDealCurrentOfferAmount?: string | null, latestNegotiationDealBuyerAccountDisplayName?: string | null, latestNegotiationDealBuyerAgentName?: string | null, buyerCity?: string | null, buyerState?: string | null, buyerOrgStatusCode?: string | null, buyerOrgAaNum?: string | null, buyerAgentAaNum?: string | null, buyerAgentStatusCode?: string | null, saleListingKey?: string | null, make?: string | null, model?: string | null, year?: string | null, vin?: string | null, stockNumber?: string | null, saleDate?: string | null, saleDateLastRanTime?: string | null, buyerDisplayName?: string | null, sellerDisplayName?: string | null, dealCurrentOfferAmount?: string | null, dealNote?: string | null, floorAmount?: string | null, buyerAgentName?: string | null, buyerAgentEmail?: string | null, buyerAgentPhoneMobile?: string | null, buyerAgentId?: string | null, sellerAgentName?: string | null, sellerAgentEmail?: string | null, sellerAgentPhoneMobile?: string | null, sellerAgentId?: string | null, thumbUrl?: string | null, ballControlCode?: string | null, typeCode?: string | null, pipelineUri?: string | null } | null> | null } | null } | null };

export type OdsIfOfferListQueryVariables = Exact<{
  searchString: Scalars['String'];
  limit: Scalars['Int'];
  auctionId?: InputMaybe<Scalars['String']>;
  offset: Scalars['Int'];
  sortType?: InputMaybe<Search_Sort_Types>;
  sortOrder?: InputMaybe<Sort_Direction>;
}>;


export type OdsIfOfferListQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', vehicleCount?: number | null, vehicleResult?: Array<{ __typename?: 'SearchVehicle', assetId?: string | null, status?: string | null, saleMethod?: string | null, saleAmount?: string | null, runPadded?: string | null, lane?: string | null, lot?: string | null, latestNegotiationLastEventCreatedAt?: string | null, latestNegotiationEventDealCurrentOfferAmount?: string | null, latestNegotiationDealBuyerAccountDisplayName?: string | null, latestNegotiationDealBuyerAgentName?: string | null, buyerCity?: string | null, buyerState?: string | null, buyerOrgStatusCode?: string | null, buyerOrgAaNum?: string | null, buyerAgentAaNum?: string | null, buyerAgentStatusCode?: string | null, saleListingKey?: string | null, make?: string | null, model?: string | null, year?: string | null, vin?: string | null, stockNumber?: string | null, saleDate?: string | null, saleDateLastRanTime?: string | null, buyerDisplayName?: string | null, sellerDisplayName?: string | null, dealCurrentOfferAmount?: string | null, dealNote?: string | null, floorAmount?: string | null, buyerAgentName?: string | null, buyerAgentEmail?: string | null, buyerAgentPhoneMobile?: string | null, buyerAgentId?: string | null, sellerAgentName?: string | null, sellerAgentEmail?: string | null, sellerAgentPhoneMobile?: string | null, sellerAgentId?: string | null, thumbUrl?: string | null, ballControlCode?: string | null, typeCode?: string | null, pipelineUri?: string | null } | null> | null } | null } | null };

export type GetInspectionTypesQueryVariables = Exact<{
  orgCode: Scalars['String'];
}>;


export type GetInspectionTypesQuery = { __typename?: 'Query', auction?: { __typename?: 'Auction', psi?: { __typename?: 'Psi', inspectionTypes?: Array<{ __typename?: 'InspectionType', chargeAmount: number, chargeAmountFail?: number | null, chargeCode?: string | null, defaultPrinterName?: string | null, longDesc: string, quickPickLabel?: string | null, ordinal: number, orgId: number, printOnCreate?: number | null, quickPickOrdinal: number, serviceClass: string, serviceCode: string, shortDesc: string } | null> | null } | null } | null };

export type OpenPsiMutationVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  inspections: Array<InputMaybe<InspectionInput>> | InputMaybe<InspectionInput>;
}>;


export type OpenPsiMutation = { __typename?: 'Mutation', createPSI?: { __typename?: 'OpenPsiResponse', responseCode?: number | null, message?: string | null, serviceResponses?: Array<{ __typename?: 'ServiceResponse', serviceClass?: string | null, serviceCode?: string | null, stockNumber?: string | null, vin?: string | null, statusCode?: number | null, statusText?: string | null } | null> | null } | null };

export type PostSaleInspectionEligibleQueryVariables = Exact<{
  searchString: Scalars['String'];
  limit: Scalars['Int'];
  auctionId?: InputMaybe<Scalars['String']>;
  offset: Scalars['Int'];
  sortType?: InputMaybe<Search_Sort_Types>;
  sortOrder?: InputMaybe<Sort_Direction>;
  aggrSortType?: InputMaybe<Aggr_Search_Sort_Types>;
  aggrSortOrder?: InputMaybe<Sort_Direction>;
}>;


export type PostSaleInspectionEligibleQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', vehicleCount?: number | null, searchStringDisplay?: string | null, searchType?: string | null, vehicleResult?: Array<{ __typename?: 'SearchVehicle', assetId?: string | null, status?: string | null, saleMethod?: string | null, runPadded?: string | null, buyerAgentId?: string | null, buyerId?: string | null, lane?: string | null, lot?: string | null, make?: string | null, model?: string | null, year?: string | null, odometer?: string | null, vin?: string | null, announcementLight?: string | null, stockNumber?: string | null, saleDate?: string | null, saleAmount?: string | null, soldDateLastRanTime?: string | null, buyerDisplayName?: string | null, buyerAgentName?: string | null, sellerDisplayName?: string | null, psiCreatedAt?: string | null, psiLongDesc?: string | null, psiChargeAmount?: number | null, psiAmsServiceResultCode?: string | null } | null> | null } | null } | null };

export type RecentAccountsDetailQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  searchString: Scalars['String'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type RecentAccountsDetailQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', accountCount?: number | null, accountResult?: Array<{ __typename?: 'SearchAccount', accountId?: string | null, accountKey?: string | null, displayName?: string | null, city?: string | null, state?: string | null, lastAttendedAt?: string | null, lastBoughtAt?: string | null, lastSoldAt?: string | null, establishedAt?: string | null, accountLegacyType?: string | null } | null> | null } | null } | null };

export type SalesOverviewDetailQueryVariables = Exact<{
  endDate: Scalars['String'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  auctionId?: InputMaybe<Scalars['String']>;
  startDate: Scalars['String'];
}>;


export type SalesOverviewDetailQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', statistics?: { __typename?: 'AuctionStatistics', lanes?: { __typename?: 'LaneList', count?: number | null, list?: Array<{ __typename?: 'Lane', name: string, eventDate?: string | null, arbitration?: number | null, hasCr?: number | null, offer?: number | null, offerOnline?: number | null, sold?: number | null, soldOnline?: number | null, run?: number | null, units?: number | null } | null> | null } | null } | null } | null };

export type SearchVehiclesByAccountDetailQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  searchString: Scalars['String'];
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type SearchVehiclesByAccountDetailQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', accountCount?: number | null, searchStringDisplay?: string | null, searchType?: string | null, vehicleStatsByCompany?: Array<{ __typename?: 'VehicleStatsByCompany', accountName?: string | null, accountId?: number | null, total?: number | null, ran?: number | null, sold?: number | null, conversion?: number | null, avgSaleAmount?: number | null, sumSaleAmount?: number | null } | null> | null } | null } | null };

export type SearchVehiclesByBuyerDetailQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  searchString: Scalars['String'];
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type SearchVehiclesByBuyerDetailQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', accountCount?: number | null, searchStringDisplay?: string | null, searchType?: string | null, vehicleStatsByCompany?: Array<{ __typename?: 'VehicleStatsByCompany', accountName?: string | null, accountId?: number | null, total?: number | null, ran?: number | null, sold?: number | null, conversion?: number | null, avgSaleAmount?: number | null, sumSaleAmount?: number | null } | null> | null } | null } | null };

export type SearchContactLogDetailQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  searchString: Scalars['String'];
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type SearchContactLogDetailQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', contactLogCount?: number | null, searchStringDisplay?: string | null, searchType?: string | null, contactLogResult?: Array<{ __typename?: 'SearchContactLog', id?: number | null, creatorFullName?: string | null, followupFullName?: string | null, completedFullName?: string | null, creatorUsername?: string | null, followupUsername?: string | null, completedUsername?: string | null, creatorEmail?: string | null, followupEmail?: string | null, completedEmail?: string | null, creatorUserid?: string | null, followupUserid?: string | null, completedUserid?: string | null, completedAt?: string | null, contactedAt?: string | null, followupAt?: string | null, agentId?: string | null, agentName?: string | null, statusCode?: string | null, typeCode?: string | null, accountId?: string | null, accountDisplayName?: string | null, accountAuctionAccess?: string | null, accountKey?: string | null, note?: string | null, auctionCode?: string | null, update?: string | null, followUpDate?: string | null, followUpUserId?: string | null, completedBy?: string | null } | null> | null } | null } | null };

export type SearchAllQueryVariables = Exact<{
  searchString: Scalars['String'];
  limit: Scalars['Int'];
  auctionId?: InputMaybe<Scalars['String']>;
  offset: Scalars['Int'];
}>;


export type SearchAllQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', searchStringJson?: string | null, searchStringDisplay?: string | null, totalCount?: number | null, vehicleCount?: number | null, vehicleRecentlySoldCount?: number | null, vehicleInSaleCount?: number | null, accountCount?: number | null, agentCount?: number | null, vehicleResult?: Array<{ __typename?: 'SearchVehicle', assetId?: string | null, year?: string | null, make?: string | null, model?: string | null, vin?: string | null, color?: string | null, lot?: string | null, lane?: string | null, runPadded?: string | null, ranAt?: string | null, saleDate?: string | null, checkedInAt?: string | null, status?: string | null, stockNumber?: string | null, odometer?: string | null, buyer?: string | null, consignor?: string | null, searchScore?: string | null, orgCode?: string | null, saleAmount?: string | null, thumbUrl?: string | null, consignorStockNumber?: string | null, daysOnLot?: string | null } | null> | null, vehicleInSaleResult?: Array<{ __typename?: 'SearchVehicle', assetId?: string | null, year?: string | null, make?: string | null, model?: string | null, vin?: string | null, color?: string | null, lot?: string | null, runPadded?: string | null, lane?: string | null, ranAt?: string | null, saleDate?: string | null, checkedInAt?: string | null, status?: string | null, consignor?: string | null, stockNumber?: string | null, buyer?: string | null, odometer?: string | null, searchScore?: string | null, orgCode?: string | null, thumbUrl?: string | null, consignorStockNumber?: string | null, daysOnLot?: string | null } | null> | null, vehicleRecentlySoldResult?: Array<{ __typename?: 'SearchVehicle', assetId?: string | null, year?: string | null, make?: string | null, model?: string | null, vin?: string | null, color?: string | null, lot?: string | null, runPadded?: string | null, lane?: string | null, ranAt?: string | null, saleDate?: string | null, checkedInAt?: string | null, status?: string | null, buyer?: string | null, consignor?: string | null, stockNumber?: string | null, odometer?: string | null, searchScore?: string | null, orgCode?: string | null, saleAmount?: string | null, thumbUrl?: string | null, consignorStockNumber?: string | null, daysOnLot?: string | null } | null> | null, agentResult?: Array<{ __typename?: 'SearchAgent', agentId?: string | null, firstName?: string | null, lastName?: string | null, cellPhone?: string | null, workPhone?: string | null, email?: string | null, legalName?: string | null, displayName?: string | null, dbaName?: string | null, city?: string | null, state?: string | null, searchScore?: string | null, auctionAccess?: string | null, accountKey?: string | null, lastAttendBadgeNum?: string | null, lastAttendDate?: string | null, lastAttendBidderType?: string | null } | null> | null, accountResult?: Array<{ __typename?: 'SearchAccount', accountId?: string | null, legalName?: string | null, displayName?: string | null, dbaName?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, searchScore?: string | null, auctionAccess?: string | null, accountKey?: string | null, accountLegacyType?: string | null, lastAttendedAt?: string | null, lastBoughtAt?: string | null, lastSoldAt?: string | null, isActive?: boolean | null, canBuy?: boolean | null, canSell?: boolean | null } | null> | null } | null } | null };

export type SearchAllAgentsQueryVariables = Exact<{
  searchString: Scalars['String'];
  limit: Scalars['Int'];
  auctionId?: InputMaybe<Scalars['String']>;
  offset: Scalars['Int'];
}>;


export type SearchAllAgentsQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', searchStringJson?: string | null, searchStringDisplay?: string | null, totalCount?: number | null, vehicleCount?: number | null, vehicleRecentlySoldCount?: number | null, vehicleInSaleCount?: number | null, accountCount?: number | null, agentCount?: number | null, agentResult?: Array<{ __typename?: 'SearchAgent', agentId?: string | null, firstName?: string | null, lastName?: string | null, cellPhone?: string | null, workPhone?: string | null, email?: string | null, legalName?: string | null, displayName?: string | null, dbaName?: string | null, city?: string | null, state?: string | null, searchScore?: string | null, auctionAccess?: string | null, accountKey?: string | null, lastAttendBadgeNum?: string | null, lastAttendDate?: string | null, lastAttendBidderType?: string | null } | null> | null } | null } | null };

export type SearchAllCompaniesQueryVariables = Exact<{
  searchString: Scalars['String'];
  offset: Scalars['Int'];
  auctionId?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  sort?: InputMaybe<SearchSort>;
}>;


export type SearchAllCompaniesQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', searchStringJson?: string | null, searchStringDisplay?: string | null, totalCount?: number | null, vehicleCount?: number | null, vehicleRecentlySoldCount?: number | null, vehicleInSaleCount?: number | null, accountCount?: number | null, agentCount?: number | null, accountResult?: Array<{ __typename?: 'SearchAccount', accountId?: string | null, legalName?: string | null, displayName?: string | null, dbaName?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, searchScore?: string | null, auctionAccess?: string | null, accountKey?: string | null, accountLegacyType?: string | null, lastAttendedAt?: string | null, lastBoughtAt?: string | null, lastSoldAt?: string | null, isFavorite?: boolean | null, isActive?: boolean | null, canBuy?: boolean | null, canSell?: boolean | null } | null> | null } | null } | null };

export type SearchAllVehiclesQueryVariables = Exact<{
  searchString: Scalars['String'];
  offset: Scalars['Int'];
  auctionId?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
}>;


export type SearchAllVehiclesQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', searchStringJson?: string | null, searchStringDisplay?: string | null, totalCount?: number | null, vehicleCount?: number | null, vehicleRecentlySoldCount?: number | null, vehicleInSaleCount?: number | null, accountCount?: number | null, agentCount?: number | null, vehicleResult?: Array<{ __typename?: 'SearchVehicle', assetId?: string | null, year?: string | null, make?: string | null, model?: string | null, vin?: string | null, color?: string | null, lot?: string | null, lane?: string | null, runPadded?: string | null, ranAt?: string | null, saleDate?: string | null, checkedInAt?: string | null, status?: string | null, odometer?: string | null, buyer?: string | null, stockNumber?: string | null, consignor?: string | null, searchScore?: string | null, orgCode?: string | null, saleAmount?: string | null, thumbUrl?: string | null, consignorStockNumber?: string | null, daysOnLot?: string | null } | null> | null } | null } | null };

export type SearchInSaleVehiclesQueryVariables = Exact<{
  searchString: Scalars['String'];
  offset: Scalars['Int'];
  auctionId?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
}>;


export type SearchInSaleVehiclesQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', totalCount?: number | null, vehicleCount?: number | null, vehicleRecentlySoldCount?: number | null, vehicleInSaleCount?: number | null, accountCount?: number | null, agentCount?: number | null, vehicleInSaleResult?: Array<{ __typename?: 'SearchVehicle', assetId?: string | null, year?: string | null, make?: string | null, model?: string | null, vin?: string | null, color?: string | null, lot?: string | null, lane?: string | null, runPadded?: string | null, ranAt?: string | null, saleDate?: string | null, checkedInAt?: string | null, status?: string | null, stockNumber?: string | null, searchScore?: string | null, odometer?: string | null, buyer?: string | null, consignor?: string | null, orgCode?: string | null, saleAmount?: string | null, thumbUrl?: string | null } | null> | null } | null } | null };

export type SearchSoldVehiclesQueryVariables = Exact<{
  searchString: Scalars['String'];
  offset: Scalars['Int'];
  auctionId?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
}>;


export type SearchSoldVehiclesQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', totalCount?: number | null, vehicleCount?: number | null, vehicleRecentlySoldCount?: number | null, vehicleInSaleCount?: number | null, accountCount?: number | null, agentCount?: number | null, vehicleRecentlySoldResult?: Array<{ __typename?: 'SearchVehicle', assetId?: string | null, year?: string | null, make?: string | null, model?: string | null, vin?: string | null, color?: string | null, lot?: string | null, lane?: string | null, runPadded?: string | null, ranAt?: string | null, saleDate?: string | null, checkedInAt?: string | null, status?: string | null, stockNumber?: string | null, odometer?: string | null, buyer?: string | null, searchScore?: string | null, consignor?: string | null, orgCode?: string | null, saleAmount?: string | null, thumbUrl?: string | null } | null> | null } | null } | null };

export type PushToAmsUsingAssetIdMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PushToAmsUsingAssetIdMutation = { __typename?: 'Mutation', pushVehicleToAms?: { __typename?: 'PushVehicleToAmsResults', success?: boolean | null, stockNumber?: number | null, message?: string | null } | null };

export type PushToAmsUsingAssetIdArrayMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type PushToAmsUsingAssetIdArrayMutation = { __typename?: 'Mutation', pushVehiclesToAms?: { __typename?: 'PushVehiclesToAmsResults', results?: Array<{ __typename?: 'SinglePushVehicleToAmsResult', id: string, isPossible: boolean } | null> | null } | null };

export type SearchVehiclesDmsFeedDetailQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  searchString: Scalars['String'];
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type SearchVehiclesDmsFeedDetailQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', vehicleCount?: number | null, searchStringDisplay?: string | null, searchType?: string | null, vehicleResult?: Array<{ __typename?: 'SearchVehicle', saleDate?: string | null, stockNumber?: string | null, year?: string | null, make?: string | null, model?: string | null, consignorId?: string | null, consignorLegacyId?: string | null, consignor?: string | null, checkedInAt?: string | null, assetId?: string | null, sourceName?: string | null, consignorStockNumber?: string | null, daysOnLot?: string | null, isNew?: string | null, floorAmount?: string | null, odometer?: string | null, vin?: string | null } | null> | null } | null } | null };

export type SearchVehiclesDetailQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  searchString: Scalars['String'];
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type SearchVehiclesDetailQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', vehicleCount?: number | null, searchStringDisplay?: string | null, searchType?: string | null, vehicleResult?: Array<{ __typename?: 'SearchVehicle', stockNumber?: string | null, consignor?: string | null, consignorId?: string | null, consignorLegacyId?: string | null, year?: string | null, odometer?: string | null, make?: string | null, model?: string | null, assetId?: string | null, checkedInAt?: string | null, status?: string | null, ranCount?: string | null, ranAt?: string | null, saleAmount?: string | null, vin?: string | null, saleDate?: string | null } | null> | null } | null } | null };

export type GeneratePdfMutationVariables = Exact<{
  input?: InputMaybe<GeneratePdfInput>;
}>;


export type GeneratePdfMutation = { __typename?: 'Mutation', generatePDF?: { __typename?: 'ShareReportResponse', url?: string | null, success: boolean, message?: string | null, data?: string | null, status?: number | null } | null };

export type GetReportConfigQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type GetReportConfigQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', getReportConfig?: { __typename?: 'ReportConfig', PK?: string | null, SK?: string | null, id?: string | null, userId?: string | null, auctionId?: string | null, reportKey?: string | null, displayName?: string | null, dataConfig?: { __typename?: 'DataConfig', dataSource?: DataSourceTypes | null, dataFilter?: { __typename?: 'ReportSearchFilter', searchString?: string | null, searchType?: Search_Types | null, dataQuery?: string | null, watched?: boolean | null, statusCode?: string | null, forFollowup?: string | null, dateOffset?: { __typename?: 'ReportDateOffset', start?: number | null, end?: number | null } | null } | null, pageInfo?: { __typename?: 'PageInfoConfig', overRidePageLimit?: boolean | null, limit?: number | null, offset?: number | null, sortColumns?: Array<{ __typename?: 'SortColumn', name?: string | null, sortOrder?: Sort_Direction | null } | null> | null } | null } | null, listViewConfig?: { __typename?: 'ListView', title?: string | null, subtitle?: string | null, shareSubject?: string | null, paths?: { __typename?: 'PathConfig', listPath?: string | null, countPath?: string | null } | null, mobileColumns?: Array<{ __typename?: 'ReportColumn', header?: string | null, key?: string | null, width?: number | null } | null> | null, columns?: Array<{ __typename?: 'ReportColumn', header?: string | null, key?: string | null, width?: number | null } | null> | null } | null } | null } | null };

export type GetReportDownloadQueryVariables = Exact<{
  reportConfigId?: InputMaybe<Scalars['String']>;
  auctionId?: InputMaybe<Scalars['String']>;
  auctionName?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<GenerateOptions>;
  userSearchString?: InputMaybe<Scalars['String']>;
  searchFilter?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  creationDate?: InputMaybe<Scalars['String']>;
}>;


export type GetReportDownloadQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', getDownloadLink?: { __typename?: 'ShareReportResponse', url?: string | null, success: boolean, message?: string | null, data?: string | null, status?: number | null } | null } | null };

export type SearchVehiclesDetailNewQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  searchString: Scalars['String'];
  auctionId?: InputMaybe<Scalars['String']>;
  searchType?: InputMaybe<Search_Types>;
  sortColumns?: InputMaybe<Array<InputMaybe<SortColumnInput>> | InputMaybe<SortColumnInput>>;
}>;


export type SearchVehiclesDetailNewQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', vehicleCount?: number | null, accountCount?: number | null, searchStringDisplay?: string | null, searchType?: string | null, vehicleResult?: Array<{ __typename?: 'SearchVehicle', stockNumber?: string | null, consignor?: string | null, consignorId?: string | null, consignorLegacyId?: string | null, year?: string | null, odometer?: string | null, make?: string | null, model?: string | null, assetId?: string | null, checkedInAt?: string | null, status?: string | null, ranCount?: string | null, ranAt?: string | null, saleAmount?: string | null, vin?: string | null, saleDate?: string | null, runPadded?: string | null, floorAmount?: string | null, buyer?: string | null, buyerAgentName?: string | null, buyerDisplayName?: string | null, buyerId?: string | null, buyerAgentId?: string | null, buyerLegacyId?: string | null, hasTitle?: string | null, hasCr?: string | null, photoCount?: string | null, sourceName?: string | null, consignorStockNumber?: string | null, daysOnLot?: string | null, isNew?: string | null } | null> | null, vehicleStatsByCompany?: Array<{ __typename?: 'VehicleStatsByCompany', accountName?: string | null, accountId?: number | null, total?: number | null, ran?: number | null, sold?: number | null, conversion?: number | null, avgSaleAmount?: number | null, sumSaleAmount?: number | null } | null> | null } | null } | null };

export type SearchVehiclesInventoryConsignedQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  searchString: Scalars['String'];
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type SearchVehiclesInventoryConsignedQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', vehicleCount?: number | null, searchStringDisplay?: string | null, searchType?: string | null, vehicleResult?: Array<{ __typename?: 'SearchVehicle', stockNumber?: string | null, consignor?: string | null, consignorId?: string | null, consignorLegacyId?: string | null, year?: string | null, odometer?: string | null, make?: string | null, model?: string | null, assetId?: string | null, checkedInAt?: string | null, status?: string | null, ranCount?: string | null, ranAt?: string | null, saleAmount?: string | null, vin?: string | null } | null> | null } | null } | null };

export type SearchVehiclesPresaleDetailQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  searchString: Scalars['String'];
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type SearchVehiclesPresaleDetailQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', vehicleCount?: number | null, searchStringDisplay?: string | null, searchType?: string | null, vehicleResult?: Array<{ __typename?: 'SearchVehicle', saleDate?: string | null, runPadded?: string | null, stockNumber?: string | null, year?: string | null, make?: string | null, model?: string | null, consignorId?: string | null, consignorLegacyId?: string | null, consignor?: string | null, checkedInAt?: string | null, assetId?: string | null, floorAmount?: string | null, photoCount?: string | null, hasCr?: string | null } | null> | null } | null } | null };

export type SearchVehiclesWithBuyersDetailQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  searchString: Scalars['String'];
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type SearchVehiclesWithBuyersDetailQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', vehicleCount?: number | null, searchStringDisplay?: string | null, searchType?: string | null, vehicleResult?: Array<{ __typename?: 'SearchVehicle', consignor?: string | null, consignorId?: string | null, consignorLegacyId?: string | null, year?: string | null, stockNumber?: string | null, make?: string | null, model?: string | null, assetId?: string | null, status?: string | null, runPadded?: string | null, saleAmount?: string | null, floorAmount?: string | null, buyerAgentId?: string | null, buyerId?: string | null, buyerLegacyId?: string | null, buyerAgentName?: string | null, hasTitle?: string | null, saleDate?: string | null } | null> | null } | null } | null };

export type SearchVehiclesWithDealsDetailQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  searchString: Scalars['String'];
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type SearchVehiclesWithDealsDetailQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', vehicleCount?: number | null, searchStringDisplay?: string | null, searchType?: string | null, vehicleResult?: Array<{ __typename?: 'SearchVehicle', consignor?: string | null, consignorId?: string | null, consignorLegacyId?: string | null, year?: string | null, stockNumber?: string | null, make?: string | null, model?: string | null, assetId?: string | null, color?: string | null, status?: string | null, saleAmount?: string | null, saleDate?: string | null, floorAmount?: string | null, buyerAgentId?: string | null, buyerLegacyId?: string | null, buyerAgentName?: string | null, buyerDisplayName?: string | null, buyerId?: string | null } | null> | null } | null } | null };

export type SearchVehiclesWithSellersDetailQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  searchString: Scalars['String'];
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type SearchVehiclesWithSellersDetailQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', vehicleCount?: number | null, searchStringDisplay?: string | null, searchType?: string | null, vehicleResult?: Array<{ __typename?: 'SearchVehicle', consignor?: string | null, consignorId?: string | null, consignorLegacyId?: string | null, year?: string | null, stockNumber?: string | null, make?: string | null, model?: string | null, assetId?: string | null, status?: string | null, runPadded?: string | null, saleAmount?: string | null, floorAmount?: string | null, buyer?: string | null, buyerId?: string | null, buyerLegacyId?: string | null, hasTitle?: string | null, saleDate?: string | null } | null> | null } | null } | null };

export type OdsVdpViewsQueryVariables = Exact<{
  endDate: Scalars['String'];
  startDate: Scalars['String'];
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type OdsVdpViewsQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', card?: { __typename?: 'GenericCard', vdpViewsCount?: number | null, vdpViewsStats?: Array<{ __typename?: 'OnlineStatistic', count: number, date: string } | null> | null } | null } | null };

export type GetVehicleDetailQueryVariables = Exact<{
  assetId?: InputMaybe<Scalars['ID']>;
  auctionId?: InputMaybe<Scalars['String']>;
  stockNumber?: InputMaybe<Scalars['String']>;
}>;


export type GetVehicleDetailQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', assets?: { __typename?: 'Assets', byId?: { __typename?: 'Asset', buyerAccountId?: number | null, buyerAccountKey?: string | null, buyerDisplayName?: string | null, ownerStockNumber?: string | null, stockNumber?: string | null, assetId: string, vin?: string | null, customerReferenceNumber?: string | null, checkinDate?: string | null, saleListingSaleStatus?: string | null, checkinTime?: string | null, checkinUser?: string | null, grade?: string | null, hasTitle?: string | null, titleNumber?: string | null, titleState?: string | null, titleReceivedDate?: string | null, listingCondition?: string | null, listingConditionId?: number | null, listingConditionCode?: string | null, year?: string | null, make?: string | null, model?: string | null, trim?: string | null, color?: string | null, exteriorColor?: string | null, interiorColor?: string | null, transmissionType?: string | null, drivetrain?: string | null, drivetrainDesc?: string | null, fuelType?: string | null, crStatus?: string | null, pmrValue?: number | null, mmrValue?: number | null, blackBookValue?: number | null, photoCount?: number | null, photoBeauty?: string | null, proxyBidCount?: number | null, saleAmount?: number | null, floorAmount?: number | null, odometer?: string | null, bodyStyle?: string | null, engineSize?: string | null, cylinders?: string | null, cylinderConfiguration?: string | null, pipelineUri?: string | null, saleEvents?: Array<{ __typename?: 'SaleEvent', eventTitle?: string | null, eventDate?: string | null, venueEventTypeCode?: string | null, eventStartTs?: string | null, eventEndTs?: string | null, eventEndedAtTs?: string | null, venueEventKey?: string | null, lane?: string | null, lotNumber?: string | null, floorPrice?: number | null, saleListingStatus?: string | null, dealSaleAmt?: number | null, dealStatus?: string | null, buyerName?: string | null, saleListingKey?: string | null, buyerOrgAaNum?: string | null, buyerOrgStatusCode?: string | null, buyerAgentAaNum?: string | null, buyerAgentStatusCode?: string | null, city?: string | null, state?: string | null } | null> | null, conditionReport?: { __typename?: 'ConditionReport', conditionReportTime?: string | null, conditionReportStatus?: string | null, conditionReportWriter?: string | null } | null, photos?: Array<{ __typename?: 'Photo', pipelineUri?: string | null, position?: number | null, fileName?: string | null, note?: string | null } | null> | null, saleListing?: { __typename?: 'SaleListing', saleStatus?: string | null, saleDate?: string | null, soldDateLastRanTime?: string | null, saleListingDealSoldAt?: string | null, saleListingOfferCreatedAt?: string | null, lane?: string | null, lot?: string | null, saleMethod?: string | null, venueName?: string | null, venueCode?: string | null, venueUrl?: string | null, buyerAgentName?: string | null, buyerAgentId?: number | null, buyerAgentPicture?: string | null, buyerAgentEmail?: string | null, buyerAgentPhoneMobile?: string | null, sellerAgentId?: number | null, sellerAgentName?: string | null, sellerAgentEmail?: string | null, sellerAgentPhoneMobile?: string | null, buyerAgentNotes?: string | null } | null, assetFees?: Array<{ __typename?: 'AssetFees', stockNumber?: string | null, amount?: string | null, chargeCode?: string | null, description?: string | null, run?: string | null } | null> | null, announcements?: Array<{ __typename?: 'Announcement', type?: string | null, id?: number | null, announcement?: string | null, ordinal?: number | null } | null> | null, consignor?: { __typename?: 'Account', accountKey: string, accountId: number, displayName?: string | null, accountOrgId: number, accountOrgDisplayName?: string | null } | null, onlineListing?: { __typename?: 'OnlineListing', webViews?: number | null } | null, services?: Array<{ __typename?: 'Service', id?: string | null, serviceProductDescription?: string | null, serviceOrderedByAmsUser?: string | null, serviceOrderedAt?: string | null, createdAt?: string | null, serviceClassCode?: string | null, organizationServiceProductId?: string | null, amsServiceProductCode?: string | null, amsChargeCode?: string | null, serviceResultAt?: string | null, notes?: string | null, dealId?: string | null, chargeAmount?: number | null, amsServiceResultCode?: string | null } | null> | null } | null } | null } | null };

export type GetOfferBuyerSellerAgentsQueryVariables = Exact<{
  assetId: Scalars['ID'];
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type GetOfferBuyerSellerAgentsQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', assets?: { __typename?: 'Assets', byId?: { __typename?: 'Asset', ifOfferManagement?: { __typename?: 'IfOfferManagement', ifOfferHistory?: Array<{ __typename?: 'IfOfferHistory', buyerAgentId?: number | null, sellerAgentId?: number | null } | null> | null, buyerAgents?: Array<{ __typename?: 'Agent', firstName?: string | null, lastName?: string | null, agentId: number, cellPhone?: string | null, email?: string | null } | null> | null, sellerAgents?: Array<{ __typename?: 'Agent', firstName?: string | null, lastName?: string | null, agentId: number, cellPhone?: string | null, email?: string | null } | null> | null } | null, saleListing?: { __typename?: 'SaleListing', buyerAgentEmail?: string | null, buyerAgentId?: number | null, buyerAgentName?: string | null, buyerAgentPhoneMobile?: string | null, sellerAgentEmail?: string | null, sellerAgentId?: number | null, sellerAgentName?: string | null, sellerAgentPhoneMobile?: string | null } | null } | null } | null } | null };

export type GetVehicleIfOfferQueryVariables = Exact<{
  assetId: Scalars['ID'];
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type GetVehicleIfOfferQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', assets?: { __typename?: 'Assets', byId?: { __typename?: 'Asset', ifOfferManagement?: { __typename?: 'IfOfferManagement', buyerAgent?: { __typename?: 'Agent', notes?: Array<{ __typename?: 'AgentNote', noteType?: string | null, noteText?: string | null } | null> | null } | null, sellerAgent?: { __typename?: 'Agent', notes?: Array<{ __typename?: 'AgentNote', noteType?: string | null, noteText?: string | null } | null> | null } | null, calculatedIfOfferData?: { __typename?: 'CalculatedIfOfferData', buyerNotesThisOffer?: Array<string | null> | null, sellerNotesThisOffer?: Array<string | null> | null, sellerMovementThisOffer?: number | null, buyerMovementThisOffer?: number | null } | null, eventTypes?: Array<{ __typename?: 'EventTypeTrigger', code?: string | null, shortDescription?: string | null, longDescription?: string | null } | null> | null, eventTriggers?: Array<{ __typename?: 'EventTypeTrigger', code?: string | null, shortDescription?: string | null, longDescription?: string | null } | null> | null, ifOfferHistory?: Array<{ __typename?: 'IfOfferHistory', saleListingId?: number | null, dealId?: number | null, eventDate?: string | null, laneName?: string | null, lotNumber?: string | null, eventTypeCode?: EventTypeCode | null, eventTriggerCode?: EventTriggerCode | null, eventTypeDesc?: string | null, eventTriggerDesc?: string | null, currentOfferAmount?: number | null, currentOfferAmountPrevious?: number | null, eventCreatedAt?: string | null, eventCreatedBy?: string | null, eventNote?: string | null, floorPrice?: number | null, ballControlCode?: BallControlCode | null, buyerAgentId?: number | null, sellerAgentId?: number | null, buyerAgentName?: string | null, sellerAgentName?: string | null } | null> | null, pastSalesHistory?: Array<{ __typename?: 'PastSale', eventDate?: string | null, saleListingId?: number | null, dealId?: number | null, dealStatus?: string | null, lane?: string | null, lot?: string | null, highBid?: number | null, hasRun?: boolean | null, soldAmount?: number | null, lastCounter?: number | null, lastCounterBy?: string | null, buyerDisplayName?: string | null, buyerAccountId?: number | null, dealOutcome?: string | null, rejectedBy?: string | null, closedDate?: string | null, eventClassCode?: string | null, eventClassName?: string | null, venueCode?: string | null, venueEventTitle?: string | null, venueName?: string | null, noSold?: boolean | null, dealHistory?: Array<{ __typename?: 'IfOfferHistory', correlationId?: string | null, saleListingId?: number | null, dealId?: number | null, laneName?: string | null, lotNumber?: string | null, eventDate?: string | null, eventTypeDesc?: string | null, eventTypeCode?: EventTypeCode | null, eventTriggerDesc?: string | null, eventTriggerCode?: EventTriggerCode | null, floorPrice?: number | null, buyNowPrice?: number | null, valuationBlackbookAmount?: number | null, valuationMMRAmount?: number | null, assetAnnouncementOne?: string | null, assetAnnouncementTwo?: string | null, assetAnnouncementThree?: string | null, assetAnnouncementFour?: string | null, buyerAgentId?: number | null, buyerAgentName?: string | null, sellerAgentName?: string | null, sellerAgentId?: number | null, buyerOrSellerAccountId?: number | null, currentOfferAmount?: number | null, currentOfferAmountPrevious?: number | null, announcementLight?: string | null, fees?: number | null, eventCreatedAt?: string | null, eventCreatedBy?: string | null, eventCreatedById?: number | null, eventNote?: string | null, ballControlDescription?: string | null, ballControlCode?: BallControlCode | null } | null> | null } | null> | null } | null } | null } | null } | null };

export type UpdateIfOfferMutationVariables = Exact<{
  auctionId: Scalars['String'];
  assetId: Scalars['ID'];
  sparkUserId: Scalars['Int'];
  eventTypeCode: EventTypeCode;
  eventTriggerCode: EventTriggerCode;
  offerAmount: Scalars['Int'];
  offerNote: Scalars['String'];
  buyerAgentId?: InputMaybe<Scalars['Int']>;
  sellerAgentId?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateIfOfferMutation = { __typename?: 'Mutation', updateIfOffer?: { __typename?: 'IfOfferUpdateResults', success?: boolean | null } | null };

export type UpdateIfOffersMutationVariables = Exact<{
  offers?: InputMaybe<Array<InputMaybe<IfOfferDetails>> | InputMaybe<IfOfferDetails>>;
}>;


export type UpdateIfOffersMutation = { __typename?: 'Mutation', updateMultipleIfOffers?: { __typename?: 'IfOfferUpdateResults', success?: boolean | null, results?: Array<{ __typename?: 'IfOfferUpdateResult', assetId?: string | null, amsStatusCode?: number | null, amsStatusText?: string | null, success?: boolean | null, stockNumber?: string | null, vin?: string | null, ifNotes?: Array<{ __typename?: 'IfOfferNotes', date: string, user: string, note: string, type: IfOfferNoteType } | null> | null } | null> | null } | null };

export type RegisterBidderMutationVariables = Exact<{
  bidderDetails: RegisterBidderDetails;
}>;


export type RegisterBidderMutation = { __typename?: 'Mutation', registerBidder?: { __typename?: 'RegisterBidderResponse', status?: number | null, message?: string | null, errors?: Array<string | null> | null } | null };

export type DocumentFilterListsQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  stockNumber: Scalars['String'];
}>;


export type DocumentFilterListsQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', document?: { __typename?: 'Document', documentFilterLists?: Array<{ __typename?: 'Document', docId: string, docName?: string | null, docTypeId: string, docTypeName: string, docTypeShortCode?: string | null, createdAt: string, createdBy?: string | null, updatedAt?: string | null, s3Url?: string | null, s3UrlExpires?: string | null, stockNumber?: string | null, transactionId?: string | null, customerId?: string | null } | null> | null } | null } | null };

export type DocumentListQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  assetId: Scalars['ID'];
}>;


export type DocumentListQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', document?: { __typename?: 'Document', documentLists?: Array<{ __typename?: 'Document', docId: string, docTypeId: string, docTypeName: string, docTypeShortCode?: string | null, createdAt: string, createdBy?: string | null, s3Url?: string | null, s3UrlExpires?: string | null, transactionId?: string | null } | null> | null } | null } | null };

export type GetLightOptionsQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type GetLightOptionsQuery = { __typename?: 'Query', auction?: { __typename?: 'Auction', lightOptions?: Array<{ __typename?: 'LightOption', lightId?: number | null, lightCode?: string | null, lightDescription?: string | null } | null> | null } | null };

export type VdpByStockNumberTranslationQueryVariables = Exact<{
  amsId?: InputMaybe<Scalars['String']>;
  stockNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
}>;


export type VdpByStockNumberTranslationQuery = { __typename?: 'Query', auction?: { __typename?: 'Auction', keys?: { __typename?: 'VdpByStockNumberResults', uaId?: string | null, assetId?: string | null } | null } | null };

export type VehiclesCheckedInDetailQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  searchString: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type VehiclesCheckedInDetailQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', vehicleCount?: number | null, vehicleResult?: Array<{ __typename?: 'SearchVehicle', saleDate?: string | null, runPadded?: string | null, stockNumber?: string | null, year?: string | null, make?: string | null, model?: string | null, consignorId?: string | null, consignorLegacyId?: string | null, consignor?: string | null, checkedInAt?: string | null, assetId?: string | null, floorAmount?: string | null, photoCount?: string | null, hasCr?: string | null } | null> | null } | null } | null };

export type MissingPhotosInSaleDetailQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  searchStringPhotos: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type MissingPhotosInSaleDetailQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', vehicleCount?: number | null, vehicleResult?: Array<{ __typename?: 'SearchVehicle', saleDate?: string | null, runPadded?: string | null, stockNumber?: string | null, year?: string | null, make?: string | null, model?: string | null, consignorId?: string | null, consignorLegacyId?: string | null, consignor?: string | null, checkedInAt?: string | null, assetId?: string | null, hasCr?: string | null, photoCount?: string | null, floorAmount?: string | null } | null> | null } | null } | null };

export type DealersWatchingVehicleQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  stockNumber: Scalars['String'];
}>;


export type DealersWatchingVehicleQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', assets?: { __typename?: 'Assets', list?: Array<{ __typename?: 'Asset', onlineListing?: { __typename?: 'OnlineListing', watchers?: Array<{ __typename?: 'Watcher', emailAddress?: string | null, memberName?: string | null, mobileNumber?: string | null, phoneNumber?: string | null } | null> | null } | null } | null> | null } | null } | null };

export type OdsWatchedVehiclesQueryVariables = Exact<{
  endDate: Scalars['String'];
  startDate: Scalars['String'];
  auctionId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type OdsWatchedVehiclesQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', card?: { __typename?: 'GenericCard', watchedVehiclesCount?: number | null, watchedVehiclesList?: Array<{ __typename?: 'OnlineListing', assetId?: string | null, make?: string | null, mmrValuation?: number | null, model?: string | null, stockNumber?: string | null, watchCount?: number | null, year?: string | null, webViews?: number | null } | null> | null } | null } | null };

export type UserInfoForUpdateUserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInfoForUpdateUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', dashboards?: Array<string | null> | null, attributes?: { __typename?: 'UserAttributes', authenticationId?: string | null, firstName?: string | null, lastName?: string | null, mobilePhone?: string | null, email?: string | null, isGlobalAdmin?: boolean | null, authenticationUsername?: string | null, databaseId?: number | null } | null, permissions?: { __typename?: 'UserPermissions', userPermissions?: Array<{ __typename?: 'PermissionItem', key?: string | null, description?: string | null, note?: string | null } | null> | null } | null, organizations?: Array<{ __typename?: 'Organization', orgId?: string | null, displayName?: string | null, description?: string | null, isAdmin?: boolean | null, lastUpdated?: string | null, type?: string | null } | null> | null, roles?: Array<{ __typename?: 'RoleAttributes', id: number, name?: string | null, description?: string | null } | null> | null } | null };

export type ActiveOrgDisplayNameQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveOrgDisplayNameQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', displayName?: string | null } };

export type BatchCreateDocumentMutationVariables = Exact<{
  docs: Array<CreateDocumentInput> | CreateDocumentInput;
}>;


export type BatchCreateDocumentMutation = { __typename?: 'Mutation', batchCreateDocument?: Array<{ __typename?: 'Document', docId: string } | null> | null };

export type CreateDocumentsClientMutationVariables = Exact<{
  docs: Array<LocalCreateDocumentInput> | LocalCreateDocumentInput;
}>;


export type CreateDocumentsClientMutation = { __typename?: 'Mutation', createDocumentsClient?: Array<{ __typename?: 'LocalCreateDocumentOutput', docId: string } | null> | null };

export type GenerateUploadUrlMutationVariables = Exact<{
  assetId: Scalars['ID'];
}>;


export type GenerateUploadUrlMutation = { __typename?: 'Mutation', generateUploadUrl: { __typename?: 'DocumentUploadURL', customerId: string, tenantId: string, fileName: string, fileType: string, s3uploadUrl: string, urlExpires: string, s3Key: string } };

export type UpdateDocumentMutationVariables = Exact<{
  input: UpdateDocumentInput;
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument?: { __typename?: 'Document', docId: string } | null };

export type UploadDocumentMutationVariables = Exact<{
  input: LocalUploadDocumentInput;
}>;


export type UploadDocumentMutation = { __typename?: 'Mutation', uploadDocument?: boolean | null };

export type UploadDocumentsMutationVariables = Exact<{
  docs: Array<LocalUploadDocumentInput> | LocalUploadDocumentInput;
}>;


export type UploadDocumentsMutation = { __typename?: 'Mutation', uploadDocuments?: boolean | null };

export type PushToAmsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PushToAmsMutation = { __typename?: 'Mutation', pushToAMS?: { __typename?: 'pushToAMSResponse', results?: Array<{ __typename?: 'pushToAMSResposeResult', id: string, success: PendingSuccess } | null> | null } | null };

export type SetVehicleInfoApiQueryVariables = Exact<{
  amsType?: InputMaybe<Scalars['String']>;
  auctionId?: InputMaybe<Scalars['String']>;
  assetId: Scalars['ID'];
  oldFloor: Scalars['Int'];
  newFloor: Scalars['Int'];
  newLight?: InputMaybe<Scalars['String']>;
  oldLight?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<Array<InputMaybe<SetAnnouncements>> | InputMaybe<SetAnnouncements>>;
  expectedAnnouncements?: InputMaybe<Array<InputMaybe<ExpectedAnnouncement>> | InputMaybe<ExpectedAnnouncement>>;
  stockNumber: Scalars['String'];
  cancelProxyBids?: InputMaybe<Scalars['Boolean']>;
  numberOfProxyBids?: InputMaybe<Scalars['Int']>;
}>;


export type SetVehicleInfoApiQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', setVehicleInfo?: { __typename?: 'SetVehicleInfoResults', results?: Array<{ __typename?: 'AmsCallResult', operation?: string | null, success?: boolean | null, message?: string | null } | null> | null, cancelProxyBidsResult?: { __typename?: 'CancelProxyBidsResult', success: boolean, errors?: Array<string | null> | null } | null } | null } | null };

export type SetVehicleInfoMutationVariables = Exact<{
  amsType: Scalars['String'];
  assetId: Scalars['ID'];
  floor: Scalars['Int'];
  announcements?: InputMaybe<Array<InputMaybe<SetAnnouncements>> | InputMaybe<SetAnnouncements>>;
  expectedAnnouncements?: InputMaybe<Array<InputMaybe<ExpectedAnnouncement>> | InputMaybe<ExpectedAnnouncement>>;
  stockNumber: Scalars['String'];
  selectedLightId: Scalars['Int'];
  cancelProxyBids?: InputMaybe<Scalars['Boolean']>;
  numberOfProxyBids?: InputMaybe<Scalars['Int']>;
}>;


export type SetVehicleInfoMutation = { __typename?: 'Mutation', setVehicleInfo?: { __typename?: 'SetVehicleInfoResults', results?: Array<{ __typename?: 'AmsCallResult', success?: boolean | null, message?: string | null } | null> | null } | null };

export type AdminUserAttributesQueryVariables = Exact<{
  auctionId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type AdminUserAttributesQuery = { __typename?: 'Query', administrator?: { __typename?: 'Administrator', user?: { __typename?: 'User', attributes?: { __typename?: 'UserAttributes', firstName?: string | null, lastName?: string | null } | null } | null } | null };

export type AssetByStockNumberQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  stockNumber: Scalars['String'];
}>;


export type AssetByStockNumberQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', assets?: { __typename?: 'Assets', byStockNumber?: { __typename?: 'Asset', assetId: string, consignorAccountId?: number | null, year?: string | null, make?: string | null, model?: string | null } | null } | null } | null };

export type AssetFromAssetIdQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  assetId: Scalars['ID'];
}>;


export type AssetFromAssetIdQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', assets?: { __typename?: 'Assets', byId?: { __typename?: 'Asset', assetId: string, stockNumber?: string | null, consignor?: { __typename?: 'Account', accountId: number } | null } | null } | null } | null };

export type DocumentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentTypesQuery = { __typename?: 'Query', documentTypes: Array<{ __typename?: 'DocType', docTypeName: string, docTypeId: string, displayOrder: number, shortCode: string }> };

export type PresignedS3UrlQueryVariables = Exact<{
  accountId: Scalars['Int'];
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type PresignedS3UrlQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', document?: { __typename?: 'Document', documentUploadURLs?: Array<{ __typename?: 'DocumentUploadURL', customerId: string, tenantId: string, fileName: string, fileType: string, s3uploadUrl: string, urlExpires: string, s3Key: string } | null> | null } | null } | null };

export type RemoteDocumentTypesQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  verticalTypeId: Scalars['String'];
}>;


export type RemoteDocumentTypesQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', document?: { __typename?: 'Document', documentTypes?: Array<{ __typename?: 'DocType', docTypeName: string, docTypeId: string, displayOrder: number, shortCode: string } | null> | null } | null } | null };

export type ResetPasswordByEmailClientMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResetPasswordByEmailClientMutation = { __typename?: 'Mutation', doResetPasswordByEmail?: { __typename?: 'ResetPasswordByEmailResponse', userEmail: string, statusCode: number, statusMessage: string } | null };

export type AddSearchesMutationVariables = Exact<{
  displayName: Scalars['String'];
  searchName: Scalars['String'];
  filterName: Scalars['String'];
}>;


export type AddSearchesMutation = { __typename?: 'Mutation', addPastSearch?: boolean | null };

export type GetPastSearchesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPastSearchesQuery = { __typename?: 'Query', pastSearches?: Array<{ __typename?: 'PastSearch', displayName?: string | null, searchName?: string | null, filterName?: string | null } | null> | null };

export type ActiveAuctionDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveAuctionDetailsQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null, displayName?: string | null } };

export type UpdateFavoriteAccountMutationVariables = Exact<{
  auctionId: Scalars['String'];
  accountKey: Scalars['String'];
  isFavorite: Scalars['Boolean'];
}>;


export type UpdateFavoriteAccountMutation = { __typename?: 'Mutation', updateFavoriteAccount?: { __typename?: 'HttpResponse', statusCode: number, statusMessage?: string | null } | null };

export type GetAuctionIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuctionIdQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null } };

export type GetAuctionTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuctionTypeQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', type?: string | null } };

export type CurrentUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserInfoQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', userId: string, familyName: string, name: string, email: string, mobilePhone?: string | null, databaseId: number } | null };

export type DoLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type DoLogoutMutation = { __typename?: 'Mutation', doLogout?: boolean | null };

export type GetExpanderStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExpanderStateQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', isAdmin?: boolean | null, orgId?: string | null }, profile?: { __typename?: 'Profile', isAdmin: boolean, name: string, familyName: string } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', doLogout?: boolean | null };

export type GlobalSearchQueryVariables = Exact<{
  searchString: Scalars['String'];
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type GlobalSearchQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', vehicleCount?: number | null, vehicleInSaleCount?: number | null, vehicleRecentlySoldCount?: number | null, accountCount?: number | null, agentCount?: number | null, vehicleResult?: Array<{ __typename?: 'SearchVehicle', stockNumber?: string | null, assetId?: string | null, year?: string | null, make?: string | null, model?: string | null, consignor?: string | null } | null> | null, vehicleInSaleResult?: Array<{ __typename?: 'SearchVehicle', stockNumber?: string | null, assetId?: string | null, year?: string | null, make?: string | null, model?: string | null, consignor?: string | null } | null> | null, vehicleRecentlySoldResult?: Array<{ __typename?: 'SearchVehicle', stockNumber?: string | null, assetId?: string | null, year?: string | null, make?: string | null, model?: string | null, consignor?: string | null } | null> | null, accountResult?: Array<{ __typename?: 'SearchAccount', accountId?: string | null, displayName?: string | null, city?: string | null, state?: string | null } | null> | null, agentResult?: Array<{ __typename?: 'SearchAgent', agentId?: string | null, firstName?: string | null, lastName?: string | null, displayName?: string | null } | null> | null } | null } | null };

export type ChangeAuctionMutationVariables = Exact<{
  newAuction: Scalars['String'];
}>;


export type ChangeAuctionMutation = { __typename?: 'Mutation', changeAuction?: boolean | null };

export type UserProfileOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserProfileOptionsQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', isAdmin: boolean, name: string, familyName: string, email: string } | null, activeOrganization: { __typename?: 'Organization', orgId?: string | null, displayName?: string | null, description?: string | null, isAdmin?: boolean | null, sites?: Array<{ __typename?: 'Site', auctionName?: string | null, pipelineCode?: string | null, locationName?: string | null, lookoutCodeName?: string | null, biCode?: string | null } | null> | null }, user?: { __typename?: 'User', dashboards?: Array<string | null> | null, attributes?: { __typename?: 'UserAttributes', isGlobalAdmin?: boolean | null } | null, organizations?: Array<{ __typename?: 'Organization', orgId?: string | null, displayName?: string | null, description?: string | null, isAdmin?: boolean | null, lastUpdated?: string | null, orgTypeCode?: string | null, groupOrgId?: number | null, orgNumber?: number | null } | null> | null } | null };

export type ShareModalMutationVariables = Exact<{
  displayUrl?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  smsNumber?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  messageBody?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  subject?: InputMaybe<Scalars['String']>;
  textHeader?: InputMaybe<Scalars['String']>;
  senderName: Scalars['String'];
  senderEmail: Scalars['String'];
  context?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  stockNumber?: InputMaybe<Scalars['String']>;
}>;


export type ShareModalMutation = { __typename?: 'Mutation', putMessage?: { __typename?: 'sendMessageStatus', smsSentStatus?: string | null, emailSentStatus?: string | null } | null };

export type CsvLinkQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  searchString: Scalars['String'];
}>;


export type CsvLinkQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', vehicleResultCsvUrl?: string | null } | null } | null };

export type SharePdfCsvMutationVariables = Exact<{
  displayUrl?: InputMaybe<Scalars['String']>;
  smsNumber?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  emailAddress?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  messageBody: Scalars['String'];
  subject?: InputMaybe<Scalars['String']>;
  textHeader?: InputMaybe<Scalars['String']>;
  senderEmail: Scalars['String'];
  senderName: Scalars['String'];
}>;


export type SharePdfCsvMutation = { __typename?: 'Mutation', sharePdfCsv: boolean };

export type SharePdfMutationVariables = Exact<{
  displayUrl?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  smsNumber?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  messageBody?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  subject?: InputMaybe<Scalars['String']>;
  textHeader?: InputMaybe<Scalars['String']>;
  senderEmail: Scalars['String'];
  senderName: Scalars['String'];
}>;


export type SharePdfMutation = { __typename?: 'Mutation', putMessage?: { __typename?: 'sendMessageStatus', smsSentStatus?: string | null, emailSentStatus?: string | null } | null };

export type DeleteUserMutationVariables = Exact<{
  subjectUserId: Scalars['String'];
  auctionId: Scalars['String'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: { __typename?: 'UserMutationResponse', firstName?: string | null, lastName?: string | null, email?: string | null, mobilePhone?: string | null, workPhone?: string | null, notes?: string | null, isLocked?: boolean | null, isGlobalAdmin?: boolean | null, auctionAccessNumber?: string | null, authenticationId?: string | null, authenticationUsername?: string | null, statusMessage?: string | null, statusCode?: number | null } | null };

export type CreateUserMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  authenticationUsername: Scalars['String'];
  isGlobalAdmin: Scalars['Boolean'];
  auctionId: Scalars['String'];
  mobilePhone: Scalars['String'];
  workPhone: Scalars['String'];
  auctionAccessNumber?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  isSiteAdmin: Scalars['Boolean'];
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'UserMutationResponse', authenticationId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, mobilePhone?: string | null, workPhone?: string | null, auctionAccessNumber?: string | null, authenticationUsername?: string | null, notes?: string | null, isLocked?: boolean | null, statusCode?: number | null, statusMessage?: string | null, isGlobalAdmin?: boolean | null } | null };

export type GetUserDetailsQueryVariables = Exact<{
  subjectUserId: Scalars['String'];
  auctionId: Scalars['String'];
}>;


export type GetUserDetailsQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', isAdmin: boolean } | null, user?: { __typename?: 'User', organizations?: Array<{ __typename?: 'Organization', orgId?: string | null, displayName?: string | null, description?: string | null, type?: string | null, isAEAdmin?: boolean | null, isAuctionUser?: boolean | null, isAdmin?: boolean | null, orgTypeCode?: string | null, isCorporateGroupUser?: boolean | null, groupOrgId?: number | null, orgNumber?: number | null } | null> | null } | null, administrator?: { __typename?: 'Administrator', user?: { __typename?: 'User', biRoles?: string | null, permissions?: { __typename?: 'UserPermissions', userPermissions?: Array<{ __typename?: 'PermissionItem', key?: string | null, description?: string | null, note?: string | null } | null> | null } | null, organizations?: Array<{ __typename?: 'Organization', orgId?: string | null, displayName?: string | null, description?: string | null, type?: string | null, isAuctionUser?: boolean | null, isAdmin?: boolean | null, note?: string | null, orgTypeCode?: string | null, isCorporateGroupUser?: boolean | null, groupOrgId?: number | null, orgNumber?: number | null } | null> | null, roles?: Array<{ __typename?: 'RoleAttributes', id: number, name?: string | null, visible?: boolean | null, description?: string | null } | null> | null } | null } | null };

export type UpdateUserMutationVariables = Exact<{
  auctionId: Scalars['String'];
  subjectUserId: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
  workPhone?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  isGlobalAdmin: Scalars['Boolean'];
  notes?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UserMutationResponse', authenticationId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, mobilePhone?: string | null, workPhone?: string | null, auctionAccessNumber?: string | null, authenticationUsername?: string | null, notes?: string | null, isLocked?: boolean | null, statusCode?: number | null, statusMessage?: string | null, isGlobalAdmin?: boolean | null } | null };

export type ResendVerificationEmailMutationVariables = Exact<{
  username: Scalars['String'];
  auctionId: Scalars['String'];
  subjectUserId: Scalars['String'];
}>;


export type ResendVerificationEmailMutation = { __typename?: 'Mutation', resendUnconfirmedPassword?: { __typename?: 'HttpResponse', statusCode: number, statusMessage?: string | null } | null };

export type GetUserListQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type GetUserListQuery = { __typename?: 'Query', administrator?: { __typename?: 'Administrator', users?: Array<{ __typename?: 'UserAttributes', authenticationId?: string | null, authenticationUsername?: string | null, firstName?: string | null, lastName?: string | null, lastSeenAt?: string | null, mobilePhone?: string | null, workPhone?: string | null, email?: string | null, isGlobalAdmin?: boolean | null, notes?: string | null, auctionAccessNumber?: string | null } | null> | null } | null };

export type UpdateUserOrgsMutationVariables = Exact<{
  subjectUserId: Scalars['String'];
  auctionId: Scalars['String'];
  updatedOrganizations: Array<OrganizationInput> | OrganizationInput;
}>;


export type UpdateUserOrgsMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UserMutationResponse', authenticationId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, mobilePhone?: string | null, workPhone?: string | null, auctionAccessNumber?: string | null, authenticationUsername?: string | null, notes?: string | null, isLocked?: boolean | null, statusCode?: number | null, statusMessage?: string | null, isGlobalAdmin?: boolean | null } | null };

export type GetPossibleRolesQueryVariables = Exact<{
  auctionId: Scalars['String'];
}>;


export type GetPossibleRolesQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, roles: Array<{ __typename?: 'RoleAttributes', id: number, name?: string | null, description?: string | null, visible?: boolean | null }>, auction?: { __typename?: 'Auction', roles?: Array<{ __typename?: 'RoleAttributes', id: number, name?: string | null, description?: string | null, visible?: boolean | null } | null> | null } | null };

export type UpdateUserRolesMutationVariables = Exact<{
  subjectUserId: Scalars['String'];
  auctionId: Scalars['String'];
  updatedRoles?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UpdateUserRolesMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UserMutationResponse', authenticationId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, mobilePhone?: string | null, workPhone?: string | null, auctionAccessNumber?: string | null, authenticationUsername?: string | null, notes?: string | null, isLocked?: boolean | null, statusCode?: number | null, statusMessage?: string | null, isGlobalAdmin?: boolean | null } | null };

export type ActiveOrgAndProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveOrgAndProfileQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null, displayName?: string | null, isAdmin?: boolean | null }, profile?: { __typename?: 'Profile', userId: string, isAdmin: boolean } | null };

export type EditSaleConditionsDetailQueryVariables = Exact<{
  assetId?: InputMaybe<Scalars['ID']>;
  auctionId?: InputMaybe<Scalars['String']>;
  stockNumber?: InputMaybe<Scalars['String']>;
}>;


export type EditSaleConditionsDetailQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', assets?: { __typename?: 'Assets', byId?: { __typename?: 'Asset', buyerAccountId?: number | null, buyerAccountKey?: string | null, buyerDisplayName?: string | null, ownerStockNumber?: string | null, stockNumber?: string | null, assetId: string, vin?: string | null, checkinDate?: string | null, saleListingSaleStatus?: string | null, checkinTime?: string | null, checkinUser?: string | null, hasTitle?: string | null, titleNumber?: string | null, titleState?: string | null, titleReceivedDate?: string | null, listingCondition?: string | null, listingConditionId?: number | null, listingConditionCode?: string | null, year?: string | null, make?: string | null, model?: string | null, trim?: string | null, color?: string | null, exteriorColor?: string | null, interiorColor?: string | null, transmissionType?: string | null, drivetrain?: string | null, drivetrainDesc?: string | null, fuelType?: string | null, crStatus?: string | null, mmrValue?: number | null, blackBookValue?: number | null, photoCount?: number | null, photoBeauty?: string | null, proxyBidCount?: number | null, saleAmount?: number | null, floorAmount?: number | null, odometer?: string | null, bodyStyle?: string | null, engineSize?: string | null, cylinders?: string | null, cylinderConfiguration?: string | null, pipelineUri?: string | null, saleEvents?: Array<{ __typename?: 'SaleEvent', eventTitle?: string | null, eventDate?: string | null, venueEventTypeCode?: string | null, eventStartTs?: string | null, eventEndTs?: string | null, eventEndedAtTs?: string | null, venueEventKey?: string | null, lane?: string | null, lotNumber?: string | null, floorPrice?: number | null, saleListingStatus?: string | null, dealSaleAmt?: number | null, dealStatus?: string | null, buyerName?: string | null, saleListingKey?: string | null, buyerOrgAaNum?: string | null, buyerOrgStatusCode?: string | null, buyerAgentAaNum?: string | null, buyerAgentStatusCode?: string | null, city?: string | null, state?: string | null } | null> | null, conditionReport?: { __typename?: 'ConditionReport', conditionReportTime?: string | null, conditionReportStatus?: string | null, conditionReportWriter?: string | null } | null, photos?: Array<{ __typename?: 'Photo', pipelineUri?: string | null, position?: number | null, fileName?: string | null, note?: string | null } | null> | null, saleListing?: { __typename?: 'SaleListing', saleStatus?: string | null, saleDate?: string | null, soldDateLastRanTime?: string | null, saleListingDealSoldAt?: string | null, saleListingOfferCreatedAt?: string | null, lane?: string | null, lot?: string | null, saleMethod?: string | null, venueName?: string | null, venueCode?: string | null, venueUrl?: string | null, buyerAgentName?: string | null, buyerAgentId?: number | null, buyerAgentPicture?: string | null, buyerAgentEmail?: string | null, buyerAgentPhoneMobile?: string | null, sellerAgentId?: number | null, sellerAgentName?: string | null, sellerAgentEmail?: string | null, sellerAgentPhoneMobile?: string | null, buyerAgentNotes?: string | null } | null, assetFees?: Array<{ __typename?: 'AssetFees', stockNumber?: string | null, amount?: string | null, chargeCode?: string | null, description?: string | null, run?: string | null } | null> | null, announcements?: Array<{ __typename?: 'Announcement', type?: string | null, id?: number | null, announcement?: string | null, ordinal?: number | null } | null> | null, consignor?: { __typename?: 'Account', accountKey: string, accountId: number, displayName?: string | null, accountOrgId: number, accountOrgDisplayName?: string | null } | null, onlineListing?: { __typename?: 'OnlineListing', webViews?: number | null } | null, services?: Array<{ __typename?: 'Service', id?: string | null, serviceProductDescription?: string | null, serviceOrderedByAmsUser?: string | null, serviceOrderedAt?: string | null, createdAt?: string | null, serviceClassCode?: string | null, organizationServiceProductId?: string | null, amsServiceProductCode?: string | null, amsChargeCode?: string | null, serviceResultAt?: string | null, notes?: string | null, dealId?: string | null, chargeAmount?: number | null, amsServiceResultCode?: string | null } | null> | null } | null } | null, lightOptions?: Array<{ __typename?: 'LightOption', lightId?: number | null, lightCode?: string | null, lightDescription?: string | null } | null> | null } | null };

export type EditSaleConditionsUpdateQueryVariables = Exact<{
  amsType?: InputMaybe<Scalars['String']>;
  auctionId?: InputMaybe<Scalars['String']>;
  assetId: Scalars['ID'];
  floorPrice?: InputMaybe<SetFloorPrice>;
  lights?: InputMaybe<SetLights>;
  announcements?: InputMaybe<Array<InputMaybe<SetAnnouncements>> | InputMaybe<SetAnnouncements>>;
  stockNumber: Scalars['String'];
  cancelProxyBids?: InputMaybe<Scalars['Boolean']>;
}>;


export type EditSaleConditionsUpdateQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', setVehicleInfo?: { __typename?: 'SetVehicleInfoResults', results?: Array<{ __typename?: 'AmsCallResult', operation?: string | null, success?: boolean | null, message?: string | null } | null> | null, cancelProxyBidsResult?: { __typename?: 'CancelProxyBidsResult', success: boolean, errors?: Array<string | null> | null } | null } | null } | null };

export type CreateAgentContactMutationVariables = Exact<{
  agentId: Scalars['Int'];
  statusCode: Scalars['String'];
  typeCode: Scalars['String'];
  contactedAt: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  followUpDate?: InputMaybe<Scalars['String']>;
  followUpUserId?: InputMaybe<Scalars['Int']>;
  completedAt?: InputMaybe<Scalars['String']>;
  completedBy?: InputMaybe<Scalars['Int']>;
  buyerSellerAccountId?: InputMaybe<Scalars['Int']>;
}>;


export type CreateAgentContactMutation = { __typename?: 'Mutation', createAgentContact?: { __typename?: 'Contact', id: number, userName?: string | null, contactedAt?: string | null, note?: string | null, statusCode?: string | null, typeCode?: string | null } | null };

export type GetContactModalInfoQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type GetContactModalInfoQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', users?: Array<{ __typename?: 'UserAttributes', databaseId?: number | null, firstName?: string | null, lastName?: string | null, authenticationUsername?: string | null } | null> | null, contactManagement?: { __typename?: 'ContactManagement', statuses?: Array<{ __typename?: 'ContactStatus', id?: number | null, code?: string | null, description?: string | null } | null> | null, types?: Array<{ __typename?: 'ContactType', id?: number | null, code?: string | null, description?: string | null } | null> | null } | null } | null };

export type UpdateAgentContactMutationVariables = Exact<{
  id: Scalars['Int'];
  agentId: Scalars['Int'];
  statusCode: Scalars['String'];
  typeCode: Scalars['String'];
  contactedAt: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  followUpDate?: InputMaybe<Scalars['String']>;
  followUpUserId?: InputMaybe<Scalars['Int']>;
  completedAt?: InputMaybe<Scalars['String']>;
  completedBy?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateAgentContactMutation = { __typename?: 'Mutation', updateAgentContact?: { __typename?: 'Contact', id: number, agentId?: number | null, followUpUserId?: number | null, followUpDate?: string | null, completedAt?: string | null, completedBy?: number | null, contactedAt?: string | null, typeCode?: string | null, statusCode?: string | null, note?: string | null } | null };

export type UserInfoContactModalQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type UserInfoContactModalQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, profile?: { __typename?: 'Profile', userId: string } | null, user?: { __typename?: 'User', attributes?: { __typename?: 'UserAttributes', databaseId?: number | null, authenticationId?: string | null, firstName?: string | null, lastName?: string | null, mobilePhone?: string | null, email?: string | null, isGlobalAdmin?: boolean | null, authenticationUsername?: string | null } | null, permissions?: { __typename?: 'UserPermissions', userPermissions?: Array<{ __typename?: 'PermissionItem', key?: string | null, description?: string | null, note?: string | null } | null> | null, orgPermissions?: Array<{ __typename?: 'PermissionItem', key?: string | null, description?: string | null, note?: string | null } | null> | null } | null, organizations?: Array<{ __typename?: 'Organization', orgId?: string | null, displayName?: string | null, description?: string | null, isAdmin?: boolean | null } | null> | null } | null };

export type CreateContactMutationVariables = Exact<{
  agentId: Scalars['Int'];
  statusCode: Scalars['String'];
  typeCode: Scalars['String'];
  contactedAt: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  followUpDate?: InputMaybe<Scalars['String']>;
  followUpUserId?: InputMaybe<Scalars['Int']>;
  completedAt?: InputMaybe<Scalars['String']>;
  completedBy?: InputMaybe<Scalars['Int']>;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createAgentContact?: { __typename?: 'Contact', id: number, userName?: string | null, contactedAt?: string | null, note?: string | null, statusCode?: string | null, typeCode?: string | null } | null };

export type UpdateContactDeprecatedMutationVariables = Exact<{
  id: Scalars['Int'];
  agentId: Scalars['Int'];
  statusCode: Scalars['String'];
  typeCode: Scalars['String'];
  contactedAt: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  followUpDate?: InputMaybe<Scalars['String']>;
  followUpUserId?: InputMaybe<Scalars['Int']>;
  completedAt?: InputMaybe<Scalars['String']>;
  completedBy?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateContactDeprecatedMutation = { __typename?: 'Mutation', updateAgentContact?: { __typename?: 'Contact', id: number, agentId?: number | null, followUpUserId?: number | null, followUpDate?: string | null, completedAt?: string | null, completedBy?: number | null, contactedAt?: string | null, typeCode?: string | null, statusCode?: string | null, note?: string | null } | null };

export type GetDetailPageFieldQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type GetDetailPageFieldQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', reportDetailPages: Array<{ __typename?: 'ReportDetailPage', name: string, displayName: string, url: string, requiredRoles?: Array<string> | null }> } | null };

export type BidderStatsQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
  searchString: Scalars['String'];
  searchStringOnline: Scalars['String'];
}>;


export type BidderStatsQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', totalbidders?: { __typename?: 'SearchResults', bidderCount?: number | null } | null, onlinebidders?: { __typename?: 'SearchResults', bidderCount?: number | null } | null } | null };

export type FavoriteSellersQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type FavoriteSellersQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, auction?: { __typename?: 'Auction', search?: { __typename?: 'SearchResults', accountCount?: number | null, accountResult?: Array<{ __typename?: 'SearchAccount', accountId?: string | null, displayName?: string | null, isFavorite?: boolean | null } | null> | null } | null, detail?: { __typename?: 'SearchResults', accountCount?: number | null, searchStringDisplay?: string | null, searchType?: string | null, vehicleStatsByCompany?: Array<{ __typename?: 'VehicleStatsByCompany', accountName?: string | null, accountId?: number | null, total?: number | null, ran?: number | null, sold?: number | null, conversion?: number | null, avgSaleAmount?: number | null, sumSaleAmount?: number | null } | null> | null } | null } | null };

export type GetReportListQueryVariables = Exact<{
  auctionType?: InputMaybe<Scalars['String']>;
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type GetReportListQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null, type?: string | null }, auction?: { __typename?: 'Auction', reports?: Array<{ __typename?: 'Report', reportId?: number | null, reportShortName?: string | null, shortDescription?: string | null, auctionType?: number | null, reportUrl?: string | null } | null> | null } | null };

export type UserInfoQueryVariables = Exact<{
  auctionId?: InputMaybe<Scalars['String']>;
}>;


export type UserInfoQuery = { __typename?: 'Query', activeOrganization: { __typename?: 'Organization', orgId?: string | null }, profile?: { __typename?: 'Profile', userId: string } | null, user?: { __typename?: 'User', attributes?: { __typename?: 'UserAttributes', databaseId?: number | null, authenticationId?: string | null, firstName?: string | null, lastName?: string | null, mobilePhone?: string | null, email?: string | null, isGlobalAdmin?: boolean | null, authenticationUsername?: string | null } | null, permissions?: { __typename?: 'UserPermissions', userPermissions?: Array<{ __typename?: 'PermissionItem', key?: string | null, description?: string | null, note?: string | null } | null> | null, orgPermissions?: Array<{ __typename?: 'PermissionItem', key?: string | null, description?: string | null, note?: string | null } | null> | null } | null, organizations?: Array<{ __typename?: 'Organization', orgId?: string | null, displayName?: string | null, description?: string | null, isAdmin?: boolean | null, orgTypeCode?: string | null, isCorporateGroupUser?: boolean | null, groupOrgId?: number | null, orgNumber?: number | null } | null> | null } | null };

export type GetUserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserRolesQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', roles?: Array<{ __typename?: 'RoleAttributes', id: number, name?: string | null, description?: string | null }> | null } | null };


export const CompletePasswordDocument = gql`
    mutation CompletePassword($password: String!) {
  doCompleteNewPassword(newPassword: $password) @client {
    result
    message
  }
}
    `;
export type CompletePasswordMutationFn = ApolloReactCommon.MutationFunction<CompletePasswordMutation, CompletePasswordMutationVariables>;

/**
 * __useCompletePasswordMutation__
 *
 * To run a mutation, you first call `useCompletePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completePasswordMutation, { data, loading, error }] = useCompletePasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCompletePasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompletePasswordMutation, CompletePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompletePasswordMutation, CompletePasswordMutationVariables>(CompletePasswordDocument, options);
      }
export type CompletePasswordMutationHookResult = ReturnType<typeof useCompletePasswordMutation>;
export type CompletePasswordMutationResult = ApolloReactCommon.MutationResult<CompletePasswordMutation>;
export type CompletePasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<CompletePasswordMutation, CompletePasswordMutationVariables>;
export const GetSavedEmailDocument = gql`
    query GetSavedEmail {
  passwordRecoveryEmail @client
}
    `;

/**
 * __useGetSavedEmailQuery__
 *
 * To run a query within a React component, call `useGetSavedEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedEmailQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSavedEmailQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSavedEmailQuery, GetSavedEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSavedEmailQuery, GetSavedEmailQueryVariables>(GetSavedEmailDocument, options);
      }
export function useGetSavedEmailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSavedEmailQuery, GetSavedEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSavedEmailQuery, GetSavedEmailQueryVariables>(GetSavedEmailDocument, options);
        }
export type GetSavedEmailQueryHookResult = ReturnType<typeof useGetSavedEmailQuery>;
export type GetSavedEmailLazyQueryHookResult = ReturnType<typeof useGetSavedEmailLazyQuery>;
export type GetSavedEmailQueryResult = ApolloReactCommon.QueryResult<GetSavedEmailQuery, GetSavedEmailQueryVariables>;
export const ResetPasswordByEmailDocument = gql`
    mutation resetPasswordByEmail($email: String!) {
  resetPasswordByEmail(input: {email: $email}) {
    userEmail
    statusCode
    statusMessage
  }
}
    `;
export type ResetPasswordByEmailMutationFn = ApolloReactCommon.MutationFunction<ResetPasswordByEmailMutation, ResetPasswordByEmailMutationVariables>;

/**
 * __useResetPasswordByEmailMutation__
 *
 * To run a mutation, you first call `useResetPasswordByEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordByEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordByEmailMutation, { data, loading, error }] = useResetPasswordByEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordByEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetPasswordByEmailMutation, ResetPasswordByEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetPasswordByEmailMutation, ResetPasswordByEmailMutationVariables>(ResetPasswordByEmailDocument, options);
      }
export type ResetPasswordByEmailMutationHookResult = ReturnType<typeof useResetPasswordByEmailMutation>;
export type ResetPasswordByEmailMutationResult = ApolloReactCommon.MutationResult<ResetPasswordByEmailMutation>;
export type ResetPasswordByEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetPasswordByEmailMutation, ResetPasswordByEmailMutationVariables>;
export const DoLoginDocument = gql`
    mutation DoLogin($username: String!, $password: String!) {
  doLogin(credentials: {username: $username, password: $password}) @client {
    result
    message
  }
}
    `;
export type DoLoginMutationFn = ApolloReactCommon.MutationFunction<DoLoginMutation, DoLoginMutationVariables>;

/**
 * __useDoLoginMutation__
 *
 * To run a mutation, you first call `useDoLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doLoginMutation, { data, loading, error }] = useDoLoginMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useDoLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DoLoginMutation, DoLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DoLoginMutation, DoLoginMutationVariables>(DoLoginDocument, options);
      }
export type DoLoginMutationHookResult = ReturnType<typeof useDoLoginMutation>;
export type DoLoginMutationResult = ApolloReactCommon.MutationResult<DoLoginMutation>;
export type DoLoginMutationOptions = ApolloReactCommon.BaseMutationOptions<DoLoginMutation, DoLoginMutationVariables>;
export const ViewRouterDocument = gql`
    query ViewRouter {
  profile @client {
    userId
    roles {
      id
      name
      description
    }
  }
}
    `;

/**
 * __useViewRouterQuery__
 *
 * To run a query within a React component, call `useViewRouterQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewRouterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewRouterQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewRouterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewRouterQuery, ViewRouterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewRouterQuery, ViewRouterQueryVariables>(ViewRouterDocument, options);
      }
export function useViewRouterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewRouterQuery, ViewRouterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewRouterQuery, ViewRouterQueryVariables>(ViewRouterDocument, options);
        }
export type ViewRouterQueryHookResult = ReturnType<typeof useViewRouterQuery>;
export type ViewRouterLazyQueryHookResult = ReturnType<typeof useViewRouterLazyQuery>;
export type ViewRouterQueryResult = ApolloReactCommon.QueryResult<ViewRouterQuery, ViewRouterQueryVariables>;
export const GetAgentPurchaseHistoryDocument = gql`
    query getAgentPurchaseHistory($offset: Int!, $limit: Int!, $searchString: String!, $auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: VEHICLES}
      pageInfo: {limit: $limit, offset: $offset, sortType: AGENT_PURCHASES_BY_DATE}
    ) {
      vehicleCount
      vehicleResult {
        year
        stockNumber
        make
        model
        assetId
        saleAmount
        saleDate
        buyerAgentId
        buyerAgentName
      }
      searchStringDisplay
      searchType
    }
  }
}
    `;

/**
 * __useGetAgentPurchaseHistoryQuery__
 *
 * To run a query within a React component, call `useGetAgentPurchaseHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentPurchaseHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentPurchaseHistoryQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useGetAgentPurchaseHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAgentPurchaseHistoryQuery, GetAgentPurchaseHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAgentPurchaseHistoryQuery, GetAgentPurchaseHistoryQueryVariables>(GetAgentPurchaseHistoryDocument, options);
      }
export function useGetAgentPurchaseHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAgentPurchaseHistoryQuery, GetAgentPurchaseHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAgentPurchaseHistoryQuery, GetAgentPurchaseHistoryQueryVariables>(GetAgentPurchaseHistoryDocument, options);
        }
export type GetAgentPurchaseHistoryQueryHookResult = ReturnType<typeof useGetAgentPurchaseHistoryQuery>;
export type GetAgentPurchaseHistoryLazyQueryHookResult = ReturnType<typeof useGetAgentPurchaseHistoryLazyQuery>;
export type GetAgentPurchaseHistoryQueryResult = ApolloReactCommon.QueryResult<GetAgentPurchaseHistoryQuery, GetAgentPurchaseHistoryQueryVariables>;
export const GetAgentByIdDocument = gql`
    query getAgentById($agentId: Int!, $auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    agents(filter: {id: $agentId}) {
      byId {
        agentId
        accountKey
        agentNumber
        bidderNumber
        buyerName
        dealerName
        dateAddedOn
        online
        firstName
        lastName
        lastAttendedDate
        firstAttendedDate
        lastAttendBadgeNum
        lastAttendBadgeType
        lastPurchaseActivity
        otherCompanies {
          list {
            agentId
            accountId
            accountDisplayName
          }
        }
        attendanceHistory {
          list {
            eventDate
            bidderBadgeNumber
            attendanceType
          }
        }
        cellPhone
        workPhone
        homePhone
        fax
        email
        birthday
        auctionAccessNumber
        auctionAccessPicture
        accountDisplayName
        accountId
        canBuy
        canSell
        roles {
          agentId
          longDescription
          shortDescription
          code
          id
        }
        agentNotes
        notes {
          agentId
          noteType
          noteText
        }
        contacts {
          count
          list {
            id
            agentId
            agentName
            userName
            followupUserName
            creatorFullName
            createdAt
            contactedAt
            statusCode
            typeCode
            note
            followUpDate
            followUpUserId
            completedBy
            completedAt
          }
        }
      }
    }
    agentRoles {
      id
      code
      shortDescription
      longDescription
      ordinal
    }
  }
}
    `;

/**
 * __useGetAgentByIdQuery__
 *
 * To run a query within a React component, call `useGetAgentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentByIdQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useGetAgentByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAgentByIdQuery, GetAgentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAgentByIdQuery, GetAgentByIdQueryVariables>(GetAgentByIdDocument, options);
      }
export function useGetAgentByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAgentByIdQuery, GetAgentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAgentByIdQuery, GetAgentByIdQueryVariables>(GetAgentByIdDocument, options);
        }
export type GetAgentByIdQueryHookResult = ReturnType<typeof useGetAgentByIdQuery>;
export type GetAgentByIdLazyQueryHookResult = ReturnType<typeof useGetAgentByIdLazyQuery>;
export type GetAgentByIdQueryResult = ApolloReactCommon.QueryResult<GetAgentByIdQuery, GetAgentByIdQueryVariables>;
export const UpdateAgentNoteDocument = gql`
    mutation updateAgentNote($agentNoteUpdate: AgentNoteUpdate) {
  updateAgentNote(agentNoteUpdate: $agentNoteUpdate) {
    success
  }
}
    `;
export type UpdateAgentNoteMutationFn = ApolloReactCommon.MutationFunction<UpdateAgentNoteMutation, UpdateAgentNoteMutationVariables>;

/**
 * __useUpdateAgentNoteMutation__
 *
 * To run a mutation, you first call `useUpdateAgentNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgentNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgentNoteMutation, { data, loading, error }] = useUpdateAgentNoteMutation({
 *   variables: {
 *      agentNoteUpdate: // value for 'agentNoteUpdate'
 *   },
 * });
 */
export function useUpdateAgentNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAgentNoteMutation, UpdateAgentNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAgentNoteMutation, UpdateAgentNoteMutationVariables>(UpdateAgentNoteDocument, options);
      }
export type UpdateAgentNoteMutationHookResult = ReturnType<typeof useUpdateAgentNoteMutation>;
export type UpdateAgentNoteMutationResult = ApolloReactCommon.MutationResult<UpdateAgentNoteMutation>;
export type UpdateAgentNoteMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAgentNoteMutation, UpdateAgentNoteMutationVariables>;
export const UpdateAgentRolesDocument = gql`
    mutation updateAgentRoles($agentRoleUpdate: AgentRoleUpdate) {
  updateAgentRoles(agentRoleUpdate: $agentRoleUpdate) {
    success
    results {
      roleCode
      success
    }
  }
}
    `;
export type UpdateAgentRolesMutationFn = ApolloReactCommon.MutationFunction<UpdateAgentRolesMutation, UpdateAgentRolesMutationVariables>;

/**
 * __useUpdateAgentRolesMutation__
 *
 * To run a mutation, you first call `useUpdateAgentRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgentRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgentRolesMutation, { data, loading, error }] = useUpdateAgentRolesMutation({
 *   variables: {
 *      agentRoleUpdate: // value for 'agentRoleUpdate'
 *   },
 * });
 */
export function useUpdateAgentRolesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAgentRolesMutation, UpdateAgentRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAgentRolesMutation, UpdateAgentRolesMutationVariables>(UpdateAgentRolesDocument, options);
      }
export type UpdateAgentRolesMutationHookResult = ReturnType<typeof useUpdateAgentRolesMutation>;
export type UpdateAgentRolesMutationResult = ApolloReactCommon.MutationResult<UpdateAgentRolesMutation>;
export type UpdateAgentRolesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAgentRolesMutation, UpdateAgentRolesMutationVariables>;
export const UpdateBiRolesDocument = gql`
    mutation updateBIRoles($auctionId: String, $roles: String, $subjectUserId: String) {
  updateBIRoles(orgCode: $auctionId, roles: $roles, subjectUserId: $subjectUserId) {
    statusCode
    statusMessage
  }
}
    `;
export type UpdateBiRolesMutationFn = ApolloReactCommon.MutationFunction<UpdateBiRolesMutation, UpdateBiRolesMutationVariables>;

/**
 * __useUpdateBiRolesMutation__
 *
 * To run a mutation, you first call `useUpdateBiRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBiRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBiRolesMutation, { data, loading, error }] = useUpdateBiRolesMutation({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      roles: // value for 'roles'
 *      subjectUserId: // value for 'subjectUserId'
 *   },
 * });
 */
export function useUpdateBiRolesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBiRolesMutation, UpdateBiRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateBiRolesMutation, UpdateBiRolesMutationVariables>(UpdateBiRolesDocument, options);
      }
export type UpdateBiRolesMutationHookResult = ReturnType<typeof useUpdateBiRolesMutation>;
export type UpdateBiRolesMutationResult = ApolloReactCommon.MutationResult<UpdateBiRolesMutation>;
export type UpdateBiRolesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBiRolesMutation, UpdateBiRolesMutationVariables>;
export const BidderStatsDetailDocument = gql`
    query bidderStatsDetail($auctionId: String, $searchString: String!, $limit: Int!, $offset: Int!) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      pageInfo: {limit: $limit, offset: $offset}
      filter: {type: BIDDERS, searchString: $searchString}
    ) {
      bidderCount
      bidderResult {
        agentId
        firstName
        lastName
        eventDate
        BadgeNum
        BidderType
        consignorLegacyId
        consignor
        consignorId
        vehiclesPurchasedCount
        city
        state
      }
    }
  }
}
    `;

/**
 * __useBidderStatsDetailQuery__
 *
 * To run a query within a React component, call `useBidderStatsDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidderStatsDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidderStatsDetailQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useBidderStatsDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidderStatsDetailQuery, BidderStatsDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidderStatsDetailQuery, BidderStatsDetailQueryVariables>(BidderStatsDetailDocument, options);
      }
export function useBidderStatsDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidderStatsDetailQuery, BidderStatsDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidderStatsDetailQuery, BidderStatsDetailQueryVariables>(BidderStatsDetailDocument, options);
        }
export type BidderStatsDetailQueryHookResult = ReturnType<typeof useBidderStatsDetailQuery>;
export type BidderStatsDetailLazyQueryHookResult = ReturnType<typeof useBidderStatsDetailLazyQuery>;
export type BidderStatsDetailQueryResult = ApolloReactCommon.QueryResult<BidderStatsDetailQuery, BidderStatsDetailQueryVariables>;
export const GetContactLogByAccountDocument = gql`
    query GetContactLogByAccount($auctionId: String, $accountId: Int, $offset: Int, $limit: Int) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    contactManagement {
      contacts(filter: {accountId: $accountId}) {
        count
        list(pageInfo: {offset: $offset, limit: $limit}) {
          id
          agentId
          agentName
          userName
          followupUserName
          creatorFullName
          contactedAt
          createdAt
          statusCode
          typeCode
          note
          followUpDate
          followUpUserId
          completedBy
          completedAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetContactLogByAccountQuery__
 *
 * To run a query within a React component, call `useGetContactLogByAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactLogByAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactLogByAccountQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      accountId: // value for 'accountId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetContactLogByAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactLogByAccountQuery, GetContactLogByAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetContactLogByAccountQuery, GetContactLogByAccountQueryVariables>(GetContactLogByAccountDocument, options);
      }
export function useGetContactLogByAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactLogByAccountQuery, GetContactLogByAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetContactLogByAccountQuery, GetContactLogByAccountQueryVariables>(GetContactLogByAccountDocument, options);
        }
export type GetContactLogByAccountQueryHookResult = ReturnType<typeof useGetContactLogByAccountQuery>;
export type GetContactLogByAccountLazyQueryHookResult = ReturnType<typeof useGetContactLogByAccountLazyQuery>;
export type GetContactLogByAccountQueryResult = ApolloReactCommon.QueryResult<GetContactLogByAccountQuery, GetContactLogByAccountQueryVariables>;
export const GetCompanyByIdDocument = gql`
    query GetCompanyById($auctionId: String, $accountId: Int!) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    accounts(filter: {id: $accountId}) {
      byId {
        accountId
        accountOrgId
        accountKey
        accountSalesRep
        orgCode
        legalName
        displayName
        dbaName
        establishedAt
        auctionAccessNumber
        lastSoldActivity
        lastPurchaseActivity
        accountTypeCode
        canBuy
        canSell
        isActive
        phoneMain
        phoneSecondary
        phoneMobile
        email
        website
        lastAttended
        isFavorite
        locations {
          id
          address1
          address2
          city
          state
          zip
          type
        }
        agents {
          list {
            firstName
            lastName
            cellPhone
            email
            auctionAccessNumber
            auctionAccessPicture
            agentAuthCode
            agentNotes
            agentId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompanyByIdQuery__
 *
 * To run a query within a React component, call `useGetCompanyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyByIdQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetCompanyByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCompanyByIdQuery, GetCompanyByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCompanyByIdQuery, GetCompanyByIdQueryVariables>(GetCompanyByIdDocument, options);
      }
export function useGetCompanyByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyByIdQuery, GetCompanyByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCompanyByIdQuery, GetCompanyByIdQueryVariables>(GetCompanyByIdDocument, options);
        }
export type GetCompanyByIdQueryHookResult = ReturnType<typeof useGetCompanyByIdQuery>;
export type GetCompanyByIdLazyQueryHookResult = ReturnType<typeof useGetCompanyByIdLazyQuery>;
export type GetCompanyByIdQueryResult = ApolloReactCommon.QueryResult<GetCompanyByIdQuery, GetCompanyByIdQueryVariables>;
export const ConditionReportDetailDocument = gql`
    query conditionReportDetail($auctionId: String, $searchString: String!, $limit: Int, $offset: Int) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      pageInfo: {limit: $limit, offset: $offset, sortType: CHECK_IN}
      filter: {type: VEHICLES, searchString: $searchString}
    ) {
      vehicleCount
      vehicleResult {
        saleDate
        runPadded
        stockNumber
        year
        make
        model
        consignorId
        consignorLegacyId
        consignor
        checkedInAt
        assetId
        floorAmount
        photoCount
        hasCr
      }
    }
  }
}
    `;

/**
 * __useConditionReportDetailQuery__
 *
 * To run a query within a React component, call `useConditionReportDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useConditionReportDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConditionReportDetailQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useConditionReportDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConditionReportDetailQuery, ConditionReportDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConditionReportDetailQuery, ConditionReportDetailQueryVariables>(ConditionReportDetailDocument, options);
      }
export function useConditionReportDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConditionReportDetailQuery, ConditionReportDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConditionReportDetailQuery, ConditionReportDetailQueryVariables>(ConditionReportDetailDocument, options);
        }
export type ConditionReportDetailQueryHookResult = ReturnType<typeof useConditionReportDetailQuery>;
export type ConditionReportDetailLazyQueryHookResult = ReturnType<typeof useConditionReportDetailLazyQuery>;
export type ConditionReportDetailQueryResult = ApolloReactCommon.QueryResult<ConditionReportDetailQuery, ConditionReportDetailQueryVariables>;
export const FavoritesDetailDocument = gql`
    query favoritesDetail($auctionId: String, $searchString: String!, $limit: Int!, $offset: Int!) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: COMPANY}
      pageInfo: {limit: $limit, offset: $offset}
    ) {
      searchStringJson
      searchStringDisplay
      accountCount
      accountResult {
        accountKey
        accountId
        displayName
        city
        state
      }
    }
  }
}
    `;

/**
 * __useFavoritesDetailQuery__
 *
 * To run a query within a React component, call `useFavoritesDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoritesDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoritesDetailQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFavoritesDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FavoritesDetailQuery, FavoritesDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FavoritesDetailQuery, FavoritesDetailQueryVariables>(FavoritesDetailDocument, options);
      }
export function useFavoritesDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FavoritesDetailQuery, FavoritesDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FavoritesDetailQuery, FavoritesDetailQueryVariables>(FavoritesDetailDocument, options);
        }
export type FavoritesDetailQueryHookResult = ReturnType<typeof useFavoritesDetailQuery>;
export type FavoritesDetailLazyQueryHookResult = ReturnType<typeof useFavoritesDetailLazyQuery>;
export type FavoritesDetailQueryResult = ApolloReactCommon.QueryResult<FavoritesDetailQuery, FavoritesDetailQueryVariables>;
export const IfOffersListDocument = gql`
    query ifOffersList($searchString: String!, $limit: Int!, $auctionId: String, $offset: Int!, $sortType: SEARCH_SORT_TYPES, $sortOrder: SORT_DIRECTION) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: VEHICLES}
      pageInfo: {offset: $offset, limit: $limit, sortType: $sortType, sortOrder: $sortOrder}
    ) {
      vehicleCount
      searchStringDisplay
      searchType
      vehicleResult {
        assetId
        status
        saleMethod
        saleAmount
        runPadded
        lane
        lot
        latestNegotiationLastEventCreatedAt
        latestNegotiationEventDealCurrentOfferAmount
        latestNegotiationDealBuyerAccountDisplayName
        latestNegotiationDealBuyerAgentName
        buyerCity
        buyerState
        buyerOrgStatusCode
        buyerOrgAaNum
        buyerAgentAaNum
        buyerAgentStatusCode
        saleListingKey
        make
        model
        year
        vin
        stockNumber
        saleDate
        saleDateLastRanTime
        buyerDisplayName
        sellerDisplayName
        dealCurrentOfferAmount
        dealNote
        floorAmount
        buyerAgentName
        buyerAgentEmail
        buyerAgentPhoneMobile
        buyerAgentId
        sellerAgentName
        sellerAgentEmail
        sellerAgentPhoneMobile
        sellerAgentId
        thumbUrl
        ballControlCode
        typeCode
        pipelineUri
        announcementOne
        announcementTwo
        announcementThree
        announcementFour
        announcementLight
      }
    }
  }
}
    `;

/**
 * __useIfOffersListQuery__
 *
 * To run a query within a React component, call `useIfOffersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIfOffersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIfOffersListQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *      auctionId: // value for 'auctionId'
 *      offset: // value for 'offset'
 *      sortType: // value for 'sortType'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useIfOffersListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IfOffersListQuery, IfOffersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IfOffersListQuery, IfOffersListQueryVariables>(IfOffersListDocument, options);
      }
export function useIfOffersListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IfOffersListQuery, IfOffersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IfOffersListQuery, IfOffersListQueryVariables>(IfOffersListDocument, options);
        }
export type IfOffersListQueryHookResult = ReturnType<typeof useIfOffersListQuery>;
export type IfOffersListLazyQueryHookResult = ReturnType<typeof useIfOffersListLazyQuery>;
export type IfOffersListQueryResult = ApolloReactCommon.QueryResult<IfOffersListQuery, IfOffersListQueryVariables>;
export const MyContactLogFollowupsDocument = gql`
    query myContactLogFollowups($auctionId: String, $statusCode: String, $forFollowUp: Boolean, $offset: Int, $limit: Int) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    contactManagement {
      contacts(filter: {statusCode: $statusCode, forFollowUp: $forFollowUp}) {
        count
        list(pageInfo: {offset: $offset, limit: $limit}) {
          id
          account
          accountId
          agentName
          agentId
          userName
          followupUserName
          creatorFullName
          followUpDate
          followUpUserId
          contactedAt
          note
          typeCode
          statusCode
        }
      }
    }
  }
}
    `;

/**
 * __useMyContactLogFollowupsQuery__
 *
 * To run a query within a React component, call `useMyContactLogFollowupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyContactLogFollowupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyContactLogFollowupsQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      statusCode: // value for 'statusCode'
 *      forFollowUp: // value for 'forFollowUp'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMyContactLogFollowupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyContactLogFollowupsQuery, MyContactLogFollowupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyContactLogFollowupsQuery, MyContactLogFollowupsQueryVariables>(MyContactLogFollowupsDocument, options);
      }
export function useMyContactLogFollowupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyContactLogFollowupsQuery, MyContactLogFollowupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyContactLogFollowupsQuery, MyContactLogFollowupsQueryVariables>(MyContactLogFollowupsDocument, options);
        }
export type MyContactLogFollowupsQueryHookResult = ReturnType<typeof useMyContactLogFollowupsQuery>;
export type MyContactLogFollowupsLazyQueryHookResult = ReturnType<typeof useMyContactLogFollowupsLazyQuery>;
export type MyContactLogFollowupsQueryResult = ApolloReactCommon.QueryResult<MyContactLogFollowupsQuery, MyContactLogFollowupsQueryVariables>;
export const OdsIfOfferFilterListDocument = gql`
    query odsIfOfferFilterList($searchString: String!, $limit: Int!, $auctionId: String, $offset: Int!, $sortType: SEARCH_SORT_TYPES, $sortOrder: SORT_DIRECTION) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: VEHICLES, useSQL: true}
      pageInfo: {offset: $offset, limit: $limit, sortType: $sortType, sortOrder: $sortOrder}
    ) {
      vehicleCount
      vehicleResult {
        assetId
        status
        saleMethod
        saleAmount
        runPadded
        lane
        lot
        latestNegotiationLastEventCreatedAt
        latestNegotiationEventDealCurrentOfferAmount
        latestNegotiationDealBuyerAccountDisplayName
        latestNegotiationDealBuyerAgentName
        buyerCity
        buyerState
        buyerOrgStatusCode
        buyerOrgAaNum
        buyerAgentAaNum
        buyerAgentStatusCode
        saleListingKey
        make
        model
        year
        vin
        stockNumber
        saleDate
        saleDateLastRanTime
        buyerDisplayName
        sellerDisplayName
        dealCurrentOfferAmount
        dealNote
        floorAmount
        buyerAgentName
        buyerAgentEmail
        buyerAgentPhoneMobile
        buyerAgentId
        sellerAgentName
        sellerAgentEmail
        sellerAgentPhoneMobile
        sellerAgentId
        thumbUrl
        ballControlCode
        typeCode
        pipelineUri
      }
    }
  }
}
    `;

/**
 * __useOdsIfOfferFilterListQuery__
 *
 * To run a query within a React component, call `useOdsIfOfferFilterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOdsIfOfferFilterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOdsIfOfferFilterListQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *      auctionId: // value for 'auctionId'
 *      offset: // value for 'offset'
 *      sortType: // value for 'sortType'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useOdsIfOfferFilterListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OdsIfOfferFilterListQuery, OdsIfOfferFilterListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OdsIfOfferFilterListQuery, OdsIfOfferFilterListQueryVariables>(OdsIfOfferFilterListDocument, options);
      }
export function useOdsIfOfferFilterListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OdsIfOfferFilterListQuery, OdsIfOfferFilterListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OdsIfOfferFilterListQuery, OdsIfOfferFilterListQueryVariables>(OdsIfOfferFilterListDocument, options);
        }
export type OdsIfOfferFilterListQueryHookResult = ReturnType<typeof useOdsIfOfferFilterListQuery>;
export type OdsIfOfferFilterListLazyQueryHookResult = ReturnType<typeof useOdsIfOfferFilterListLazyQuery>;
export type OdsIfOfferFilterListQueryResult = ApolloReactCommon.QueryResult<OdsIfOfferFilterListQuery, OdsIfOfferFilterListQueryVariables>;
export const OdsIfOfferListDocument = gql`
    query odsIfOfferList($searchString: String!, $limit: Int!, $auctionId: String, $offset: Int!, $sortType: SEARCH_SORT_TYPES, $sortOrder: SORT_DIRECTION) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: VEHICLES, useSQL: true}
      pageInfo: {offset: $offset, limit: $limit, sortType: $sortType, sortOrder: $sortOrder}
    ) {
      vehicleCount
      vehicleResult {
        assetId
        status
        saleMethod
        saleAmount
        runPadded
        lane
        lot
        latestNegotiationLastEventCreatedAt
        latestNegotiationEventDealCurrentOfferAmount
        latestNegotiationDealBuyerAccountDisplayName
        latestNegotiationDealBuyerAgentName
        buyerCity
        buyerState
        buyerOrgStatusCode
        buyerOrgAaNum
        buyerAgentAaNum
        buyerAgentStatusCode
        saleListingKey
        make
        model
        year
        vin
        stockNumber
        saleDate
        saleDateLastRanTime
        buyerDisplayName
        sellerDisplayName
        dealCurrentOfferAmount
        dealNote
        floorAmount
        buyerAgentName
        buyerAgentEmail
        buyerAgentPhoneMobile
        buyerAgentId
        sellerAgentName
        sellerAgentEmail
        sellerAgentPhoneMobile
        sellerAgentId
        thumbUrl
        ballControlCode
        typeCode
        pipelineUri
      }
    }
  }
}
    `;

/**
 * __useOdsIfOfferListQuery__
 *
 * To run a query within a React component, call `useOdsIfOfferListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOdsIfOfferListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOdsIfOfferListQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *      auctionId: // value for 'auctionId'
 *      offset: // value for 'offset'
 *      sortType: // value for 'sortType'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useOdsIfOfferListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OdsIfOfferListQuery, OdsIfOfferListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OdsIfOfferListQuery, OdsIfOfferListQueryVariables>(OdsIfOfferListDocument, options);
      }
export function useOdsIfOfferListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OdsIfOfferListQuery, OdsIfOfferListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OdsIfOfferListQuery, OdsIfOfferListQueryVariables>(OdsIfOfferListDocument, options);
        }
export type OdsIfOfferListQueryHookResult = ReturnType<typeof useOdsIfOfferListQuery>;
export type OdsIfOfferListLazyQueryHookResult = ReturnType<typeof useOdsIfOfferListLazyQuery>;
export type OdsIfOfferListQueryResult = ApolloReactCommon.QueryResult<OdsIfOfferListQuery, OdsIfOfferListQueryVariables>;
export const GetInspectionTypesDocument = gql`
    query getInspectionTypes($orgCode: String!) {
  auction(id: $orgCode) {
    psi(filter: {orgCode: $orgCode}) {
      inspectionTypes {
        chargeAmount
        chargeAmountFail
        chargeCode
        defaultPrinterName
        longDesc
        quickPickLabel
        ordinal
        orgId
        printOnCreate
        quickPickOrdinal
        serviceClass
        serviceCode
        shortDesc
      }
    }
  }
}
    `;

/**
 * __useGetInspectionTypesQuery__
 *
 * To run a query within a React component, call `useGetInspectionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInspectionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInspectionTypesQuery({
 *   variables: {
 *      orgCode: // value for 'orgCode'
 *   },
 * });
 */
export function useGetInspectionTypesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetInspectionTypesQuery, GetInspectionTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInspectionTypesQuery, GetInspectionTypesQueryVariables>(GetInspectionTypesDocument, options);
      }
export function useGetInspectionTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInspectionTypesQuery, GetInspectionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInspectionTypesQuery, GetInspectionTypesQueryVariables>(GetInspectionTypesDocument, options);
        }
export type GetInspectionTypesQueryHookResult = ReturnType<typeof useGetInspectionTypesQuery>;
export type GetInspectionTypesLazyQueryHookResult = ReturnType<typeof useGetInspectionTypesLazyQuery>;
export type GetInspectionTypesQueryResult = ApolloReactCommon.QueryResult<GetInspectionTypesQuery, GetInspectionTypesQueryVariables>;
export const OpenPsiDocument = gql`
    mutation openPsi($auctionId: String, $inspections: [InspectionInput]!) {
  createPSI(auctionId: $auctionId, inspections: $inspections) {
    responseCode
    message
    serviceResponses {
      serviceClass
      serviceCode
      stockNumber
      vin
      statusCode
      statusText
    }
  }
}
    `;
export type OpenPsiMutationFn = ApolloReactCommon.MutationFunction<OpenPsiMutation, OpenPsiMutationVariables>;

/**
 * __useOpenPsiMutation__
 *
 * To run a mutation, you first call `useOpenPsiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenPsiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openPsiMutation, { data, loading, error }] = useOpenPsiMutation({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      inspections: // value for 'inspections'
 *   },
 * });
 */
export function useOpenPsiMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OpenPsiMutation, OpenPsiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OpenPsiMutation, OpenPsiMutationVariables>(OpenPsiDocument, options);
      }
export type OpenPsiMutationHookResult = ReturnType<typeof useOpenPsiMutation>;
export type OpenPsiMutationResult = ApolloReactCommon.MutationResult<OpenPsiMutation>;
export type OpenPsiMutationOptions = ApolloReactCommon.BaseMutationOptions<OpenPsiMutation, OpenPsiMutationVariables>;
export const PostSaleInspectionEligibleDocument = gql`
    query postSaleInspectionEligible($searchString: String!, $limit: Int!, $auctionId: String, $offset: Int!, $sortType: SEARCH_SORT_TYPES, $sortOrder: SORT_DIRECTION, $aggrSortType: AGGR_SEARCH_SORT_TYPES, $aggrSortOrder: SORT_DIRECTION) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: VEHICLES}
      pageInfo: {offset: $offset, limit: $limit, sortType: $sortType, sortOrder: $sortOrder, aggrSortType: $aggrSortType, aggrSortOrder: $aggrSortOrder}
    ) {
      vehicleCount
      searchStringDisplay
      searchType
      vehicleResult {
        assetId
        status
        saleMethod
        runPadded
        buyerAgentId
        buyerId
        lane
        lot
        make
        model
        year
        odometer
        vin
        announcementLight
        stockNumber
        saleDate
        saleAmount
        soldDateLastRanTime
        buyerDisplayName
        buyerAgentName
        sellerDisplayName
        psiCreatedAt
        psiLongDesc
        psiChargeAmount
        psiAmsServiceResultCode
      }
    }
  }
}
    `;

/**
 * __usePostSaleInspectionEligibleQuery__
 *
 * To run a query within a React component, call `usePostSaleInspectionEligibleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostSaleInspectionEligibleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostSaleInspectionEligibleQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *      auctionId: // value for 'auctionId'
 *      offset: // value for 'offset'
 *      sortType: // value for 'sortType'
 *      sortOrder: // value for 'sortOrder'
 *      aggrSortType: // value for 'aggrSortType'
 *      aggrSortOrder: // value for 'aggrSortOrder'
 *   },
 * });
 */
export function usePostSaleInspectionEligibleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PostSaleInspectionEligibleQuery, PostSaleInspectionEligibleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PostSaleInspectionEligibleQuery, PostSaleInspectionEligibleQueryVariables>(PostSaleInspectionEligibleDocument, options);
      }
export function usePostSaleInspectionEligibleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PostSaleInspectionEligibleQuery, PostSaleInspectionEligibleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PostSaleInspectionEligibleQuery, PostSaleInspectionEligibleQueryVariables>(PostSaleInspectionEligibleDocument, options);
        }
export type PostSaleInspectionEligibleQueryHookResult = ReturnType<typeof usePostSaleInspectionEligibleQuery>;
export type PostSaleInspectionEligibleLazyQueryHookResult = ReturnType<typeof usePostSaleInspectionEligibleLazyQuery>;
export type PostSaleInspectionEligibleQueryResult = ApolloReactCommon.QueryResult<PostSaleInspectionEligibleQuery, PostSaleInspectionEligibleQueryVariables>;
export const RecentAccountsDetailDocument = gql`
    query recentAccountsDetail($auctionId: String, $searchString: String!, $offset: Int!, $limit: Int!) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      pageInfo: {limit: $limit, offset: $offset}
      filter: {type: COMPANY, searchString: $searchString}
    ) {
      accountCount
      accountResult {
        accountId
        accountKey
        displayName
        city
        state
        lastAttendedAt
        lastBoughtAt
        lastSoldAt
        establishedAt
        accountLegacyType
      }
    }
  }
}
    `;

/**
 * __useRecentAccountsDetailQuery__
 *
 * To run a query within a React component, call `useRecentAccountsDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentAccountsDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentAccountsDetailQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      searchString: // value for 'searchString'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRecentAccountsDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RecentAccountsDetailQuery, RecentAccountsDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RecentAccountsDetailQuery, RecentAccountsDetailQueryVariables>(RecentAccountsDetailDocument, options);
      }
export function useRecentAccountsDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecentAccountsDetailQuery, RecentAccountsDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RecentAccountsDetailQuery, RecentAccountsDetailQueryVariables>(RecentAccountsDetailDocument, options);
        }
export type RecentAccountsDetailQueryHookResult = ReturnType<typeof useRecentAccountsDetailQuery>;
export type RecentAccountsDetailLazyQueryHookResult = ReturnType<typeof useRecentAccountsDetailLazyQuery>;
export type RecentAccountsDetailQueryResult = ApolloReactCommon.QueryResult<RecentAccountsDetailQuery, RecentAccountsDetailQueryVariables>;
export const SalesOverviewDetailDocument = gql`
    query salesOverviewDetail($endDate: String!, $offset: Int!, $limit: Int!, $auctionId: String, $startDate: String!) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    statistics(
      filter: {dataSource: "datalake", dates: {startDate: $startDate, endDate: $endDate}}
    ) {
      lanes {
        count
        list(pageInfo: {limit: $limit, offset: $offset}) {
          name
          eventDate
          arbitration
          hasCr
          offer
          offerOnline
          sold
          soldOnline
          run
          units
        }
      }
    }
  }
}
    `;

/**
 * __useSalesOverviewDetailQuery__
 *
 * To run a query within a React component, call `useSalesOverviewDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesOverviewDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesOverviewDetailQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      auctionId: // value for 'auctionId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useSalesOverviewDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SalesOverviewDetailQuery, SalesOverviewDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SalesOverviewDetailQuery, SalesOverviewDetailQueryVariables>(SalesOverviewDetailDocument, options);
      }
export function useSalesOverviewDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SalesOverviewDetailQuery, SalesOverviewDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SalesOverviewDetailQuery, SalesOverviewDetailQueryVariables>(SalesOverviewDetailDocument, options);
        }
export type SalesOverviewDetailQueryHookResult = ReturnType<typeof useSalesOverviewDetailQuery>;
export type SalesOverviewDetailLazyQueryHookResult = ReturnType<typeof useSalesOverviewDetailLazyQuery>;
export type SalesOverviewDetailQueryResult = ApolloReactCommon.QueryResult<SalesOverviewDetailQuery, SalesOverviewDetailQueryVariables>;
export const SearchVehiclesByAccountDetailDocument = gql`
    query SearchVehiclesByAccountDetail($limit: Int!, $offset: Int!, $searchString: String!, $auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: VEHICLES_BY_COMPANY}
      pageInfo: {limit: $limit, offset: $offset}
    ) {
      vehicleStatsByCompany {
        accountName
        accountId
        total
        ran
        sold
        conversion
        avgSaleAmount
        sumSaleAmount
      }
      accountCount
      searchStringDisplay
      searchType
    }
  }
}
    `;

/**
 * __useSearchVehiclesByAccountDetailQuery__
 *
 * To run a query within a React component, call `useSearchVehiclesByAccountDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVehiclesByAccountDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVehiclesByAccountDetailQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchString: // value for 'searchString'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useSearchVehiclesByAccountDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchVehiclesByAccountDetailQuery, SearchVehiclesByAccountDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchVehiclesByAccountDetailQuery, SearchVehiclesByAccountDetailQueryVariables>(SearchVehiclesByAccountDetailDocument, options);
      }
export function useSearchVehiclesByAccountDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchVehiclesByAccountDetailQuery, SearchVehiclesByAccountDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchVehiclesByAccountDetailQuery, SearchVehiclesByAccountDetailQueryVariables>(SearchVehiclesByAccountDetailDocument, options);
        }
export type SearchVehiclesByAccountDetailQueryHookResult = ReturnType<typeof useSearchVehiclesByAccountDetailQuery>;
export type SearchVehiclesByAccountDetailLazyQueryHookResult = ReturnType<typeof useSearchVehiclesByAccountDetailLazyQuery>;
export type SearchVehiclesByAccountDetailQueryResult = ApolloReactCommon.QueryResult<SearchVehiclesByAccountDetailQuery, SearchVehiclesByAccountDetailQueryVariables>;
export const SearchVehiclesByBuyerDetailDocument = gql`
    query SearchVehiclesByBuyerDetail($limit: Int!, $offset: Int!, $searchString: String!, $auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: VEHICLES_BY_BUYERS}
      pageInfo: {limit: $limit, offset: $offset}
    ) {
      vehicleStatsByCompany {
        accountName
        accountId
        total
        ran
        sold
        conversion
        avgSaleAmount
        sumSaleAmount
      }
      accountCount
      searchStringDisplay
      searchType
    }
  }
}
    `;

/**
 * __useSearchVehiclesByBuyerDetailQuery__
 *
 * To run a query within a React component, call `useSearchVehiclesByBuyerDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVehiclesByBuyerDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVehiclesByBuyerDetailQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchString: // value for 'searchString'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useSearchVehiclesByBuyerDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchVehiclesByBuyerDetailQuery, SearchVehiclesByBuyerDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchVehiclesByBuyerDetailQuery, SearchVehiclesByBuyerDetailQueryVariables>(SearchVehiclesByBuyerDetailDocument, options);
      }
export function useSearchVehiclesByBuyerDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchVehiclesByBuyerDetailQuery, SearchVehiclesByBuyerDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchVehiclesByBuyerDetailQuery, SearchVehiclesByBuyerDetailQueryVariables>(SearchVehiclesByBuyerDetailDocument, options);
        }
export type SearchVehiclesByBuyerDetailQueryHookResult = ReturnType<typeof useSearchVehiclesByBuyerDetailQuery>;
export type SearchVehiclesByBuyerDetailLazyQueryHookResult = ReturnType<typeof useSearchVehiclesByBuyerDetailLazyQuery>;
export type SearchVehiclesByBuyerDetailQueryResult = ApolloReactCommon.QueryResult<SearchVehiclesByBuyerDetailQuery, SearchVehiclesByBuyerDetailQueryVariables>;
export const SearchContactLogDetailDocument = gql`
    query SearchContactLogDetail($offset: Int!, $limit: Int!, $searchString: String!, $auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: CONTACT_LOGS}
      pageInfo: {limit: $limit, offset: $offset}
    ) {
      contactLogCount
      contactLogResult {
        id
        creatorFullName
        followupFullName
        completedFullName
        creatorUsername
        followupUsername
        completedUsername
        creatorEmail
        followupEmail
        completedEmail
        creatorUserid
        followupUserid
        completedUserid
        completedAt
        contactedAt
        followupAt
        agentId
        agentName
        statusCode
        typeCode
        accountId
        accountDisplayName
        accountAuctionAccess
        accountKey
        note
        auctionCode
        update
        followUpDate
        followUpUserId
        completedBy
      }
      searchStringDisplay
      searchType
    }
  }
}
    `;

/**
 * __useSearchContactLogDetailQuery__
 *
 * To run a query within a React component, call `useSearchContactLogDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContactLogDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContactLogDetailQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useSearchContactLogDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchContactLogDetailQuery, SearchContactLogDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchContactLogDetailQuery, SearchContactLogDetailQueryVariables>(SearchContactLogDetailDocument, options);
      }
export function useSearchContactLogDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchContactLogDetailQuery, SearchContactLogDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchContactLogDetailQuery, SearchContactLogDetailQueryVariables>(SearchContactLogDetailDocument, options);
        }
export type SearchContactLogDetailQueryHookResult = ReturnType<typeof useSearchContactLogDetailQuery>;
export type SearchContactLogDetailLazyQueryHookResult = ReturnType<typeof useSearchContactLogDetailLazyQuery>;
export type SearchContactLogDetailQueryResult = ApolloReactCommon.QueryResult<SearchContactLogDetailQuery, SearchContactLogDetailQueryVariables>;
export const SearchAllDocument = gql`
    query searchAll($searchString: String!, $limit: Int!, $auctionId: String, $offset: Int!) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: BROAD}
      pageInfo: {limit: $limit, offset: $offset}
    ) {
      searchStringJson
      searchStringDisplay
      totalCount
      vehicleCount
      vehicleRecentlySoldCount
      vehicleInSaleCount
      accountCount
      agentCount
      vehicleResult {
        assetId
        year
        make
        model
        vin
        color
        lot
        lane
        runPadded
        ranAt
        saleDate
        checkedInAt
        status
        stockNumber
        odometer
        buyer
        consignor
        searchScore
        orgCode
        saleAmount
        thumbUrl
        consignorStockNumber
        daysOnLot
      }
      vehicleInSaleResult {
        assetId
        year
        make
        model
        vin
        color
        lot
        runPadded
        lane
        ranAt
        saleDate
        checkedInAt
        status
        consignor
        stockNumber
        buyer
        odometer
        searchScore
        orgCode
        thumbUrl
        consignorStockNumber
        daysOnLot
      }
      vehicleRecentlySoldResult {
        assetId
        year
        make
        model
        vin
        color
        lot
        runPadded
        lane
        ranAt
        saleDate
        checkedInAt
        status
        buyer
        consignor
        stockNumber
        odometer
        searchScore
        orgCode
        saleAmount
        thumbUrl
        consignorStockNumber
        daysOnLot
      }
      agentResult {
        agentId
        firstName
        lastName
        cellPhone
        workPhone
        email
        legalName
        displayName
        dbaName
        city
        state
        searchScore
        auctionAccess
        accountKey
        lastAttendBadgeNum
        lastAttendDate
        lastAttendBidderType
      }
      accountResult {
        accountId
        legalName
        displayName
        dbaName
        city
        state
        postalCode
        searchScore
        auctionAccess
        accountKey
        accountLegacyType
        lastAttendedAt
        lastBoughtAt
        lastSoldAt
        isActive
        canBuy
        canSell
      }
    }
  }
}
    `;

/**
 * __useSearchAllQuery__
 *
 * To run a query within a React component, call `useSearchAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAllQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *      auctionId: // value for 'auctionId'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchAllQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchAllQuery, SearchAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchAllQuery, SearchAllQueryVariables>(SearchAllDocument, options);
      }
export function useSearchAllLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchAllQuery, SearchAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchAllQuery, SearchAllQueryVariables>(SearchAllDocument, options);
        }
export type SearchAllQueryHookResult = ReturnType<typeof useSearchAllQuery>;
export type SearchAllLazyQueryHookResult = ReturnType<typeof useSearchAllLazyQuery>;
export type SearchAllQueryResult = ApolloReactCommon.QueryResult<SearchAllQuery, SearchAllQueryVariables>;
export const SearchAllAgentsDocument = gql`
    query searchAllAgents($searchString: String!, $limit: Int!, $auctionId: String, $offset: Int!) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: BROAD}
      pageInfo: {limit: $limit, offset: $offset}
    ) {
      searchStringJson
      searchStringDisplay
      totalCount
      vehicleCount
      vehicleRecentlySoldCount
      vehicleInSaleCount
      accountCount
      agentCount
      agentResult {
        agentId
        firstName
        lastName
        cellPhone
        workPhone
        email
        legalName
        displayName
        dbaName
        city
        state
        searchScore
        auctionAccess
        accountKey
        lastAttendBadgeNum
        lastAttendDate
        lastAttendBidderType
      }
    }
  }
}
    `;

/**
 * __useSearchAllAgentsQuery__
 *
 * To run a query within a React component, call `useSearchAllAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAllAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAllAgentsQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *      auctionId: // value for 'auctionId'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchAllAgentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchAllAgentsQuery, SearchAllAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchAllAgentsQuery, SearchAllAgentsQueryVariables>(SearchAllAgentsDocument, options);
      }
export function useSearchAllAgentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchAllAgentsQuery, SearchAllAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchAllAgentsQuery, SearchAllAgentsQueryVariables>(SearchAllAgentsDocument, options);
        }
export type SearchAllAgentsQueryHookResult = ReturnType<typeof useSearchAllAgentsQuery>;
export type SearchAllAgentsLazyQueryHookResult = ReturnType<typeof useSearchAllAgentsLazyQuery>;
export type SearchAllAgentsQueryResult = ApolloReactCommon.QueryResult<SearchAllAgentsQuery, SearchAllAgentsQueryVariables>;
export const SearchAllCompaniesDocument = gql`
    query searchAllCompanies($searchString: String!, $offset: Int!, $auctionId: String, $limit: Int!, $sort: SearchSort) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: BROAD}
      pageInfo: {limit: $limit, offset: $offset}
      sort: $sort
    ) {
      searchStringJson
      searchStringDisplay
      totalCount
      vehicleCount
      vehicleRecentlySoldCount
      vehicleInSaleCount
      accountCount
      agentCount
      accountResult {
        accountId
        legalName
        displayName
        dbaName
        city
        state
        postalCode
        searchScore
        auctionAccess
        accountKey
        accountLegacyType
        lastAttendedAt
        lastBoughtAt
        lastSoldAt
        isFavorite
        isActive
        canBuy
        canSell
      }
    }
  }
}
    `;

/**
 * __useSearchAllCompaniesQuery__
 *
 * To run a query within a React component, call `useSearchAllCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAllCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAllCompaniesQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      offset: // value for 'offset'
 *      auctionId: // value for 'auctionId'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchAllCompaniesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchAllCompaniesQuery, SearchAllCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchAllCompaniesQuery, SearchAllCompaniesQueryVariables>(SearchAllCompaniesDocument, options);
      }
export function useSearchAllCompaniesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchAllCompaniesQuery, SearchAllCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchAllCompaniesQuery, SearchAllCompaniesQueryVariables>(SearchAllCompaniesDocument, options);
        }
export type SearchAllCompaniesQueryHookResult = ReturnType<typeof useSearchAllCompaniesQuery>;
export type SearchAllCompaniesLazyQueryHookResult = ReturnType<typeof useSearchAllCompaniesLazyQuery>;
export type SearchAllCompaniesQueryResult = ApolloReactCommon.QueryResult<SearchAllCompaniesQuery, SearchAllCompaniesQueryVariables>;
export const SearchAllVehiclesDocument = gql`
    query searchAllVehicles($searchString: String!, $offset: Int!, $auctionId: String, $limit: Int!) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: BROAD}
      pageInfo: {limit: $limit, offset: $offset}
    ) {
      searchStringJson
      searchStringDisplay
      totalCount
      vehicleCount
      vehicleRecentlySoldCount
      vehicleInSaleCount
      accountCount
      agentCount
      vehicleResult {
        assetId
        year
        make
        model
        vin
        color
        lot
        lane
        runPadded
        ranAt
        saleDate
        checkedInAt
        status
        odometer
        buyer
        stockNumber
        consignor
        searchScore
        orgCode
        saleAmount
        thumbUrl
        consignorStockNumber
        daysOnLot
      }
    }
  }
}
    `;

/**
 * __useSearchAllVehiclesQuery__
 *
 * To run a query within a React component, call `useSearchAllVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAllVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAllVehiclesQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      offset: // value for 'offset'
 *      auctionId: // value for 'auctionId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchAllVehiclesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchAllVehiclesQuery, SearchAllVehiclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchAllVehiclesQuery, SearchAllVehiclesQueryVariables>(SearchAllVehiclesDocument, options);
      }
export function useSearchAllVehiclesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchAllVehiclesQuery, SearchAllVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchAllVehiclesQuery, SearchAllVehiclesQueryVariables>(SearchAllVehiclesDocument, options);
        }
export type SearchAllVehiclesQueryHookResult = ReturnType<typeof useSearchAllVehiclesQuery>;
export type SearchAllVehiclesLazyQueryHookResult = ReturnType<typeof useSearchAllVehiclesLazyQuery>;
export type SearchAllVehiclesQueryResult = ApolloReactCommon.QueryResult<SearchAllVehiclesQuery, SearchAllVehiclesQueryVariables>;
export const SearchInSaleVehiclesDocument = gql`
    query searchInSaleVehicles($searchString: String!, $offset: Int!, $auctionId: String, $limit: Int!) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: BROAD}
      pageInfo: {limit: $limit, offset: $offset}
    ) {
      totalCount
      vehicleCount
      vehicleRecentlySoldCount
      vehicleInSaleCount
      accountCount
      agentCount
      vehicleInSaleResult {
        assetId
        year
        make
        model
        vin
        color
        lot
        lane
        runPadded
        ranAt
        saleDate
        checkedInAt
        status
        stockNumber
        searchScore
        odometer
        buyer
        consignor
        orgCode
        saleAmount
        thumbUrl
      }
    }
  }
}
    `;

/**
 * __useSearchInSaleVehiclesQuery__
 *
 * To run a query within a React component, call `useSearchInSaleVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchInSaleVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchInSaleVehiclesQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      offset: // value for 'offset'
 *      auctionId: // value for 'auctionId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchInSaleVehiclesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchInSaleVehiclesQuery, SearchInSaleVehiclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchInSaleVehiclesQuery, SearchInSaleVehiclesQueryVariables>(SearchInSaleVehiclesDocument, options);
      }
export function useSearchInSaleVehiclesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchInSaleVehiclesQuery, SearchInSaleVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchInSaleVehiclesQuery, SearchInSaleVehiclesQueryVariables>(SearchInSaleVehiclesDocument, options);
        }
export type SearchInSaleVehiclesQueryHookResult = ReturnType<typeof useSearchInSaleVehiclesQuery>;
export type SearchInSaleVehiclesLazyQueryHookResult = ReturnType<typeof useSearchInSaleVehiclesLazyQuery>;
export type SearchInSaleVehiclesQueryResult = ApolloReactCommon.QueryResult<SearchInSaleVehiclesQuery, SearchInSaleVehiclesQueryVariables>;
export const SearchSoldVehiclesDocument = gql`
    query searchSoldVehicles($searchString: String!, $offset: Int!, $auctionId: String, $limit: Int!) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: BROAD}
      pageInfo: {limit: $limit, offset: $offset}
    ) {
      totalCount
      vehicleCount
      vehicleRecentlySoldCount
      vehicleInSaleCount
      accountCount
      agentCount
      vehicleRecentlySoldResult {
        assetId
        year
        make
        model
        vin
        color
        lot
        lane
        runPadded
        ranAt
        saleDate
        checkedInAt
        status
        stockNumber
        odometer
        buyer
        searchScore
        consignor
        orgCode
        saleAmount
        thumbUrl
      }
    }
  }
}
    `;

/**
 * __useSearchSoldVehiclesQuery__
 *
 * To run a query within a React component, call `useSearchSoldVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSoldVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSoldVehiclesQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      offset: // value for 'offset'
 *      auctionId: // value for 'auctionId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchSoldVehiclesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchSoldVehiclesQuery, SearchSoldVehiclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchSoldVehiclesQuery, SearchSoldVehiclesQueryVariables>(SearchSoldVehiclesDocument, options);
      }
export function useSearchSoldVehiclesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchSoldVehiclesQuery, SearchSoldVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchSoldVehiclesQuery, SearchSoldVehiclesQueryVariables>(SearchSoldVehiclesDocument, options);
        }
export type SearchSoldVehiclesQueryHookResult = ReturnType<typeof useSearchSoldVehiclesQuery>;
export type SearchSoldVehiclesLazyQueryHookResult = ReturnType<typeof useSearchSoldVehiclesLazyQuery>;
export type SearchSoldVehiclesQueryResult = ApolloReactCommon.QueryResult<SearchSoldVehiclesQuery, SearchSoldVehiclesQueryVariables>;
export const PushToAmsUsingAssetIdDocument = gql`
    mutation PushToAmsUsingAssetId($id: ID!) {
  pushVehicleToAms(id: $id) {
    success
    stockNumber
    message
  }
}
    `;
export type PushToAmsUsingAssetIdMutationFn = ApolloReactCommon.MutationFunction<PushToAmsUsingAssetIdMutation, PushToAmsUsingAssetIdMutationVariables>;

/**
 * __usePushToAmsUsingAssetIdMutation__
 *
 * To run a mutation, you first call `usePushToAmsUsingAssetIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushToAmsUsingAssetIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushToAmsUsingAssetIdMutation, { data, loading, error }] = usePushToAmsUsingAssetIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePushToAmsUsingAssetIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PushToAmsUsingAssetIdMutation, PushToAmsUsingAssetIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PushToAmsUsingAssetIdMutation, PushToAmsUsingAssetIdMutationVariables>(PushToAmsUsingAssetIdDocument, options);
      }
export type PushToAmsUsingAssetIdMutationHookResult = ReturnType<typeof usePushToAmsUsingAssetIdMutation>;
export type PushToAmsUsingAssetIdMutationResult = ApolloReactCommon.MutationResult<PushToAmsUsingAssetIdMutation>;
export type PushToAmsUsingAssetIdMutationOptions = ApolloReactCommon.BaseMutationOptions<PushToAmsUsingAssetIdMutation, PushToAmsUsingAssetIdMutationVariables>;
export const PushToAmsUsingAssetIdArrayDocument = gql`
    mutation PushToAmsUsingAssetIdArray($ids: [ID]!) {
  pushVehiclesToAms(ids: $ids) {
    results {
      id
      isPossible
    }
  }
}
    `;
export type PushToAmsUsingAssetIdArrayMutationFn = ApolloReactCommon.MutationFunction<PushToAmsUsingAssetIdArrayMutation, PushToAmsUsingAssetIdArrayMutationVariables>;

/**
 * __usePushToAmsUsingAssetIdArrayMutation__
 *
 * To run a mutation, you first call `usePushToAmsUsingAssetIdArrayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushToAmsUsingAssetIdArrayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushToAmsUsingAssetIdArrayMutation, { data, loading, error }] = usePushToAmsUsingAssetIdArrayMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePushToAmsUsingAssetIdArrayMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PushToAmsUsingAssetIdArrayMutation, PushToAmsUsingAssetIdArrayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PushToAmsUsingAssetIdArrayMutation, PushToAmsUsingAssetIdArrayMutationVariables>(PushToAmsUsingAssetIdArrayDocument, options);
      }
export type PushToAmsUsingAssetIdArrayMutationHookResult = ReturnType<typeof usePushToAmsUsingAssetIdArrayMutation>;
export type PushToAmsUsingAssetIdArrayMutationResult = ApolloReactCommon.MutationResult<PushToAmsUsingAssetIdArrayMutation>;
export type PushToAmsUsingAssetIdArrayMutationOptions = ApolloReactCommon.BaseMutationOptions<PushToAmsUsingAssetIdArrayMutation, PushToAmsUsingAssetIdArrayMutationVariables>;
export const SearchVehiclesDmsFeedDetailDocument = gql`
    query SearchVehiclesDMSFeedDetail($offset: Int!, $limit: Int!, $searchString: String!, $auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: VEHICLES}
      pageInfo: {limit: $limit, offset: $offset, sortType: STOCK_LOT_DAYS}
    ) {
      vehicleCount
      vehicleResult {
        saleDate
        stockNumber
        year
        make
        model
        consignorId
        consignorLegacyId
        consignor
        checkedInAt
        assetId
        sourceName
        consignorStockNumber
        daysOnLot
        isNew
        floorAmount
        odometer
        vin
      }
      searchStringDisplay
      searchType
    }
  }
}
    `;

/**
 * __useSearchVehiclesDmsFeedDetailQuery__
 *
 * To run a query within a React component, call `useSearchVehiclesDmsFeedDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVehiclesDmsFeedDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVehiclesDmsFeedDetailQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useSearchVehiclesDmsFeedDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchVehiclesDmsFeedDetailQuery, SearchVehiclesDmsFeedDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchVehiclesDmsFeedDetailQuery, SearchVehiclesDmsFeedDetailQueryVariables>(SearchVehiclesDmsFeedDetailDocument, options);
      }
export function useSearchVehiclesDmsFeedDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchVehiclesDmsFeedDetailQuery, SearchVehiclesDmsFeedDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchVehiclesDmsFeedDetailQuery, SearchVehiclesDmsFeedDetailQueryVariables>(SearchVehiclesDmsFeedDetailDocument, options);
        }
export type SearchVehiclesDmsFeedDetailQueryHookResult = ReturnType<typeof useSearchVehiclesDmsFeedDetailQuery>;
export type SearchVehiclesDmsFeedDetailLazyQueryHookResult = ReturnType<typeof useSearchVehiclesDmsFeedDetailLazyQuery>;
export type SearchVehiclesDmsFeedDetailQueryResult = ApolloReactCommon.QueryResult<SearchVehiclesDmsFeedDetailQuery, SearchVehiclesDmsFeedDetailQueryVariables>;
export const SearchVehiclesDetailDocument = gql`
    query SearchVehiclesDetail($offset: Int!, $limit: Int!, $searchString: String!, $auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: VEHICLES}
      pageInfo: {limit: $limit, offset: $offset, sortType: RAN_AT}
    ) {
      vehicleCount
      vehicleResult {
        stockNumber
        consignor
        consignorId
        consignorLegacyId
        year
        odometer
        make
        model
        assetId
        checkedInAt
        status
        ranCount
        ranAt
        saleAmount
        vin
        saleDate
      }
      searchStringDisplay
      searchType
    }
  }
}
    `;

/**
 * __useSearchVehiclesDetailQuery__
 *
 * To run a query within a React component, call `useSearchVehiclesDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVehiclesDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVehiclesDetailQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useSearchVehiclesDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchVehiclesDetailQuery, SearchVehiclesDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchVehiclesDetailQuery, SearchVehiclesDetailQueryVariables>(SearchVehiclesDetailDocument, options);
      }
export function useSearchVehiclesDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchVehiclesDetailQuery, SearchVehiclesDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchVehiclesDetailQuery, SearchVehiclesDetailQueryVariables>(SearchVehiclesDetailDocument, options);
        }
export type SearchVehiclesDetailQueryHookResult = ReturnType<typeof useSearchVehiclesDetailQuery>;
export type SearchVehiclesDetailLazyQueryHookResult = ReturnType<typeof useSearchVehiclesDetailLazyQuery>;
export type SearchVehiclesDetailQueryResult = ApolloReactCommon.QueryResult<SearchVehiclesDetailQuery, SearchVehiclesDetailQueryVariables>;
export const GeneratePdfDocument = gql`
    mutation GeneratePdf($input: GeneratePDFInput) {
  generatePDF(input: $input) {
    url
    success
    message
    data
    status
  }
}
    `;
export type GeneratePdfMutationFn = ApolloReactCommon.MutationFunction<GeneratePdfMutation, GeneratePdfMutationVariables>;

/**
 * __useGeneratePdfMutation__
 *
 * To run a mutation, you first call `useGeneratePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePdfMutation, { data, loading, error }] = useGeneratePdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGeneratePdfMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GeneratePdfMutation, GeneratePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GeneratePdfMutation, GeneratePdfMutationVariables>(GeneratePdfDocument, options);
      }
export type GeneratePdfMutationHookResult = ReturnType<typeof useGeneratePdfMutation>;
export type GeneratePdfMutationResult = ApolloReactCommon.MutationResult<GeneratePdfMutation>;
export type GeneratePdfMutationOptions = ApolloReactCommon.BaseMutationOptions<GeneratePdfMutation, GeneratePdfMutationVariables>;
export const GetReportConfigDocument = gql`
    query GetReportConfig($id: String, $auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    getReportConfig(reportConfigId: $id) {
      PK
      SK
      id
      userId
      auctionId
      reportKey
      displayName
      dataConfig {
        dataSource
        dataFilter {
          searchString
          searchType
          dataQuery
          dateOffset {
            start
            end
          }
          watched
          statusCode
          forFollowup
        }
        pageInfo {
          overRidePageLimit
          limit
          offset
          sortColumns {
            name
            sortOrder
          }
        }
      }
      listViewConfig {
        title
        subtitle
        shareSubject
        paths {
          listPath
          countPath
        }
        mobileColumns {
          header
          key
          width
        }
        columns {
          header
          key
          width
        }
      }
    }
  }
}
    `;

/**
 * __useGetReportConfigQuery__
 *
 * To run a query within a React component, call `useGetReportConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useGetReportConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReportConfigQuery, GetReportConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportConfigQuery, GetReportConfigQueryVariables>(GetReportConfigDocument, options);
      }
export function useGetReportConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReportConfigQuery, GetReportConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportConfigQuery, GetReportConfigQueryVariables>(GetReportConfigDocument, options);
        }
export type GetReportConfigQueryHookResult = ReturnType<typeof useGetReportConfigQuery>;
export type GetReportConfigLazyQueryHookResult = ReturnType<typeof useGetReportConfigLazyQuery>;
export type GetReportConfigQueryResult = ApolloReactCommon.QueryResult<GetReportConfigQuery, GetReportConfigQueryVariables>;
export const GetReportDownloadDocument = gql`
    query GetReportDownload($reportConfigId: String, $auctionId: String, $auctionName: String, $format: String, $options: GenerateOptions, $userSearchString: String, $searchFilter: String, $title: String, $subtitle: String, $creationDate: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    getDownloadLink(
      reportConfigId: $reportConfigId
      auctionName: $auctionName
      format: $format
      options: $options
      userSearchString: $userSearchString
      searchFilter: $searchFilter
      title: $title
      subtitle: $subtitle
      creationDate: $creationDate
    ) {
      url
      success
      message
      data
      status
    }
  }
}
    `;

/**
 * __useGetReportDownloadQuery__
 *
 * To run a query within a React component, call `useGetReportDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportDownloadQuery({
 *   variables: {
 *      reportConfigId: // value for 'reportConfigId'
 *      auctionId: // value for 'auctionId'
 *      auctionName: // value for 'auctionName'
 *      format: // value for 'format'
 *      options: // value for 'options'
 *      userSearchString: // value for 'userSearchString'
 *      searchFilter: // value for 'searchFilter'
 *      title: // value for 'title'
 *      subtitle: // value for 'subtitle'
 *      creationDate: // value for 'creationDate'
 *   },
 * });
 */
export function useGetReportDownloadQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReportDownloadQuery, GetReportDownloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportDownloadQuery, GetReportDownloadQueryVariables>(GetReportDownloadDocument, options);
      }
export function useGetReportDownloadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReportDownloadQuery, GetReportDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportDownloadQuery, GetReportDownloadQueryVariables>(GetReportDownloadDocument, options);
        }
export type GetReportDownloadQueryHookResult = ReturnType<typeof useGetReportDownloadQuery>;
export type GetReportDownloadLazyQueryHookResult = ReturnType<typeof useGetReportDownloadLazyQuery>;
export type GetReportDownloadQueryResult = ApolloReactCommon.QueryResult<GetReportDownloadQuery, GetReportDownloadQueryVariables>;
export const SearchVehiclesDetailNewDocument = gql`
    query SearchVehiclesDetailNew($offset: Int!, $limit: Int!, $searchString: String!, $auctionId: String, $searchType: SEARCH_TYPES = VEHICLES, $sortColumns: [SortColumnInput]) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: $searchType}
      pageInfo: {limit: $limit, offset: $offset, sortColumns: $sortColumns}
    ) {
      vehicleCount
      vehicleResult {
        stockNumber
        consignor
        consignorId
        consignorLegacyId
        year
        odometer
        make
        model
        assetId
        checkedInAt
        status
        ranCount
        ranAt
        saleAmount
        vin
        saleDate
        runPadded
        floorAmount
        buyer
        buyerAgentName
        buyerDisplayName
        buyerId
        buyerAgentId
        buyerLegacyId
        hasTitle
        hasCr
        photoCount
        sourceName
        consignorStockNumber
        daysOnLot
        isNew
      }
      vehicleStatsByCompany {
        accountName
        accountId
        total
        ran
        sold
        conversion
        avgSaleAmount
        sumSaleAmount
      }
      accountCount
      searchStringDisplay
      searchType
    }
  }
}
    `;

/**
 * __useSearchVehiclesDetailNewQuery__
 *
 * To run a query within a React component, call `useSearchVehiclesDetailNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVehiclesDetailNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVehiclesDetailNewQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      auctionId: // value for 'auctionId'
 *      searchType: // value for 'searchType'
 *      sortColumns: // value for 'sortColumns'
 *   },
 * });
 */
export function useSearchVehiclesDetailNewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchVehiclesDetailNewQuery, SearchVehiclesDetailNewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchVehiclesDetailNewQuery, SearchVehiclesDetailNewQueryVariables>(SearchVehiclesDetailNewDocument, options);
      }
export function useSearchVehiclesDetailNewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchVehiclesDetailNewQuery, SearchVehiclesDetailNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchVehiclesDetailNewQuery, SearchVehiclesDetailNewQueryVariables>(SearchVehiclesDetailNewDocument, options);
        }
export type SearchVehiclesDetailNewQueryHookResult = ReturnType<typeof useSearchVehiclesDetailNewQuery>;
export type SearchVehiclesDetailNewLazyQueryHookResult = ReturnType<typeof useSearchVehiclesDetailNewLazyQuery>;
export type SearchVehiclesDetailNewQueryResult = ApolloReactCommon.QueryResult<SearchVehiclesDetailNewQuery, SearchVehiclesDetailNewQueryVariables>;
export const SearchVehiclesInventoryConsignedDocument = gql`
    query SearchVehiclesInventoryConsigned($offset: Int!, $limit: Int!, $searchString: String!, $auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: VEHICLES}
      pageInfo: {limit: $limit, offset: $offset, sortType: RAN_AT}
    ) {
      vehicleCount
      vehicleResult {
        stockNumber
        consignor
        consignorId
        consignorLegacyId
        year
        odometer
        make
        model
        assetId
        checkedInAt
        status
        ranCount
        ranAt
        saleAmount
        vin
      }
      searchStringDisplay
      searchType
    }
  }
}
    `;

/**
 * __useSearchVehiclesInventoryConsignedQuery__
 *
 * To run a query within a React component, call `useSearchVehiclesInventoryConsignedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVehiclesInventoryConsignedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVehiclesInventoryConsignedQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useSearchVehiclesInventoryConsignedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchVehiclesInventoryConsignedQuery, SearchVehiclesInventoryConsignedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchVehiclesInventoryConsignedQuery, SearchVehiclesInventoryConsignedQueryVariables>(SearchVehiclesInventoryConsignedDocument, options);
      }
export function useSearchVehiclesInventoryConsignedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchVehiclesInventoryConsignedQuery, SearchVehiclesInventoryConsignedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchVehiclesInventoryConsignedQuery, SearchVehiclesInventoryConsignedQueryVariables>(SearchVehiclesInventoryConsignedDocument, options);
        }
export type SearchVehiclesInventoryConsignedQueryHookResult = ReturnType<typeof useSearchVehiclesInventoryConsignedQuery>;
export type SearchVehiclesInventoryConsignedLazyQueryHookResult = ReturnType<typeof useSearchVehiclesInventoryConsignedLazyQuery>;
export type SearchVehiclesInventoryConsignedQueryResult = ApolloReactCommon.QueryResult<SearchVehiclesInventoryConsignedQuery, SearchVehiclesInventoryConsignedQueryVariables>;
export const SearchVehiclesPresaleDetailDocument = gql`
    query SearchVehiclesPresaleDetail($offset: Int!, $limit: Int!, $searchString: String!, $auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: VEHICLES}
      pageInfo: {limit: $limit, offset: $offset, sortType: CHECK_IN}
    ) {
      vehicleCount
      vehicleResult {
        saleDate
        runPadded
        stockNumber
        year
        make
        model
        consignorId
        consignorLegacyId
        consignor
        checkedInAt
        assetId
        floorAmount
        photoCount
        hasCr
      }
      searchStringDisplay
      searchType
    }
  }
}
    `;

/**
 * __useSearchVehiclesPresaleDetailQuery__
 *
 * To run a query within a React component, call `useSearchVehiclesPresaleDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVehiclesPresaleDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVehiclesPresaleDetailQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useSearchVehiclesPresaleDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchVehiclesPresaleDetailQuery, SearchVehiclesPresaleDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchVehiclesPresaleDetailQuery, SearchVehiclesPresaleDetailQueryVariables>(SearchVehiclesPresaleDetailDocument, options);
      }
export function useSearchVehiclesPresaleDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchVehiclesPresaleDetailQuery, SearchVehiclesPresaleDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchVehiclesPresaleDetailQuery, SearchVehiclesPresaleDetailQueryVariables>(SearchVehiclesPresaleDetailDocument, options);
        }
export type SearchVehiclesPresaleDetailQueryHookResult = ReturnType<typeof useSearchVehiclesPresaleDetailQuery>;
export type SearchVehiclesPresaleDetailLazyQueryHookResult = ReturnType<typeof useSearchVehiclesPresaleDetailLazyQuery>;
export type SearchVehiclesPresaleDetailQueryResult = ApolloReactCommon.QueryResult<SearchVehiclesPresaleDetailQuery, SearchVehiclesPresaleDetailQueryVariables>;
export const SearchVehiclesWithBuyersDetailDocument = gql`
    query SearchVehiclesWithBuyersDetail($offset: Int!, $limit: Int!, $searchString: String!, $auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: VEHICLES}
      pageInfo: {limit: $limit, offset: $offset, sortType: SALE_DATE_LANE_LOT}
    ) {
      vehicleCount
      vehicleResult {
        consignor
        consignorId
        consignorLegacyId
        year
        stockNumber
        make
        model
        assetId
        status
        runPadded
        saleAmount
        floorAmount
        buyerAgentId
        buyerId
        buyerLegacyId
        buyerAgentName
        hasTitle
        saleDate
      }
      searchStringDisplay
      searchType
    }
  }
}
    `;

/**
 * __useSearchVehiclesWithBuyersDetailQuery__
 *
 * To run a query within a React component, call `useSearchVehiclesWithBuyersDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVehiclesWithBuyersDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVehiclesWithBuyersDetailQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useSearchVehiclesWithBuyersDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchVehiclesWithBuyersDetailQuery, SearchVehiclesWithBuyersDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchVehiclesWithBuyersDetailQuery, SearchVehiclesWithBuyersDetailQueryVariables>(SearchVehiclesWithBuyersDetailDocument, options);
      }
export function useSearchVehiclesWithBuyersDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchVehiclesWithBuyersDetailQuery, SearchVehiclesWithBuyersDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchVehiclesWithBuyersDetailQuery, SearchVehiclesWithBuyersDetailQueryVariables>(SearchVehiclesWithBuyersDetailDocument, options);
        }
export type SearchVehiclesWithBuyersDetailQueryHookResult = ReturnType<typeof useSearchVehiclesWithBuyersDetailQuery>;
export type SearchVehiclesWithBuyersDetailLazyQueryHookResult = ReturnType<typeof useSearchVehiclesWithBuyersDetailLazyQuery>;
export type SearchVehiclesWithBuyersDetailQueryResult = ApolloReactCommon.QueryResult<SearchVehiclesWithBuyersDetailQuery, SearchVehiclesWithBuyersDetailQueryVariables>;
export const SearchVehiclesWithDealsDetailDocument = gql`
    query SearchVehiclesWithDealsDetail($offset: Int!, $limit: Int!, $searchString: String!, $auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: VEHICLES}
      pageInfo: {limit: $limit, offset: $offset, sortType: SELLER_MAKE_MODEL_YEAR}
    ) {
      vehicleCount
      vehicleResult {
        consignor
        consignorId
        consignorLegacyId
        year
        stockNumber
        make
        model
        assetId
        color
        status
        saleAmount
        saleDate
        floorAmount
        buyerAgentId
        buyerLegacyId
        buyerAgentName
        buyerDisplayName
        buyerId
      }
      searchStringDisplay
      searchType
    }
  }
}
    `;

/**
 * __useSearchVehiclesWithDealsDetailQuery__
 *
 * To run a query within a React component, call `useSearchVehiclesWithDealsDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVehiclesWithDealsDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVehiclesWithDealsDetailQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useSearchVehiclesWithDealsDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchVehiclesWithDealsDetailQuery, SearchVehiclesWithDealsDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchVehiclesWithDealsDetailQuery, SearchVehiclesWithDealsDetailQueryVariables>(SearchVehiclesWithDealsDetailDocument, options);
      }
export function useSearchVehiclesWithDealsDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchVehiclesWithDealsDetailQuery, SearchVehiclesWithDealsDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchVehiclesWithDealsDetailQuery, SearchVehiclesWithDealsDetailQueryVariables>(SearchVehiclesWithDealsDetailDocument, options);
        }
export type SearchVehiclesWithDealsDetailQueryHookResult = ReturnType<typeof useSearchVehiclesWithDealsDetailQuery>;
export type SearchVehiclesWithDealsDetailLazyQueryHookResult = ReturnType<typeof useSearchVehiclesWithDealsDetailLazyQuery>;
export type SearchVehiclesWithDealsDetailQueryResult = ApolloReactCommon.QueryResult<SearchVehiclesWithDealsDetailQuery, SearchVehiclesWithDealsDetailQueryVariables>;
export const SearchVehiclesWithSellersDetailDocument = gql`
    query SearchVehiclesWithSellersDetail($offset: Int!, $limit: Int!, $searchString: String!, $auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      filter: {searchString: $searchString, type: VEHICLES}
      pageInfo: {limit: $limit, offset: $offset, sortType: SALE_DATE_LANE_LOT}
    ) {
      vehicleCount
      vehicleResult {
        consignor
        consignorId
        consignorLegacyId
        year
        stockNumber
        make
        model
        assetId
        status
        runPadded
        saleAmount
        floorAmount
        buyer
        buyerId
        buyerLegacyId
        hasTitle
        saleDate
      }
      searchStringDisplay
      searchType
    }
  }
}
    `;

/**
 * __useSearchVehiclesWithSellersDetailQuery__
 *
 * To run a query within a React component, call `useSearchVehiclesWithSellersDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVehiclesWithSellersDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVehiclesWithSellersDetailQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchString: // value for 'searchString'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useSearchVehiclesWithSellersDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchVehiclesWithSellersDetailQuery, SearchVehiclesWithSellersDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchVehiclesWithSellersDetailQuery, SearchVehiclesWithSellersDetailQueryVariables>(SearchVehiclesWithSellersDetailDocument, options);
      }
export function useSearchVehiclesWithSellersDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchVehiclesWithSellersDetailQuery, SearchVehiclesWithSellersDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchVehiclesWithSellersDetailQuery, SearchVehiclesWithSellersDetailQueryVariables>(SearchVehiclesWithSellersDetailDocument, options);
        }
export type SearchVehiclesWithSellersDetailQueryHookResult = ReturnType<typeof useSearchVehiclesWithSellersDetailQuery>;
export type SearchVehiclesWithSellersDetailLazyQueryHookResult = ReturnType<typeof useSearchVehiclesWithSellersDetailLazyQuery>;
export type SearchVehiclesWithSellersDetailQueryResult = ApolloReactCommon.QueryResult<SearchVehiclesWithSellersDetailQuery, SearchVehiclesWithSellersDetailQueryVariables>;
export const OdsVdpViewsDocument = gql`
    query odsVdpViews($endDate: String!, $startDate: String!, $auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    card(filter: {startDate: $startDate, endDate: $endDate, auctionId: $auctionId}) {
      vdpViewsCount
      vdpViewsStats {
        count
        date
      }
    }
  }
}
    `;

/**
 * __useOdsVdpViewsQuery__
 *
 * To run a query within a React component, call `useOdsVdpViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOdsVdpViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOdsVdpViewsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useOdsVdpViewsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OdsVdpViewsQuery, OdsVdpViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OdsVdpViewsQuery, OdsVdpViewsQueryVariables>(OdsVdpViewsDocument, options);
      }
export function useOdsVdpViewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OdsVdpViewsQuery, OdsVdpViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OdsVdpViewsQuery, OdsVdpViewsQueryVariables>(OdsVdpViewsDocument, options);
        }
export type OdsVdpViewsQueryHookResult = ReturnType<typeof useOdsVdpViewsQuery>;
export type OdsVdpViewsLazyQueryHookResult = ReturnType<typeof useOdsVdpViewsLazyQuery>;
export type OdsVdpViewsQueryResult = ApolloReactCommon.QueryResult<OdsVdpViewsQuery, OdsVdpViewsQueryVariables>;
export const GetVehicleDetailDocument = gql`
    query getVehicleDetail($assetId: ID, $auctionId: String, $stockNumber: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    assets(filter: {id: $assetId, stockNumber: $stockNumber}) {
      byId {
        buyerAccountId
        buyerAccountKey
        buyerDisplayName
        ownerStockNumber
        stockNumber
        assetId
        vin
        customerReferenceNumber
        checkinDate
        saleListingSaleStatus
        checkinTime
        checkinUser
        grade
        hasTitle
        titleNumber
        titleState
        titleReceivedDate
        saleEvents {
          eventTitle
          eventDate
          venueEventTypeCode
          eventStartTs
          eventEndTs
          eventEndedAtTs
          venueEventKey
          lane
          lotNumber
          floorPrice
          saleListingStatus
          dealSaleAmt
          dealStatus
          buyerName
          saleListingKey
          buyerOrgAaNum
          buyerOrgStatusCode
          buyerAgentAaNum
          buyerAgentStatusCode
          city
          state
        }
        listingCondition
        listingConditionId
        listingConditionCode
        year
        make
        model
        trim
        color
        exteriorColor
        interiorColor
        transmissionType
        drivetrain
        drivetrainDesc
        fuelType
        crStatus
        pmrValue
        mmrValue
        blackBookValue
        conditionReport {
          conditionReportTime
          conditionReportStatus
          conditionReportWriter
        }
        photoCount
        photoBeauty
        photos {
          pipelineUri
          position
          fileName
          note
        }
        proxyBidCount
        saleListing {
          saleStatus
          saleDate
          soldDateLastRanTime
          saleListingDealSoldAt
          saleListingOfferCreatedAt
          lane
          lot
          saleMethod
          venueName
          venueCode
          venueUrl
          buyerAgentName
          buyerAgentId
          buyerAgentPicture
          buyerAgentEmail
          buyerAgentPhoneMobile
          sellerAgentId
          sellerAgentName
          sellerAgentEmail
          sellerAgentPhoneMobile
          buyerAgentNotes
        }
        assetFees {
          stockNumber
          amount
          chargeCode
          description
          run
        }
        saleAmount
        floorAmount
        odometer
        bodyStyle
        announcements {
          type
          id
          announcement
          ordinal
        }
        engineSize
        cylinders
        cylinderConfiguration
        photoCount
        pipelineUri
        consignor {
          accountKey
          accountId
          displayName
          accountOrgId
          accountOrgDisplayName
        }
        onlineListing {
          webViews
        }
        services {
          id
          serviceProductDescription
          serviceOrderedByAmsUser
          serviceOrderedAt
          createdAt
          serviceClassCode
          organizationServiceProductId
          amsServiceProductCode
          amsChargeCode
          serviceResultAt
          notes
          dealId
          chargeAmount
          amsServiceResultCode
        }
      }
    }
  }
}
    `;

/**
 * __useGetVehicleDetailQuery__
 *
 * To run a query within a React component, call `useGetVehicleDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleDetailQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      auctionId: // value for 'auctionId'
 *      stockNumber: // value for 'stockNumber'
 *   },
 * });
 */
export function useGetVehicleDetailQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVehicleDetailQuery, GetVehicleDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVehicleDetailQuery, GetVehicleDetailQueryVariables>(GetVehicleDetailDocument, options);
      }
export function useGetVehicleDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVehicleDetailQuery, GetVehicleDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVehicleDetailQuery, GetVehicleDetailQueryVariables>(GetVehicleDetailDocument, options);
        }
export type GetVehicleDetailQueryHookResult = ReturnType<typeof useGetVehicleDetailQuery>;
export type GetVehicleDetailLazyQueryHookResult = ReturnType<typeof useGetVehicleDetailLazyQuery>;
export type GetVehicleDetailQueryResult = ApolloReactCommon.QueryResult<GetVehicleDetailQuery, GetVehicleDetailQueryVariables>;
export const GetOfferBuyerSellerAgentsDocument = gql`
    query getOfferBuyerSellerAgents($assetId: ID!, $auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    assets(filter: {id: $assetId}) {
      byId {
        ifOfferManagement {
          ifOfferHistory {
            buyerAgentId
            sellerAgentId
          }
          buyerAgents {
            firstName
            lastName
            agentId
            cellPhone
            email
          }
          sellerAgents {
            firstName
            lastName
            agentId
            cellPhone
            email
          }
        }
        saleListing {
          buyerAgentEmail
          buyerAgentId
          buyerAgentName
          buyerAgentPhoneMobile
          sellerAgentEmail
          sellerAgentId
          sellerAgentName
          sellerAgentPhoneMobile
        }
      }
    }
  }
}
    `;

/**
 * __useGetOfferBuyerSellerAgentsQuery__
 *
 * To run a query within a React component, call `useGetOfferBuyerSellerAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferBuyerSellerAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferBuyerSellerAgentsQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useGetOfferBuyerSellerAgentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOfferBuyerSellerAgentsQuery, GetOfferBuyerSellerAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOfferBuyerSellerAgentsQuery, GetOfferBuyerSellerAgentsQueryVariables>(GetOfferBuyerSellerAgentsDocument, options);
      }
export function useGetOfferBuyerSellerAgentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOfferBuyerSellerAgentsQuery, GetOfferBuyerSellerAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOfferBuyerSellerAgentsQuery, GetOfferBuyerSellerAgentsQueryVariables>(GetOfferBuyerSellerAgentsDocument, options);
        }
export type GetOfferBuyerSellerAgentsQueryHookResult = ReturnType<typeof useGetOfferBuyerSellerAgentsQuery>;
export type GetOfferBuyerSellerAgentsLazyQueryHookResult = ReturnType<typeof useGetOfferBuyerSellerAgentsLazyQuery>;
export type GetOfferBuyerSellerAgentsQueryResult = ApolloReactCommon.QueryResult<GetOfferBuyerSellerAgentsQuery, GetOfferBuyerSellerAgentsQueryVariables>;
export const GetVehicleIfOfferDocument = gql`
    query getVehicleIfOffer($assetId: ID!, $auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    assets(filter: {id: $assetId}) {
      byId {
        ifOfferManagement {
          buyerAgent {
            notes {
              noteType
              noteText
            }
          }
          sellerAgent {
            notes {
              noteType
              noteText
            }
          }
          calculatedIfOfferData {
            buyerNotesThisOffer
            sellerNotesThisOffer
            sellerMovementThisOffer
            buyerMovementThisOffer
          }
          eventTypes {
            code
            shortDescription
            longDescription
          }
          eventTriggers {
            code
            shortDescription
            longDescription
          }
          ifOfferHistory {
            saleListingId
            dealId
            eventDate
            laneName
            lotNumber
            eventTypeCode
            eventTriggerCode
            eventTypeDesc
            eventTriggerDesc
            currentOfferAmount
            currentOfferAmountPrevious
            eventCreatedAt
            eventCreatedBy
            eventNote
            floorPrice
            ballControlCode
            buyerAgentId
            sellerAgentId
            buyerAgentName
            sellerAgentName
          }
          pastSalesHistory {
            eventDate
            saleListingId
            dealId
            dealStatus
            lane
            lot
            highBid
            hasRun
            soldAmount
            lastCounter
            lastCounterBy
            buyerDisplayName
            buyerAccountId
            dealOutcome
            rejectedBy
            closedDate
            eventClassCode
            eventClassName
            venueCode
            venueEventTitle
            venueName
            noSold
            dealHistory {
              correlationId
              saleListingId
              dealId
              laneName
              lotNumber
              eventDate
              eventTypeDesc
              eventTypeCode
              eventTriggerDesc
              eventTriggerCode
              floorPrice
              buyNowPrice
              valuationBlackbookAmount
              valuationMMRAmount
              assetAnnouncementOne
              assetAnnouncementTwo
              assetAnnouncementThree
              assetAnnouncementFour
              buyerAgentId
              buyerAgentName
              sellerAgentName
              sellerAgentId
              buyerOrSellerAccountId
              currentOfferAmount
              currentOfferAmountPrevious
              announcementLight
              fees
              eventCreatedAt
              eventCreatedBy
              eventCreatedById
              eventNote
              ballControlDescription
              ballControlCode
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetVehicleIfOfferQuery__
 *
 * To run a query within a React component, call `useGetVehicleIfOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleIfOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleIfOfferQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useGetVehicleIfOfferQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVehicleIfOfferQuery, GetVehicleIfOfferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVehicleIfOfferQuery, GetVehicleIfOfferQueryVariables>(GetVehicleIfOfferDocument, options);
      }
export function useGetVehicleIfOfferLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVehicleIfOfferQuery, GetVehicleIfOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVehicleIfOfferQuery, GetVehicleIfOfferQueryVariables>(GetVehicleIfOfferDocument, options);
        }
export type GetVehicleIfOfferQueryHookResult = ReturnType<typeof useGetVehicleIfOfferQuery>;
export type GetVehicleIfOfferLazyQueryHookResult = ReturnType<typeof useGetVehicleIfOfferLazyQuery>;
export type GetVehicleIfOfferQueryResult = ApolloReactCommon.QueryResult<GetVehicleIfOfferQuery, GetVehicleIfOfferQueryVariables>;
export const UpdateIfOfferDocument = gql`
    mutation updateIfOffer($auctionId: String!, $assetId: ID!, $sparkUserId: Int!, $eventTypeCode: EventTypeCode!, $eventTriggerCode: EventTriggerCode!, $offerAmount: Int!, $offerNote: String!, $buyerAgentId: Int, $sellerAgentId: Int) {
  updateIfOffer(
    ifOfferDetails: {orgCode: $auctionId, assetId: $assetId, sparkUserId: $sparkUserId, eventTypeCode: $eventTypeCode, eventTriggerCode: $eventTriggerCode, offerAmount: $offerAmount, offerNote: $offerNote, buyerAgentId: $buyerAgentId, sellerAgentId: $sellerAgentId}
  ) {
    success
  }
}
    `;
export type UpdateIfOfferMutationFn = ApolloReactCommon.MutationFunction<UpdateIfOfferMutation, UpdateIfOfferMutationVariables>;

/**
 * __useUpdateIfOfferMutation__
 *
 * To run a mutation, you first call `useUpdateIfOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIfOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIfOfferMutation, { data, loading, error }] = useUpdateIfOfferMutation({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      assetId: // value for 'assetId'
 *      sparkUserId: // value for 'sparkUserId'
 *      eventTypeCode: // value for 'eventTypeCode'
 *      eventTriggerCode: // value for 'eventTriggerCode'
 *      offerAmount: // value for 'offerAmount'
 *      offerNote: // value for 'offerNote'
 *      buyerAgentId: // value for 'buyerAgentId'
 *      sellerAgentId: // value for 'sellerAgentId'
 *   },
 * });
 */
export function useUpdateIfOfferMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateIfOfferMutation, UpdateIfOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateIfOfferMutation, UpdateIfOfferMutationVariables>(UpdateIfOfferDocument, options);
      }
export type UpdateIfOfferMutationHookResult = ReturnType<typeof useUpdateIfOfferMutation>;
export type UpdateIfOfferMutationResult = ApolloReactCommon.MutationResult<UpdateIfOfferMutation>;
export type UpdateIfOfferMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateIfOfferMutation, UpdateIfOfferMutationVariables>;
export const UpdateIfOffersDocument = gql`
    mutation updateIfOffers($offers: [IfOfferDetails]) {
  updateMultipleIfOffers(ifOfferDetails: $offers) {
    success
    results {
      assetId
      amsStatusCode
      amsStatusText
      success
      stockNumber
      vin
      ifNotes {
        date
        user
        note
        type
      }
    }
  }
}
    `;
export type UpdateIfOffersMutationFn = ApolloReactCommon.MutationFunction<UpdateIfOffersMutation, UpdateIfOffersMutationVariables>;

/**
 * __useUpdateIfOffersMutation__
 *
 * To run a mutation, you first call `useUpdateIfOffersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIfOffersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIfOffersMutation, { data, loading, error }] = useUpdateIfOffersMutation({
 *   variables: {
 *      offers: // value for 'offers'
 *   },
 * });
 */
export function useUpdateIfOffersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateIfOffersMutation, UpdateIfOffersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateIfOffersMutation, UpdateIfOffersMutationVariables>(UpdateIfOffersDocument, options);
      }
export type UpdateIfOffersMutationHookResult = ReturnType<typeof useUpdateIfOffersMutation>;
export type UpdateIfOffersMutationResult = ApolloReactCommon.MutationResult<UpdateIfOffersMutation>;
export type UpdateIfOffersMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateIfOffersMutation, UpdateIfOffersMutationVariables>;
export const RegisterBidderDocument = gql`
    mutation registerBidder($bidderDetails: RegisterBidderDetails!) {
  registerBidder(bidderDetails: $bidderDetails) {
    status
    message
    errors
  }
}
    `;
export type RegisterBidderMutationFn = ApolloReactCommon.MutationFunction<RegisterBidderMutation, RegisterBidderMutationVariables>;

/**
 * __useRegisterBidderMutation__
 *
 * To run a mutation, you first call `useRegisterBidderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterBidderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerBidderMutation, { data, loading, error }] = useRegisterBidderMutation({
 *   variables: {
 *      bidderDetails: // value for 'bidderDetails'
 *   },
 * });
 */
export function useRegisterBidderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterBidderMutation, RegisterBidderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RegisterBidderMutation, RegisterBidderMutationVariables>(RegisterBidderDocument, options);
      }
export type RegisterBidderMutationHookResult = ReturnType<typeof useRegisterBidderMutation>;
export type RegisterBidderMutationResult = ApolloReactCommon.MutationResult<RegisterBidderMutation>;
export type RegisterBidderMutationOptions = ApolloReactCommon.BaseMutationOptions<RegisterBidderMutation, RegisterBidderMutationVariables>;
export const DocumentFilterListsDocument = gql`
    query documentFilterLists($auctionId: String, $stockNumber: String!) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    document {
      documentFilterLists(filter: {stockNumber: $stockNumber}) {
        docId
        docName
        docTypeId
        docTypeName
        docTypeShortCode
        createdAt
        createdBy
        updatedAt
        s3Url
        s3UrlExpires
        stockNumber
        transactionId
        customerId
      }
    }
  }
}
    `;

/**
 * __useDocumentFilterListsQuery__
 *
 * To run a query within a React component, call `useDocumentFilterListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentFilterListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentFilterListsQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      stockNumber: // value for 'stockNumber'
 *   },
 * });
 */
export function useDocumentFilterListsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DocumentFilterListsQuery, DocumentFilterListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentFilterListsQuery, DocumentFilterListsQueryVariables>(DocumentFilterListsDocument, options);
      }
export function useDocumentFilterListsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentFilterListsQuery, DocumentFilterListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentFilterListsQuery, DocumentFilterListsQueryVariables>(DocumentFilterListsDocument, options);
        }
export type DocumentFilterListsQueryHookResult = ReturnType<typeof useDocumentFilterListsQuery>;
export type DocumentFilterListsLazyQueryHookResult = ReturnType<typeof useDocumentFilterListsLazyQuery>;
export type DocumentFilterListsQueryResult = ApolloReactCommon.QueryResult<DocumentFilterListsQuery, DocumentFilterListsQueryVariables>;
export const DocumentListDocument = gql`
    query documentList($auctionId: String, $assetId: ID!) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    document {
      documentLists(filter: {assetId: $assetId}) {
        docId
        docTypeId
        docTypeName
        docTypeShortCode
        createdAt
        createdBy
        s3Url
        s3UrlExpires
        transactionId
      }
    }
  }
}
    `;

/**
 * __useDocumentListQuery__
 *
 * To run a query within a React component, call `useDocumentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentListQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useDocumentListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DocumentListQuery, DocumentListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentListQuery, DocumentListQueryVariables>(DocumentListDocument, options);
      }
export function useDocumentListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentListQuery, DocumentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentListQuery, DocumentListQueryVariables>(DocumentListDocument, options);
        }
export type DocumentListQueryHookResult = ReturnType<typeof useDocumentListQuery>;
export type DocumentListLazyQueryHookResult = ReturnType<typeof useDocumentListLazyQuery>;
export type DocumentListQueryResult = ApolloReactCommon.QueryResult<DocumentListQuery, DocumentListQueryVariables>;
export const GetLightOptionsDocument = gql`
    query getLightOptions($auctionId: String) {
  auction(id: $auctionId) {
    lightOptions {
      lightId
      lightCode
      lightDescription
    }
  }
}
    `;

/**
 * __useGetLightOptionsQuery__
 *
 * To run a query within a React component, call `useGetLightOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLightOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLightOptionsQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useGetLightOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLightOptionsQuery, GetLightOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLightOptionsQuery, GetLightOptionsQueryVariables>(GetLightOptionsDocument, options);
      }
export function useGetLightOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLightOptionsQuery, GetLightOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLightOptionsQuery, GetLightOptionsQueryVariables>(GetLightOptionsDocument, options);
        }
export type GetLightOptionsQueryHookResult = ReturnType<typeof useGetLightOptionsQuery>;
export type GetLightOptionsLazyQueryHookResult = ReturnType<typeof useGetLightOptionsLazyQuery>;
export type GetLightOptionsQueryResult = ApolloReactCommon.QueryResult<GetLightOptionsQuery, GetLightOptionsQueryVariables>;
export const VdpByStockNumberTranslationDocument = gql`
    query vdpByStockNumberTranslation($amsId: String, $stockNumber: String, $id: String) {
  auction(amsId: $amsId, stockNumber: $stockNumber, id: $id) {
    keys {
      uaId
      assetId
    }
  }
}
    `;

/**
 * __useVdpByStockNumberTranslationQuery__
 *
 * To run a query within a React component, call `useVdpByStockNumberTranslationQuery` and pass it any options that fit your needs.
 * When your component renders, `useVdpByStockNumberTranslationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVdpByStockNumberTranslationQuery({
 *   variables: {
 *      amsId: // value for 'amsId'
 *      stockNumber: // value for 'stockNumber'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVdpByStockNumberTranslationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VdpByStockNumberTranslationQuery, VdpByStockNumberTranslationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VdpByStockNumberTranslationQuery, VdpByStockNumberTranslationQueryVariables>(VdpByStockNumberTranslationDocument, options);
      }
export function useVdpByStockNumberTranslationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VdpByStockNumberTranslationQuery, VdpByStockNumberTranslationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VdpByStockNumberTranslationQuery, VdpByStockNumberTranslationQueryVariables>(VdpByStockNumberTranslationDocument, options);
        }
export type VdpByStockNumberTranslationQueryHookResult = ReturnType<typeof useVdpByStockNumberTranslationQuery>;
export type VdpByStockNumberTranslationLazyQueryHookResult = ReturnType<typeof useVdpByStockNumberTranslationLazyQuery>;
export type VdpByStockNumberTranslationQueryResult = ApolloReactCommon.QueryResult<VdpByStockNumberTranslationQuery, VdpByStockNumberTranslationQueryVariables>;
export const VehiclesCheckedInDetailDocument = gql`
    query vehiclesCheckedInDetail($auctionId: String, $searchString: String!, $limit: Int, $offset: Int) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      pageInfo: {limit: $limit, offset: $offset, sortType: CHECK_IN}
      filter: {type: VEHICLES, searchString: $searchString}
    ) {
      vehicleCount
      vehicleResult {
        saleDate
        runPadded
        stockNumber
        year
        make
        model
        consignorId
        consignorLegacyId
        consignor
        checkedInAt
        assetId
        floorAmount
        photoCount
        hasCr
      }
    }
  }
}
    `;

/**
 * __useVehiclesCheckedInDetailQuery__
 *
 * To run a query within a React component, call `useVehiclesCheckedInDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehiclesCheckedInDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehiclesCheckedInDetailQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useVehiclesCheckedInDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<VehiclesCheckedInDetailQuery, VehiclesCheckedInDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VehiclesCheckedInDetailQuery, VehiclesCheckedInDetailQueryVariables>(VehiclesCheckedInDetailDocument, options);
      }
export function useVehiclesCheckedInDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VehiclesCheckedInDetailQuery, VehiclesCheckedInDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VehiclesCheckedInDetailQuery, VehiclesCheckedInDetailQueryVariables>(VehiclesCheckedInDetailDocument, options);
        }
export type VehiclesCheckedInDetailQueryHookResult = ReturnType<typeof useVehiclesCheckedInDetailQuery>;
export type VehiclesCheckedInDetailLazyQueryHookResult = ReturnType<typeof useVehiclesCheckedInDetailLazyQuery>;
export type VehiclesCheckedInDetailQueryResult = ApolloReactCommon.QueryResult<VehiclesCheckedInDetailQuery, VehiclesCheckedInDetailQueryVariables>;
export const MissingPhotosInSaleDetailDocument = gql`
    query missingPhotosInSaleDetail($auctionId: String, $searchStringPhotos: String!, $limit: Int, $offset: Int) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(
      pageInfo: {limit: $limit, offset: $offset, sortType: CHECK_IN}
      filter: {type: VEHICLES, searchString: $searchStringPhotos}
    ) {
      vehicleCount
      vehicleResult {
        saleDate
        runPadded
        stockNumber
        year
        make
        model
        consignorId
        consignorLegacyId
        consignor
        checkedInAt
        assetId
        hasCr
        photoCount
        floorAmount
      }
    }
  }
}
    `;

/**
 * __useMissingPhotosInSaleDetailQuery__
 *
 * To run a query within a React component, call `useMissingPhotosInSaleDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMissingPhotosInSaleDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMissingPhotosInSaleDetailQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      searchStringPhotos: // value for 'searchStringPhotos'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMissingPhotosInSaleDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MissingPhotosInSaleDetailQuery, MissingPhotosInSaleDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MissingPhotosInSaleDetailQuery, MissingPhotosInSaleDetailQueryVariables>(MissingPhotosInSaleDetailDocument, options);
      }
export function useMissingPhotosInSaleDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MissingPhotosInSaleDetailQuery, MissingPhotosInSaleDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MissingPhotosInSaleDetailQuery, MissingPhotosInSaleDetailQueryVariables>(MissingPhotosInSaleDetailDocument, options);
        }
export type MissingPhotosInSaleDetailQueryHookResult = ReturnType<typeof useMissingPhotosInSaleDetailQuery>;
export type MissingPhotosInSaleDetailLazyQueryHookResult = ReturnType<typeof useMissingPhotosInSaleDetailLazyQuery>;
export type MissingPhotosInSaleDetailQueryResult = ApolloReactCommon.QueryResult<MissingPhotosInSaleDetailQuery, MissingPhotosInSaleDetailQueryVariables>;
export const DealersWatchingVehicleDocument = gql`
    query dealersWatchingVehicle($auctionId: String, $stockNumber: String!) {
  activeOrganization @client {
    orgId @export(as: "auctionID")
  }
  auction(id: $auctionId) {
    assets(filter: {stockNumber: $stockNumber}) {
      list {
        onlineListing {
          watchers {
            emailAddress
            memberName
            mobileNumber
            phoneNumber
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDealersWatchingVehicleQuery__
 *
 * To run a query within a React component, call `useDealersWatchingVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealersWatchingVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealersWatchingVehicleQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      stockNumber: // value for 'stockNumber'
 *   },
 * });
 */
export function useDealersWatchingVehicleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DealersWatchingVehicleQuery, DealersWatchingVehicleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DealersWatchingVehicleQuery, DealersWatchingVehicleQueryVariables>(DealersWatchingVehicleDocument, options);
      }
export function useDealersWatchingVehicleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DealersWatchingVehicleQuery, DealersWatchingVehicleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DealersWatchingVehicleQuery, DealersWatchingVehicleQueryVariables>(DealersWatchingVehicleDocument, options);
        }
export type DealersWatchingVehicleQueryHookResult = ReturnType<typeof useDealersWatchingVehicleQuery>;
export type DealersWatchingVehicleLazyQueryHookResult = ReturnType<typeof useDealersWatchingVehicleLazyQuery>;
export type DealersWatchingVehicleQueryResult = ApolloReactCommon.QueryResult<DealersWatchingVehicleQuery, DealersWatchingVehicleQueryVariables>;
export const OdsWatchedVehiclesDocument = gql`
    query odsWatchedVehicles($endDate: String!, $startDate: String!, $auctionId: String, $limit: Int, $offset: Int) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    card(
      filter: {startDate: $startDate, endDate: $endDate, auctionId: $auctionId, limit: $limit, offset: $offset}
    ) {
      watchedVehiclesCount
      watchedVehiclesList {
        assetId
        make
        mmrValuation
        model
        stockNumber
        watchCount
        year
        webViews
      }
    }
  }
}
    `;

/**
 * __useOdsWatchedVehiclesQuery__
 *
 * To run a query within a React component, call `useOdsWatchedVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOdsWatchedVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOdsWatchedVehiclesQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      auctionId: // value for 'auctionId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useOdsWatchedVehiclesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OdsWatchedVehiclesQuery, OdsWatchedVehiclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OdsWatchedVehiclesQuery, OdsWatchedVehiclesQueryVariables>(OdsWatchedVehiclesDocument, options);
      }
export function useOdsWatchedVehiclesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OdsWatchedVehiclesQuery, OdsWatchedVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OdsWatchedVehiclesQuery, OdsWatchedVehiclesQueryVariables>(OdsWatchedVehiclesDocument, options);
        }
export type OdsWatchedVehiclesQueryHookResult = ReturnType<typeof useOdsWatchedVehiclesQuery>;
export type OdsWatchedVehiclesLazyQueryHookResult = ReturnType<typeof useOdsWatchedVehiclesLazyQuery>;
export type OdsWatchedVehiclesQueryResult = ApolloReactCommon.QueryResult<OdsWatchedVehiclesQuery, OdsWatchedVehiclesQueryVariables>;
export const UserInfoForUpdateUserDocument = gql`
    query userInfoForUpdateUser {
  user {
    attributes {
      authenticationId
      firstName
      lastName
      mobilePhone
      email
      isGlobalAdmin
      authenticationUsername
      databaseId
    }
    permissions {
      userPermissions {
        key
        description
        note
      }
    }
    organizations {
      orgId
      displayName
      description
      isAdmin
      lastUpdated
      type
    }
    roles {
      id
      name
      description
    }
    dashboards
  }
}
    `;

/**
 * __useUserInfoForUpdateUserQuery__
 *
 * To run a query within a React component, call `useUserInfoForUpdateUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInfoForUpdateUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInfoForUpdateUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserInfoForUpdateUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserInfoForUpdateUserQuery, UserInfoForUpdateUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserInfoForUpdateUserQuery, UserInfoForUpdateUserQueryVariables>(UserInfoForUpdateUserDocument, options);
      }
export function useUserInfoForUpdateUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserInfoForUpdateUserQuery, UserInfoForUpdateUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserInfoForUpdateUserQuery, UserInfoForUpdateUserQueryVariables>(UserInfoForUpdateUserDocument, options);
        }
export type UserInfoForUpdateUserQueryHookResult = ReturnType<typeof useUserInfoForUpdateUserQuery>;
export type UserInfoForUpdateUserLazyQueryHookResult = ReturnType<typeof useUserInfoForUpdateUserLazyQuery>;
export type UserInfoForUpdateUserQueryResult = ApolloReactCommon.QueryResult<UserInfoForUpdateUserQuery, UserInfoForUpdateUserQueryVariables>;
export const ActiveOrgDisplayNameDocument = gql`
    query activeOrgDisplayName {
  activeOrganization @client {
    displayName
  }
}
    `;

/**
 * __useActiveOrgDisplayNameQuery__
 *
 * To run a query within a React component, call `useActiveOrgDisplayNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveOrgDisplayNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveOrgDisplayNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveOrgDisplayNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActiveOrgDisplayNameQuery, ActiveOrgDisplayNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActiveOrgDisplayNameQuery, ActiveOrgDisplayNameQueryVariables>(ActiveOrgDisplayNameDocument, options);
      }
export function useActiveOrgDisplayNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveOrgDisplayNameQuery, ActiveOrgDisplayNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActiveOrgDisplayNameQuery, ActiveOrgDisplayNameQueryVariables>(ActiveOrgDisplayNameDocument, options);
        }
export type ActiveOrgDisplayNameQueryHookResult = ReturnType<typeof useActiveOrgDisplayNameQuery>;
export type ActiveOrgDisplayNameLazyQueryHookResult = ReturnType<typeof useActiveOrgDisplayNameLazyQuery>;
export type ActiveOrgDisplayNameQueryResult = ApolloReactCommon.QueryResult<ActiveOrgDisplayNameQuery, ActiveOrgDisplayNameQueryVariables>;
export const BatchCreateDocumentDocument = gql`
    mutation batchCreateDocument($docs: [CreateDocumentInput!]!) {
  batchCreateDocument(createDocumentInput: $docs) {
    docId
  }
}
    `;
export type BatchCreateDocumentMutationFn = ApolloReactCommon.MutationFunction<BatchCreateDocumentMutation, BatchCreateDocumentMutationVariables>;

/**
 * __useBatchCreateDocumentMutation__
 *
 * To run a mutation, you first call `useBatchCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreateDocumentMutation, { data, loading, error }] = useBatchCreateDocumentMutation({
 *   variables: {
 *      docs: // value for 'docs'
 *   },
 * });
 */
export function useBatchCreateDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BatchCreateDocumentMutation, BatchCreateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BatchCreateDocumentMutation, BatchCreateDocumentMutationVariables>(BatchCreateDocumentDocument, options);
      }
export type BatchCreateDocumentMutationHookResult = ReturnType<typeof useBatchCreateDocumentMutation>;
export type BatchCreateDocumentMutationResult = ApolloReactCommon.MutationResult<BatchCreateDocumentMutation>;
export type BatchCreateDocumentMutationOptions = ApolloReactCommon.BaseMutationOptions<BatchCreateDocumentMutation, BatchCreateDocumentMutationVariables>;
export const CreateDocumentsClientDocument = gql`
    mutation createDocumentsClient($docs: [LocalCreateDocumentInput!]!) {
  createDocumentsClient(docs: $docs) @client {
    docId
  }
}
    `;
export type CreateDocumentsClientMutationFn = ApolloReactCommon.MutationFunction<CreateDocumentsClientMutation, CreateDocumentsClientMutationVariables>;

/**
 * __useCreateDocumentsClientMutation__
 *
 * To run a mutation, you first call `useCreateDocumentsClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentsClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentsClientMutation, { data, loading, error }] = useCreateDocumentsClientMutation({
 *   variables: {
 *      docs: // value for 'docs'
 *   },
 * });
 */
export function useCreateDocumentsClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDocumentsClientMutation, CreateDocumentsClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDocumentsClientMutation, CreateDocumentsClientMutationVariables>(CreateDocumentsClientDocument, options);
      }
export type CreateDocumentsClientMutationHookResult = ReturnType<typeof useCreateDocumentsClientMutation>;
export type CreateDocumentsClientMutationResult = ApolloReactCommon.MutationResult<CreateDocumentsClientMutation>;
export type CreateDocumentsClientMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDocumentsClientMutation, CreateDocumentsClientMutationVariables>;
export const GenerateUploadUrlDocument = gql`
    mutation generateUploadUrl($assetId: ID!) {
  generateUploadUrl(assetId: $assetId) @client {
    customerId
    tenantId
    fileName
    fileType
    s3uploadUrl
    urlExpires
    s3Key
  }
}
    `;
export type GenerateUploadUrlMutationFn = ApolloReactCommon.MutationFunction<GenerateUploadUrlMutation, GenerateUploadUrlMutationVariables>;

/**
 * __useGenerateUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadUrlMutation, { data, loading, error }] = useGenerateUploadUrlMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useGenerateUploadUrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateUploadUrlMutation, GenerateUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateUploadUrlMutation, GenerateUploadUrlMutationVariables>(GenerateUploadUrlDocument, options);
      }
export type GenerateUploadUrlMutationHookResult = ReturnType<typeof useGenerateUploadUrlMutation>;
export type GenerateUploadUrlMutationResult = ApolloReactCommon.MutationResult<GenerateUploadUrlMutation>;
export type GenerateUploadUrlMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateUploadUrlMutation, GenerateUploadUrlMutationVariables>;
export const UpdateDocumentDocument = gql`
    mutation updateDocument($input: UpdateDocumentInput!) {
  updateDocument(updateDocumentInput: $input) {
    docId
  }
}
    `;
export type UpdateDocumentMutationFn = ApolloReactCommon.MutationFunction<UpdateDocumentMutation, UpdateDocumentMutationVariables>;

/**
 * __useUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentMutation, { data, loading, error }] = useUpdateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDocumentMutation, UpdateDocumentMutationVariables>(UpdateDocumentDocument, options);
      }
export type UpdateDocumentMutationHookResult = ReturnType<typeof useUpdateDocumentMutation>;
export type UpdateDocumentMutationResult = ApolloReactCommon.MutationResult<UpdateDocumentMutation>;
export type UpdateDocumentMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>;
export const UploadDocumentDocument = gql`
    mutation uploadDocument($input: LocalUploadDocumentInput!) {
  uploadDocument(input: $input) @client
}
    `;
export type UploadDocumentMutationFn = ApolloReactCommon.MutationFunction<UploadDocumentMutation, UploadDocumentMutationVariables>;

/**
 * __useUploadDocumentMutation__
 *
 * To run a mutation, you first call `useUploadDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentMutation, { data, loading, error }] = useUploadDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadDocumentMutation, UploadDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UploadDocumentMutation, UploadDocumentMutationVariables>(UploadDocumentDocument, options);
      }
export type UploadDocumentMutationHookResult = ReturnType<typeof useUploadDocumentMutation>;
export type UploadDocumentMutationResult = ApolloReactCommon.MutationResult<UploadDocumentMutation>;
export type UploadDocumentMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadDocumentMutation, UploadDocumentMutationVariables>;
export const UploadDocumentsDocument = gql`
    mutation uploadDocuments($docs: [LocalUploadDocumentInput!]!) {
  uploadDocuments(docs: $docs) @client
}
    `;
export type UploadDocumentsMutationFn = ApolloReactCommon.MutationFunction<UploadDocumentsMutation, UploadDocumentsMutationVariables>;

/**
 * __useUploadDocumentsMutation__
 *
 * To run a mutation, you first call `useUploadDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentsMutation, { data, loading, error }] = useUploadDocumentsMutation({
 *   variables: {
 *      docs: // value for 'docs'
 *   },
 * });
 */
export function useUploadDocumentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadDocumentsMutation, UploadDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UploadDocumentsMutation, UploadDocumentsMutationVariables>(UploadDocumentsDocument, options);
      }
export type UploadDocumentsMutationHookResult = ReturnType<typeof useUploadDocumentsMutation>;
export type UploadDocumentsMutationResult = ApolloReactCommon.MutationResult<UploadDocumentsMutation>;
export type UploadDocumentsMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadDocumentsMutation, UploadDocumentsMutationVariables>;
export const PushToAmsDocument = gql`
    mutation pushToAMS($ids: [ID!]!) {
  pushToAMS(ids: $ids) @client {
    results {
      id
      success
    }
  }
}
    `;
export type PushToAmsMutationFn = ApolloReactCommon.MutationFunction<PushToAmsMutation, PushToAmsMutationVariables>;

/**
 * __usePushToAmsMutation__
 *
 * To run a mutation, you first call `usePushToAmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushToAmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushToAmsMutation, { data, loading, error }] = usePushToAmsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePushToAmsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PushToAmsMutation, PushToAmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PushToAmsMutation, PushToAmsMutationVariables>(PushToAmsDocument, options);
      }
export type PushToAmsMutationHookResult = ReturnType<typeof usePushToAmsMutation>;
export type PushToAmsMutationResult = ApolloReactCommon.MutationResult<PushToAmsMutation>;
export type PushToAmsMutationOptions = ApolloReactCommon.BaseMutationOptions<PushToAmsMutation, PushToAmsMutationVariables>;
export const SetVehicleInfoApiDocument = gql`
    query setVehicleInfoApi($amsType: String, $auctionId: String, $assetId: ID!, $oldFloor: Int!, $newFloor: Int!, $newLight: String, $oldLight: String, $announcements: [SetAnnouncements], $expectedAnnouncements: [ExpectedAnnouncement], $stockNumber: String!, $cancelProxyBids: Boolean, $numberOfProxyBids: Int) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    setVehicleInfo(
      amsType: $amsType
      assetId: $assetId
      floorPrice: {newValue: $newFloor, oldValue: $oldFloor}
      lights: {oldValue: $oldLight, newValue: $newLight}
      stockNumber: $stockNumber
      announcements: $announcements
      expectedAnnouncements: $expectedAnnouncements
      cancelProxyBids: $cancelProxyBids
      numberOfProxyBids: $numberOfProxyBids
    ) {
      results {
        operation
        success
        message
      }
      cancelProxyBidsResult {
        success
        errors
      }
    }
  }
}
    `;

/**
 * __useSetVehicleInfoApiQuery__
 *
 * To run a query within a React component, call `useSetVehicleInfoApiQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetVehicleInfoApiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetVehicleInfoApiQuery({
 *   variables: {
 *      amsType: // value for 'amsType'
 *      auctionId: // value for 'auctionId'
 *      assetId: // value for 'assetId'
 *      oldFloor: // value for 'oldFloor'
 *      newFloor: // value for 'newFloor'
 *      newLight: // value for 'newLight'
 *      oldLight: // value for 'oldLight'
 *      announcements: // value for 'announcements'
 *      expectedAnnouncements: // value for 'expectedAnnouncements'
 *      stockNumber: // value for 'stockNumber'
 *      cancelProxyBids: // value for 'cancelProxyBids'
 *      numberOfProxyBids: // value for 'numberOfProxyBids'
 *   },
 * });
 */
export function useSetVehicleInfoApiQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SetVehicleInfoApiQuery, SetVehicleInfoApiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SetVehicleInfoApiQuery, SetVehicleInfoApiQueryVariables>(SetVehicleInfoApiDocument, options);
      }
export function useSetVehicleInfoApiLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SetVehicleInfoApiQuery, SetVehicleInfoApiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SetVehicleInfoApiQuery, SetVehicleInfoApiQueryVariables>(SetVehicleInfoApiDocument, options);
        }
export type SetVehicleInfoApiQueryHookResult = ReturnType<typeof useSetVehicleInfoApiQuery>;
export type SetVehicleInfoApiLazyQueryHookResult = ReturnType<typeof useSetVehicleInfoApiLazyQuery>;
export type SetVehicleInfoApiQueryResult = ApolloReactCommon.QueryResult<SetVehicleInfoApiQuery, SetVehicleInfoApiQueryVariables>;
export const SetVehicleInfoDocument = gql`
    mutation setVehicleInfo($amsType: String!, $assetId: ID!, $floor: Int!, $announcements: [SetAnnouncements], $expectedAnnouncements: [ExpectedAnnouncement], $stockNumber: String!, $selectedLightId: Int!, $cancelProxyBids: Boolean, $numberOfProxyBids: Int) {
  setVehicleInfo(
    amsType: $amsType
    assetId: $assetId
    floor: $floor
    announcements: $announcements
    expectedAnnouncements: $expectedAnnouncements
    selectedLightId: $selectedLightId
    stockNumber: $stockNumber
    cancelProxyBids: $cancelProxyBids
    numberOfProxyBids: $numberOfProxyBids
  ) @client {
    results {
      success
      message
    }
  }
}
    `;
export type SetVehicleInfoMutationFn = ApolloReactCommon.MutationFunction<SetVehicleInfoMutation, SetVehicleInfoMutationVariables>;

/**
 * __useSetVehicleInfoMutation__
 *
 * To run a mutation, you first call `useSetVehicleInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetVehicleInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setVehicleInfoMutation, { data, loading, error }] = useSetVehicleInfoMutation({
 *   variables: {
 *      amsType: // value for 'amsType'
 *      assetId: // value for 'assetId'
 *      floor: // value for 'floor'
 *      announcements: // value for 'announcements'
 *      expectedAnnouncements: // value for 'expectedAnnouncements'
 *      stockNumber: // value for 'stockNumber'
 *      selectedLightId: // value for 'selectedLightId'
 *      cancelProxyBids: // value for 'cancelProxyBids'
 *      numberOfProxyBids: // value for 'numberOfProxyBids'
 *   },
 * });
 */
export function useSetVehicleInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetVehicleInfoMutation, SetVehicleInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetVehicleInfoMutation, SetVehicleInfoMutationVariables>(SetVehicleInfoDocument, options);
      }
export type SetVehicleInfoMutationHookResult = ReturnType<typeof useSetVehicleInfoMutation>;
export type SetVehicleInfoMutationResult = ApolloReactCommon.MutationResult<SetVehicleInfoMutation>;
export type SetVehicleInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<SetVehicleInfoMutation, SetVehicleInfoMutationVariables>;
export const AdminUserAttributesDocument = gql`
    query adminUserAttributes($auctionId: String!, $userId: String!) {
  administrator {
    user(input: {admin: {auctionId: $auctionId, subjectUserId: $userId}}) {
      attributes {
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useAdminUserAttributesQuery__
 *
 * To run a query within a React component, call `useAdminUserAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserAttributesQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminUserAttributesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminUserAttributesQuery, AdminUserAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminUserAttributesQuery, AdminUserAttributesQueryVariables>(AdminUserAttributesDocument, options);
      }
export function useAdminUserAttributesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminUserAttributesQuery, AdminUserAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminUserAttributesQuery, AdminUserAttributesQueryVariables>(AdminUserAttributesDocument, options);
        }
export type AdminUserAttributesQueryHookResult = ReturnType<typeof useAdminUserAttributesQuery>;
export type AdminUserAttributesLazyQueryHookResult = ReturnType<typeof useAdminUserAttributesLazyQuery>;
export type AdminUserAttributesQueryResult = ApolloReactCommon.QueryResult<AdminUserAttributesQuery, AdminUserAttributesQueryVariables>;
export const AssetByStockNumberDocument = gql`
    query assetByStockNumber($auctionId: String, $stockNumber: String!) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    assets(filter: {stockNumber: $stockNumber}) {
      byStockNumber {
        assetId
        consignorAccountId
        year
        make
        model
      }
    }
  }
}
    `;

/**
 * __useAssetByStockNumberQuery__
 *
 * To run a query within a React component, call `useAssetByStockNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetByStockNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetByStockNumberQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      stockNumber: // value for 'stockNumber'
 *   },
 * });
 */
export function useAssetByStockNumberQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AssetByStockNumberQuery, AssetByStockNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetByStockNumberQuery, AssetByStockNumberQueryVariables>(AssetByStockNumberDocument, options);
      }
export function useAssetByStockNumberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetByStockNumberQuery, AssetByStockNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetByStockNumberQuery, AssetByStockNumberQueryVariables>(AssetByStockNumberDocument, options);
        }
export type AssetByStockNumberQueryHookResult = ReturnType<typeof useAssetByStockNumberQuery>;
export type AssetByStockNumberLazyQueryHookResult = ReturnType<typeof useAssetByStockNumberLazyQuery>;
export type AssetByStockNumberQueryResult = ApolloReactCommon.QueryResult<AssetByStockNumberQuery, AssetByStockNumberQueryVariables>;
export const AssetFromAssetIdDocument = gql`
    query assetFromAssetId($auctionId: String, $assetId: ID!) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    assets(filter: {id: $assetId}) {
      byId {
        assetId
        stockNumber
        consignor {
          accountId
        }
      }
    }
  }
}
    `;

/**
 * __useAssetFromAssetIdQuery__
 *
 * To run a query within a React component, call `useAssetFromAssetIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetFromAssetIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetFromAssetIdQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useAssetFromAssetIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AssetFromAssetIdQuery, AssetFromAssetIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssetFromAssetIdQuery, AssetFromAssetIdQueryVariables>(AssetFromAssetIdDocument, options);
      }
export function useAssetFromAssetIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssetFromAssetIdQuery, AssetFromAssetIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssetFromAssetIdQuery, AssetFromAssetIdQueryVariables>(AssetFromAssetIdDocument, options);
        }
export type AssetFromAssetIdQueryHookResult = ReturnType<typeof useAssetFromAssetIdQuery>;
export type AssetFromAssetIdLazyQueryHookResult = ReturnType<typeof useAssetFromAssetIdLazyQuery>;
export type AssetFromAssetIdQueryResult = ApolloReactCommon.QueryResult<AssetFromAssetIdQuery, AssetFromAssetIdQueryVariables>;
export const DocumentTypesDocument = gql`
    query documentTypes {
  documentTypes @client {
    docTypeName
    docTypeId
    displayOrder
    shortCode
  }
}
    `;

/**
 * __useDocumentTypesQuery__
 *
 * To run a query within a React component, call `useDocumentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDocumentTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DocumentTypesQuery, DocumentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentTypesQuery, DocumentTypesQueryVariables>(DocumentTypesDocument, options);
      }
export function useDocumentTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentTypesQuery, DocumentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentTypesQuery, DocumentTypesQueryVariables>(DocumentTypesDocument, options);
        }
export type DocumentTypesQueryHookResult = ReturnType<typeof useDocumentTypesQuery>;
export type DocumentTypesLazyQueryHookResult = ReturnType<typeof useDocumentTypesLazyQuery>;
export type DocumentTypesQueryResult = ApolloReactCommon.QueryResult<DocumentTypesQuery, DocumentTypesQueryVariables>;
export const PresignedS3UrlDocument = gql`
    query presignedS3Url($accountId: Int!, $auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    document {
      documentUploadURLs(
        filter: {accountId: $accountId, numFiles: 1, fileType: "application/pdf"}
      ) {
        customerId
        tenantId
        fileName
        fileType
        s3uploadUrl
        urlExpires
        s3Key
      }
    }
  }
}
    `;

/**
 * __usePresignedS3UrlQuery__
 *
 * To run a query within a React component, call `usePresignedS3UrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePresignedS3UrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePresignedS3UrlQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function usePresignedS3UrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PresignedS3UrlQuery, PresignedS3UrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PresignedS3UrlQuery, PresignedS3UrlQueryVariables>(PresignedS3UrlDocument, options);
      }
export function usePresignedS3UrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PresignedS3UrlQuery, PresignedS3UrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PresignedS3UrlQuery, PresignedS3UrlQueryVariables>(PresignedS3UrlDocument, options);
        }
export type PresignedS3UrlQueryHookResult = ReturnType<typeof usePresignedS3UrlQuery>;
export type PresignedS3UrlLazyQueryHookResult = ReturnType<typeof usePresignedS3UrlLazyQuery>;
export type PresignedS3UrlQueryResult = ApolloReactCommon.QueryResult<PresignedS3UrlQuery, PresignedS3UrlQueryVariables>;
export const RemoteDocumentTypesDocument = gql`
    query remoteDocumentTypes($auctionId: String, $verticalTypeId: String!) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    document {
      documentTypes(verticalTypeId: $verticalTypeId) {
        docTypeName
        docTypeId
        displayOrder
        shortCode
      }
    }
  }
}
    `;

/**
 * __useRemoteDocumentTypesQuery__
 *
 * To run a query within a React component, call `useRemoteDocumentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemoteDocumentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemoteDocumentTypesQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      verticalTypeId: // value for 'verticalTypeId'
 *   },
 * });
 */
export function useRemoteDocumentTypesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RemoteDocumentTypesQuery, RemoteDocumentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RemoteDocumentTypesQuery, RemoteDocumentTypesQueryVariables>(RemoteDocumentTypesDocument, options);
      }
export function useRemoteDocumentTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RemoteDocumentTypesQuery, RemoteDocumentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RemoteDocumentTypesQuery, RemoteDocumentTypesQueryVariables>(RemoteDocumentTypesDocument, options);
        }
export type RemoteDocumentTypesQueryHookResult = ReturnType<typeof useRemoteDocumentTypesQuery>;
export type RemoteDocumentTypesLazyQueryHookResult = ReturnType<typeof useRemoteDocumentTypesLazyQuery>;
export type RemoteDocumentTypesQueryResult = ApolloReactCommon.QueryResult<RemoteDocumentTypesQuery, RemoteDocumentTypesQueryVariables>;
export const ResetPasswordByEmailClientDocument = gql`
    mutation ResetPasswordByEmailClient($email: String!) {
  doResetPasswordByEmail(email: $email) @client {
    userEmail
    statusCode
    statusMessage
  }
}
    `;
export type ResetPasswordByEmailClientMutationFn = ApolloReactCommon.MutationFunction<ResetPasswordByEmailClientMutation, ResetPasswordByEmailClientMutationVariables>;

/**
 * __useResetPasswordByEmailClientMutation__
 *
 * To run a mutation, you first call `useResetPasswordByEmailClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordByEmailClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordByEmailClientMutation, { data, loading, error }] = useResetPasswordByEmailClientMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordByEmailClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetPasswordByEmailClientMutation, ResetPasswordByEmailClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetPasswordByEmailClientMutation, ResetPasswordByEmailClientMutationVariables>(ResetPasswordByEmailClientDocument, options);
      }
export type ResetPasswordByEmailClientMutationHookResult = ReturnType<typeof useResetPasswordByEmailClientMutation>;
export type ResetPasswordByEmailClientMutationResult = ApolloReactCommon.MutationResult<ResetPasswordByEmailClientMutation>;
export type ResetPasswordByEmailClientMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetPasswordByEmailClientMutation, ResetPasswordByEmailClientMutationVariables>;
export const AddSearchesDocument = gql`
    mutation AddSearches($displayName: String!, $searchName: String!, $filterName: String!) {
  addPastSearch(
    input: {displayName: $displayName, searchName: $searchName, filterName: $filterName}
  ) @client
}
    `;
export type AddSearchesMutationFn = ApolloReactCommon.MutationFunction<AddSearchesMutation, AddSearchesMutationVariables>;

/**
 * __useAddSearchesMutation__
 *
 * To run a mutation, you first call `useAddSearchesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSearchesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSearchesMutation, { data, loading, error }] = useAddSearchesMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      searchName: // value for 'searchName'
 *      filterName: // value for 'filterName'
 *   },
 * });
 */
export function useAddSearchesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddSearchesMutation, AddSearchesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddSearchesMutation, AddSearchesMutationVariables>(AddSearchesDocument, options);
      }
export type AddSearchesMutationHookResult = ReturnType<typeof useAddSearchesMutation>;
export type AddSearchesMutationResult = ApolloReactCommon.MutationResult<AddSearchesMutation>;
export type AddSearchesMutationOptions = ApolloReactCommon.BaseMutationOptions<AddSearchesMutation, AddSearchesMutationVariables>;
export const GetPastSearchesDocument = gql`
    query getPastSearches {
  pastSearches @client {
    displayName
    searchName
    filterName
  }
}
    `;

/**
 * __useGetPastSearchesQuery__
 *
 * To run a query within a React component, call `useGetPastSearchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPastSearchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPastSearchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPastSearchesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPastSearchesQuery, GetPastSearchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPastSearchesQuery, GetPastSearchesQueryVariables>(GetPastSearchesDocument, options);
      }
export function useGetPastSearchesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPastSearchesQuery, GetPastSearchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPastSearchesQuery, GetPastSearchesQueryVariables>(GetPastSearchesDocument, options);
        }
export type GetPastSearchesQueryHookResult = ReturnType<typeof useGetPastSearchesQuery>;
export type GetPastSearchesLazyQueryHookResult = ReturnType<typeof useGetPastSearchesLazyQuery>;
export type GetPastSearchesQueryResult = ApolloReactCommon.QueryResult<GetPastSearchesQuery, GetPastSearchesQueryVariables>;
export const ActiveAuctionDetailsDocument = gql`
    query activeAuctionDetails {
  activeOrganization @client {
    orgId
    displayName
  }
}
    `;

/**
 * __useActiveAuctionDetailsQuery__
 *
 * To run a query within a React component, call `useActiveAuctionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveAuctionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveAuctionDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveAuctionDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActiveAuctionDetailsQuery, ActiveAuctionDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActiveAuctionDetailsQuery, ActiveAuctionDetailsQueryVariables>(ActiveAuctionDetailsDocument, options);
      }
export function useActiveAuctionDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveAuctionDetailsQuery, ActiveAuctionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActiveAuctionDetailsQuery, ActiveAuctionDetailsQueryVariables>(ActiveAuctionDetailsDocument, options);
        }
export type ActiveAuctionDetailsQueryHookResult = ReturnType<typeof useActiveAuctionDetailsQuery>;
export type ActiveAuctionDetailsLazyQueryHookResult = ReturnType<typeof useActiveAuctionDetailsLazyQuery>;
export type ActiveAuctionDetailsQueryResult = ApolloReactCommon.QueryResult<ActiveAuctionDetailsQuery, ActiveAuctionDetailsQueryVariables>;
export const UpdateFavoriteAccountDocument = gql`
    mutation updateFavoriteAccount($auctionId: String!, $accountKey: String!, $isFavorite: Boolean!) {
  updateFavoriteAccount(
    input: {orgCode: $auctionId, accountKey: $accountKey, isFavorite: $isFavorite}
  ) {
    statusCode
    statusMessage
  }
}
    `;
export type UpdateFavoriteAccountMutationFn = ApolloReactCommon.MutationFunction<UpdateFavoriteAccountMutation, UpdateFavoriteAccountMutationVariables>;

/**
 * __useUpdateFavoriteAccountMutation__
 *
 * To run a mutation, you first call `useUpdateFavoriteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFavoriteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFavoriteAccountMutation, { data, loading, error }] = useUpdateFavoriteAccountMutation({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      accountKey: // value for 'accountKey'
 *      isFavorite: // value for 'isFavorite'
 *   },
 * });
 */
export function useUpdateFavoriteAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFavoriteAccountMutation, UpdateFavoriteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateFavoriteAccountMutation, UpdateFavoriteAccountMutationVariables>(UpdateFavoriteAccountDocument, options);
      }
export type UpdateFavoriteAccountMutationHookResult = ReturnType<typeof useUpdateFavoriteAccountMutation>;
export type UpdateFavoriteAccountMutationResult = ApolloReactCommon.MutationResult<UpdateFavoriteAccountMutation>;
export type UpdateFavoriteAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateFavoriteAccountMutation, UpdateFavoriteAccountMutationVariables>;
export const GetAuctionIdDocument = gql`
    query GetAuctionId {
  activeOrganization @client {
    orgId
  }
}
    `;

/**
 * __useGetAuctionIdQuery__
 *
 * To run a query within a React component, call `useGetAuctionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuctionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuctionIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAuctionIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAuctionIdQuery, GetAuctionIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAuctionIdQuery, GetAuctionIdQueryVariables>(GetAuctionIdDocument, options);
      }
export function useGetAuctionIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAuctionIdQuery, GetAuctionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAuctionIdQuery, GetAuctionIdQueryVariables>(GetAuctionIdDocument, options);
        }
export type GetAuctionIdQueryHookResult = ReturnType<typeof useGetAuctionIdQuery>;
export type GetAuctionIdLazyQueryHookResult = ReturnType<typeof useGetAuctionIdLazyQuery>;
export type GetAuctionIdQueryResult = ApolloReactCommon.QueryResult<GetAuctionIdQuery, GetAuctionIdQueryVariables>;
export const GetAuctionTypeDocument = gql`
    query GetAuctionType {
  activeOrganization @client {
    type
  }
}
    `;

/**
 * __useGetAuctionTypeQuery__
 *
 * To run a query within a React component, call `useGetAuctionTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuctionTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuctionTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAuctionTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAuctionTypeQuery, GetAuctionTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAuctionTypeQuery, GetAuctionTypeQueryVariables>(GetAuctionTypeDocument, options);
      }
export function useGetAuctionTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAuctionTypeQuery, GetAuctionTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAuctionTypeQuery, GetAuctionTypeQueryVariables>(GetAuctionTypeDocument, options);
        }
export type GetAuctionTypeQueryHookResult = ReturnType<typeof useGetAuctionTypeQuery>;
export type GetAuctionTypeLazyQueryHookResult = ReturnType<typeof useGetAuctionTypeLazyQuery>;
export type GetAuctionTypeQueryResult = ApolloReactCommon.QueryResult<GetAuctionTypeQuery, GetAuctionTypeQueryVariables>;
export const CurrentUserInfoDocument = gql`
    query currentUserInfo {
  profile @client {
    userId
    familyName
    name
    email
    mobilePhone
    databaseId
  }
}
    `;

/**
 * __useCurrentUserInfoQuery__
 *
 * To run a query within a React component, call `useCurrentUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserInfoQuery, CurrentUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserInfoQuery, CurrentUserInfoQueryVariables>(CurrentUserInfoDocument, options);
      }
export function useCurrentUserInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserInfoQuery, CurrentUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserInfoQuery, CurrentUserInfoQueryVariables>(CurrentUserInfoDocument, options);
        }
export type CurrentUserInfoQueryHookResult = ReturnType<typeof useCurrentUserInfoQuery>;
export type CurrentUserInfoLazyQueryHookResult = ReturnType<typeof useCurrentUserInfoLazyQuery>;
export type CurrentUserInfoQueryResult = ApolloReactCommon.QueryResult<CurrentUserInfoQuery, CurrentUserInfoQueryVariables>;
export const DoLogoutDocument = gql`
    mutation DoLogout {
  doLogout @client
}
    `;
export type DoLogoutMutationFn = ApolloReactCommon.MutationFunction<DoLogoutMutation, DoLogoutMutationVariables>;

/**
 * __useDoLogoutMutation__
 *
 * To run a mutation, you first call `useDoLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doLogoutMutation, { data, loading, error }] = useDoLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useDoLogoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DoLogoutMutation, DoLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DoLogoutMutation, DoLogoutMutationVariables>(DoLogoutDocument, options);
      }
export type DoLogoutMutationHookResult = ReturnType<typeof useDoLogoutMutation>;
export type DoLogoutMutationResult = ApolloReactCommon.MutationResult<DoLogoutMutation>;
export type DoLogoutMutationOptions = ApolloReactCommon.BaseMutationOptions<DoLogoutMutation, DoLogoutMutationVariables>;
export const GetExpanderStateDocument = gql`
    query getExpanderState {
  activeOrganization @client {
    isAdmin
    orgId
  }
  profile @client {
    isAdmin
    name
    familyName
  }
}
    `;

/**
 * __useGetExpanderStateQuery__
 *
 * To run a query within a React component, call `useGetExpanderStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpanderStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpanderStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExpanderStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetExpanderStateQuery, GetExpanderStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetExpanderStateQuery, GetExpanderStateQueryVariables>(GetExpanderStateDocument, options);
      }
export function useGetExpanderStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExpanderStateQuery, GetExpanderStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetExpanderStateQuery, GetExpanderStateQueryVariables>(GetExpanderStateDocument, options);
        }
export type GetExpanderStateQueryHookResult = ReturnType<typeof useGetExpanderStateQuery>;
export type GetExpanderStateLazyQueryHookResult = ReturnType<typeof useGetExpanderStateLazyQuery>;
export type GetExpanderStateQueryResult = ApolloReactCommon.QueryResult<GetExpanderStateQuery, GetExpanderStateQueryVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  doLogout @client
}
    `;
export type LogoutMutationFn = ApolloReactCommon.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = ApolloReactCommon.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = ApolloReactCommon.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const GlobalSearchDocument = gql`
    query globalSearch($searchString: String!, $auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(filter: {searchString: $searchString, type: BROAD}, pageInfo: {limit: 5}) {
      vehicleCount
      vehicleInSaleCount
      vehicleRecentlySoldCount
      accountCount
      agentCount
      vehicleResult {
        stockNumber
        assetId
        year
        make
        model
        consignor
      }
      vehicleInSaleResult {
        stockNumber
        assetId
        year
        make
        model
        consignor
      }
      vehicleRecentlySoldResult {
        stockNumber
        assetId
        year
        make
        model
        consignor
      }
      accountResult {
        accountId
        displayName
        city
        state
      }
      agentResult {
        agentId
        firstName
        lastName
        displayName
      }
    }
  }
}
    `;

/**
 * __useGlobalSearchQuery__
 *
 * To run a query within a React component, call `useGlobalSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalSearchQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useGlobalSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GlobalSearchQuery, GlobalSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalSearchQuery, GlobalSearchQueryVariables>(GlobalSearchDocument, options);
      }
export function useGlobalSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalSearchQuery, GlobalSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalSearchQuery, GlobalSearchQueryVariables>(GlobalSearchDocument, options);
        }
export type GlobalSearchQueryHookResult = ReturnType<typeof useGlobalSearchQuery>;
export type GlobalSearchLazyQueryHookResult = ReturnType<typeof useGlobalSearchLazyQuery>;
export type GlobalSearchQueryResult = ApolloReactCommon.QueryResult<GlobalSearchQuery, GlobalSearchQueryVariables>;
export const ChangeAuctionDocument = gql`
    mutation ChangeAuction($newAuction: String!) {
  changeAuction(newAuction: $newAuction) @client
}
    `;
export type ChangeAuctionMutationFn = ApolloReactCommon.MutationFunction<ChangeAuctionMutation, ChangeAuctionMutationVariables>;

/**
 * __useChangeAuctionMutation__
 *
 * To run a mutation, you first call `useChangeAuctionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeAuctionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeAuctionMutation, { data, loading, error }] = useChangeAuctionMutation({
 *   variables: {
 *      newAuction: // value for 'newAuction'
 *   },
 * });
 */
export function useChangeAuctionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeAuctionMutation, ChangeAuctionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChangeAuctionMutation, ChangeAuctionMutationVariables>(ChangeAuctionDocument, options);
      }
export type ChangeAuctionMutationHookResult = ReturnType<typeof useChangeAuctionMutation>;
export type ChangeAuctionMutationResult = ApolloReactCommon.MutationResult<ChangeAuctionMutation>;
export type ChangeAuctionMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangeAuctionMutation, ChangeAuctionMutationVariables>;
export const UserProfileOptionsDocument = gql`
    query userProfileOptions {
  profile @client {
    isAdmin
    name
    familyName
    email
  }
  activeOrganization @client {
    orgId
    displayName
    description
    isAdmin
    sites {
      auctionName
      pipelineCode
      locationName
      lookoutCodeName
      biCode
    }
  }
  user {
    dashboards
    attributes {
      isGlobalAdmin
    }
    organizations {
      orgId
      displayName
      description
      isAdmin
      lastUpdated
      orgTypeCode
      groupOrgId
      orgNumber
    }
  }
}
    `;

/**
 * __useUserProfileOptionsQuery__
 *
 * To run a query within a React component, call `useUserProfileOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserProfileOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserProfileOptionsQuery, UserProfileOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserProfileOptionsQuery, UserProfileOptionsQueryVariables>(UserProfileOptionsDocument, options);
      }
export function useUserProfileOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserProfileOptionsQuery, UserProfileOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserProfileOptionsQuery, UserProfileOptionsQueryVariables>(UserProfileOptionsDocument, options);
        }
export type UserProfileOptionsQueryHookResult = ReturnType<typeof useUserProfileOptionsQuery>;
export type UserProfileOptionsLazyQueryHookResult = ReturnType<typeof useUserProfileOptionsLazyQuery>;
export type UserProfileOptionsQueryResult = ApolloReactCommon.QueryResult<UserProfileOptionsQuery, UserProfileOptionsQueryVariables>;
export const ShareModalDocument = gql`
    mutation shareModal($displayUrl: String, $emailAddress: [String], $smsNumber: [String], $messageBody: String, $displayName: String!, $subject: String, $textHeader: String, $senderName: String!, $senderEmail: String!, $context: [String], $stockNumber: String) {
  putMessage(
    input: {displayUrl: $displayUrl, emailAddress: $emailAddress, smsNumber: $smsNumber, messageBody: $messageBody, displayName: $displayName, subject: $subject, textHeader: $textHeader, senderName: $senderName, senderEmail: $senderEmail, context: $context, stockNumber: $stockNumber}
  ) {
    smsSentStatus
    emailSentStatus
  }
}
    `;
export type ShareModalMutationFn = ApolloReactCommon.MutationFunction<ShareModalMutation, ShareModalMutationVariables>;

/**
 * __useShareModalMutation__
 *
 * To run a mutation, you first call `useShareModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareModalMutation, { data, loading, error }] = useShareModalMutation({
 *   variables: {
 *      displayUrl: // value for 'displayUrl'
 *      emailAddress: // value for 'emailAddress'
 *      smsNumber: // value for 'smsNumber'
 *      messageBody: // value for 'messageBody'
 *      displayName: // value for 'displayName'
 *      subject: // value for 'subject'
 *      textHeader: // value for 'textHeader'
 *      senderName: // value for 'senderName'
 *      senderEmail: // value for 'senderEmail'
 *      context: // value for 'context'
 *      stockNumber: // value for 'stockNumber'
 *   },
 * });
 */
export function useShareModalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShareModalMutation, ShareModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShareModalMutation, ShareModalMutationVariables>(ShareModalDocument, options);
      }
export type ShareModalMutationHookResult = ReturnType<typeof useShareModalMutation>;
export type ShareModalMutationResult = ApolloReactCommon.MutationResult<ShareModalMutation>;
export type ShareModalMutationOptions = ApolloReactCommon.BaseMutationOptions<ShareModalMutation, ShareModalMutationVariables>;
export const CsvLinkDocument = gql`
    query csvLink($auctionId: String, $searchString: String!) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(filter: {createCSV: true, searchString: $searchString, type: VEHICLES}) {
      vehicleResultCsvUrl
    }
  }
}
    `;

/**
 * __useCsvLinkQuery__
 *
 * To run a query within a React component, call `useCsvLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCsvLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCsvLinkQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useCsvLinkQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CsvLinkQuery, CsvLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CsvLinkQuery, CsvLinkQueryVariables>(CsvLinkDocument, options);
      }
export function useCsvLinkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CsvLinkQuery, CsvLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CsvLinkQuery, CsvLinkQueryVariables>(CsvLinkDocument, options);
        }
export type CsvLinkQueryHookResult = ReturnType<typeof useCsvLinkQuery>;
export type CsvLinkLazyQueryHookResult = ReturnType<typeof useCsvLinkLazyQuery>;
export type CsvLinkQueryResult = ApolloReactCommon.QueryResult<CsvLinkQuery, CsvLinkQueryVariables>;
export const SharePdfCsvDocument = gql`
    mutation sharePdfCsv($displayUrl: String, $smsNumber: [String], $emailAddress: [String], $messageBody: String!, $subject: String, $textHeader: String, $senderEmail: String!, $senderName: String!) {
  sharePdfCsv(
    displayUrl: $displayUrl
    smsNumber: $smsNumber
    emailAddress: $emailAddress
    messageBody: $messageBody
    subject: $subject
    textHeader: $textHeader
    senderEmail: $senderEmail
    senderName: $senderName
  ) @client
}
    `;
export type SharePdfCsvMutationFn = ApolloReactCommon.MutationFunction<SharePdfCsvMutation, SharePdfCsvMutationVariables>;

/**
 * __useSharePdfCsvMutation__
 *
 * To run a mutation, you first call `useSharePdfCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharePdfCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharePdfCsvMutation, { data, loading, error }] = useSharePdfCsvMutation({
 *   variables: {
 *      displayUrl: // value for 'displayUrl'
 *      smsNumber: // value for 'smsNumber'
 *      emailAddress: // value for 'emailAddress'
 *      messageBody: // value for 'messageBody'
 *      subject: // value for 'subject'
 *      textHeader: // value for 'textHeader'
 *      senderEmail: // value for 'senderEmail'
 *      senderName: // value for 'senderName'
 *   },
 * });
 */
export function useSharePdfCsvMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SharePdfCsvMutation, SharePdfCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SharePdfCsvMutation, SharePdfCsvMutationVariables>(SharePdfCsvDocument, options);
      }
export type SharePdfCsvMutationHookResult = ReturnType<typeof useSharePdfCsvMutation>;
export type SharePdfCsvMutationResult = ApolloReactCommon.MutationResult<SharePdfCsvMutation>;
export type SharePdfCsvMutationOptions = ApolloReactCommon.BaseMutationOptions<SharePdfCsvMutation, SharePdfCsvMutationVariables>;
export const SharePdfDocument = gql`
    mutation sharePdf($displayUrl: String, $emailAddress: [String], $smsNumber: [String], $messageBody: String, $displayName: String!, $subject: String, $textHeader: String, $senderEmail: String!, $senderName: String!) {
  putMessage(
    input: {displayUrl: $displayUrl, emailAddress: $emailAddress, smsNumber: $smsNumber, messageBody: $messageBody, displayName: $displayName, subject: $subject, textHeader: $textHeader, senderName: $senderName, senderEmail: $senderEmail}
  ) {
    smsSentStatus
    emailSentStatus
  }
}
    `;
export type SharePdfMutationFn = ApolloReactCommon.MutationFunction<SharePdfMutation, SharePdfMutationVariables>;

/**
 * __useSharePdfMutation__
 *
 * To run a mutation, you first call `useSharePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharePdfMutation, { data, loading, error }] = useSharePdfMutation({
 *   variables: {
 *      displayUrl: // value for 'displayUrl'
 *      emailAddress: // value for 'emailAddress'
 *      smsNumber: // value for 'smsNumber'
 *      messageBody: // value for 'messageBody'
 *      displayName: // value for 'displayName'
 *      subject: // value for 'subject'
 *      textHeader: // value for 'textHeader'
 *      senderEmail: // value for 'senderEmail'
 *      senderName: // value for 'senderName'
 *   },
 * });
 */
export function useSharePdfMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SharePdfMutation, SharePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SharePdfMutation, SharePdfMutationVariables>(SharePdfDocument, options);
      }
export type SharePdfMutationHookResult = ReturnType<typeof useSharePdfMutation>;
export type SharePdfMutationResult = ApolloReactCommon.MutationResult<SharePdfMutation>;
export type SharePdfMutationOptions = ApolloReactCommon.BaseMutationOptions<SharePdfMutation, SharePdfMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($subjectUserId: String!, $auctionId: String!) {
  deleteUser(
    input: {admin: {auctionId: $auctionId, subjectUserId: $subjectUserId}}
  ) {
    firstName
    lastName
    email
    mobilePhone
    workPhone
    notes
    isLocked
    isGlobalAdmin
    auctionAccessNumber
    authenticationId
    authenticationUsername
    statusMessage
    statusCode
  }
}
    `;
export type DeleteUserMutationFn = ApolloReactCommon.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      subjectUserId: // value for 'subjectUserId'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = ApolloReactCommon.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($firstName: String!, $lastName: String!, $email: String!, $authenticationUsername: String!, $isGlobalAdmin: Boolean!, $auctionId: String!, $mobilePhone: String!, $workPhone: String!, $auctionAccessNumber: String, $notes: String, $isSiteAdmin: Boolean!) {
  createUser(
    input: {firstName: $firstName, lastName: $lastName, email: $email, authenticationUsername: $authenticationUsername, isGlobalAdmin: $isGlobalAdmin, admin: {auctionId: $auctionId}, mobilePhone: $mobilePhone, workPhone: $workPhone, auctionAccessNumber: $auctionAccessNumber, notes: $notes, isSiteAdmin: $isSiteAdmin}
  ) {
    authenticationId
    firstName
    lastName
    email
    mobilePhone
    workPhone
    auctionAccessNumber
    authenticationUsername
    notes
    isLocked
    statusCode
    statusMessage
    isGlobalAdmin
  }
}
    `;
export type CreateUserMutationFn = ApolloReactCommon.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      authenticationUsername: // value for 'authenticationUsername'
 *      isGlobalAdmin: // value for 'isGlobalAdmin'
 *      auctionId: // value for 'auctionId'
 *      mobilePhone: // value for 'mobilePhone'
 *      workPhone: // value for 'workPhone'
 *      auctionAccessNumber: // value for 'auctionAccessNumber'
 *      notes: // value for 'notes'
 *      isSiteAdmin: // value for 'isSiteAdmin'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = ApolloReactCommon.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const GetUserDetailsDocument = gql`
    query getUserDetails($subjectUserId: String!, $auctionId: String!) {
  profile @client {
    isAdmin
  }
  user {
    organizations {
      orgId
      displayName
      description
      type
      isAEAdmin
      isAuctionUser
      isAdmin
      orgTypeCode
      isCorporateGroupUser
      description
      groupOrgId
      orgNumber
    }
  }
  administrator {
    user(input: {admin: {auctionId: $auctionId, subjectUserId: $subjectUserId}}) {
      permissions {
        userPermissions {
          key
          description
          note
        }
      }
      organizations {
        orgId
        displayName
        description
        type
        isAuctionUser
        isAdmin
        note
        orgTypeCode
        isCorporateGroupUser
        groupOrgId
        orgNumber
      }
      roles {
        id
        name
        visible
        description
      }
      biRoles
    }
  }
}
    `;

/**
 * __useGetUserDetailsQuery__
 *
 * To run a query within a React component, call `useGetUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDetailsQuery({
 *   variables: {
 *      subjectUserId: // value for 'subjectUserId'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useGetUserDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
      }
export function useGetUserDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
        }
export type GetUserDetailsQueryHookResult = ReturnType<typeof useGetUserDetailsQuery>;
export type GetUserDetailsLazyQueryHookResult = ReturnType<typeof useGetUserDetailsLazyQuery>;
export type GetUserDetailsQueryResult = ApolloReactCommon.QueryResult<GetUserDetailsQuery, GetUserDetailsQueryVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($auctionId: String!, $subjectUserId: String!, $firstName: String, $lastName: String, $mobilePhone: String, $workPhone: String, $email: String!, $isGlobalAdmin: Boolean!, $notes: String) {
  updateUser(
    input: {admin: {auctionId: $auctionId, subjectUserId: $subjectUserId}, updatedAttributes: {firstName: $firstName, lastName: $lastName, mobilePhone: $mobilePhone, workPhone: $workPhone, email: $email, isGlobalAdmin: $isGlobalAdmin, notes: $notes}}
  ) {
    authenticationId
    firstName
    lastName
    email
    mobilePhone
    workPhone
    auctionAccessNumber
    authenticationUsername
    notes
    isLocked
    statusCode
    statusMessage
    isGlobalAdmin
  }
}
    `;
export type UpdateUserMutationFn = ApolloReactCommon.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      subjectUserId: // value for 'subjectUserId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      mobilePhone: // value for 'mobilePhone'
 *      workPhone: // value for 'workPhone'
 *      email: // value for 'email'
 *      isGlobalAdmin: // value for 'isGlobalAdmin'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = ApolloReactCommon.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const ResendVerificationEmailDocument = gql`
    mutation resendVerificationEmail($username: String!, $auctionId: String!, $subjectUserId: String!) {
  resendUnconfirmedPassword(
    input: {username: $username, admin: {auctionId: $auctionId, subjectUserId: $subjectUserId}}
  ) {
    statusCode
    statusMessage
  }
}
    `;
export type ResendVerificationEmailMutationFn = ApolloReactCommon.MutationFunction<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;

/**
 * __useResendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationEmailMutation, { data, loading, error }] = useResendVerificationEmailMutation({
 *   variables: {
 *      username: // value for 'username'
 *      auctionId: // value for 'auctionId'
 *      subjectUserId: // value for 'subjectUserId'
 *   },
 * });
 */
export function useResendVerificationEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>(ResendVerificationEmailDocument, options);
      }
export type ResendVerificationEmailMutationHookResult = ReturnType<typeof useResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationResult = ApolloReactCommon.MutationResult<ResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;
export const GetUserListDocument = gql`
    query getUserList($auctionId: String = "") {
  administrator {
    users(input: {admin: {auctionId: $auctionId}}) {
      authenticationId
      authenticationUsername
      firstName
      lastName
      lastSeenAt
      mobilePhone
      workPhone
      email
      isGlobalAdmin
      notes
      auctionAccessNumber
    }
  }
}
    `;

/**
 * __useGetUserListQuery__
 *
 * To run a query within a React component, call `useGetUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserListQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useGetUserListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserListQuery, GetUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserListQuery, GetUserListQueryVariables>(GetUserListDocument, options);
      }
export function useGetUserListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserListQuery, GetUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserListQuery, GetUserListQueryVariables>(GetUserListDocument, options);
        }
export type GetUserListQueryHookResult = ReturnType<typeof useGetUserListQuery>;
export type GetUserListLazyQueryHookResult = ReturnType<typeof useGetUserListLazyQuery>;
export type GetUserListQueryResult = ApolloReactCommon.QueryResult<GetUserListQuery, GetUserListQueryVariables>;
export const UpdateUserOrgsDocument = gql`
    mutation updateUserOrgs($subjectUserId: String!, $auctionId: String!, $updatedOrganizations: [OrganizationInput!]!) {
  updateUser(
    input: {admin: {auctionId: $auctionId, subjectUserId: $subjectUserId}, updatedOrganizations: $updatedOrganizations}
  ) {
    authenticationId
    firstName
    lastName
    email
    mobilePhone
    workPhone
    auctionAccessNumber
    authenticationUsername
    notes
    isLocked
    statusCode
    statusMessage
    isGlobalAdmin
  }
}
    `;
export type UpdateUserOrgsMutationFn = ApolloReactCommon.MutationFunction<UpdateUserOrgsMutation, UpdateUserOrgsMutationVariables>;

/**
 * __useUpdateUserOrgsMutation__
 *
 * To run a mutation, you first call `useUpdateUserOrgsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOrgsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOrgsMutation, { data, loading, error }] = useUpdateUserOrgsMutation({
 *   variables: {
 *      subjectUserId: // value for 'subjectUserId'
 *      auctionId: // value for 'auctionId'
 *      updatedOrganizations: // value for 'updatedOrganizations'
 *   },
 * });
 */
export function useUpdateUserOrgsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserOrgsMutation, UpdateUserOrgsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserOrgsMutation, UpdateUserOrgsMutationVariables>(UpdateUserOrgsDocument, options);
      }
export type UpdateUserOrgsMutationHookResult = ReturnType<typeof useUpdateUserOrgsMutation>;
export type UpdateUserOrgsMutationResult = ApolloReactCommon.MutationResult<UpdateUserOrgsMutation>;
export type UpdateUserOrgsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserOrgsMutation, UpdateUserOrgsMutationVariables>;
export const GetPossibleRolesDocument = gql`
    query getPossibleRoles($auctionId: String!) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  roles @client {
    id
    name
    description
    visible
  }
  auction(id: $auctionId) {
    roles {
      id
      name
      description
      visible
    }
  }
}
    `;

/**
 * __useGetPossibleRolesQuery__
 *
 * To run a query within a React component, call `useGetPossibleRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPossibleRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPossibleRolesQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useGetPossibleRolesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPossibleRolesQuery, GetPossibleRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPossibleRolesQuery, GetPossibleRolesQueryVariables>(GetPossibleRolesDocument, options);
      }
export function useGetPossibleRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPossibleRolesQuery, GetPossibleRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPossibleRolesQuery, GetPossibleRolesQueryVariables>(GetPossibleRolesDocument, options);
        }
export type GetPossibleRolesQueryHookResult = ReturnType<typeof useGetPossibleRolesQuery>;
export type GetPossibleRolesLazyQueryHookResult = ReturnType<typeof useGetPossibleRolesLazyQuery>;
export type GetPossibleRolesQueryResult = ApolloReactCommon.QueryResult<GetPossibleRolesQuery, GetPossibleRolesQueryVariables>;
export const UpdateUserRolesDocument = gql`
    mutation updateUserRoles($subjectUserId: String!, $auctionId: String!, $updatedRoles: [String!]) {
  updateUser(
    input: {admin: {auctionId: $auctionId, subjectUserId: $subjectUserId}, updatedRoles: $updatedRoles}
  ) {
    authenticationId
    firstName
    lastName
    email
    mobilePhone
    workPhone
    auctionAccessNumber
    authenticationUsername
    notes
    isLocked
    statusCode
    statusMessage
    isGlobalAdmin
  }
}
    `;
export type UpdateUserRolesMutationFn = ApolloReactCommon.MutationFunction<UpdateUserRolesMutation, UpdateUserRolesMutationVariables>;

/**
 * __useUpdateUserRolesMutation__
 *
 * To run a mutation, you first call `useUpdateUserRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRolesMutation, { data, loading, error }] = useUpdateUserRolesMutation({
 *   variables: {
 *      subjectUserId: // value for 'subjectUserId'
 *      auctionId: // value for 'auctionId'
 *      updatedRoles: // value for 'updatedRoles'
 *   },
 * });
 */
export function useUpdateUserRolesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserRolesMutation, UpdateUserRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserRolesMutation, UpdateUserRolesMutationVariables>(UpdateUserRolesDocument, options);
      }
export type UpdateUserRolesMutationHookResult = ReturnType<typeof useUpdateUserRolesMutation>;
export type UpdateUserRolesMutationResult = ApolloReactCommon.MutationResult<UpdateUserRolesMutation>;
export type UpdateUserRolesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserRolesMutation, UpdateUserRolesMutationVariables>;
export const ActiveOrgAndProfileDocument = gql`
    query activeOrgAndProfile {
  activeOrganization @client {
    orgId
    displayName
    isAdmin
  }
  profile @client {
    userId
    isAdmin
  }
}
    `;

/**
 * __useActiveOrgAndProfileQuery__
 *
 * To run a query within a React component, call `useActiveOrgAndProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveOrgAndProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveOrgAndProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveOrgAndProfileQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActiveOrgAndProfileQuery, ActiveOrgAndProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActiveOrgAndProfileQuery, ActiveOrgAndProfileQueryVariables>(ActiveOrgAndProfileDocument, options);
      }
export function useActiveOrgAndProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveOrgAndProfileQuery, ActiveOrgAndProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActiveOrgAndProfileQuery, ActiveOrgAndProfileQueryVariables>(ActiveOrgAndProfileDocument, options);
        }
export type ActiveOrgAndProfileQueryHookResult = ReturnType<typeof useActiveOrgAndProfileQuery>;
export type ActiveOrgAndProfileLazyQueryHookResult = ReturnType<typeof useActiveOrgAndProfileLazyQuery>;
export type ActiveOrgAndProfileQueryResult = ApolloReactCommon.QueryResult<ActiveOrgAndProfileQuery, ActiveOrgAndProfileQueryVariables>;
export const EditSaleConditionsDetailDocument = gql`
    query EditSaleConditionsDetail($assetId: ID, $auctionId: String, $stockNumber: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    assets(filter: {id: $assetId, stockNumber: $stockNumber}) {
      byId {
        buyerAccountId
        buyerAccountKey
        buyerDisplayName
        ownerStockNumber
        stockNumber
        assetId
        vin
        checkinDate
        saleListingSaleStatus
        checkinTime
        checkinUser
        hasTitle
        titleNumber
        titleState
        titleReceivedDate
        saleEvents {
          eventTitle
          eventDate
          venueEventTypeCode
          eventStartTs
          eventEndTs
          eventEndedAtTs
          venueEventKey
          lane
          lotNumber
          floorPrice
          saleListingStatus
          dealSaleAmt
          dealStatus
          buyerName
          saleListingKey
          buyerOrgAaNum
          buyerOrgStatusCode
          buyerAgentAaNum
          buyerAgentStatusCode
          city
          state
        }
        listingCondition
        listingConditionId
        listingConditionCode
        year
        make
        model
        trim
        color
        exteriorColor
        interiorColor
        transmissionType
        drivetrain
        drivetrainDesc
        fuelType
        crStatus
        mmrValue
        blackBookValue
        conditionReport {
          conditionReportTime
          conditionReportStatus
          conditionReportWriter
        }
        photoCount
        photoBeauty
        photos {
          pipelineUri
          position
          fileName
          note
        }
        proxyBidCount
        saleListing {
          saleStatus
          saleDate
          soldDateLastRanTime
          saleListingDealSoldAt
          saleListingOfferCreatedAt
          lane
          lot
          saleMethod
          venueName
          venueCode
          venueUrl
          buyerAgentName
          buyerAgentId
          buyerAgentPicture
          buyerAgentEmail
          buyerAgentPhoneMobile
          sellerAgentId
          sellerAgentName
          sellerAgentEmail
          sellerAgentPhoneMobile
          buyerAgentNotes
        }
        assetFees {
          stockNumber
          amount
          chargeCode
          description
          run
        }
        saleAmount
        floorAmount
        odometer
        bodyStyle
        announcements {
          type
          id
          announcement
          ordinal
        }
        engineSize
        cylinders
        cylinderConfiguration
        photoCount
        pipelineUri
        consignor {
          accountKey
          accountId
          displayName
          accountOrgId
          accountOrgDisplayName
        }
        onlineListing {
          webViews
        }
        services {
          id
          serviceProductDescription
          serviceOrderedByAmsUser
          serviceOrderedAt
          createdAt
          serviceClassCode
          organizationServiceProductId
          amsServiceProductCode
          amsChargeCode
          serviceResultAt
          notes
          dealId
          chargeAmount
          amsServiceResultCode
        }
      }
    }
    lightOptions {
      lightId
      lightCode
      lightDescription
    }
  }
}
    `;

/**
 * __useEditSaleConditionsDetailQuery__
 *
 * To run a query within a React component, call `useEditSaleConditionsDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditSaleConditionsDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditSaleConditionsDetailQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      auctionId: // value for 'auctionId'
 *      stockNumber: // value for 'stockNumber'
 *   },
 * });
 */
export function useEditSaleConditionsDetailQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EditSaleConditionsDetailQuery, EditSaleConditionsDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditSaleConditionsDetailQuery, EditSaleConditionsDetailQueryVariables>(EditSaleConditionsDetailDocument, options);
      }
export function useEditSaleConditionsDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditSaleConditionsDetailQuery, EditSaleConditionsDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditSaleConditionsDetailQuery, EditSaleConditionsDetailQueryVariables>(EditSaleConditionsDetailDocument, options);
        }
export type EditSaleConditionsDetailQueryHookResult = ReturnType<typeof useEditSaleConditionsDetailQuery>;
export type EditSaleConditionsDetailLazyQueryHookResult = ReturnType<typeof useEditSaleConditionsDetailLazyQuery>;
export type EditSaleConditionsDetailQueryResult = ApolloReactCommon.QueryResult<EditSaleConditionsDetailQuery, EditSaleConditionsDetailQueryVariables>;
export const EditSaleConditionsUpdateDocument = gql`
    query EditSaleConditionsUpdate($amsType: String, $auctionId: String, $assetId: ID!, $floorPrice: SetFloorPrice, $lights: SetLights, $announcements: [SetAnnouncements], $stockNumber: String!, $cancelProxyBids: Boolean) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    setVehicleInfo(
      amsType: $amsType
      assetId: $assetId
      floorPrice: $floorPrice
      lights: $lights
      announcements: $announcements
      stockNumber: $stockNumber
      cancelProxyBids: $cancelProxyBids
    ) {
      results {
        operation
        success
        message
      }
      cancelProxyBidsResult {
        success
        errors
      }
    }
  }
}
    `;

/**
 * __useEditSaleConditionsUpdateQuery__
 *
 * To run a query within a React component, call `useEditSaleConditionsUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditSaleConditionsUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditSaleConditionsUpdateQuery({
 *   variables: {
 *      amsType: // value for 'amsType'
 *      auctionId: // value for 'auctionId'
 *      assetId: // value for 'assetId'
 *      floorPrice: // value for 'floorPrice'
 *      lights: // value for 'lights'
 *      announcements: // value for 'announcements'
 *      stockNumber: // value for 'stockNumber'
 *      cancelProxyBids: // value for 'cancelProxyBids'
 *   },
 * });
 */
export function useEditSaleConditionsUpdateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditSaleConditionsUpdateQuery, EditSaleConditionsUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditSaleConditionsUpdateQuery, EditSaleConditionsUpdateQueryVariables>(EditSaleConditionsUpdateDocument, options);
      }
export function useEditSaleConditionsUpdateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditSaleConditionsUpdateQuery, EditSaleConditionsUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditSaleConditionsUpdateQuery, EditSaleConditionsUpdateQueryVariables>(EditSaleConditionsUpdateDocument, options);
        }
export type EditSaleConditionsUpdateQueryHookResult = ReturnType<typeof useEditSaleConditionsUpdateQuery>;
export type EditSaleConditionsUpdateLazyQueryHookResult = ReturnType<typeof useEditSaleConditionsUpdateLazyQuery>;
export type EditSaleConditionsUpdateQueryResult = ApolloReactCommon.QueryResult<EditSaleConditionsUpdateQuery, EditSaleConditionsUpdateQueryVariables>;
export const CreateAgentContactDocument = gql`
    mutation createAgentContact($agentId: Int!, $statusCode: String!, $typeCode: String!, $contactedAt: String!, $note: String, $followUpDate: String, $followUpUserId: Int, $completedAt: String, $completedBy: Int, $buyerSellerAccountId: Int) {
  createAgentContact(
    input: {agentId: $agentId, statusCode: $statusCode, typeCode: $typeCode, contactedAt: $contactedAt, note: $note, followUpDate: $followUpDate, followUpUserId: $followUpUserId, completedAt: $completedAt, completedBy: $completedBy, buyerSellerAccountId: $buyerSellerAccountId}
  ) {
    id
    userName
    contactedAt
    note
    statusCode
    typeCode
  }
}
    `;
export type CreateAgentContactMutationFn = ApolloReactCommon.MutationFunction<CreateAgentContactMutation, CreateAgentContactMutationVariables>;

/**
 * __useCreateAgentContactMutation__
 *
 * To run a mutation, you first call `useCreateAgentContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgentContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgentContactMutation, { data, loading, error }] = useCreateAgentContactMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      statusCode: // value for 'statusCode'
 *      typeCode: // value for 'typeCode'
 *      contactedAt: // value for 'contactedAt'
 *      note: // value for 'note'
 *      followUpDate: // value for 'followUpDate'
 *      followUpUserId: // value for 'followUpUserId'
 *      completedAt: // value for 'completedAt'
 *      completedBy: // value for 'completedBy'
 *      buyerSellerAccountId: // value for 'buyerSellerAccountId'
 *   },
 * });
 */
export function useCreateAgentContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAgentContactMutation, CreateAgentContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAgentContactMutation, CreateAgentContactMutationVariables>(CreateAgentContactDocument, options);
      }
export type CreateAgentContactMutationHookResult = ReturnType<typeof useCreateAgentContactMutation>;
export type CreateAgentContactMutationResult = ApolloReactCommon.MutationResult<CreateAgentContactMutation>;
export type CreateAgentContactMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAgentContactMutation, CreateAgentContactMutationVariables>;
export const GetContactModalInfoDocument = gql`
    query GetContactModalInfo($auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    users {
      databaseId
      firstName
      lastName
      authenticationUsername
    }
    contactManagement {
      statuses {
        id
        code
        description
      }
      types {
        id
        code
        description
      }
    }
  }
}
    `;

/**
 * __useGetContactModalInfoQuery__
 *
 * To run a query within a React component, call `useGetContactModalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactModalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactModalInfoQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useGetContactModalInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactModalInfoQuery, GetContactModalInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetContactModalInfoQuery, GetContactModalInfoQueryVariables>(GetContactModalInfoDocument, options);
      }
export function useGetContactModalInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactModalInfoQuery, GetContactModalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetContactModalInfoQuery, GetContactModalInfoQueryVariables>(GetContactModalInfoDocument, options);
        }
export type GetContactModalInfoQueryHookResult = ReturnType<typeof useGetContactModalInfoQuery>;
export type GetContactModalInfoLazyQueryHookResult = ReturnType<typeof useGetContactModalInfoLazyQuery>;
export type GetContactModalInfoQueryResult = ApolloReactCommon.QueryResult<GetContactModalInfoQuery, GetContactModalInfoQueryVariables>;
export const UpdateAgentContactDocument = gql`
    mutation updateAgentContact($id: Int!, $agentId: Int!, $statusCode: String!, $typeCode: String!, $contactedAt: String!, $note: String, $followUpDate: String, $followUpUserId: Int, $completedAt: String, $completedBy: Int) {
  updateAgentContact(
    id: $id
    input: {agentId: $agentId, statusCode: $statusCode, typeCode: $typeCode, contactedAt: $contactedAt, note: $note, followUpDate: $followUpDate, followUpUserId: $followUpUserId, completedAt: $completedAt, completedBy: $completedBy}
  ) {
    id
    agentId
    followUpUserId
    followUpDate
    completedAt
    completedBy
    contactedAt
    typeCode
    statusCode
    note
  }
}
    `;
export type UpdateAgentContactMutationFn = ApolloReactCommon.MutationFunction<UpdateAgentContactMutation, UpdateAgentContactMutationVariables>;

/**
 * __useUpdateAgentContactMutation__
 *
 * To run a mutation, you first call `useUpdateAgentContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgentContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgentContactMutation, { data, loading, error }] = useUpdateAgentContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *      agentId: // value for 'agentId'
 *      statusCode: // value for 'statusCode'
 *      typeCode: // value for 'typeCode'
 *      contactedAt: // value for 'contactedAt'
 *      note: // value for 'note'
 *      followUpDate: // value for 'followUpDate'
 *      followUpUserId: // value for 'followUpUserId'
 *      completedAt: // value for 'completedAt'
 *      completedBy: // value for 'completedBy'
 *   },
 * });
 */
export function useUpdateAgentContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAgentContactMutation, UpdateAgentContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAgentContactMutation, UpdateAgentContactMutationVariables>(UpdateAgentContactDocument, options);
      }
export type UpdateAgentContactMutationHookResult = ReturnType<typeof useUpdateAgentContactMutation>;
export type UpdateAgentContactMutationResult = ApolloReactCommon.MutationResult<UpdateAgentContactMutation>;
export type UpdateAgentContactMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAgentContactMutation, UpdateAgentContactMutationVariables>;
export const UserInfoContactModalDocument = gql`
    query userInfoContactModal($auctionId: String = "") {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  profile @client {
    userId
  }
  user {
    attributes {
      databaseId
      authenticationId
      firstName
      lastName
      mobilePhone
      email
      isGlobalAdmin
      authenticationUsername
    }
    permissions {
      userPermissions {
        key
        description
        note
      }
      orgPermissions(auctionId: $auctionId) {
        key
        description
        note
      }
    }
    organizations {
      orgId
      displayName
      description
      isAdmin
    }
  }
}
    `;

/**
 * __useUserInfoContactModalQuery__
 *
 * To run a query within a React component, call `useUserInfoContactModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInfoContactModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInfoContactModalQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useUserInfoContactModalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserInfoContactModalQuery, UserInfoContactModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserInfoContactModalQuery, UserInfoContactModalQueryVariables>(UserInfoContactModalDocument, options);
      }
export function useUserInfoContactModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserInfoContactModalQuery, UserInfoContactModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserInfoContactModalQuery, UserInfoContactModalQueryVariables>(UserInfoContactModalDocument, options);
        }
export type UserInfoContactModalQueryHookResult = ReturnType<typeof useUserInfoContactModalQuery>;
export type UserInfoContactModalLazyQueryHookResult = ReturnType<typeof useUserInfoContactModalLazyQuery>;
export type UserInfoContactModalQueryResult = ApolloReactCommon.QueryResult<UserInfoContactModalQuery, UserInfoContactModalQueryVariables>;
export const CreateContactDocument = gql`
    mutation createContact($agentId: Int!, $statusCode: String!, $typeCode: String!, $contactedAt: String!, $note: String, $followUpDate: String, $followUpUserId: Int, $completedAt: String, $completedBy: Int) {
  createAgentContact(
    input: {agentId: $agentId, statusCode: $statusCode, typeCode: $typeCode, contactedAt: $contactedAt, note: $note, followUpDate: $followUpDate, followUpUserId: $followUpUserId, completedAt: $completedAt, completedBy: $completedBy}
  ) @client {
    id
    userName
    contactedAt
    note
    statusCode
    typeCode
  }
}
    `;
export type CreateContactMutationFn = ApolloReactCommon.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      statusCode: // value for 'statusCode'
 *      typeCode: // value for 'typeCode'
 *      contactedAt: // value for 'contactedAt'
 *      note: // value for 'note'
 *      followUpDate: // value for 'followUpDate'
 *      followUpUserId: // value for 'followUpUserId'
 *      completedAt: // value for 'completedAt'
 *      completedBy: // value for 'completedBy'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = ApolloReactCommon.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const UpdateContactDeprecatedDocument = gql`
    mutation updateContactDeprecated($id: Int!, $agentId: Int!, $statusCode: String!, $typeCode: String!, $contactedAt: String!, $note: String, $followUpDate: String, $followUpUserId: Int, $completedAt: String, $completedBy: Int) {
  updateAgentContact(
    id: $id
    input: {agentId: $agentId, statusCode: $statusCode, typeCode: $typeCode, contactedAt: $contactedAt, note: $note, followUpDate: $followUpDate, followUpUserId: $followUpUserId, completedAt: $completedAt, completedBy: $completedBy}
  ) @client {
    id
    agentId
    followUpUserId
    followUpDate
    completedAt
    completedBy
    contactedAt
    typeCode
    statusCode
    note
  }
}
    `;
export type UpdateContactDeprecatedMutationFn = ApolloReactCommon.MutationFunction<UpdateContactDeprecatedMutation, UpdateContactDeprecatedMutationVariables>;

/**
 * __useUpdateContactDeprecatedMutation__
 *
 * To run a mutation, you first call `useUpdateContactDeprecatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactDeprecatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactDeprecatedMutation, { data, loading, error }] = useUpdateContactDeprecatedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      agentId: // value for 'agentId'
 *      statusCode: // value for 'statusCode'
 *      typeCode: // value for 'typeCode'
 *      contactedAt: // value for 'contactedAt'
 *      note: // value for 'note'
 *      followUpDate: // value for 'followUpDate'
 *      followUpUserId: // value for 'followUpUserId'
 *      completedAt: // value for 'completedAt'
 *      completedBy: // value for 'completedBy'
 *   },
 * });
 */
export function useUpdateContactDeprecatedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContactDeprecatedMutation, UpdateContactDeprecatedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateContactDeprecatedMutation, UpdateContactDeprecatedMutationVariables>(UpdateContactDeprecatedDocument, options);
      }
export type UpdateContactDeprecatedMutationHookResult = ReturnType<typeof useUpdateContactDeprecatedMutation>;
export type UpdateContactDeprecatedMutationResult = ApolloReactCommon.MutationResult<UpdateContactDeprecatedMutation>;
export type UpdateContactDeprecatedMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateContactDeprecatedMutation, UpdateContactDeprecatedMutationVariables>;
export const GetDetailPageFieldDocument = gql`
    query getDetailPageField($auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    reportDetailPages {
      name
      displayName
      url
      requiredRoles
    }
  }
}
    `;

/**
 * __useGetDetailPageFieldQuery__
 *
 * To run a query within a React component, call `useGetDetailPageFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailPageFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailPageFieldQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useGetDetailPageFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDetailPageFieldQuery, GetDetailPageFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDetailPageFieldQuery, GetDetailPageFieldQueryVariables>(GetDetailPageFieldDocument, options);
      }
export function useGetDetailPageFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDetailPageFieldQuery, GetDetailPageFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDetailPageFieldQuery, GetDetailPageFieldQueryVariables>(GetDetailPageFieldDocument, options);
        }
export type GetDetailPageFieldQueryHookResult = ReturnType<typeof useGetDetailPageFieldQuery>;
export type GetDetailPageFieldLazyQueryHookResult = ReturnType<typeof useGetDetailPageFieldLazyQuery>;
export type GetDetailPageFieldQueryResult = ApolloReactCommon.QueryResult<GetDetailPageFieldQuery, GetDetailPageFieldQueryVariables>;
export const BidderStatsDocument = gql`
    query bidderStats($auctionId: String, $searchString: String!, $searchStringOnline: String!) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    totalbidders: search(filter: {type: BIDDERS, searchString: $searchString}) {
      bidderCount
    }
    onlinebidders: search(
      filter: {type: BIDDERS, searchString: $searchStringOnline}
    ) {
      bidderCount
    }
  }
}
    `;

/**
 * __useBidderStatsQuery__
 *
 * To run a query within a React component, call `useBidderStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidderStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidderStatsQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      searchString: // value for 'searchString'
 *      searchStringOnline: // value for 'searchStringOnline'
 *   },
 * });
 */
export function useBidderStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidderStatsQuery, BidderStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidderStatsQuery, BidderStatsQueryVariables>(BidderStatsDocument, options);
      }
export function useBidderStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidderStatsQuery, BidderStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidderStatsQuery, BidderStatsQueryVariables>(BidderStatsDocument, options);
        }
export type BidderStatsQueryHookResult = ReturnType<typeof useBidderStatsQuery>;
export type BidderStatsLazyQueryHookResult = ReturnType<typeof useBidderStatsLazyQuery>;
export type BidderStatsQueryResult = ApolloReactCommon.QueryResult<BidderStatsQuery, BidderStatsQueryVariables>;
export const FavoriteSellersDocument = gql`
    query favoriteSellers($auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  auction(id: $auctionId) {
    search(filter: {searchString: "fav:yes", type: BROAD}) {
      accountCount
      accountResult {
        accountId
        displayName
        isFavorite
      }
    }
    detail: search(filter: {searchString: "fav:yes", type: VEHICLES_BY_COMPANY}) {
      accountCount
      searchStringDisplay
      searchType
      vehicleStatsByCompany {
        accountName
        accountId
        total
        ran
        sold
        conversion
        avgSaleAmount
        sumSaleAmount
      }
    }
  }
}
    `;

/**
 * __useFavoriteSellersQuery__
 *
 * To run a query within a React component, call `useFavoriteSellersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoriteSellersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoriteSellersQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useFavoriteSellersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FavoriteSellersQuery, FavoriteSellersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FavoriteSellersQuery, FavoriteSellersQueryVariables>(FavoriteSellersDocument, options);
      }
export function useFavoriteSellersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FavoriteSellersQuery, FavoriteSellersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FavoriteSellersQuery, FavoriteSellersQueryVariables>(FavoriteSellersDocument, options);
        }
export type FavoriteSellersQueryHookResult = ReturnType<typeof useFavoriteSellersQuery>;
export type FavoriteSellersLazyQueryHookResult = ReturnType<typeof useFavoriteSellersLazyQuery>;
export type FavoriteSellersQueryResult = ApolloReactCommon.QueryResult<FavoriteSellersQuery, FavoriteSellersQueryVariables>;
export const GetReportListDocument = gql`
    query getReportList($auctionType: String, $auctionId: String) {
  activeOrganization @client {
    orgId @export(as: "auctionId")
    type
  }
  auction(id: $auctionId) {
    reports(filter: {auctionType: $auctionType}) {
      reportId
      reportShortName
      shortDescription
      auctionType
      reportUrl
      auctionType
    }
  }
}
    `;

/**
 * __useGetReportListQuery__
 *
 * To run a query within a React component, call `useGetReportListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportListQuery({
 *   variables: {
 *      auctionType: // value for 'auctionType'
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useGetReportListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReportListQuery, GetReportListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportListQuery, GetReportListQueryVariables>(GetReportListDocument, options);
      }
export function useGetReportListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReportListQuery, GetReportListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportListQuery, GetReportListQueryVariables>(GetReportListDocument, options);
        }
export type GetReportListQueryHookResult = ReturnType<typeof useGetReportListQuery>;
export type GetReportListLazyQueryHookResult = ReturnType<typeof useGetReportListLazyQuery>;
export type GetReportListQueryResult = ApolloReactCommon.QueryResult<GetReportListQuery, GetReportListQueryVariables>;
export const UserInfoDocument = gql`
    query userInfo($auctionId: String = "") {
  activeOrganization @client {
    orgId @export(as: "auctionId")
  }
  profile @client {
    userId
  }
  user {
    attributes {
      databaseId
      authenticationId
      firstName
      lastName
      mobilePhone
      email
      isGlobalAdmin
      authenticationUsername
    }
    permissions {
      userPermissions {
        key
        description
        note
      }
      orgPermissions(auctionId: $auctionId) {
        key
        description
        note
      }
    }
    organizations {
      orgId
      displayName
      description
      isAdmin
      orgTypeCode
      isCorporateGroupUser
      groupOrgId
      orgNumber
    }
  }
}
    `;

/**
 * __useUserInfoQuery__
 *
 * To run a query within a React component, call `useUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInfoQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useUserInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserInfoQuery, UserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserInfoQuery, UserInfoQueryVariables>(UserInfoDocument, options);
      }
export function useUserInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserInfoQuery, UserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserInfoQuery, UserInfoQueryVariables>(UserInfoDocument, options);
        }
export type UserInfoQueryHookResult = ReturnType<typeof useUserInfoQuery>;
export type UserInfoLazyQueryHookResult = ReturnType<typeof useUserInfoLazyQuery>;
export type UserInfoQueryResult = ApolloReactCommon.QueryResult<UserInfoQuery, UserInfoQueryVariables>;
export const GetUserRolesDocument = gql`
    query getUserRoles {
  profile @client {
    roles {
      id
      name
      description
    }
  }
}
    `;

/**
 * __useGetUserRolesQuery__
 *
 * To run a query within a React component, call `useGetUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserRolesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserRolesQuery, GetUserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserRolesQuery, GetUserRolesQueryVariables>(GetUserRolesDocument, options);
      }
export function useGetUserRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserRolesQuery, GetUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserRolesQuery, GetUserRolesQueryVariables>(GetUserRolesDocument, options);
        }
export type GetUserRolesQueryHookResult = ReturnType<typeof useGetUserRolesQuery>;
export type GetUserRolesLazyQueryHookResult = ReturnType<typeof useGetUserRolesLazyQuery>;
export type GetUserRolesQueryResult = ApolloReactCommon.QueryResult<GetUserRolesQuery, GetUserRolesQueryVariables>;